let adr = [{
    "cityCode": "110000",
    "label": "北京", "value": "北京",
    "children": [{
        "cityCode": "110100",
        "label": "北京市", "value": "北京市",
        "children": [{
            "cityCode": "110101",
            "label": "东城区", "value": "东城区",
            "pcode": "110100"
        },
        {
            "cityCode": "110102",
            "label": "西城区", "value": "西城区",
            "pcode": "110100"
        },
        {
            "cityCode": "110105",
            "label": "朝阳区", "value": "朝阳区",
            "pcode": "110100"
        },
        {
            "cityCode": "110106",
            "label": "丰台区", "value": "丰台区",
            "pcode": "110100"
        },
        {
            "cityCode": "110107",
            "label": "石景山区", "value": "石景山区",
            "pcode": "110100"
        },
        {
            "cityCode": "110108",
            "label": "海淀区", "value": "海淀区",
            "pcode": "110100"
        },
        {
            "cityCode": "110109",
            "label": "门头沟区", "value": "门头沟区",
            "pcode": "110100"
        },
        {
            "cityCode": "110111",
            "label": "房山区", "value": "房山区",
            "pcode": "110100"
        },
        {
            "cityCode": "110112",
            "label": "通州区", "value": "通州区",
            "pcode": "110100"
        },
        {
            "cityCode": "110113",
            "label": "顺义区", "value": "顺义区",
            "pcode": "110100"
        },
        {
            "cityCode": "110114",
            "label": "昌平区", "value": "昌平区",
            "pcode": "110100"
        },
        {
            "cityCode": "110115",
            "label": "大兴区", "value": "大兴区",
            "pcode": "110100"
        },
        {
            "cityCode": "110116",
            "label": "怀柔区", "value": "怀柔区",
            "pcode": "110100"
        },
        {
            "cityCode": "110117",
            "label": "平谷区", "value": "平谷区",
            "pcode": "110100"
        },
        {
            "cityCode": "110118",
            "label": "密云区", "value": "密云区",
            "pcode": "110100"
        },
        {
            "cityCode": "110119",
            "label": "延庆区", "value": "延庆区",
            "pcode": "110100"
        }],
        "pcode": "110000"
    }]
},
{
    "cityCode": "120000",
    "label": "天津", "value": "天津",
    "children": [{
        "cityCode": "120100",
        "label": "天津市", "value": "天津市",
        "children": [{
            "cityCode": "120101",
            "label": "和平区", "value": "和平区",
            "pcode": "120100"
        },
        {
            "cityCode": "120102",
            "label": "河东区", "value": "河东区",
            "pcode": "120100"
        },
        {
            "cityCode": "120103",
            "label": "河西区", "value": "河西区",
            "pcode": "120100"
        },
        {
            "cityCode": "120104",
            "label": "南开区", "value": "南开区",
            "pcode": "120100"
        },
        {
            "cityCode": "120105",
            "label": "河北区", "value": "河北区",
            "pcode": "120100"
        },
        {
            "cityCode": "120106",
            "label": "红桥区", "value": "红桥区",
            "pcode": "120100"
        },
        {
            "cityCode": "120110",
            "label": "东丽区", "value": "东丽区",
            "pcode": "120100"
        },
        {
            "cityCode": "120111",
            "label": "西青区", "value": "西青区",
            "pcode": "120100"
        },
        {
            "cityCode": "120112",
            "label": "津南区", "value": "津南区",
            "pcode": "120100"
        },
        {
            "cityCode": "120113",
            "label": "北辰区", "value": "北辰区",
            "pcode": "120100"
        },
        {
            "cityCode": "120114",
            "label": "武清区", "value": "武清区",
            "pcode": "120100"
        },
        {
            "cityCode": "120115",
            "label": "宝坻区", "value": "宝坻区",
            "pcode": "120100"
        },
        {
            "cityCode": "120116",
            "label": "滨海新区", "value": "滨海新区",
            "pcode": "120100"
        },
        {
            "cityCode": "120117",
            "label": "宁河区", "value": "宁河区",
            "pcode": "120100"
        },
        {
            "cityCode": "120118",
            "label": "静海区", "value": "静海区",
            "pcode": "120100"
        },
        {
            "cityCode": "120119",
            "label": "蓟州区", "value": "蓟州区",
            "pcode": "120100"
        }],
        "pcode": "120000"
    }]
},
{
    "cityCode": "130000",
    "label": "河北省", "value": "河北省",
    "children": [{
        "cityCode": "130100",
        "label": "石家庄市", "value": "石家庄市",
        "children": [{
            "cityCode": "130102",
            "label": "长安区", "value": "长安区",
            "pcode": "130100"
        },
        {
            "cityCode": "130104",
            "label": "桥西区", "value": "桥西区",
            "pcode": "130100"
        },
        {
            "cityCode": "130105",
            "label": "新华区", "value": "新华区",
            "pcode": "130100"
        },
        {
            "cityCode": "130107",
            "label": "井陉矿区", "value": "井陉矿区",
            "pcode": "130100"
        },
        {
            "cityCode": "130108",
            "label": "裕华区", "value": "裕华区",
            "pcode": "130100"
        },
        {
            "cityCode": "130109",
            "label": "藁城区", "value": "藁城区",
            "pcode": "130100"
        },
        {
            "cityCode": "130110",
            "label": "鹿泉区", "value": "鹿泉区",
            "pcode": "130100"
        },
        {
            "cityCode": "130111",
            "label": "栾城区", "value": "栾城区",
            "pcode": "130100"
        },
        {
            "cityCode": "130121",
            "label": "井陉县", "value": "井陉县",
            "pcode": "130100"
        },
        {
            "cityCode": "130123",
            "label": "正定县", "value": "正定县",
            "pcode": "130100"
        },
        {
            "cityCode": "130125",
            "label": "行唐县", "value": "行唐县",
            "pcode": "130100"
        },
        {
            "cityCode": "130126",
            "label": "灵寿县", "value": "灵寿县",
            "pcode": "130100"
        },
        {
            "cityCode": "130127",
            "label": "高邑县", "value": "高邑县",
            "pcode": "130100"
        },
        {
            "cityCode": "130128",
            "label": "深泽县", "value": "深泽县",
            "pcode": "130100"
        },
        {
            "cityCode": "130129",
            "label": "赞皇县", "value": "赞皇县",
            "pcode": "130100"
        },
        {
            "cityCode": "130130",
            "label": "无极县", "value": "无极县",
            "pcode": "130100"
        },
        {
            "cityCode": "130131",
            "label": "平山县", "value": "平山县",
            "pcode": "130100"
        },
        {
            "cityCode": "130132",
            "label": "元氏县", "value": "元氏县",
            "pcode": "130100"
        },
        {
            "cityCode": "130133",
            "label": "赵县", "value": "赵县",
            "pcode": "130100"
        },
        {
            "cityCode": "130181",
            "label": "辛集市", "value": "辛集市",
            "pcode": "130100"
        },
        {
            "cityCode": "130183",
            "label": "晋州市", "value": "晋州市",
            "pcode": "130100"
        },
        {
            "cityCode": "130184",
            "label": "新乐市", "value": "新乐市",
            "pcode": "130100"
        }],
        "pcode": "130000"
    },
    {
        "cityCode": "130200",
        "label": "唐山市", "value": "唐山市",
        "children": [{
            "cityCode": "130202",
            "label": "路南区", "value": "路南区",
            "pcode": "130200"
        },
        {
            "cityCode": "130203",
            "label": "路北区", "value": "路北区",
            "pcode": "130200"
        },
        {
            "cityCode": "130204",
            "label": "古冶区", "value": "古冶区",
            "pcode": "130200"
        },
        {
            "cityCode": "130205",
            "label": "开平区", "value": "开平区",
            "pcode": "130200"
        },
        {
            "cityCode": "130207",
            "label": "丰南区", "value": "丰南区",
            "pcode": "130200"
        },
        {
            "cityCode": "130208",
            "label": "丰润区", "value": "丰润区",
            "pcode": "130200"
        },
        {
            "cityCode": "130209",
            "label": "曹妃甸区", "value": "曹妃甸区",
            "pcode": "130200"
        },
        {
            "cityCode": "130223",
            "label": "滦县", "value": "滦县",
            "pcode": "130200"
        },
        {
            "cityCode": "130224",
            "label": "滦南县", "value": "滦南县",
            "pcode": "130200"
        },
        {
            "cityCode": "130225",
            "label": "乐亭县", "value": "乐亭县",
            "pcode": "130200"
        },
        {
            "cityCode": "130227",
            "label": "迁西县", "value": "迁西县",
            "pcode": "130200"
        },
        {
            "cityCode": "130229",
            "label": "玉田县", "value": "玉田县",
            "pcode": "130200"
        },
        {
            "cityCode": "130281",
            "label": "遵化市", "value": "遵化市",
            "pcode": "130200"
        },
        {
            "cityCode": "130283",
            "label": "迁安市", "value": "迁安市",
            "pcode": "130200"
        }],
        "pcode": "130000"
    },
    {
        "cityCode": "130300",
        "label": "秦皇岛市", "value": "秦皇岛市",
        "children": [{
            "cityCode": "130302",
            "label": "海港区", "value": "海港区",
            "pcode": "130300"
        },
        {
            "cityCode": "130303",
            "label": "山海关区", "value": "山海关区",
            "pcode": "130300"
        },
        {
            "cityCode": "130304",
            "label": "北戴河区", "value": "北戴河区",
            "pcode": "130300"
        },
        {
            "cityCode": "130306",
            "label": "抚宁区", "value": "抚宁区",
            "pcode": "130300"
        },
        {
            "cityCode": "130321",
            "label": "青龙满族自治县", "value": "青龙满族自治县",
            "pcode": "130300"
        },
        {
            "cityCode": "130322",
            "label": "昌黎县", "value": "昌黎县",
            "pcode": "130300"
        },
        {
            "cityCode": "130324",
            "label": "卢龙县", "value": "卢龙县",
            "pcode": "130300"
        }],
        "pcode": "130000"
    },
    {
        "cityCode": "130400",
        "label": "邯郸市", "value": "邯郸市",
        "children": [{
            "cityCode": "130402",
            "label": "邯山区", "value": "邯山区",
            "pcode": "130400"
        },
        {
            "cityCode": "130403",
            "label": "丛台区", "value": "丛台区",
            "pcode": "130400"
        },
        {
            "cityCode": "130404",
            "label": "复兴区", "value": "复兴区",
            "pcode": "130400"
        },
        {
            "cityCode": "130406",
            "label": "峰峰矿区", "value": "峰峰矿区",
            "pcode": "130400"
        },
        {
            "cityCode": "130423",
            "label": "临漳县", "value": "临漳县",
            "pcode": "130400"
        },
        {
            "cityCode": "130424",
            "label": "成安县", "value": "成安县",
            "pcode": "130400"
        },
        {
            "cityCode": "130425",
            "label": "大名县", "value": "大名县",
            "pcode": "130400"
        },
        {
            "cityCode": "130426",
            "label": "涉县", "value": "涉县",
            "pcode": "130400"
        },
        {
            "cityCode": "130427",
            "label": "磁县", "value": "磁县",
            "pcode": "130400"
        },
        {
            "cityCode": "130428",
            "label": "肥乡区", "value": "肥乡区",
            "pcode": "130400"
        },
        {
            "cityCode": "130429",
            "label": "永年区", "value": "永年区",
            "pcode": "130400"
        },
        {
            "cityCode": "130430",
            "label": "邱县", "value": "邱县",
            "pcode": "130400"
        },
        {
            "cityCode": "130431",
            "label": "鸡泽县", "value": "鸡泽县",
            "pcode": "130400"
        },
        {
            "cityCode": "130432",
            "label": "广平县", "value": "广平县",
            "pcode": "130400"
        },
        {
            "cityCode": "130433",
            "label": "馆陶县", "value": "馆陶县",
            "pcode": "130400"
        },
        {
            "cityCode": "130434",
            "label": "魏县", "value": "魏县",
            "pcode": "130400"
        },
        {
            "cityCode": "130435",
            "label": "曲周县", "value": "曲周县",
            "pcode": "130400"
        },
        {
            "cityCode": "130481",
            "label": "武安市", "value": "武安市",
            "pcode": "130400"
        }],
        "pcode": "130000"
    },
    {
        "cityCode": "130500",
        "label": "邢台市", "value": "邢台市",
        "children": [{
            "cityCode": "130502",
            "label": "桥东区", "value": "桥东区",
            "pcode": "130500"
        },
        {
            "cityCode": "130503",
            "label": "桥西区", "value": "桥西区",
            "pcode": "130500"
        },
        {
            "cityCode": "130521",
            "label": "邢台县", "value": "邢台县",
            "pcode": "130500"
        },
        {
            "cityCode": "130522",
            "label": "临城县", "value": "临城县",
            "pcode": "130500"
        },
        {
            "cityCode": "130523",
            "label": "内丘县", "value": "内丘县",
            "pcode": "130500"
        },
        {
            "cityCode": "130524",
            "label": "柏乡县", "value": "柏乡县",
            "pcode": "130500"
        },
        {
            "cityCode": "130525",
            "label": "隆尧县", "value": "隆尧县",
            "pcode": "130500"
        },
        {
            "cityCode": "130526",
            "label": "任县", "value": "任县",
            "pcode": "130500"
        },
        {
            "cityCode": "130527",
            "label": "南和县", "value": "南和县",
            "pcode": "130500"
        },
        {
            "cityCode": "130528",
            "label": "宁晋县", "value": "宁晋县",
            "pcode": "130500"
        },
        {
            "cityCode": "130529",
            "label": "巨鹿县", "value": "巨鹿县",
            "pcode": "130500"
        },
        {
            "cityCode": "130530",
            "label": "新河县", "value": "新河县",
            "pcode": "130500"
        },
        {
            "cityCode": "130531",
            "label": "广宗县", "value": "广宗县",
            "pcode": "130500"
        },
        {
            "cityCode": "130532",
            "label": "平乡县", "value": "平乡县",
            "pcode": "130500"
        },
        {
            "cityCode": "130533",
            "label": "威县", "value": "威县",
            "pcode": "130500"
        },
        {
            "cityCode": "130534",
            "label": "清河县", "value": "清河县",
            "pcode": "130500"
        },
        {
            "cityCode": "130535",
            "label": "临西县", "value": "临西县",
            "pcode": "130500"
        },
        {
            "cityCode": "130581",
            "label": "南宫市", "value": "南宫市",
            "pcode": "130500"
        },
        {
            "cityCode": "130582",
            "label": "沙河市", "value": "沙河市",
            "pcode": "130500"
        }],
        "pcode": "130000"
    },
    {
        "cityCode": "130600",
        "label": "保定市", "value": "保定市",
        "children": [{
            "cityCode": "130602",
            "label": "竞秀区", "value": "竞秀区",
            "pcode": "130600"
        },
        {
            "cityCode": "130606",
            "label": "莲池区", "value": "莲池区",
            "pcode": "130600"
        },
        {
            "cityCode": "130607",
            "label": "满城区", "value": "满城区",
            "pcode": "130600"
        },
        {
            "cityCode": "130608",
            "label": "清苑区", "value": "清苑区",
            "pcode": "130600"
        },
        {
            "cityCode": "130609",
            "label": "徐水区", "value": "徐水区",
            "pcode": "130600"
        },
        {
            "cityCode": "130623",
            "label": "涞水县", "value": "涞水县",
            "pcode": "130600"
        },
        {
            "cityCode": "130624",
            "label": "阜平县", "value": "阜平县",
            "pcode": "130600"
        },
        {
            "cityCode": "130626",
            "label": "定兴县", "value": "定兴县",
            "pcode": "130600"
        },
        {
            "cityCode": "130627",
            "label": "唐县", "value": "唐县",
            "pcode": "130600"
        },
        {
            "cityCode": "130628",
            "label": "高阳县", "value": "高阳县",
            "pcode": "130600"
        },
        {
            "cityCode": "130629",
            "label": "容城县", "value": "容城县",
            "pcode": "130600"
        },
        {
            "cityCode": "130630",
            "label": "涞源县", "value": "涞源县",
            "pcode": "130600"
        },
        {
            "cityCode": "130631",
            "label": "望都县", "value": "望都县",
            "pcode": "130600"
        },
        {
            "cityCode": "130632",
            "label": "安新县", "value": "安新县",
            "pcode": "130600"
        },
        {
            "cityCode": "130633",
            "label": "易县", "value": "易县",
            "pcode": "130600"
        },
        {
            "cityCode": "130634",
            "label": "曲阳县", "value": "曲阳县",
            "pcode": "130600"
        },
        {
            "cityCode": "130635",
            "label": "蠡县", "value": "蠡县",
            "pcode": "130600"
        },
        {
            "cityCode": "130636",
            "label": "顺平县", "value": "顺平县",
            "pcode": "130600"
        },
        {
            "cityCode": "130637",
            "label": "博野县", "value": "博野县",
            "pcode": "130600"
        },
        {
            "cityCode": "130638",
            "label": "雄县", "value": "雄县",
            "pcode": "130600"
        },
        {
            "cityCode": "130681",
            "label": "涿州市", "value": "涿州市",
            "pcode": "130600"
        },
        {
            "cityCode": "130682",
            "label": "定州市", "value": "定州市",
            "pcode": "130600"
        },
        {
            "cityCode": "130683",
            "label": "安国市", "value": "安国市",
            "pcode": "130600"
        },
        {
            "cityCode": "130684",
            "label": "高碑店市", "value": "高碑店市",
            "pcode": "130600"
        }],
        "pcode": "130000"
    },
    {
        "cityCode": "130700",
        "label": "张家口市", "value": "张家口市",
        "children": [{
            "cityCode": "130702",
            "label": "桥东区", "value": "桥东区",
            "pcode": "130700"
        },
        {
            "cityCode": "130703",
            "label": "桥西区", "value": "桥西区",
            "pcode": "130700"
        },
        {
            "cityCode": "130705",
            "label": "宣化区", "value": "宣化区",
            "pcode": "130700"
        },
        {
            "cityCode": "130706",
            "label": "下花园区", "value": "下花园区",
            "pcode": "130700"
        },
        {
            "cityCode": "130708",
            "label": "万全区", "value": "万全区",
            "pcode": "130700"
        },
        {
            "cityCode": "130709",
            "label": "崇礼区", "value": "崇礼区",
            "pcode": "130700"
        },
        {
            "cityCode": "130722",
            "label": "张北县", "value": "张北县",
            "pcode": "130700"
        },
        {
            "cityCode": "130723",
            "label": "康保县", "value": "康保县",
            "pcode": "130700"
        },
        {
            "cityCode": "130724",
            "label": "沽源县", "value": "沽源县",
            "pcode": "130700"
        },
        {
            "cityCode": "130725",
            "label": "尚义县", "value": "尚义县",
            "pcode": "130700"
        },
        {
            "cityCode": "130726",
            "label": "蔚县", "value": "蔚县",
            "pcode": "130700"
        },
        {
            "cityCode": "130727",
            "label": "阳原县", "value": "阳原县",
            "pcode": "130700"
        },
        {
            "cityCode": "130728",
            "label": "怀安县", "value": "怀安县",
            "pcode": "130700"
        },
        {
            "cityCode": "130730",
            "label": "怀来县", "value": "怀来县",
            "pcode": "130700"
        },
        {
            "cityCode": "130731",
            "label": "涿鹿县", "value": "涿鹿县",
            "pcode": "130700"
        },
        {
            "cityCode": "130732",
            "label": "赤城县", "value": "赤城县",
            "pcode": "130700"
        }],
        "pcode": "130000"
    },
    {
        "cityCode": "130800",
        "label": "承德市", "value": "承德市",
        "children": [{
            "cityCode": "130802",
            "label": "双桥区", "value": "双桥区",
            "pcode": "130800"
        },
        {
            "cityCode": "130803",
            "label": "双滦区", "value": "双滦区",
            "pcode": "130800"
        },
        {
            "cityCode": "130804",
            "label": "鹰手营子矿区", "value": "鹰手营子矿区",
            "pcode": "130800"
        },
        {
            "cityCode": "130821",
            "label": "承德县", "value": "承德县",
            "pcode": "130800"
        },
        {
            "cityCode": "130822",
            "label": "兴隆县", "value": "兴隆县",
            "pcode": "130800"
        },
        {
            "cityCode": "130823",
            "label": "平泉县", "value": "平泉县",
            "pcode": "130800"
        },
        {
            "cityCode": "130824",
            "label": "滦平县", "value": "滦平县",
            "pcode": "130800"
        },
        {
            "cityCode": "130825",
            "label": "隆化县", "value": "隆化县",
            "pcode": "130800"
        },
        {
            "cityCode": "130826",
            "label": "丰宁满族自治县", "value": "丰宁满族自治县",
            "pcode": "130800"
        },
        {
            "cityCode": "130827",
            "label": "宽城满族自治县", "value": "宽城满族自治县",
            "pcode": "130800"
        },
        {
            "cityCode": "130828",
            "label": "围场满族蒙古族自治县", "value": "围场满族蒙古族自治县",
            "pcode": "130800"
        }],
        "pcode": "130000"
    },
    {
        "cityCode": "130900",
        "label": "沧州市", "value": "沧州市",
        "children": [{
            "cityCode": "130902",
            "label": "新华区", "value": "新华区",
            "pcode": "130900"
        },
        {
            "cityCode": "130903",
            "label": "运河区", "value": "运河区",
            "pcode": "130900"
        },
        {
            "cityCode": "130921",
            "label": "沧县", "value": "沧县",
            "pcode": "130900"
        },
        {
            "cityCode": "130922",
            "label": "青县", "value": "青县",
            "pcode": "130900"
        },
        {
            "cityCode": "130923",
            "label": "东光县", "value": "东光县",
            "pcode": "130900"
        },
        {
            "cityCode": "130924",
            "label": "海兴县", "value": "海兴县",
            "pcode": "130900"
        },
        {
            "cityCode": "130925",
            "label": "盐山县", "value": "盐山县",
            "pcode": "130900"
        },
        {
            "cityCode": "130926",
            "label": "肃宁县", "value": "肃宁县",
            "pcode": "130900"
        },
        {
            "cityCode": "130927",
            "label": "南皮县", "value": "南皮县",
            "pcode": "130900"
        },
        {
            "cityCode": "130928",
            "label": "吴桥县", "value": "吴桥县",
            "pcode": "130900"
        },
        {
            "cityCode": "130929",
            "label": "献县", "value": "献县",
            "pcode": "130900"
        },
        {
            "cityCode": "130930",
            "label": "孟村回族自治县", "value": "孟村回族自治县",
            "pcode": "130900"
        },
        {
            "cityCode": "130981",
            "label": "泊头市", "value": "泊头市",
            "pcode": "130900"
        },
        {
            "cityCode": "130982",
            "label": "任丘市", "value": "任丘市",
            "pcode": "130900"
        },
        {
            "cityCode": "130983",
            "label": "黄骅市", "value": "黄骅市",
            "pcode": "130900"
        },
        {
            "cityCode": "130984",
            "label": "河间市", "value": "河间市",
            "pcode": "130900"
        }],
        "pcode": "130000"
    },
    {
        "cityCode": "131000",
        "label": "廊坊市", "value": "廊坊市",
        "children": [{
            "cityCode": "131002",
            "label": "安次区", "value": "安次区",
            "pcode": "131000"
        },
        {
            "cityCode": "131003",
            "label": "广阳区", "value": "广阳区",
            "pcode": "131000"
        },
        {
            "cityCode": "131022",
            "label": "固安县", "value": "固安县",
            "pcode": "131000"
        },
        {
            "cityCode": "131023",
            "label": "永清县", "value": "永清县",
            "pcode": "131000"
        },
        {
            "cityCode": "131024",
            "label": "香河县", "value": "香河县",
            "pcode": "131000"
        },
        {
            "cityCode": "131025",
            "label": "大城县", "value": "大城县",
            "pcode": "131000"
        },
        {
            "cityCode": "131026",
            "label": "文安县", "value": "文安县",
            "pcode": "131000"
        },
        {
            "cityCode": "131028",
            "label": "大厂回族自治县", "value": "大厂回族自治县",
            "pcode": "131000"
        },
        {
            "cityCode": "131081",
            "label": "霸州市", "value": "霸州市",
            "pcode": "131000"
        },
        {
            "cityCode": "131082",
            "label": "三河市", "value": "三河市",
            "pcode": "131000"
        }],
        "pcode": "130000"
    },
    {
        "cityCode": "131100",
        "label": "衡水市", "value": "衡水市",
        "children": [{
            "cityCode": "131102",
            "label": "桃城区", "value": "桃城区",
            "pcode": "131100"
        },
        {
            "cityCode": "131103",
            "label": "冀州区", "value": "冀州区",
            "pcode": "131100"
        },
        {
            "cityCode": "131121",
            "label": "枣强县", "value": "枣强县",
            "pcode": "131100"
        },
        {
            "cityCode": "131122",
            "label": "武邑县", "value": "武邑县",
            "pcode": "131100"
        },
        {
            "cityCode": "131123",
            "label": "武强县", "value": "武强县",
            "pcode": "131100"
        },
        {
            "cityCode": "131124",
            "label": "饶阳县", "value": "饶阳县",
            "pcode": "131100"
        },
        {
            "cityCode": "131125",
            "label": "安平县", "value": "安平县",
            "pcode": "131100"
        },
        {
            "cityCode": "131126",
            "label": "故城县", "value": "故城县",
            "pcode": "131100"
        },
        {
            "cityCode": "131127",
            "label": "景县", "value": "景县",
            "pcode": "131100"
        },
        {
            "cityCode": "131128",
            "label": "阜城县", "value": "阜城县",
            "pcode": "131100"
        },
        {
            "cityCode": "131182",
            "label": "深州市", "value": "深州市",
            "pcode": "131100"
        }],
        "pcode": "130000"
    }]
},
{
    "cityCode": "140000",
    "label": "山西省", "value": "山西省",
    "children": [{
        "cityCode": "140100",
        "label": "太原市", "value": "太原市",
        "children": [{
            "cityCode": "140105",
            "label": "小店区", "value": "小店区",
            "pcode": "140100"
        },
        {
            "cityCode": "140106",
            "label": "迎泽区", "value": "迎泽区",
            "pcode": "140100"
        },
        {
            "cityCode": "140107",
            "label": "杏花岭区", "value": "杏花岭区",
            "pcode": "140100"
        },
        {
            "cityCode": "140108",
            "label": "尖草坪区", "value": "尖草坪区",
            "pcode": "140100"
        },
        {
            "cityCode": "140109",
            "label": "万柏林区", "value": "万柏林区",
            "pcode": "140100"
        },
        {
            "cityCode": "140110",
            "label": "晋源区", "value": "晋源区",
            "pcode": "140100"
        },
        {
            "cityCode": "140121",
            "label": "清徐县", "value": "清徐县",
            "pcode": "140100"
        },
        {
            "cityCode": "140122",
            "label": "阳曲县", "value": "阳曲县",
            "pcode": "140100"
        },
        {
            "cityCode": "140123",
            "label": "娄烦县", "value": "娄烦县",
            "pcode": "140100"
        },
        {
            "cityCode": "140181",
            "label": "古交市", "value": "古交市",
            "pcode": "140100"
        }],
        "pcode": "140000"
    },
    {
        "cityCode": "140200",
        "label": "大同市", "value": "大同市",
        "children": [{
            "cityCode": "140202",
            "label": "城区", "value": "城区",
            "pcode": "140200"
        },
        {
            "cityCode": "140203",
            "label": "矿区", "value": "矿区",
            "pcode": "140200"
        },
        {
            "cityCode": "140211",
            "label": "南郊区", "value": "南郊区",
            "pcode": "140200"
        },
        {
            "cityCode": "140212",
            "label": "新荣区", "value": "新荣区",
            "pcode": "140200"
        },
        {
            "cityCode": "140221",
            "label": "阳高县", "value": "阳高县",
            "pcode": "140200"
        },
        {
            "cityCode": "140222",
            "label": "天镇县", "value": "天镇县",
            "pcode": "140200"
        },
        {
            "cityCode": "140223",
            "label": "广灵县", "value": "广灵县",
            "pcode": "140200"
        },
        {
            "cityCode": "140224",
            "label": "灵丘县", "value": "灵丘县",
            "pcode": "140200"
        },
        {
            "cityCode": "140225",
            "label": "浑源县", "value": "浑源县",
            "pcode": "140200"
        },
        {
            "cityCode": "140226",
            "label": "左云县", "value": "左云县",
            "pcode": "140200"
        },
        {
            "cityCode": "140271",
            "label": "大同县", "value": "大同县",
            "pcode": "140200"
        }],
        "pcode": "140000"
    },
    {
        "cityCode": "140300",
        "label": "阳泉市", "value": "阳泉市",
        "children": [{
            "cityCode": "140302",
            "label": "城区", "value": "城区",
            "pcode": "140300"
        },
        {
            "cityCode": "140303",
            "label": "矿区", "value": "矿区",
            "pcode": "140300"
        },
        {
            "cityCode": "140311",
            "label": "郊区", "value": "郊区",
            "pcode": "140300"
        },
        {
            "cityCode": "140321",
            "label": "平定县", "value": "平定县",
            "pcode": "140300"
        },
        {
            "cityCode": "140322",
            "label": "盂县", "value": "盂县",
            "pcode": "140300"
        }],
        "pcode": "140000"
    },
    {
        "cityCode": "140400",
        "label": "长治市", "value": "长治市",
        "children": [{
            "cityCode": "140402",
            "label": "城区", "value": "城区",
            "pcode": "140400"
        },
        {
            "cityCode": "140411",
            "label": "郊区", "value": "郊区",
            "pcode": "140400"
        },
        {
            "cityCode": "140421",
            "label": "长治县", "value": "长治县",
            "pcode": "140400"
        },
        {
            "cityCode": "140423",
            "label": "襄垣县", "value": "襄垣县",
            "pcode": "140400"
        },
        {
            "cityCode": "140424",
            "label": "屯留县", "value": "屯留县",
            "pcode": "140400"
        },
        {
            "cityCode": "140425",
            "label": "平顺县", "value": "平顺县",
            "pcode": "140400"
        },
        {
            "cityCode": "140426",
            "label": "黎城县", "value": "黎城县",
            "pcode": "140400"
        },
        {
            "cityCode": "140427",
            "label": "壶关县", "value": "壶关县",
            "pcode": "140400"
        },
        {
            "cityCode": "140428",
            "label": "长子县", "value": "长子县",
            "pcode": "140400"
        },
        {
            "cityCode": "140429",
            "label": "武乡县", "value": "武乡县",
            "pcode": "140400"
        },
        {
            "cityCode": "140430",
            "label": "沁县", "value": "沁县",
            "pcode": "140400"
        },
        {
            "cityCode": "140431",
            "label": "沁源县", "value": "沁源县",
            "pcode": "140400"
        },
        {
            "cityCode": "140481",
            "label": "潞城市", "value": "潞城市",
            "pcode": "140400"
        }],
        "pcode": "140000"
    },
    {
        "cityCode": "140500",
        "label": "晋城市", "value": "晋城市",
        "children": [{
            "cityCode": "140502",
            "label": "城区", "value": "城区",
            "pcode": "140500"
        },
        {
            "cityCode": "140521",
            "label": "沁水县", "value": "沁水县",
            "pcode": "140500"
        },
        {
            "cityCode": "140522",
            "label": "阳城县", "value": "阳城县",
            "pcode": "140500"
        },
        {
            "cityCode": "140524",
            "label": "陵川县", "value": "陵川县",
            "pcode": "140500"
        },
        {
            "cityCode": "140525",
            "label": "泽州县", "value": "泽州县",
            "pcode": "140500"
        },
        {
            "cityCode": "140581",
            "label": "高平市", "value": "高平市",
            "pcode": "140500"
        }],
        "pcode": "140000"
    },
    {
        "cityCode": "140600",
        "label": "朔州市", "value": "朔州市",
        "children": [{
            "cityCode": "140602",
            "label": "朔城区", "value": "朔城区",
            "pcode": "140600"
        },
        {
            "cityCode": "140603",
            "label": "平鲁区", "value": "平鲁区",
            "pcode": "140600"
        },
        {
            "cityCode": "140621",
            "label": "山阴县", "value": "山阴县",
            "pcode": "140600"
        },
        {
            "cityCode": "140622",
            "label": "应县", "value": "应县",
            "pcode": "140600"
        },
        {
            "cityCode": "140623",
            "label": "右玉县", "value": "右玉县",
            "pcode": "140600"
        },
        {
            "cityCode": "140624",
            "label": "怀仁县", "value": "怀仁县",
            "pcode": "140600"
        }],
        "pcode": "140000"
    },
    {
        "cityCode": "140700",
        "label": "晋中市", "value": "晋中市",
        "children": [{
            "cityCode": "140702",
            "label": "榆次区", "value": "榆次区",
            "pcode": "140700"
        },
        {
            "cityCode": "140721",
            "label": "榆社县", "value": "榆社县",
            "pcode": "140700"
        },
        {
            "cityCode": "140722",
            "label": "左权县", "value": "左权县",
            "pcode": "140700"
        },
        {
            "cityCode": "140723",
            "label": "和顺县", "value": "和顺县",
            "pcode": "140700"
        },
        {
            "cityCode": "140724",
            "label": "昔阳县", "value": "昔阳县",
            "pcode": "140700"
        },
        {
            "cityCode": "140725",
            "label": "寿阳县", "value": "寿阳县",
            "pcode": "140700"
        },
        {
            "cityCode": "140726",
            "label": "太谷县", "value": "太谷县",
            "pcode": "140700"
        },
        {
            "cityCode": "140727",
            "label": "祁县", "value": "祁县",
            "pcode": "140700"
        },
        {
            "cityCode": "140728",
            "label": "平遥县", "value": "平遥县",
            "pcode": "140700"
        },
        {
            "cityCode": "140729",
            "label": "灵石县", "value": "灵石县",
            "pcode": "140700"
        },
        {
            "cityCode": "140781",
            "label": "介休市", "value": "介休市",
            "pcode": "140700"
        }],
        "pcode": "140000"
    },
    {
        "cityCode": "140800",
        "label": "运城市", "value": "运城市",
        "children": [{
            "cityCode": "140802",
            "label": "盐湖区", "value": "盐湖区",
            "pcode": "140800"
        },
        {
            "cityCode": "140821",
            "label": "临猗县", "value": "临猗县",
            "pcode": "140800"
        },
        {
            "cityCode": "140822",
            "label": "万荣县", "value": "万荣县",
            "pcode": "140800"
        },
        {
            "cityCode": "140823",
            "label": "闻喜县", "value": "闻喜县",
            "pcode": "140800"
        },
        {
            "cityCode": "140824",
            "label": "稷山县", "value": "稷山县",
            "pcode": "140800"
        },
        {
            "cityCode": "140825",
            "label": "新绛县", "value": "新绛县",
            "pcode": "140800"
        },
        {
            "cityCode": "140826",
            "label": "绛县", "value": "绛县",
            "pcode": "140800"
        },
        {
            "cityCode": "140827",
            "label": "垣曲县", "value": "垣曲县",
            "pcode": "140800"
        },
        {
            "cityCode": "140828",
            "label": "夏县", "value": "夏县",
            "pcode": "140800"
        },
        {
            "cityCode": "140829",
            "label": "平陆县", "value": "平陆县",
            "pcode": "140800"
        },
        {
            "cityCode": "140830",
            "label": "芮城县", "value": "芮城县",
            "pcode": "140800"
        },
        {
            "cityCode": "140881",
            "label": "永济市", "value": "永济市",
            "pcode": "140800"
        },
        {
            "cityCode": "140882",
            "label": "河津市", "value": "河津市",
            "pcode": "140800"
        }],
        "pcode": "140000"
    },
    {
        "cityCode": "140900",
        "label": "忻州市", "value": "忻州市",
        "children": [{
            "cityCode": "140902",
            "label": "忻府区", "value": "忻府区",
            "pcode": "140900"
        },
        {
            "cityCode": "140921",
            "label": "定襄县", "value": "定襄县",
            "pcode": "140900"
        },
        {
            "cityCode": "140922",
            "label": "五台县", "value": "五台县",
            "pcode": "140900"
        },
        {
            "cityCode": "140923",
            "label": "代县", "value": "代县",
            "pcode": "140900"
        },
        {
            "cityCode": "140924",
            "label": "繁峙县", "value": "繁峙县",
            "pcode": "140900"
        },
        {
            "cityCode": "140925",
            "label": "宁武县", "value": "宁武县",
            "pcode": "140900"
        },
        {
            "cityCode": "140926",
            "label": "静乐县", "value": "静乐县",
            "pcode": "140900"
        },
        {
            "cityCode": "140927",
            "label": "神池县", "value": "神池县",
            "pcode": "140900"
        },
        {
            "cityCode": "140928",
            "label": "五寨县", "value": "五寨县",
            "pcode": "140900"
        },
        {
            "cityCode": "140929",
            "label": "岢岚县", "value": "岢岚县",
            "pcode": "140900"
        },
        {
            "cityCode": "140930",
            "label": "河曲县", "value": "河曲县",
            "pcode": "140900"
        },
        {
            "cityCode": "140931",
            "label": "保德县", "value": "保德县",
            "pcode": "140900"
        },
        {
            "cityCode": "140932",
            "label": "偏关县", "value": "偏关县",
            "pcode": "140900"
        },
        {
            "cityCode": "140981",
            "label": "原平市", "value": "原平市",
            "pcode": "140900"
        }],
        "pcode": "140000"
    },
    {
        "cityCode": "141000",
        "label": "临汾市", "value": "临汾市",
        "children": [{
            "cityCode": "141002",
            "label": "尧都区", "value": "尧都区",
            "pcode": "141000"
        },
        {
            "cityCode": "141021",
            "label": "曲沃县", "value": "曲沃县",
            "pcode": "141000"
        },
        {
            "cityCode": "141022",
            "label": "翼城县", "value": "翼城县",
            "pcode": "141000"
        },
        {
            "cityCode": "141023",
            "label": "襄汾县", "value": "襄汾县",
            "pcode": "141000"
        },
        {
            "cityCode": "141024",
            "label": "洪洞县", "value": "洪洞县",
            "pcode": "141000"
        },
        {
            "cityCode": "141025",
            "label": "古县", "value": "古县",
            "pcode": "141000"
        },
        {
            "cityCode": "141026",
            "label": "安泽县", "value": "安泽县",
            "pcode": "141000"
        },
        {
            "cityCode": "141027",
            "label": "浮山县", "value": "浮山县",
            "pcode": "141000"
        },
        {
            "cityCode": "141028",
            "label": "吉县", "value": "吉县",
            "pcode": "141000"
        },
        {
            "cityCode": "141029",
            "label": "乡宁县", "value": "乡宁县",
            "pcode": "141000"
        },
        {
            "cityCode": "141030",
            "label": "大宁县", "value": "大宁县",
            "pcode": "141000"
        },
        {
            "cityCode": "141031",
            "label": "隰县", "value": "隰县",
            "pcode": "141000"
        },
        {
            "cityCode": "141032",
            "label": "永和县", "value": "永和县",
            "pcode": "141000"
        },
        {
            "cityCode": "141033",
            "label": "蒲县", "value": "蒲县",
            "pcode": "141000"
        },
        {
            "cityCode": "141034",
            "label": "汾西县", "value": "汾西县",
            "pcode": "141000"
        },
        {
            "cityCode": "141081",
            "label": "侯马市", "value": "侯马市",
            "pcode": "141000"
        },
        {
            "cityCode": "141082",
            "label": "霍州市", "value": "霍州市",
            "pcode": "141000"
        }],
        "pcode": "140000"
    },
    {
        "cityCode": "141100",
        "label": "吕梁市", "value": "吕梁市",
        "children": [{
            "cityCode": "141102",
            "label": "离石区", "value": "离石区",
            "pcode": "141100"
        },
        {
            "cityCode": "141121",
            "label": "文水县", "value": "文水县",
            "pcode": "141100"
        },
        {
            "cityCode": "141122",
            "label": "交城县", "value": "交城县",
            "pcode": "141100"
        },
        {
            "cityCode": "141123",
            "label": "兴县", "value": "兴县",
            "pcode": "141100"
        },
        {
            "cityCode": "141124",
            "label": "临县", "value": "临县",
            "pcode": "141100"
        },
        {
            "cityCode": "141125",
            "label": "柳林县", "value": "柳林县",
            "pcode": "141100"
        },
        {
            "cityCode": "141126",
            "label": "石楼县", "value": "石楼县",
            "pcode": "141100"
        },
        {
            "cityCode": "141127",
            "label": "岚县", "value": "岚县",
            "pcode": "141100"
        },
        {
            "cityCode": "141128",
            "label": "方山县", "value": "方山县",
            "pcode": "141100"
        },
        {
            "cityCode": "141129",
            "label": "中阳县", "value": "中阳县",
            "pcode": "141100"
        },
        {
            "cityCode": "141130",
            "label": "交口县", "value": "交口县",
            "pcode": "141100"
        },
        {
            "cityCode": "141181",
            "label": "孝义市", "value": "孝义市",
            "pcode": "141100"
        },
        {
            "cityCode": "141182",
            "label": "汾阳市", "value": "汾阳市",
            "pcode": "141100"
        }],
        "pcode": "140000"
    }]
},
{
    "cityCode": "150000",
    "label": "内蒙古自治区", "value": "内蒙古自治区",
    "children": [{
        "cityCode": "150100",
        "label": "呼和浩特市", "value": "呼和浩特市",
        "children": [{
            "cityCode": "150102",
            "label": "新城区", "value": "新城区",
            "pcode": "150100"
        },
        {
            "cityCode": "150103",
            "label": "回民区", "value": "回民区",
            "pcode": "150100"
        },
        {
            "cityCode": "150104",
            "label": "玉泉区", "value": "玉泉区",
            "pcode": "150100"
        },
        {
            "cityCode": "150105",
            "label": "赛罕区", "value": "赛罕区",
            "pcode": "150100"
        },
        {
            "cityCode": "150121",
            "label": "土默特左旗", "value": "土默特左旗",
            "pcode": "150100"
        },
        {
            "cityCode": "150122",
            "label": "托克托县", "value": "托克托县",
            "pcode": "150100"
        },
        {
            "cityCode": "150123",
            "label": "和林格尔县", "value": "和林格尔县",
            "pcode": "150100"
        },
        {
            "cityCode": "150124",
            "label": "清水河县", "value": "清水河县",
            "pcode": "150100"
        },
        {
            "cityCode": "150125",
            "label": "武川县", "value": "武川县",
            "pcode": "150100"
        }],
        "pcode": "150000"
    },
    {
        "cityCode": "150200",
        "label": "包头市", "value": "包头市",
        "children": [{
            "cityCode": "150202",
            "label": "东河区", "value": "东河区",
            "pcode": "150200"
        },
        {
            "cityCode": "150203",
            "label": "昆都仑区", "value": "昆都仑区",
            "pcode": "150200"
        },
        {
            "cityCode": "150204",
            "label": "青山区", "value": "青山区",
            "pcode": "150200"
        },
        {
            "cityCode": "150205",
            "label": "石拐区", "value": "石拐区",
            "pcode": "150200"
        },
        {
            "cityCode": "150206",
            "label": "白云鄂博矿区", "value": "白云鄂博矿区",
            "pcode": "150200"
        },
        {
            "cityCode": "150207",
            "label": "九原区", "value": "九原区",
            "pcode": "150200"
        },
        {
            "cityCode": "150221",
            "label": "土默特右旗", "value": "土默特右旗",
            "pcode": "150200"
        },
        {
            "cityCode": "150222",
            "label": "固阳县", "value": "固阳县",
            "pcode": "150200"
        },
        {
            "cityCode": "150223",
            "label": "达尔罕茂明安联合旗", "value": "达尔罕茂明安联合旗",
            "pcode": "150200"
        }],
        "pcode": "150000"
    },
    {
        "cityCode": "150300",
        "label": "乌海市", "value": "乌海市",
        "children": [{
            "cityCode": "150302",
            "label": "海勃湾区", "value": "海勃湾区",
            "pcode": "150300"
        },
        {
            "cityCode": "150303",
            "label": "海南区", "value": "海南区",
            "pcode": "150300"
        },
        {
            "cityCode": "150304",
            "label": "乌达区", "value": "乌达区",
            "pcode": "150300"
        }],
        "pcode": "150000"
    },
    {
        "cityCode": "150400",
        "label": "赤峰市", "value": "赤峰市",
        "children": [{
            "cityCode": "150402",
            "label": "红山区", "value": "红山区",
            "pcode": "150400"
        },
        {
            "cityCode": "150403",
            "label": "元宝山区", "value": "元宝山区",
            "pcode": "150400"
        },
        {
            "cityCode": "150404",
            "label": "松山区", "value": "松山区",
            "pcode": "150400"
        },
        {
            "cityCode": "150421",
            "label": "阿鲁科尔沁旗", "value": "阿鲁科尔沁旗",
            "pcode": "150400"
        },
        {
            "cityCode": "150422",
            "label": "巴林左旗", "value": "巴林左旗",
            "pcode": "150400"
        },
        {
            "cityCode": "150423",
            "label": "巴林右旗", "value": "巴林右旗",
            "pcode": "150400"
        },
        {
            "cityCode": "150424",
            "label": "林西县", "value": "林西县",
            "pcode": "150400"
        },
        {
            "cityCode": "150425",
            "label": "克什克腾旗", "value": "克什克腾旗",
            "pcode": "150400"
        },
        {
            "cityCode": "150426",
            "label": "翁牛特旗", "value": "翁牛特旗",
            "pcode": "150400"
        },
        {
            "cityCode": "150428",
            "label": "喀喇沁旗", "value": "喀喇沁旗",
            "pcode": "150400"
        },
        {
            "cityCode": "150429",
            "label": "宁城县", "value": "宁城县",
            "pcode": "150400"
        },
        {
            "cityCode": "150430",
            "label": "敖汉旗", "value": "敖汉旗",
            "pcode": "150400"
        }],
        "pcode": "150000"
    },
    {
        "cityCode": "150500",
        "label": "通辽市", "value": "通辽市",
        "children": [{
            "cityCode": "150502",
            "label": "科尔沁区", "value": "科尔沁区",
            "pcode": "150500"
        },
        {
            "cityCode": "150521",
            "label": "科尔沁左翼中旗", "value": "科尔沁左翼中旗",
            "pcode": "150500"
        },
        {
            "cityCode": "150522",
            "label": "科尔沁左翼后旗", "value": "科尔沁左翼后旗",
            "pcode": "150500"
        },
        {
            "cityCode": "150523",
            "label": "开鲁县", "value": "开鲁县",
            "pcode": "150500"
        },
        {
            "cityCode": "150524",
            "label": "库伦旗", "value": "库伦旗",
            "pcode": "150500"
        },
        {
            "cityCode": "150525",
            "label": "奈曼旗", "value": "奈曼旗",
            "pcode": "150500"
        },
        {
            "cityCode": "150526",
            "label": "扎鲁特旗", "value": "扎鲁特旗",
            "pcode": "150500"
        },
        {
            "cityCode": "150581",
            "label": "霍林郭勒市", "value": "霍林郭勒市",
            "pcode": "150500"
        }],
        "pcode": "150000"
    },
    {
        "cityCode": "150600",
        "label": "鄂尔多斯市", "value": "鄂尔多斯市",
        "children": [{
            "cityCode": "150602",
            "label": "东胜区", "value": "东胜区",
            "pcode": "150600"
        },
        {
            "cityCode": "150603",
            "label": "康巴什区", "value": "康巴什区",
            "pcode": "150600"
        },
        {
            "cityCode": "150621",
            "label": "达拉特旗", "value": "达拉特旗",
            "pcode": "150600"
        },
        {
            "cityCode": "150622",
            "label": "准格尔旗", "value": "准格尔旗",
            "pcode": "150600"
        },
        {
            "cityCode": "150623",
            "label": "鄂托克前旗", "value": "鄂托克前旗",
            "pcode": "150600"
        },
        {
            "cityCode": "150624",
            "label": "鄂托克旗", "value": "鄂托克旗",
            "pcode": "150600"
        },
        {
            "cityCode": "150625",
            "label": "杭锦旗", "value": "杭锦旗",
            "pcode": "150600"
        },
        {
            "cityCode": "150626",
            "label": "乌审旗", "value": "乌审旗",
            "pcode": "150600"
        },
        {
            "cityCode": "150627",
            "label": "伊金霍洛旗", "value": "伊金霍洛旗",
            "pcode": "150600"
        }],
        "pcode": "150000"
    },
    {
        "cityCode": "150700",
        "label": "呼伦贝尔市", "value": "呼伦贝尔市",
        "children": [{
            "cityCode": "150702",
            "label": "海拉尔区", "value": "海拉尔区",
            "pcode": "150700"
        },
        {
            "cityCode": "150703",
            "label": "扎赉诺尔区", "value": "扎赉诺尔区",
            "pcode": "150700"
        },
        {
            "cityCode": "150721",
            "label": "阿荣旗", "value": "阿荣旗",
            "pcode": "150700"
        },
        {
            "cityCode": "150722",
            "label": "莫力达瓦达斡尔族自治旗", "value": "莫力达瓦达斡尔族自治旗",
            "pcode": "150700"
        },
        {
            "cityCode": "150723",
            "label": "鄂伦春自治旗", "value": "鄂伦春自治旗",
            "pcode": "150700"
        },
        {
            "cityCode": "150724",
            "label": "鄂温克族自治旗", "value": "鄂温克族自治旗",
            "pcode": "150700"
        },
        {
            "cityCode": "150725",
            "label": "陈巴尔虎旗", "value": "陈巴尔虎旗",
            "pcode": "150700"
        },
        {
            "cityCode": "150726",
            "label": "新巴尔虎左旗", "value": "新巴尔虎左旗",
            "pcode": "150700"
        },
        {
            "cityCode": "150727",
            "label": "新巴尔虎右旗", "value": "新巴尔虎右旗",
            "pcode": "150700"
        },
        {
            "cityCode": "150781",
            "label": "满洲里市", "value": "满洲里市",
            "pcode": "150700"
        },
        {
            "cityCode": "150782",
            "label": "牙克石市", "value": "牙克石市",
            "pcode": "150700"
        },
        {
            "cityCode": "150783",
            "label": "扎兰屯市", "value": "扎兰屯市",
            "pcode": "150700"
        },
        {
            "cityCode": "150784",
            "label": "额尔古纳市", "value": "额尔古纳市",
            "pcode": "150700"
        },
        {
            "cityCode": "150785",
            "label": "根河市", "value": "根河市",
            "pcode": "150700"
        }],
        "pcode": "150000"
    },
    {
        "cityCode": "150800",
        "label": "巴彦淖尔市", "value": "巴彦淖尔市",
        "children": [{
            "cityCode": "150802",
            "label": "临河区", "value": "临河区",
            "pcode": "150800"
        },
        {
            "cityCode": "150821",
            "label": "五原县", "value": "五原县",
            "pcode": "150800"
        },
        {
            "cityCode": "150822",
            "label": "磴口县", "value": "磴口县",
            "pcode": "150800"
        },
        {
            "cityCode": "150823",
            "label": "乌拉特前旗", "value": "乌拉特前旗",
            "pcode": "150800"
        },
        {
            "cityCode": "150824",
            "label": "乌拉特中旗", "value": "乌拉特中旗",
            "pcode": "150800"
        },
        {
            "cityCode": "150825",
            "label": "乌拉特后旗", "value": "乌拉特后旗",
            "pcode": "150800"
        },
        {
            "cityCode": "150826",
            "label": "杭锦后旗", "value": "杭锦后旗",
            "pcode": "150800"
        }],
        "pcode": "150000"
    },
    {
        "cityCode": "150900",
        "label": "乌兰察布市", "value": "乌兰察布市",
        "children": [{
            "cityCode": "150902",
            "label": "集宁区", "value": "集宁区",
            "pcode": "150900"
        },
        {
            "cityCode": "150921",
            "label": "卓资县", "value": "卓资县",
            "pcode": "150900"
        },
        {
            "cityCode": "150922",
            "label": "化德县", "value": "化德县",
            "pcode": "150900"
        },
        {
            "cityCode": "150923",
            "label": "商都县", "value": "商都县",
            "pcode": "150900"
        },
        {
            "cityCode": "150924",
            "label": "兴和县", "value": "兴和县",
            "pcode": "150900"
        },
        {
            "cityCode": "150925",
            "label": "凉城县", "value": "凉城县",
            "pcode": "150900"
        },
        {
            "cityCode": "150926",
            "label": "察哈尔右翼前旗", "value": "察哈尔右翼前旗",
            "pcode": "150900"
        },
        {
            "cityCode": "150927",
            "label": "察哈尔右翼中旗", "value": "察哈尔右翼中旗",
            "pcode": "150900"
        },
        {
            "cityCode": "150928",
            "label": "察哈尔右翼后旗", "value": "察哈尔右翼后旗",
            "pcode": "150900"
        },
        {
            "cityCode": "150929",
            "label": "四子王旗", "value": "四子王旗",
            "pcode": "150900"
        },
        {
            "cityCode": "150981",
            "label": "丰镇市", "value": "丰镇市",
            "pcode": "150900"
        }],
        "pcode": "150000"
    },
    {
        "cityCode": "152200",
        "label": "兴安盟", "value": "兴安盟",
        "children": [{
            "cityCode": "152201",
            "label": "乌兰浩特市", "value": "乌兰浩特市",
            "pcode": "152200"
        },
        {
            "cityCode": "152202",
            "label": "阿尔山市", "value": "阿尔山市",
            "pcode": "152200"
        },
        {
            "cityCode": "152221",
            "label": "科尔沁右翼前旗", "value": "科尔沁右翼前旗",
            "pcode": "152200"
        },
        {
            "cityCode": "152222",
            "label": "科尔沁右翼中旗", "value": "科尔沁右翼中旗",
            "pcode": "152200"
        },
        {
            "cityCode": "152223",
            "label": "扎赉特旗", "value": "扎赉特旗",
            "pcode": "152200"
        },
        {
            "cityCode": "152224",
            "label": "突泉县", "value": "突泉县",
            "pcode": "152200"
        }],
        "pcode": "150000"
    },
    {
        "cityCode": "152500",
        "label": "锡林郭勒盟", "value": "锡林郭勒盟",
        "children": [{
            "cityCode": "152501",
            "label": "二连浩特市", "value": "二连浩特市",
            "pcode": "152500"
        },
        {
            "cityCode": "152502",
            "label": "锡林浩特市", "value": "锡林浩特市",
            "pcode": "152500"
        },
        {
            "cityCode": "152522",
            "label": "阿巴嘎旗", "value": "阿巴嘎旗",
            "pcode": "152500"
        },
        {
            "cityCode": "152523",
            "label": "苏尼特左旗", "value": "苏尼特左旗",
            "pcode": "152500"
        },
        {
            "cityCode": "152524",
            "label": "苏尼特右旗", "value": "苏尼特右旗",
            "pcode": "152500"
        },
        {
            "cityCode": "152525",
            "label": "东乌珠穆沁旗", "value": "东乌珠穆沁旗",
            "pcode": "152500"
        },
        {
            "cityCode": "152526",
            "label": "西乌珠穆沁旗", "value": "西乌珠穆沁旗",
            "pcode": "152500"
        },
        {
            "cityCode": "152527",
            "label": "太仆寺旗", "value": "太仆寺旗",
            "pcode": "152500"
        },
        {
            "cityCode": "152528",
            "label": "镶黄旗", "value": "镶黄旗",
            "pcode": "152500"
        },
        {
            "cityCode": "152529",
            "label": "正镶白旗", "value": "正镶白旗",
            "pcode": "152500"
        },
        {
            "cityCode": "152530",
            "label": "正蓝旗", "value": "正蓝旗",
            "pcode": "152500"
        },
        {
            "cityCode": "152531",
            "label": "多伦县", "value": "多伦县",
            "pcode": "152500"
        }],
        "pcode": "150000"
    },
    {
        "cityCode": "152900",
        "label": "阿拉善盟", "value": "阿拉善盟",
        "children": [{
            "cityCode": "152921",
            "label": "阿拉善左旗", "value": "阿拉善左旗",
            "pcode": "152900"
        },
        {
            "cityCode": "152922",
            "label": "阿拉善右旗", "value": "阿拉善右旗",
            "pcode": "152900"
        },
        {
            "cityCode": "152923",
            "label": "额济纳旗", "value": "额济纳旗",
            "pcode": "152900"
        }],
        "pcode": "150000"
    }]
},
{
    "cityCode": "210000",
    "label": "辽宁省", "value": "辽宁省",
    "children": [{
        "cityCode": "210100",
        "label": "沈阳市", "value": "沈阳市",
        "children": [{
            "cityCode": "210102",
            "label": "和平区", "value": "和平区",
            "pcode": "210100"
        },
        {
            "cityCode": "210103",
            "label": "沈河区", "value": "沈河区",
            "pcode": "210100"
        },
        {
            "cityCode": "210104",
            "label": "大东区", "value": "大东区",
            "pcode": "210100"
        },
        {
            "cityCode": "210105",
            "label": "皇姑区", "value": "皇姑区",
            "pcode": "210100"
        },
        {
            "cityCode": "210106",
            "label": "铁西区", "value": "铁西区",
            "pcode": "210100"
        },
        {
            "cityCode": "210111",
            "label": "苏家屯区", "value": "苏家屯区",
            "pcode": "210100"
        },
        {
            "cityCode": "210112",
            "label": "浑南区", "value": "浑南区",
            "pcode": "210100"
        },
        {
            "cityCode": "210113",
            "label": "沈北新区", "value": "沈北新区",
            "pcode": "210100"
        },
        {
            "cityCode": "210114",
            "label": "于洪区", "value": "于洪区",
            "pcode": "210100"
        },
        {
            "cityCode": "210115",
            "label": "辽中区", "value": "辽中区",
            "pcode": "210100"
        },
        {
            "cityCode": "210123",
            "label": "康平县", "value": "康平县",
            "pcode": "210100"
        },
        {
            "cityCode": "210124",
            "label": "法库县", "value": "法库县",
            "pcode": "210100"
        },
        {
            "cityCode": "210181",
            "label": "新民市", "value": "新民市",
            "pcode": "210100"
        }],
        "pcode": "210000"
    },
    {
        "cityCode": "210200",
        "label": "大连市", "value": "大连市",
        "children": [{
            "cityCode": "210202",
            "label": "中山区", "value": "中山区",
            "pcode": "210200"
        },
        {
            "cityCode": "210203",
            "label": "西岗区", "value": "西岗区",
            "pcode": "210200"
        },
        {
            "cityCode": "210204",
            "label": "沙河口区", "value": "沙河口区",
            "pcode": "210200"
        },
        {
            "cityCode": "210211",
            "label": "甘井子区", "value": "甘井子区",
            "pcode": "210200"
        },
        {
            "cityCode": "210212",
            "label": "旅顺口区", "value": "旅顺口区",
            "pcode": "210200"
        },
        {
            "cityCode": "210213",
            "label": "金州区", "value": "金州区",
            "pcode": "210200"
        },
        {
            "cityCode": "210214",
            "label": "普兰店区", "value": "普兰店区",
            "pcode": "210200"
        },
        {
            "cityCode": "210224",
            "label": "长海县", "value": "长海县",
            "pcode": "210200"
        },
        {
            "cityCode": "210281",
            "label": "瓦房店市", "value": "瓦房店市",
            "pcode": "210200"
        },
        {
            "cityCode": "210283",
            "label": "庄河市", "value": "庄河市",
            "pcode": "210200"
        }],
        "pcode": "210000"
    },
    {
        "cityCode": "210300",
        "label": "鞍山市", "value": "鞍山市",
        "children": [{
            "cityCode": "210302",
            "label": "铁东区", "value": "铁东区",
            "pcode": "210300"
        },
        {
            "cityCode": "210303",
            "label": "铁西区", "value": "铁西区",
            "pcode": "210300"
        },
        {
            "cityCode": "210304",
            "label": "立山区", "value": "立山区",
            "pcode": "210300"
        },
        {
            "cityCode": "210311",
            "label": "千山区", "value": "千山区",
            "pcode": "210300"
        },
        {
            "cityCode": "210321",
            "label": "台安县", "value": "台安县",
            "pcode": "210300"
        },
        {
            "cityCode": "210323",
            "label": "岫岩满族自治县", "value": "岫岩满族自治县",
            "pcode": "210300"
        },
        {
            "cityCode": "210381",
            "label": "海城市", "value": "海城市",
            "pcode": "210300"
        }],
        "pcode": "210000"
    },
    {
        "cityCode": "210400",
        "label": "抚顺市", "value": "抚顺市",
        "children": [{
            "cityCode": "210402",
            "label": "新抚区", "value": "新抚区",
            "pcode": "210400"
        },
        {
            "cityCode": "210403",
            "label": "东洲区", "value": "东洲区",
            "pcode": "210400"
        },
        {
            "cityCode": "210404",
            "label": "望花区", "value": "望花区",
            "pcode": "210400"
        },
        {
            "cityCode": "210411",
            "label": "顺城区", "value": "顺城区",
            "pcode": "210400"
        },
        {
            "cityCode": "210421",
            "label": "抚顺县", "value": "抚顺县",
            "pcode": "210400"
        },
        {
            "cityCode": "210422",
            "label": "新宾满族自治县", "value": "新宾满族自治县",
            "pcode": "210400"
        },
        {
            "cityCode": "210423",
            "label": "清原满族自治县", "value": "清原满族自治县",
            "pcode": "210400"
        }],
        "pcode": "210000"
    },
    {
        "cityCode": "210500",
        "label": "本溪市", "value": "本溪市",
        "children": [{
            "cityCode": "210502",
            "label": "平山区", "value": "平山区",
            "pcode": "210500"
        },
        {
            "cityCode": "210503",
            "label": "溪湖区", "value": "溪湖区",
            "pcode": "210500"
        },
        {
            "cityCode": "210504",
            "label": "明山区", "value": "明山区",
            "pcode": "210500"
        },
        {
            "cityCode": "210505",
            "label": "南芬区", "value": "南芬区",
            "pcode": "210500"
        },
        {
            "cityCode": "210521",
            "label": "本溪满族自治县", "value": "本溪满族自治县",
            "pcode": "210500"
        },
        {
            "cityCode": "210522",
            "label": "桓仁满族自治县", "value": "桓仁满族自治县",
            "pcode": "210500"
        }],
        "pcode": "210000"
    },
    {
        "cityCode": "210600",
        "label": "丹东市", "value": "丹东市",
        "children": [{
            "cityCode": "210602",
            "label": "元宝区", "value": "元宝区",
            "pcode": "210600"
        },
        {
            "cityCode": "210603",
            "label": "振兴区", "value": "振兴区",
            "pcode": "210600"
        },
        {
            "cityCode": "210604",
            "label": "振安区", "value": "振安区",
            "pcode": "210600"
        },
        {
            "cityCode": "210624",
            "label": "宽甸满族自治县", "value": "宽甸满族自治县",
            "pcode": "210600"
        },
        {
            "cityCode": "210681",
            "label": "东港市", "value": "东港市",
            "pcode": "210600"
        },
        {
            "cityCode": "210682",
            "label": "凤城市", "value": "凤城市",
            "pcode": "210600"
        }],
        "pcode": "210000"
    },
    {
        "cityCode": "210700",
        "label": "锦州市", "value": "锦州市",
        "children": [{
            "cityCode": "210702",
            "label": "古塔区", "value": "古塔区",
            "pcode": "210700"
        },
        {
            "cityCode": "210703",
            "label": "凌河区", "value": "凌河区",
            "pcode": "210700"
        },
        {
            "cityCode": "210711",
            "label": "太和区", "value": "太和区",
            "pcode": "210700"
        },
        {
            "cityCode": "210726",
            "label": "黑山县", "value": "黑山县",
            "pcode": "210700"
        },
        {
            "cityCode": "210727",
            "label": "义县", "value": "义县",
            "pcode": "210700"
        },
        {
            "cityCode": "210781",
            "label": "凌海市", "value": "凌海市",
            "pcode": "210700"
        },
        {
            "cityCode": "210782",
            "label": "北镇市", "value": "北镇市",
            "pcode": "210700"
        }],
        "pcode": "210000"
    },
    {
        "cityCode": "210800",
        "label": "营口市", "value": "营口市",
        "children": [{
            "cityCode": "210802",
            "label": "站前区", "value": "站前区",
            "pcode": "210800"
        },
        {
            "cityCode": "210803",
            "label": "西市区", "value": "西市区",
            "pcode": "210800"
        },
        {
            "cityCode": "210804",
            "label": "鲅鱼圈区", "value": "鲅鱼圈区",
            "pcode": "210800"
        },
        {
            "cityCode": "210811",
            "label": "老边区", "value": "老边区",
            "pcode": "210800"
        },
        {
            "cityCode": "210881",
            "label": "盖州市", "value": "盖州市",
            "pcode": "210800"
        },
        {
            "cityCode": "210882",
            "label": "大石桥市", "value": "大石桥市",
            "pcode": "210800"
        }],
        "pcode": "210000"
    },
    {
        "cityCode": "210900",
        "label": "阜新市", "value": "阜新市",
        "children": [{
            "cityCode": "210902",
            "label": "海州区", "value": "海州区",
            "pcode": "210900"
        },
        {
            "cityCode": "210903",
            "label": "新邱区", "value": "新邱区",
            "pcode": "210900"
        },
        {
            "cityCode": "210904",
            "label": "太平区", "value": "太平区",
            "pcode": "210900"
        },
        {
            "cityCode": "210905",
            "label": "清河门区", "value": "清河门区",
            "pcode": "210900"
        },
        {
            "cityCode": "210911",
            "label": "细河区", "value": "细河区",
            "pcode": "210900"
        },
        {
            "cityCode": "210921",
            "label": "阜新蒙古族自治县", "value": "阜新蒙古族自治县",
            "pcode": "210900"
        },
        {
            "cityCode": "210922",
            "label": "彰武县", "value": "彰武县",
            "pcode": "210900"
        }],
        "pcode": "210000"
    },
    {
        "cityCode": "211000",
        "label": "辽阳市", "value": "辽阳市",
        "children": [{
            "cityCode": "211002",
            "label": "白塔区", "value": "白塔区",
            "pcode": "211000"
        },
        {
            "cityCode": "211003",
            "label": "文圣区", "value": "文圣区",
            "pcode": "211000"
        },
        {
            "cityCode": "211004",
            "label": "宏伟区", "value": "宏伟区",
            "pcode": "211000"
        },
        {
            "cityCode": "211005",
            "label": "弓长岭区", "value": "弓长岭区",
            "pcode": "211000"
        },
        {
            "cityCode": "211011",
            "label": "太子河区", "value": "太子河区",
            "pcode": "211000"
        },
        {
            "cityCode": "211021",
            "label": "辽阳县", "value": "辽阳县",
            "pcode": "211000"
        },
        {
            "cityCode": "211081",
            "label": "灯塔市", "value": "灯塔市",
            "pcode": "211000"
        }],
        "pcode": "210000"
    },
    {
        "cityCode": "211100",
        "label": "盘锦市", "value": "盘锦市",
        "children": [{
            "cityCode": "211102",
            "label": "双台子区", "value": "双台子区",
            "pcode": "211100"
        },
        {
            "cityCode": "211103",
            "label": "兴隆台区", "value": "兴隆台区",
            "pcode": "211100"
        },
        {
            "cityCode": "211104",
            "label": "大洼区", "value": "大洼区",
            "pcode": "211100"
        },
        {
            "cityCode": "211122",
            "label": "盘山县", "value": "盘山县",
            "pcode": "211100"
        }],
        "pcode": "210000"
    },
    {
        "cityCode": "211200",
        "label": "铁岭市", "value": "铁岭市",
        "children": [{
            "cityCode": "211202",
            "label": "银州区", "value": "银州区",
            "pcode": "211200"
        },
        {
            "cityCode": "211204",
            "label": "清河区", "value": "清河区",
            "pcode": "211200"
        },
        {
            "cityCode": "211221",
            "label": "铁岭县", "value": "铁岭县",
            "pcode": "211200"
        },
        {
            "cityCode": "211223",
            "label": "西丰县", "value": "西丰县",
            "pcode": "211200"
        },
        {
            "cityCode": "211224",
            "label": "昌图县", "value": "昌图县",
            "pcode": "211200"
        },
        {
            "cityCode": "211281",
            "label": "调兵山市", "value": "调兵山市",
            "pcode": "211200"
        },
        {
            "cityCode": "211282",
            "label": "开原市", "value": "开原市",
            "pcode": "211200"
        }],
        "pcode": "210000"
    },
    {
        "cityCode": "211300",
        "label": "朝阳市", "value": "朝阳市",
        "children": [{
            "cityCode": "211302",
            "label": "双塔区", "value": "双塔区",
            "pcode": "211300"
        },
        {
            "cityCode": "211303",
            "label": "龙城区", "value": "龙城区",
            "pcode": "211300"
        },
        {
            "cityCode": "211321",
            "label": "朝阳县", "value": "朝阳县",
            "pcode": "211300"
        },
        {
            "cityCode": "211322",
            "label": "建平县", "value": "建平县",
            "pcode": "211300"
        },
        {
            "cityCode": "211324",
            "label": "喀喇沁左翼蒙古族自治县", "value": "喀喇沁左翼蒙古族自治县",
            "pcode": "211300"
        },
        {
            "cityCode": "211381",
            "label": "北票市", "value": "北票市",
            "pcode": "211300"
        },
        {
            "cityCode": "211382",
            "label": "凌源市", "value": "凌源市",
            "pcode": "211300"
        }],
        "pcode": "210000"
    },
    {
        "cityCode": "211400",
        "label": "葫芦岛市", "value": "葫芦岛市",
        "children": [{
            "cityCode": "211402",
            "label": "连山区", "value": "连山区",
            "pcode": "211400"
        },
        {
            "cityCode": "211403",
            "label": "龙港区", "value": "龙港区",
            "pcode": "211400"
        },
        {
            "cityCode": "211404",
            "label": "南票区", "value": "南票区",
            "pcode": "211400"
        },
        {
            "cityCode": "211421",
            "label": "绥中县", "value": "绥中县",
            "pcode": "211400"
        },
        {
            "cityCode": "211422",
            "label": "建昌县", "value": "建昌县",
            "pcode": "211400"
        },
        {
            "cityCode": "211481",
            "label": "兴城市", "value": "兴城市",
            "pcode": "211400"
        }],
        "pcode": "210000"
    }]
},
{
    "cityCode": "220000",
    "label": "吉林省", "value": "吉林省",
    "children": [{
        "cityCode": "220100",
        "label": "长春市", "value": "长春市",
        "children": [{
            "cityCode": "220102",
            "label": "南关区", "value": "南关区",
            "pcode": "220100"
        },
        {
            "cityCode": "220103",
            "label": "宽城区", "value": "宽城区",
            "pcode": "220100"
        },
        {
            "cityCode": "220104",
            "label": "朝阳区", "value": "朝阳区",
            "pcode": "220100"
        },
        {
            "cityCode": "220105",
            "label": "二道区", "value": "二道区",
            "pcode": "220100"
        },
        {
            "cityCode": "220106",
            "label": "绿园区", "value": "绿园区",
            "pcode": "220100"
        },
        {
            "cityCode": "220112",
            "label": "双阳区", "value": "双阳区",
            "pcode": "220100"
        },
        {
            "cityCode": "220113",
            "label": "九台区", "value": "九台区",
            "pcode": "220100"
        },
        {
            "cityCode": "220122",
            "label": "农安县", "value": "农安县",
            "pcode": "220100"
        },
        {
            "cityCode": "220182",
            "label": "榆树市", "value": "榆树市",
            "pcode": "220100"
        },
        {
            "cityCode": "220183",
            "label": "德惠市", "value": "德惠市",
            "pcode": "220100"
        }],
        "pcode": "220000"
    },
    {
        "cityCode": "220200",
        "label": "吉林市", "value": "吉林市",
        "children": [{
            "cityCode": "220202",
            "label": "昌邑区", "value": "昌邑区",
            "pcode": "220200"
        },
        {
            "cityCode": "220203",
            "label": "龙潭区", "value": "龙潭区",
            "pcode": "220200"
        },
        {
            "cityCode": "220204",
            "label": "船营区", "value": "船营区",
            "pcode": "220200"
        },
        {
            "cityCode": "220211",
            "label": "丰满区", "value": "丰满区",
            "pcode": "220200"
        },
        {
            "cityCode": "220221",
            "label": "永吉县", "value": "永吉县",
            "pcode": "220200"
        },
        {
            "cityCode": "220281",
            "label": "蛟河市", "value": "蛟河市",
            "pcode": "220200"
        },
        {
            "cityCode": "220282",
            "label": "桦甸市", "value": "桦甸市",
            "pcode": "220200"
        },
        {
            "cityCode": "220283",
            "label": "舒兰市", "value": "舒兰市",
            "pcode": "220200"
        },
        {
            "cityCode": "220284",
            "label": "磐石市", "value": "磐石市",
            "pcode": "220200"
        }],
        "pcode": "220000"
    },
    {
        "cityCode": "220300",
        "label": "四平市", "value": "四平市",
        "children": [{
            "cityCode": "220302",
            "label": "铁西区", "value": "铁西区",
            "pcode": "220300"
        },
        {
            "cityCode": "220303",
            "label": "铁东区", "value": "铁东区",
            "pcode": "220300"
        },
        {
            "cityCode": "220322",
            "label": "梨树县", "value": "梨树县",
            "pcode": "220300"
        },
        {
            "cityCode": "220323",
            "label": "伊通满族自治县", "value": "伊通满族自治县",
            "pcode": "220300"
        },
        {
            "cityCode": "220381",
            "label": "公主岭市", "value": "公主岭市",
            "pcode": "220300"
        },
        {
            "cityCode": "220382",
            "label": "双辽市", "value": "双辽市",
            "pcode": "220300"
        }],
        "pcode": "220000"
    },
    {
        "cityCode": "220400",
        "label": "辽源市", "value": "辽源市",
        "children": [{
            "cityCode": "220402",
            "label": "龙山区", "value": "龙山区",
            "pcode": "220400"
        },
        {
            "cityCode": "220403",
            "label": "西安区", "value": "西安区",
            "pcode": "220400"
        },
        {
            "cityCode": "220421",
            "label": "东丰县", "value": "东丰县",
            "pcode": "220400"
        },
        {
            "cityCode": "220422",
            "label": "东辽县", "value": "东辽县",
            "pcode": "220400"
        }],
        "pcode": "220000"
    },
    {
        "cityCode": "220500",
        "label": "通化市", "value": "通化市",
        "children": [{
            "cityCode": "220502",
            "label": "东昌区", "value": "东昌区",
            "pcode": "220500"
        },
        {
            "cityCode": "220503",
            "label": "二道江区", "value": "二道江区",
            "pcode": "220500"
        },
        {
            "cityCode": "220521",
            "label": "通化县", "value": "通化县",
            "pcode": "220500"
        },
        {
            "cityCode": "220523",
            "label": "辉南县", "value": "辉南县",
            "pcode": "220500"
        },
        {
            "cityCode": "220524",
            "label": "柳河县", "value": "柳河县",
            "pcode": "220500"
        },
        {
            "cityCode": "220581",
            "label": "梅河口市", "value": "梅河口市",
            "pcode": "220500"
        },
        {
            "cityCode": "220582",
            "label": "集安市", "value": "集安市",
            "pcode": "220500"
        }],
        "pcode": "220000"
    },
    {
        "cityCode": "220600",
        "label": "白山市", "value": "白山市",
        "children": [{
            "cityCode": "220602",
            "label": "浑江区", "value": "浑江区",
            "pcode": "220600"
        },
        {
            "cityCode": "220605",
            "label": "江源区", "value": "江源区",
            "pcode": "220600"
        },
        {
            "cityCode": "220621",
            "label": "抚松县", "value": "抚松县",
            "pcode": "220600"
        },
        {
            "cityCode": "220622",
            "label": "靖宇县", "value": "靖宇县",
            "pcode": "220600"
        },
        {
            "cityCode": "220623",
            "label": "长白朝鲜族自治县", "value": "长白朝鲜族自治县",
            "pcode": "220600"
        },
        {
            "cityCode": "220681",
            "label": "临江市", "value": "临江市",
            "pcode": "220600"
        }],
        "pcode": "220000"
    },
    {
        "cityCode": "220700",
        "label": "松原市", "value": "松原市",
        "children": [{
            "cityCode": "220702",
            "label": "宁江区", "value": "宁江区",
            "pcode": "220700"
        },
        {
            "cityCode": "220721",
            "label": "前郭尔罗斯蒙古族自治县", "value": "前郭尔罗斯蒙古族自治县",
            "pcode": "220700"
        },
        {
            "cityCode": "220722",
            "label": "长岭县", "value": "长岭县",
            "pcode": "220700"
        },
        {
            "cityCode": "220723",
            "label": "乾安县", "value": "乾安县",
            "pcode": "220700"
        },
        {
            "cityCode": "220781",
            "label": "扶余市", "value": "扶余市",
            "pcode": "220700"
        }],
        "pcode": "220000"
    },
    {
        "cityCode": "220800",
        "label": "白城市", "value": "白城市",
        "children": [{
            "cityCode": "220802",
            "label": "洮北区", "value": "洮北区",
            "pcode": "220800"
        },
        {
            "cityCode": "220821",
            "label": "镇赉县", "value": "镇赉县",
            "pcode": "220800"
        },
        {
            "cityCode": "220822",
            "label": "通榆县", "value": "通榆县",
            "pcode": "220800"
        },
        {
            "cityCode": "220881",
            "label": "洮南市", "value": "洮南市",
            "pcode": "220800"
        },
        {
            "cityCode": "220882",
            "label": "大安市", "value": "大安市",
            "pcode": "220800"
        }],
        "pcode": "220000"
    },
    {
        "cityCode": "222400",
        "label": "延边朝鲜族自治州", "value": "延边朝鲜族自治州",
        "children": [{
            "cityCode": "222401",
            "label": "延吉市", "value": "延吉市",
            "pcode": "222400"
        },
        {
            "cityCode": "222402",
            "label": "图们市", "value": "图们市",
            "pcode": "222400"
        },
        {
            "cityCode": "222403",
            "label": "敦化市", "value": "敦化市",
            "pcode": "222400"
        },
        {
            "cityCode": "222404",
            "label": "珲春市", "value": "珲春市",
            "pcode": "222400"
        },
        {
            "cityCode": "222405",
            "label": "龙井市", "value": "龙井市",
            "pcode": "222400"
        },
        {
            "cityCode": "222406",
            "label": "和龙市", "value": "和龙市",
            "pcode": "222400"
        },
        {
            "cityCode": "222424",
            "label": "汪清县", "value": "汪清县",
            "pcode": "222400"
        },
        {
            "cityCode": "222426",
            "label": "安图县", "value": "安图县",
            "pcode": "222400"
        }],
        "pcode": "220000"
    }]
},
{
    "cityCode": "230000",
    "label": "黑龙江省", "value": "黑龙江省",
    "children": [{
        "cityCode": "230100",
        "label": "哈尔滨市", "value": "哈尔滨市",
        "children": [{
            "cityCode": "230102",
            "label": "道里区", "value": "道里区",
            "pcode": "230100"
        },
        {
            "cityCode": "230103",
            "label": "南岗区", "value": "南岗区",
            "pcode": "230100"
        },
        {
            "cityCode": "230104",
            "label": "道外区", "value": "道外区",
            "pcode": "230100"
        },
        {
            "cityCode": "230108",
            "label": "平房区", "value": "平房区",
            "pcode": "230100"
        },
        {
            "cityCode": "230109",
            "label": "松北区", "value": "松北区",
            "pcode": "230100"
        },
        {
            "cityCode": "230110",
            "label": "香坊区", "value": "香坊区",
            "pcode": "230100"
        },
        {
            "cityCode": "230111",
            "label": "呼兰区", "value": "呼兰区",
            "pcode": "230100"
        },
        {
            "cityCode": "230112",
            "label": "阿城区", "value": "阿城区",
            "pcode": "230100"
        },
        {
            "cityCode": "230113",
            "label": "双城区", "value": "双城区",
            "pcode": "230100"
        },
        {
            "cityCode": "230123",
            "label": "依兰县", "value": "依兰县",
            "pcode": "230100"
        },
        {
            "cityCode": "230124",
            "label": "方正县", "value": "方正县",
            "pcode": "230100"
        },
        {
            "cityCode": "230125",
            "label": "宾县", "value": "宾县",
            "pcode": "230100"
        },
        {
            "cityCode": "230126",
            "label": "巴彦县", "value": "巴彦县",
            "pcode": "230100"
        },
        {
            "cityCode": "230127",
            "label": "木兰县", "value": "木兰县",
            "pcode": "230100"
        },
        {
            "cityCode": "230128",
            "label": "通河县", "value": "通河县",
            "pcode": "230100"
        },
        {
            "cityCode": "230129",
            "label": "延寿县", "value": "延寿县",
            "pcode": "230100"
        },
        {
            "cityCode": "230183",
            "label": "尚志市", "value": "尚志市",
            "pcode": "230100"
        },
        {
            "cityCode": "230184",
            "label": "五常市", "value": "五常市",
            "pcode": "230100"
        }],
        "pcode": "230000"
    },
    {
        "cityCode": "230200",
        "label": "齐齐哈尔市", "value": "齐齐哈尔市",
        "children": [{
            "cityCode": "230202",
            "label": "龙沙区", "value": "龙沙区",
            "pcode": "230200"
        },
        {
            "cityCode": "230203",
            "label": "建华区", "value": "建华区",
            "pcode": "230200"
        },
        {
            "cityCode": "230204",
            "label": "铁锋区", "value": "铁锋区",
            "pcode": "230200"
        },
        {
            "cityCode": "230205",
            "label": "昂昂溪区", "value": "昂昂溪区",
            "pcode": "230200"
        },
        {
            "cityCode": "230206",
            "label": "富拉尔基区", "value": "富拉尔基区",
            "pcode": "230200"
        },
        {
            "cityCode": "230207",
            "label": "碾子山区", "value": "碾子山区",
            "pcode": "230200"
        },
        {
            "cityCode": "230208",
            "label": "梅里斯达斡尔族区", "value": "梅里斯达斡尔族区",
            "pcode": "230200"
        },
        {
            "cityCode": "230221",
            "label": "龙江县", "value": "龙江县",
            "pcode": "230200"
        },
        {
            "cityCode": "230223",
            "label": "依安县", "value": "依安县",
            "pcode": "230200"
        },
        {
            "cityCode": "230224",
            "label": "泰来县", "value": "泰来县",
            "pcode": "230200"
        },
        {
            "cityCode": "230225",
            "label": "甘南县", "value": "甘南县",
            "pcode": "230200"
        },
        {
            "cityCode": "230227",
            "label": "富裕县", "value": "富裕县",
            "pcode": "230200"
        },
        {
            "cityCode": "230229",
            "label": "克山县", "value": "克山县",
            "pcode": "230200"
        },
        {
            "cityCode": "230230",
            "label": "克东县", "value": "克东县",
            "pcode": "230200"
        },
        {
            "cityCode": "230231",
            "label": "拜泉县", "value": "拜泉县",
            "pcode": "230200"
        },
        {
            "cityCode": "230281",
            "label": "讷河市", "value": "讷河市",
            "pcode": "230200"
        }],
        "pcode": "230000"
    },
    {
        "cityCode": "230300",
        "label": "鸡西市", "value": "鸡西市",
        "children": [{
            "cityCode": "230302",
            "label": "鸡冠区", "value": "鸡冠区",
            "pcode": "230300"
        },
        {
            "cityCode": "230303",
            "label": "恒山区", "value": "恒山区",
            "pcode": "230300"
        },
        {
            "cityCode": "230304",
            "label": "滴道区", "value": "滴道区",
            "pcode": "230300"
        },
        {
            "cityCode": "230305",
            "label": "梨树区", "value": "梨树区",
            "pcode": "230300"
        },
        {
            "cityCode": "230306",
            "label": "城子河区", "value": "城子河区",
            "pcode": "230300"
        },
        {
            "cityCode": "230307",
            "label": "麻山区", "value": "麻山区",
            "pcode": "230300"
        },
        {
            "cityCode": "230321",
            "label": "鸡东县", "value": "鸡东县",
            "pcode": "230300"
        },
        {
            "cityCode": "230381",
            "label": "虎林市", "value": "虎林市",
            "pcode": "230300"
        },
        {
            "cityCode": "230382",
            "label": "密山市", "value": "密山市",
            "pcode": "230300"
        }],
        "pcode": "230000"
    },
    {
        "cityCode": "230400",
        "label": "鹤岗市", "value": "鹤岗市",
        "children": [{
            "cityCode": "230402",
            "label": "向阳区", "value": "向阳区",
            "pcode": "230400"
        },
        {
            "cityCode": "230403",
            "label": "工农区", "value": "工农区",
            "pcode": "230400"
        },
        {
            "cityCode": "230404",
            "label": "南山区", "value": "南山区",
            "pcode": "230400"
        },
        {
            "cityCode": "230405",
            "label": "兴安区", "value": "兴安区",
            "pcode": "230400"
        },
        {
            "cityCode": "230406",
            "label": "东山区", "value": "东山区",
            "pcode": "230400"
        },
        {
            "cityCode": "230407",
            "label": "兴山区", "value": "兴山区",
            "pcode": "230400"
        },
        {
            "cityCode": "230421",
            "label": "萝北县", "value": "萝北县",
            "pcode": "230400"
        },
        {
            "cityCode": "230422",
            "label": "绥滨县", "value": "绥滨县",
            "pcode": "230400"
        }],
        "pcode": "230000"
    },
    {
        "cityCode": "230500",
        "label": "双鸭山市", "value": "双鸭山市",
        "children": [{
            "cityCode": "230502",
            "label": "尖山区", "value": "尖山区",
            "pcode": "230500"
        },
        {
            "cityCode": "230503",
            "label": "岭东区", "value": "岭东区",
            "pcode": "230500"
        },
        {
            "cityCode": "230505",
            "label": "四方台区", "value": "四方台区",
            "pcode": "230500"
        },
        {
            "cityCode": "230506",
            "label": "宝山区", "value": "宝山区",
            "pcode": "230500"
        },
        {
            "cityCode": "230521",
            "label": "集贤县", "value": "集贤县",
            "pcode": "230500"
        },
        {
            "cityCode": "230522",
            "label": "友谊县", "value": "友谊县",
            "pcode": "230500"
        },
        {
            "cityCode": "230523",
            "label": "宝清县", "value": "宝清县",
            "pcode": "230500"
        },
        {
            "cityCode": "230524",
            "label": "饶河县", "value": "饶河县",
            "pcode": "230500"
        }],
        "pcode": "230000"
    },
    {
        "cityCode": "230600",
        "label": "大庆市", "value": "大庆市",
        "children": [{
            "cityCode": "230602",
            "label": "萨尔图区", "value": "萨尔图区",
            "pcode": "230600"
        },
        {
            "cityCode": "230603",
            "label": "龙凤区", "value": "龙凤区",
            "pcode": "230600"
        },
        {
            "cityCode": "230604",
            "label": "让胡路区", "value": "让胡路区",
            "pcode": "230600"
        },
        {
            "cityCode": "230605",
            "label": "红岗区", "value": "红岗区",
            "pcode": "230600"
        },
        {
            "cityCode": "230606",
            "label": "大同区", "value": "大同区",
            "pcode": "230600"
        },
        {
            "cityCode": "230621",
            "label": "肇州县", "value": "肇州县",
            "pcode": "230600"
        },
        {
            "cityCode": "230622",
            "label": "肇源县", "value": "肇源县",
            "pcode": "230600"
        },
        {
            "cityCode": "230623",
            "label": "林甸县", "value": "林甸县",
            "pcode": "230600"
        },
        {
            "cityCode": "230624",
            "label": "杜尔伯特蒙古族自治县", "value": "杜尔伯特蒙古族自治县",
            "pcode": "230600"
        }],
        "pcode": "230000"
    },
    {
        "cityCode": "230700",
        "label": "伊春市", "value": "伊春市",
        "children": [{
            "cityCode": "230702",
            "label": "伊春区", "value": "伊春区",
            "pcode": "230700"
        },
        {
            "cityCode": "230703",
            "label": "南岔区", "value": "南岔区",
            "pcode": "230700"
        },
        {
            "cityCode": "230704",
            "label": "友好区", "value": "友好区",
            "pcode": "230700"
        },
        {
            "cityCode": "230705",
            "label": "西林区", "value": "西林区",
            "pcode": "230700"
        },
        {
            "cityCode": "230706",
            "label": "翠峦区", "value": "翠峦区",
            "pcode": "230700"
        },
        {
            "cityCode": "230707",
            "label": "新青区", "value": "新青区",
            "pcode": "230700"
        },
        {
            "cityCode": "230708",
            "label": "美溪区", "value": "美溪区",
            "pcode": "230700"
        },
        {
            "cityCode": "230709",
            "label": "金山屯区", "value": "金山屯区",
            "pcode": "230700"
        },
        {
            "cityCode": "230710",
            "label": "五营区", "value": "五营区",
            "pcode": "230700"
        },
        {
            "cityCode": "230711",
            "label": "乌马河区", "value": "乌马河区",
            "pcode": "230700"
        },
        {
            "cityCode": "230712",
            "label": "汤旺河区", "value": "汤旺河区",
            "pcode": "230700"
        },
        {
            "cityCode": "230713",
            "label": "带岭区", "value": "带岭区",
            "pcode": "230700"
        },
        {
            "cityCode": "230714",
            "label": "乌伊岭区", "value": "乌伊岭区",
            "pcode": "230700"
        },
        {
            "cityCode": "230715",
            "label": "红星区", "value": "红星区",
            "pcode": "230700"
        },
        {
            "cityCode": "230716",
            "label": "上甘岭区", "value": "上甘岭区",
            "pcode": "230700"
        },
        {
            "cityCode": "230722",
            "label": "嘉荫县", "value": "嘉荫县",
            "pcode": "230700"
        },
        {
            "cityCode": "230781",
            "label": "铁力市", "value": "铁力市",
            "pcode": "230700"
        }],
        "pcode": "230000"
    },
    {
        "cityCode": "230800",
        "label": "佳木斯市", "value": "佳木斯市",
        "children": [{
            "cityCode": "230803",
            "label": "向阳区", "value": "向阳区",
            "pcode": "230800"
        },
        {
            "cityCode": "230804",
            "label": "前进区", "value": "前进区",
            "pcode": "230800"
        },
        {
            "cityCode": "230805",
            "label": "东风区", "value": "东风区",
            "pcode": "230800"
        },
        {
            "cityCode": "230811",
            "label": "郊区", "value": "郊区",
            "pcode": "230800"
        },
        {
            "cityCode": "230822",
            "label": "桦南县", "value": "桦南县",
            "pcode": "230800"
        },
        {
            "cityCode": "230826",
            "label": "桦川县", "value": "桦川县",
            "pcode": "230800"
        },
        {
            "cityCode": "230828",
            "label": "汤原县", "value": "汤原县",
            "pcode": "230800"
        },
        {
            "cityCode": "230881",
            "label": "同江市", "value": "同江市",
            "pcode": "230800"
        },
        {
            "cityCode": "230882",
            "label": "富锦市", "value": "富锦市",
            "pcode": "230800"
        },
        {
            "cityCode": "230883",
            "label": "抚远市", "value": "抚远市",
            "pcode": "230800"
        }],
        "pcode": "230000"
    },
    {
        "cityCode": "230900",
        "label": "七台河市", "value": "七台河市",
        "children": [{
            "cityCode": "230902",
            "label": "新兴区", "value": "新兴区",
            "pcode": "230900"
        },
        {
            "cityCode": "230903",
            "label": "桃山区", "value": "桃山区",
            "pcode": "230900"
        },
        {
            "cityCode": "230904",
            "label": "茄子河区", "value": "茄子河区",
            "pcode": "230900"
        },
        {
            "cityCode": "230921",
            "label": "勃利县", "value": "勃利县",
            "pcode": "230900"
        }],
        "pcode": "230000"
    },
    {
        "cityCode": "231000",
        "label": "牡丹江市", "value": "牡丹江市",
        "children": [{
            "cityCode": "231002",
            "label": "东安区", "value": "东安区",
            "pcode": "231000"
        },
        {
            "cityCode": "231003",
            "label": "阳明区", "value": "阳明区",
            "pcode": "231000"
        },
        {
            "cityCode": "231004",
            "label": "爱民区", "value": "爱民区",
            "pcode": "231000"
        },
        {
            "cityCode": "231005",
            "label": "西安区", "value": "西安区",
            "pcode": "231000"
        },
        {
            "cityCode": "231025",
            "label": "林口县", "value": "林口县",
            "pcode": "231000"
        },
        {
            "cityCode": "231081",
            "label": "绥芬河市", "value": "绥芬河市",
            "pcode": "231000"
        },
        {
            "cityCode": "231083",
            "label": "海林市", "value": "海林市",
            "pcode": "231000"
        },
        {
            "cityCode": "231084",
            "label": "宁安市", "value": "宁安市",
            "pcode": "231000"
        },
        {
            "cityCode": "231085",
            "label": "穆棱市", "value": "穆棱市",
            "pcode": "231000"
        },
        {
            "cityCode": "231086",
            "label": "东宁市", "value": "东宁市",
            "pcode": "231000"
        }],
        "pcode": "230000"
    },
    {
        "cityCode": "231100",
        "label": "黑河市", "value": "黑河市",
        "children": [{
            "cityCode": "231102",
            "label": "爱辉区", "value": "爱辉区",
            "pcode": "231100"
        },
        {
            "cityCode": "231121",
            "label": "嫩江县", "value": "嫩江县",
            "pcode": "231100"
        },
        {
            "cityCode": "231123",
            "label": "逊克县", "value": "逊克县",
            "pcode": "231100"
        },
        {
            "cityCode": "231124",
            "label": "孙吴县", "value": "孙吴县",
            "pcode": "231100"
        },
        {
            "cityCode": "231181",
            "label": "北安市", "value": "北安市",
            "pcode": "231100"
        },
        {
            "cityCode": "231182",
            "label": "五大连池市", "value": "五大连池市",
            "pcode": "231100"
        }],
        "pcode": "230000"
    },
    {
        "cityCode": "231200",
        "label": "绥化市", "value": "绥化市",
        "children": [{
            "cityCode": "231202",
            "label": "北林区", "value": "北林区",
            "pcode": "231200"
        },
        {
            "cityCode": "231221",
            "label": "望奎县", "value": "望奎县",
            "pcode": "231200"
        },
        {
            "cityCode": "231222",
            "label": "兰西县", "value": "兰西县",
            "pcode": "231200"
        },
        {
            "cityCode": "231223",
            "label": "青冈县", "value": "青冈县",
            "pcode": "231200"
        },
        {
            "cityCode": "231224",
            "label": "庆安县", "value": "庆安县",
            "pcode": "231200"
        },
        {
            "cityCode": "231225",
            "label": "明水县", "value": "明水县",
            "pcode": "231200"
        },
        {
            "cityCode": "231226",
            "label": "绥棱县", "value": "绥棱县",
            "pcode": "231200"
        },
        {
            "cityCode": "231281",
            "label": "安达市", "value": "安达市",
            "pcode": "231200"
        },
        {
            "cityCode": "231282",
            "label": "肇东市", "value": "肇东市",
            "pcode": "231200"
        },
        {
            "cityCode": "231283",
            "label": "海伦市", "value": "海伦市",
            "pcode": "231200"
        }],
        "pcode": "230000"
    },
    {
        "cityCode": "232700",
        "label": "大兴安岭地区", "value": "大兴安岭地区",
        "children": [{
            "cityCode": "232701",
            "label": "加格达奇区", "value": "加格达奇区",
            "pcode": "232700"
        },
        {
            "cityCode": "232721",
            "label": "呼玛县", "value": "呼玛县",
            "pcode": "232700"
        },
        {
            "cityCode": "232722",
            "label": "塔河县", "value": "塔河县",
            "pcode": "232700"
        },
        {
            "cityCode": "232723",
            "label": "漠河县", "value": "漠河县",
            "pcode": "232700"
        }],
        "pcode": "230000"
    }]
},
{
    "cityCode": "310000",
    "label": "上海", "value": "上海",
    "children": [{
        "cityCode": "310100",
        "label": "上海市", "value": "上海市",
        "children": [{
            "cityCode": "310101",
            "label": "黄浦区", "value": "黄浦区",
            "pcode": "310100"
        },
        {
            "cityCode": "310104",
            "label": "徐汇区", "value": "徐汇区",
            "pcode": "310100"
        },
        {
            "cityCode": "310105",
            "label": "长宁区", "value": "长宁区",
            "pcode": "310100"
        },
        {
            "cityCode": "310106",
            "label": "静安区", "value": "静安区",
            "pcode": "310100"
        },
        {
            "cityCode": "310107",
            "label": "普陀区", "value": "普陀区",
            "pcode": "310100"
        },
        {
            "cityCode": "310109",
            "label": "虹口区", "value": "虹口区",
            "pcode": "310100"
        },
        {
            "cityCode": "310110",
            "label": "杨浦区", "value": "杨浦区",
            "pcode": "310100"
        },
        {
            "cityCode": "310112",
            "label": "闵行区", "value": "闵行区",
            "pcode": "310100"
        },
        {
            "cityCode": "310113",
            "label": "宝山区", "value": "宝山区",
            "pcode": "310100"
        },
        {
            "cityCode": "310114",
            "label": "嘉定区", "value": "嘉定区",
            "pcode": "310100"
        },
        {
            "cityCode": "310115",
            "label": "浦东新区", "value": "浦东新区",
            "pcode": "310100"
        },
        {
            "cityCode": "310116",
            "label": "金山区", "value": "金山区",
            "pcode": "310100"
        },
        {
            "cityCode": "310117",
            "label": "松江区", "value": "松江区",
            "pcode": "310100"
        },
        {
            "cityCode": "310118",
            "label": "青浦区", "value": "青浦区",
            "pcode": "310100"
        },
        {
            "cityCode": "310120",
            "label": "奉贤区", "value": "奉贤区",
            "pcode": "310100"
        },
        {
            "cityCode": "310151",
            "label": "崇明区", "value": "崇明区",
            "pcode": "310100"
        }],
        "pcode": "310000"
    }]
},
{
    "cityCode": "320000",
    "label": "江苏省", "value": "江苏省",
    "children": [{
        "cityCode": "320100",
        "label": "南京市", "value": "南京市",
        "children": [{
            "cityCode": "320102",
            "label": "玄武区", "value": "玄武区",
            "pcode": "320100"
        },
        {
            "cityCode": "320104",
            "label": "秦淮区", "value": "秦淮区",
            "pcode": "320100"
        },
        {
            "cityCode": "320105",
            "label": "建邺区", "value": "建邺区",
            "pcode": "320100"
        },
        {
            "cityCode": "320106",
            "label": "鼓楼区", "value": "鼓楼区",
            "pcode": "320100"
        },
        {
            "cityCode": "320111",
            "label": "浦口区", "value": "浦口区",
            "pcode": "320100"
        },
        {
            "cityCode": "320113",
            "label": "栖霞区", "value": "栖霞区",
            "pcode": "320100"
        },
        {
            "cityCode": "320114",
            "label": "雨花台区", "value": "雨花台区",
            "pcode": "320100"
        },
        {
            "cityCode": "320115",
            "label": "江宁区", "value": "江宁区",
            "pcode": "320100"
        },
        {
            "cityCode": "320116",
            "label": "六合区", "value": "六合区",
            "pcode": "320100"
        },
        {
            "cityCode": "320117",
            "label": "溧水区", "value": "溧水区",
            "pcode": "320100"
        },
        {
            "cityCode": "320118",
            "label": "高淳区", "value": "高淳区",
            "pcode": "320100"
        }],
        "pcode": "320000"
    },
    {
        "cityCode": "320200",
        "label": "无锡市", "value": "无锡市",
        "children": [{
            "cityCode": "320205",
            "label": "锡山区", "value": "锡山区",
            "pcode": "320200"
        },
        {
            "cityCode": "320206",
            "label": "惠山区", "value": "惠山区",
            "pcode": "320200"
        },
        {
            "cityCode": "320211",
            "label": "滨湖区", "value": "滨湖区",
            "pcode": "320200"
        },
        {
            "cityCode": "320213",
            "label": "梁溪区", "value": "梁溪区",
            "pcode": "320200"
        },
        {
            "cityCode": "320214",
            "label": "新吴区", "value": "新吴区",
            "pcode": "320200"
        },
        {
            "cityCode": "320281",
            "label": "江阴市", "value": "江阴市",
            "pcode": "320200"
        },
        {
            "cityCode": "320282",
            "label": "宜兴市", "value": "宜兴市",
            "pcode": "320200"
        }],
        "pcode": "320000"
    },
    {
        "cityCode": "320300",
        "label": "徐州市", "value": "徐州市",
        "children": [{
            "cityCode": "320302",
            "label": "鼓楼区", "value": "鼓楼区",
            "pcode": "320300"
        },
        {
            "cityCode": "320303",
            "label": "云龙区", "value": "云龙区",
            "pcode": "320300"
        },
        {
            "cityCode": "320305",
            "label": "贾汪区", "value": "贾汪区",
            "pcode": "320300"
        },
        {
            "cityCode": "320311",
            "label": "泉山区", "value": "泉山区",
            "pcode": "320300"
        },
        {
            "cityCode": "320312",
            "label": "铜山区", "value": "铜山区",
            "pcode": "320300"
        },
        {
            "cityCode": "320321",
            "label": "丰县", "value": "丰县",
            "pcode": "320300"
        },
        {
            "cityCode": "320322",
            "label": "沛县", "value": "沛县",
            "pcode": "320300"
        },
        {
            "cityCode": "320324",
            "label": "睢宁县", "value": "睢宁县",
            "pcode": "320300"
        },
        {
            "cityCode": "320381",
            "label": "新沂市", "value": "新沂市",
            "pcode": "320300"
        },
        {
            "cityCode": "320382",
            "label": "邳州市", "value": "邳州市",
            "pcode": "320300"
        }],
        "pcode": "320000"
    },
    {
        "cityCode": "320400",
        "label": "常州市", "value": "常州市",
        "children": [{
            "cityCode": "320402",
            "label": "天宁区", "value": "天宁区",
            "pcode": "320400"
        },
        {
            "cityCode": "320404",
            "label": "钟楼区", "value": "钟楼区",
            "pcode": "320400"
        },
        {
            "cityCode": "320411",
            "label": "新北区", "value": "新北区",
            "pcode": "320400"
        },
        {
            "cityCode": "320412",
            "label": "武进区", "value": "武进区",
            "pcode": "320400"
        },
        {
            "cityCode": "320413",
            "label": "金坛区", "value": "金坛区",
            "pcode": "320400"
        },
        {
            "cityCode": "320481",
            "label": "溧阳市", "value": "溧阳市",
            "pcode": "320400"
        }],
        "pcode": "320000"
    },
    {
        "cityCode": "320500",
        "label": "苏州市", "value": "苏州市",
        "children": [{
            "cityCode": "320505",
            "label": "虎丘区", "value": "虎丘区",
            "pcode": "320500"
        },
        {
            "cityCode": "320506",
            "label": "吴中区", "value": "吴中区",
            "pcode": "320500"
        },
        {
            "cityCode": "320507",
            "label": "相城区", "value": "相城区",
            "pcode": "320500"
        },
        {
            "cityCode": "320508",
            "label": "姑苏区", "value": "姑苏区",
            "pcode": "320500"
        },
        {
            "cityCode": "320509",
            "label": "吴江区", "value": "吴江区",
            "pcode": "320500"
        },
        {
            "cityCode": "320581",
            "label": "常熟市", "value": "常熟市",
            "pcode": "320500"
        },
        {
            "cityCode": "320582",
            "label": "张家港市", "value": "张家港市",
            "pcode": "320500"
        },
        {
            "cityCode": "320583",
            "label": "昆山市", "value": "昆山市",
            "pcode": "320500"
        },
        {
            "cityCode": "320585",
            "label": "太仓市", "value": "太仓市",
            "pcode": "320500"
        }],
        "pcode": "320000"
    },
    {
        "cityCode": "320600",
        "label": "南通市", "value": "南通市",
        "children": [{
            "cityCode": "320602",
            "label": "崇川区", "value": "崇川区",
            "pcode": "320600"
        },
        {
            "cityCode": "320611",
            "label": "港闸区", "value": "港闸区",
            "pcode": "320600"
        },
        {
            "cityCode": "320612",
            "label": "通州区", "value": "通州区",
            "pcode": "320600"
        },
        {
            "cityCode": "320621",
            "label": "海安县", "value": "海安县",
            "pcode": "320600"
        },
        {
            "cityCode": "320623",
            "label": "如东县", "value": "如东县",
            "pcode": "320600"
        },
        {
            "cityCode": "320681",
            "label": "启东市", "value": "启东市",
            "pcode": "320600"
        },
        {
            "cityCode": "320682",
            "label": "如皋市", "value": "如皋市",
            "pcode": "320600"
        },
        {
            "cityCode": "320684",
            "label": "海门市", "value": "海门市",
            "pcode": "320600"
        }],
        "pcode": "320000"
    },
    {
        "cityCode": "320700",
        "label": "连云港市", "value": "连云港市",
        "children": [{
            "cityCode": "320703",
            "label": "连云区", "value": "连云区",
            "pcode": "320700"
        },
        {
            "cityCode": "320706",
            "label": "海州区", "value": "海州区",
            "pcode": "320700"
        },
        {
            "cityCode": "320707",
            "label": "赣榆区", "value": "赣榆区",
            "pcode": "320700"
        },
        {
            "cityCode": "320722",
            "label": "东海县", "value": "东海县",
            "pcode": "320700"
        },
        {
            "cityCode": "320723",
            "label": "灌云县", "value": "灌云县",
            "pcode": "320700"
        },
        {
            "cityCode": "320724",
            "label": "灌南县", "value": "灌南县",
            "pcode": "320700"
        }],
        "pcode": "320000"
    },
    {
        "cityCode": "320800",
        "label": "淮安市", "value": "淮安市",
        "children": [{
            "cityCode": "320802",
            "label": "清江浦区", "value": "清江浦区",
            "pcode": "320800"
        },
        {
            "cityCode": "320803",
            "label": "淮安区", "value": "淮安区",
            "pcode": "320800"
        },
        {
            "cityCode": "320804",
            "label": "淮阴区", "value": "淮阴区",
            "pcode": "320800"
        },
        {
            "cityCode": "320813",
            "label": "洪泽区", "value": "洪泽区",
            "pcode": "320800"
        },
        {
            "cityCode": "320826",
            "label": "涟水县", "value": "涟水县",
            "pcode": "320800"
        },
        {
            "cityCode": "320830",
            "label": "盱眙县", "value": "盱眙县",
            "pcode": "320800"
        },
        {
            "cityCode": "320831",
            "label": "金湖县", "value": "金湖县",
            "pcode": "320800"
        }],
        "pcode": "320000"
    },
    {
        "cityCode": "320900",
        "label": "盐城市", "value": "盐城市",
        "children": [{
            "cityCode": "320902",
            "label": "亭湖区", "value": "亭湖区",
            "pcode": "320900"
        },
        {
            "cityCode": "320903",
            "label": "盐都区", "value": "盐都区",
            "pcode": "320900"
        },
        {
            "cityCode": "320904",
            "label": "大丰区", "value": "大丰区",
            "pcode": "320900"
        },
        {
            "cityCode": "320921",
            "label": "响水县", "value": "响水县",
            "pcode": "320900"
        },
        {
            "cityCode": "320922",
            "label": "滨海县", "value": "滨海县",
            "pcode": "320900"
        },
        {
            "cityCode": "320923",
            "label": "阜宁县", "value": "阜宁县",
            "pcode": "320900"
        },
        {
            "cityCode": "320924",
            "label": "射阳县", "value": "射阳县",
            "pcode": "320900"
        },
        {
            "cityCode": "320925",
            "label": "建湖县", "value": "建湖县",
            "pcode": "320900"
        },
        {
            "cityCode": "320981",
            "label": "东台市", "value": "东台市",
            "pcode": "320900"
        }],
        "pcode": "320000"
    },
    {
        "cityCode": "321000",
        "label": "扬州市", "value": "扬州市",
        "children": [{
            "cityCode": "321002",
            "label": "广陵区", "value": "广陵区",
            "pcode": "321000"
        },
        {
            "cityCode": "321003",
            "label": "邗江区", "value": "邗江区",
            "pcode": "321000"
        },
        {
            "cityCode": "321012",
            "label": "江都区", "value": "江都区",
            "pcode": "321000"
        },
        {
            "cityCode": "321023",
            "label": "宝应县", "value": "宝应县",
            "pcode": "321000"
        },
        {
            "cityCode": "321081",
            "label": "仪征市", "value": "仪征市",
            "pcode": "321000"
        },
        {
            "cityCode": "321084",
            "label": "高邮市", "value": "高邮市",
            "pcode": "321000"
        }],
        "pcode": "320000"
    },
    {
        "cityCode": "321100",
        "label": "镇江市", "value": "镇江市",
        "children": [{
            "cityCode": "321102",
            "label": "京口区", "value": "京口区",
            "pcode": "321100"
        },
        {
            "cityCode": "321111",
            "label": "润州区", "value": "润州区",
            "pcode": "321100"
        },
        {
            "cityCode": "321112",
            "label": "丹徒区", "value": "丹徒区",
            "pcode": "321100"
        },
        {
            "cityCode": "321181",
            "label": "丹阳市", "value": "丹阳市",
            "pcode": "321100"
        },
        {
            "cityCode": "321182",
            "label": "扬中市", "value": "扬中市",
            "pcode": "321100"
        },
        {
            "cityCode": "321183",
            "label": "句容市", "value": "句容市",
            "pcode": "321100"
        }],
        "pcode": "320000"
    },
    {
        "cityCode": "321200",
        "label": "泰州市", "value": "泰州市",
        "children": [{
            "cityCode": "321202",
            "label": "海陵区", "value": "海陵区",
            "pcode": "321200"
        },
        {
            "cityCode": "321203",
            "label": "高港区", "value": "高港区",
            "pcode": "321200"
        },
        {
            "cityCode": "321204",
            "label": "姜堰区", "value": "姜堰区",
            "pcode": "321200"
        },
        {
            "cityCode": "321281",
            "label": "兴化市", "value": "兴化市",
            "pcode": "321200"
        },
        {
            "cityCode": "321282",
            "label": "靖江市", "value": "靖江市",
            "pcode": "321200"
        },
        {
            "cityCode": "321283",
            "label": "泰兴市", "value": "泰兴市",
            "pcode": "321200"
        }],
        "pcode": "320000"
    },
    {
        "cityCode": "321300",
        "label": "宿迁市", "value": "宿迁市",
        "children": [{
            "cityCode": "321302",
            "label": "宿城区", "value": "宿城区",
            "pcode": "321300"
        },
        {
            "cityCode": "321311",
            "label": "宿豫区", "value": "宿豫区",
            "pcode": "321300"
        },
        {
            "cityCode": "321322",
            "label": "沭阳县", "value": "沭阳县",
            "pcode": "321300"
        },
        {
            "cityCode": "321323",
            "label": "泗阳县", "value": "泗阳县",
            "pcode": "321300"
        },
        {
            "cityCode": "321324",
            "label": "泗洪县", "value": "泗洪县",
            "pcode": "321300"
        }],
        "pcode": "320000"
    }]
},
{
    "cityCode": "330000",
    "label": "浙江省", "value": "浙江省",
    "children": [{
        "cityCode": "330100",
        "label": "杭州市", "value": "杭州市",
        "children": [{
            "cityCode": "330102",
            "label": "上城区", "value": "上城区",
            "pcode": "330100"
        },
        {
            "cityCode": "330103",
            "label": "下城区", "value": "下城区",
            "pcode": "330100"
        },
        {
            "cityCode": "330104",
            "label": "江干区", "value": "江干区",
            "pcode": "330100"
        },
        {
            "cityCode": "330105",
            "label": "拱墅区", "value": "拱墅区",
            "pcode": "330100"
        },
        {
            "cityCode": "330106",
            "label": "西湖区", "value": "西湖区",
            "pcode": "330100"
        },
        {
            "cityCode": "330108",
            "label": "滨江区", "value": "滨江区",
            "pcode": "330100"
        },
        {
            "cityCode": "330109",
            "label": "萧山区", "value": "萧山区",
            "pcode": "330100"
        },
        {
            "cityCode": "330110",
            "label": "余杭区", "value": "余杭区",
            "pcode": "330100"
        },
        {
            "cityCode": "330111",
            "label": "富阳区", "value": "富阳区",
            "pcode": "330100"
        },
        {
            "cityCode": "330122",
            "label": "桐庐县", "value": "桐庐县",
            "pcode": "330100"
        },
        {
            "cityCode": "330127",
            "label": "淳安县", "value": "淳安县",
            "pcode": "330100"
        },
        {
            "cityCode": "330182",
            "label": "建德市", "value": "建德市",
            "pcode": "330100"
        },
        {
            "cityCode": "330185",
            "label": "临安区", "value": "临安区",
            "pcode": "330100"
        }],
        "pcode": "330000"
    },
    {
        "cityCode": "330200",
        "label": "宁波市", "value": "宁波市",
        "children": [{
            "cityCode": "330203",
            "label": "海曙区", "value": "海曙区",
            "pcode": "330200"
        },
        {
            "cityCode": "330205",
            "label": "江北区", "value": "江北区",
            "pcode": "330200"
        },
        {
            "cityCode": "330206",
            "label": "北仑区", "value": "北仑区",
            "pcode": "330200"
        },
        {
            "cityCode": "330211",
            "label": "镇海区", "value": "镇海区",
            "pcode": "330200"
        },
        {
            "cityCode": "330212",
            "label": "鄞州区", "value": "鄞州区",
            "pcode": "330200"
        },
        {
            "cityCode": "330225",
            "label": "象山县", "value": "象山县",
            "pcode": "330200"
        },
        {
            "cityCode": "330226",
            "label": "宁海县", "value": "宁海县",
            "pcode": "330200"
        },
        {
            "cityCode": "330281",
            "label": "余姚市", "value": "余姚市",
            "pcode": "330200"
        },
        {
            "cityCode": "330282",
            "label": "慈溪市", "value": "慈溪市",
            "pcode": "330200"
        },
        {
            "cityCode": "330213",
            "label": "奉化区", "value": "奉化区",
            "pcode": "330200"
        }],
        "pcode": "330000"
    },
    {
        "cityCode": "330300",
        "label": "温州市", "value": "温州市",
        "children": [{
            "cityCode": "330302",
            "label": "鹿城区", "value": "鹿城区",
            "pcode": "330300"
        },
        {
            "cityCode": "330303",
            "label": "龙湾区", "value": "龙湾区",
            "pcode": "330300"
        },
        {
            "cityCode": "330304",
            "label": "瓯海区", "value": "瓯海区",
            "pcode": "330300"
        },
        {
            "cityCode": "330305",
            "label": "洞头区", "value": "洞头区",
            "pcode": "330300"
        },
        {
            "cityCode": "330324",
            "label": "永嘉县", "value": "永嘉县",
            "pcode": "330300"
        },
        {
            "cityCode": "330326",
            "label": "平阳县", "value": "平阳县",
            "pcode": "330300"
        },
        {
            "cityCode": "330327",
            "label": "苍南县", "value": "苍南县",
            "pcode": "330300"
        },
        {
            "cityCode": "330328",
            "label": "文成县", "value": "文成县",
            "pcode": "330300"
        },
        {
            "cityCode": "330329",
            "label": "泰顺县", "value": "泰顺县",
            "pcode": "330300"
        },
        {
            "cityCode": "330381",
            "label": "瑞安市", "value": "瑞安市",
            "pcode": "330300"
        },
        {
            "cityCode": "330382",
            "label": "乐清市", "value": "乐清市",
            "pcode": "330300"
        }],
        "pcode": "330000"
    },
    {
        "cityCode": "330400",
        "label": "嘉兴市", "value": "嘉兴市",
        "children": [{
            "cityCode": "330402",
            "label": "南湖区", "value": "南湖区",
            "pcode": "330400"
        },
        {
            "cityCode": "330411",
            "label": "秀洲区", "value": "秀洲区",
            "pcode": "330400"
        },
        {
            "cityCode": "330421",
            "label": "嘉善县", "value": "嘉善县",
            "pcode": "330400"
        },
        {
            "cityCode": "330424",
            "label": "海盐县", "value": "海盐县",
            "pcode": "330400"
        },
        {
            "cityCode": "330481",
            "label": "海宁市", "value": "海宁市",
            "pcode": "330400"
        },
        {
            "cityCode": "330482",
            "label": "平湖市", "value": "平湖市",
            "pcode": "330400"
        },
        {
            "cityCode": "330483",
            "label": "桐乡市", "value": "桐乡市",
            "pcode": "330400"
        }],
        "pcode": "330000"
    },
    {
        "cityCode": "330500",
        "label": "湖州市", "value": "湖州市",
        "children": [{
            "cityCode": "330502",
            "label": "吴兴区", "value": "吴兴区",
            "pcode": "330500"
        },
        {
            "cityCode": "330503",
            "label": "南浔区", "value": "南浔区",
            "pcode": "330500"
        },
        {
            "cityCode": "330521",
            "label": "德清县", "value": "德清县",
            "pcode": "330500"
        },
        {
            "cityCode": "330522",
            "label": "长兴县", "value": "长兴县",
            "pcode": "330500"
        },
        {
            "cityCode": "330523",
            "label": "安吉县", "value": "安吉县",
            "pcode": "330500"
        }],
        "pcode": "330000"
    },
    {
        "cityCode": "330600",
        "label": "绍兴市", "value": "绍兴市",
        "children": [{
            "cityCode": "330602",
            "label": "越城区", "value": "越城区",
            "pcode": "330600"
        },
        {
            "cityCode": "330603",
            "label": "柯桥区", "value": "柯桥区",
            "pcode": "330600"
        },
        {
            "cityCode": "330604",
            "label": "上虞区", "value": "上虞区",
            "pcode": "330600"
        },
        {
            "cityCode": "330624",
            "label": "新昌县", "value": "新昌县",
            "pcode": "330600"
        },
        {
            "cityCode": "330681",
            "label": "诸暨市", "value": "诸暨市",
            "pcode": "330600"
        },
        {
            "cityCode": "330683",
            "label": "嵊州市", "value": "嵊州市",
            "pcode": "330600"
        }],
        "pcode": "330000"
    },
    {
        "cityCode": "330700",
        "label": "金华市", "value": "金华市",
        "children": [{
            "cityCode": "330702",
            "label": "婺城区", "value": "婺城区",
            "pcode": "330700"
        },
        {
            "cityCode": "330703",
            "label": "金东区", "value": "金东区",
            "pcode": "330700"
        },
        {
            "cityCode": "330723",
            "label": "武义县", "value": "武义县",
            "pcode": "330700"
        },
        {
            "cityCode": "330726",
            "label": "浦江县", "value": "浦江县",
            "pcode": "330700"
        },
        {
            "cityCode": "330727",
            "label": "磐安县", "value": "磐安县",
            "pcode": "330700"
        },
        {
            "cityCode": "330781",
            "label": "兰溪市", "value": "兰溪市",
            "pcode": "330700"
        },
        {
            "cityCode": "330782",
            "label": "义乌市", "value": "义乌市",
            "pcode": "330700"
        },
        {
            "cityCode": "330783",
            "label": "东阳市", "value": "东阳市",
            "pcode": "330700"
        },
        {
            "cityCode": "330784",
            "label": "永康市", "value": "永康市",
            "pcode": "330700"
        }],
        "pcode": "330000"
    },
    {
        "cityCode": "330800",
        "label": "衢州市", "value": "衢州市",
        "children": [{
            "cityCode": "330802",
            "label": "柯城区", "value": "柯城区",
            "pcode": "330800"
        },
        {
            "cityCode": "330803",
            "label": "衢江区", "value": "衢江区",
            "pcode": "330800"
        },
        {
            "cityCode": "330822",
            "label": "常山县", "value": "常山县",
            "pcode": "330800"
        },
        {
            "cityCode": "330824",
            "label": "开化县", "value": "开化县",
            "pcode": "330800"
        },
        {
            "cityCode": "330825",
            "label": "龙游县", "value": "龙游县",
            "pcode": "330800"
        },
        {
            "cityCode": "330881",
            "label": "江山市", "value": "江山市",
            "pcode": "330800"
        }],
        "pcode": "330000"
    },
    {
        "cityCode": "330900",
        "label": "舟山市", "value": "舟山市",
        "children": [{
            "cityCode": "330902",
            "label": "定海区", "value": "定海区",
            "pcode": "330900"
        },
        {
            "cityCode": "330903",
            "label": "普陀区", "value": "普陀区",
            "pcode": "330900"
        },
        {
            "cityCode": "330921",
            "label": "岱山县", "value": "岱山县",
            "pcode": "330900"
        },
        {
            "cityCode": "330922",
            "label": "嵊泗县", "value": "嵊泗县",
            "pcode": "330900"
        }],
        "pcode": "330000"
    },
    {
        "cityCode": "331000",
        "label": "台州市", "value": "台州市",
        "children": [{
            "cityCode": "331002",
            "label": "椒江区", "value": "椒江区",
            "pcode": "331000"
        },
        {
            "cityCode": "331003",
            "label": "黄岩区", "value": "黄岩区",
            "pcode": "331000"
        },
        {
            "cityCode": "331004",
            "label": "路桥区", "value": "路桥区",
            "pcode": "331000"
        },
        {
            "cityCode": "331083",
            "label": "玉环市", "value": "玉环市",
            "pcode": "331000"
        },
        {
            "cityCode": "331022",
            "label": "三门县", "value": "三门县",
            "pcode": "331000"
        },
        {
            "cityCode": "331023",
            "label": "天台县", "value": "天台县",
            "pcode": "331000"
        },
        {
            "cityCode": "331024",
            "label": "仙居县", "value": "仙居县",
            "pcode": "331000"
        },
        {
            "cityCode": "331081",
            "label": "温岭市", "value": "温岭市",
            "pcode": "331000"
        },
        {
            "cityCode": "331082",
            "label": "临海市", "value": "临海市",
            "pcode": "331000"
        }],
        "pcode": "330000"
    },
    {
        "cityCode": "331100",
        "label": "丽水市", "value": "丽水市",
        "children": [{
            "cityCode": "331102",
            "label": "莲都区", "value": "莲都区",
            "pcode": "331100"
        },
        {
            "cityCode": "331121",
            "label": "青田县", "value": "青田县",
            "pcode": "331100"
        },
        {
            "cityCode": "331122",
            "label": "缙云县", "value": "缙云县",
            "pcode": "331100"
        },
        {
            "cityCode": "331123",
            "label": "遂昌县", "value": "遂昌县",
            "pcode": "331100"
        },
        {
            "cityCode": "331124",
            "label": "松阳县", "value": "松阳县",
            "pcode": "331100"
        },
        {
            "cityCode": "331125",
            "label": "云和县", "value": "云和县",
            "pcode": "331100"
        },
        {
            "cityCode": "331126",
            "label": "庆元县", "value": "庆元县",
            "pcode": "331100"
        },
        {
            "cityCode": "331127",
            "label": "景宁畲族自治县", "value": "景宁畲族自治县",
            "pcode": "331100"
        },
        {
            "cityCode": "331181",
            "label": "龙泉市", "value": "龙泉市",
            "pcode": "331100"
        }],
        "pcode": "330000"
    }]
},
{
    "cityCode": "340000",
    "label": "安徽省", "value": "安徽省",
    "children": [{
        "cityCode": "340100",
        "label": "合肥市", "value": "合肥市",
        "children": [{
            "cityCode": "340102",
            "label": "瑶海区", "value": "瑶海区",
            "pcode": "340100"
        },
        {
            "cityCode": "340103",
            "label": "庐阳区", "value": "庐阳区",
            "pcode": "340100"
        },
        {
            "cityCode": "340104",
            "label": "蜀山区", "value": "蜀山区",
            "pcode": "340100"
        },
        {
            "cityCode": "340111",
            "label": "包河区", "value": "包河区",
            "pcode": "340100"
        },
        {
            "cityCode": "340121",
            "label": "长丰县", "value": "长丰县",
            "pcode": "340100"
        },
        {
            "cityCode": "340122",
            "label": "肥东县", "value": "肥东县",
            "pcode": "340100"
        },
        {
            "cityCode": "340123",
            "label": "肥西县", "value": "肥西县",
            "pcode": "340100"
        },
        {
            "cityCode": "340124",
            "label": "庐江县", "value": "庐江县",
            "pcode": "340100"
        },
        {
            "cityCode": "340181",
            "label": "巢湖市", "value": "巢湖市",
            "pcode": "340100"
        }],
        "pcode": "340000"
    },
    {
        "cityCode": "340200",
        "label": "芜湖市", "value": "芜湖市",
        "children": [{
            "cityCode": "340202",
            "label": "镜湖区", "value": "镜湖区",
            "pcode": "340200"
        },
        {
            "cityCode": "340203",
            "label": "弋江区", "value": "弋江区",
            "pcode": "340200"
        },
        {
            "cityCode": "340207",
            "label": "鸠江区", "value": "鸠江区",
            "pcode": "340200"
        },
        {
            "cityCode": "340208",
            "label": "三山区", "value": "三山区",
            "pcode": "340200"
        },
        {
            "cityCode": "340221",
            "label": "芜湖县", "value": "芜湖县",
            "pcode": "340200"
        },
        {
            "cityCode": "340222",
            "label": "繁昌县", "value": "繁昌县",
            "pcode": "340200"
        },
        {
            "cityCode": "340223",
            "label": "南陵县", "value": "南陵县",
            "pcode": "340200"
        },
        {
            "cityCode": "340225",
            "label": "无为县", "value": "无为县",
            "pcode": "340200"
        }],
        "pcode": "340000"
    },
    {
        "cityCode": "340300",
        "label": "蚌埠市", "value": "蚌埠市",
        "children": [{
            "cityCode": "340302",
            "label": "龙子湖区", "value": "龙子湖区",
            "pcode": "340300"
        },
        {
            "cityCode": "340303",
            "label": "蚌山区", "value": "蚌山区",
            "pcode": "340300"
        },
        {
            "cityCode": "340304",
            "label": "禹会区", "value": "禹会区",
            "pcode": "340300"
        },
        {
            "cityCode": "340311",
            "label": "淮上区", "value": "淮上区",
            "pcode": "340300"
        },
        {
            "cityCode": "340321",
            "label": "怀远县", "value": "怀远县",
            "pcode": "340300"
        },
        {
            "cityCode": "340322",
            "label": "五河县", "value": "五河县",
            "pcode": "340300"
        },
        {
            "cityCode": "340323",
            "label": "固镇县", "value": "固镇县",
            "pcode": "340300"
        }],
        "pcode": "340000"
    },
    {
        "cityCode": "340400",
        "label": "淮南市", "value": "淮南市",
        "children": [{
            "cityCode": "340402",
            "label": "大通区", "value": "大通区",
            "pcode": "340400"
        },
        {
            "cityCode": "340403",
            "label": "田家庵区", "value": "田家庵区",
            "pcode": "340400"
        },
        {
            "cityCode": "340404",
            "label": "谢家集区", "value": "谢家集区",
            "pcode": "340400"
        },
        {
            "cityCode": "340405",
            "label": "八公山区", "value": "八公山区",
            "pcode": "340400"
        },
        {
            "cityCode": "340406",
            "label": "潘集区", "value": "潘集区",
            "pcode": "340400"
        },
        {
            "cityCode": "340421",
            "label": "凤台县", "value": "凤台县",
            "pcode": "340400"
        },
        {
            "cityCode": "340422",
            "label": "寿县", "value": "寿县",
            "pcode": "340400"
        }],
        "pcode": "340000"
    },
    {
        "cityCode": "340500",
        "label": "马鞍山市", "value": "马鞍山市",
        "children": [{
            "cityCode": "340503",
            "label": "花山区", "value": "花山区",
            "pcode": "340500"
        },
        {
            "cityCode": "340504",
            "label": "雨山区", "value": "雨山区",
            "pcode": "340500"
        },
        {
            "cityCode": "340506",
            "label": "博望区", "value": "博望区",
            "pcode": "340500"
        },
        {
            "cityCode": "340521",
            "label": "当涂县", "value": "当涂县",
            "pcode": "340500"
        },
        {
            "cityCode": "340522",
            "label": "含山县", "value": "含山县",
            "pcode": "340500"
        },
        {
            "cityCode": "340523",
            "label": "和县", "value": "和县",
            "pcode": "340500"
        }],
        "pcode": "340000"
    },
    {
        "cityCode": "340600",
        "label": "淮北市", "value": "淮北市",
        "children": [{
            "cityCode": "340602",
            "label": "杜集区", "value": "杜集区",
            "pcode": "340600"
        },
        {
            "cityCode": "340603",
            "label": "相山区", "value": "相山区",
            "pcode": "340600"
        },
        {
            "cityCode": "340604",
            "label": "烈山区", "value": "烈山区",
            "pcode": "340600"
        },
        {
            "cityCode": "340621",
            "label": "濉溪县", "value": "濉溪县",
            "pcode": "340600"
        }],
        "pcode": "340000"
    },
    {
        "cityCode": "340700",
        "label": "铜陵市", "value": "铜陵市",
        "children": [{
            "cityCode": "340705",
            "label": "铜官区", "value": "铜官区",
            "pcode": "340700"
        },
        {
            "cityCode": "340706",
            "label": "义安区", "value": "义安区",
            "pcode": "340700"
        },
        {
            "cityCode": "340711",
            "label": "郊区", "value": "郊区",
            "pcode": "340700"
        },
        {
            "cityCode": "340722",
            "label": "枞阳县", "value": "枞阳县",
            "pcode": "340700"
        }],
        "pcode": "340000"
    },
    {
        "cityCode": "340800",
        "label": "安庆市", "value": "安庆市",
        "children": [{
            "cityCode": "340802",
            "label": "迎江区", "value": "迎江区",
            "pcode": "340800"
        },
        {
            "cityCode": "340803",
            "label": "大观区", "value": "大观区",
            "pcode": "340800"
        },
        {
            "cityCode": "340811",
            "label": "宜秀区", "value": "宜秀区",
            "pcode": "340800"
        },
        {
            "cityCode": "340822",
            "label": "怀宁县", "value": "怀宁县",
            "pcode": "340800"
        },
        {
            "cityCode": "340824",
            "label": "潜山县", "value": "潜山县",
            "pcode": "340800"
        },
        {
            "cityCode": "340825",
            "label": "太湖县", "value": "太湖县",
            "pcode": "340800"
        },
        {
            "cityCode": "340826",
            "label": "宿松县", "value": "宿松县",
            "pcode": "340800"
        },
        {
            "cityCode": "340827",
            "label": "望江县", "value": "望江县",
            "pcode": "340800"
        },
        {
            "cityCode": "340828",
            "label": "岳西县", "value": "岳西县",
            "pcode": "340800"
        },
        {
            "cityCode": "340881",
            "label": "桐城市", "value": "桐城市",
            "pcode": "340800"
        }],
        "pcode": "340000"
    },
    {
        "cityCode": "341000",
        "label": "黄山市", "value": "黄山市",
        "children": [{
            "cityCode": "341002",
            "label": "屯溪区", "value": "屯溪区",
            "pcode": "341000"
        },
        {
            "cityCode": "341003",
            "label": "黄山区", "value": "黄山区",
            "pcode": "341000"
        },
        {
            "cityCode": "341004",
            "label": "徽州区", "value": "徽州区",
            "pcode": "341000"
        },
        {
            "cityCode": "341021",
            "label": "歙县", "value": "歙县",
            "pcode": "341000"
        },
        {
            "cityCode": "341022",
            "label": "休宁县", "value": "休宁县",
            "pcode": "341000"
        },
        {
            "cityCode": "341023",
            "label": "黟县", "value": "黟县",
            "pcode": "341000"
        },
        {
            "cityCode": "341024",
            "label": "祁门县", "value": "祁门县",
            "pcode": "341000"
        }],
        "pcode": "340000"
    },
    {
        "cityCode": "341100",
        "label": "滁州市", "value": "滁州市",
        "children": [{
            "cityCode": "341102",
            "label": "琅琊区", "value": "琅琊区",
            "pcode": "341100"
        },
        {
            "cityCode": "341103",
            "label": "南谯区", "value": "南谯区",
            "pcode": "341100"
        },
        {
            "cityCode": "341122",
            "label": "来安县", "value": "来安县",
            "pcode": "341100"
        },
        {
            "cityCode": "341124",
            "label": "全椒县", "value": "全椒县",
            "pcode": "341100"
        },
        {
            "cityCode": "341125",
            "label": "定远县", "value": "定远县",
            "pcode": "341100"
        },
        {
            "cityCode": "341126",
            "label": "凤阳县", "value": "凤阳县",
            "pcode": "341100"
        },
        {
            "cityCode": "341181",
            "label": "天长市", "value": "天长市",
            "pcode": "341100"
        },
        {
            "cityCode": "341182",
            "label": "明光市", "value": "明光市",
            "pcode": "341100"
        }],
        "pcode": "340000"
    },
    {
        "cityCode": "341200",
        "label": "阜阳市", "value": "阜阳市",
        "children": [{
            "cityCode": "341202",
            "label": "颍州区", "value": "颍州区",
            "pcode": "341200"
        },
        {
            "cityCode": "341203",
            "label": "颍东区", "value": "颍东区",
            "pcode": "341200"
        },
        {
            "cityCode": "341204",
            "label": "颍泉区", "value": "颍泉区",
            "pcode": "341200"
        },
        {
            "cityCode": "341221",
            "label": "临泉县", "value": "临泉县",
            "pcode": "341200"
        },
        {
            "cityCode": "341222",
            "label": "太和县", "value": "太和县",
            "pcode": "341200"
        },
        {
            "cityCode": "341225",
            "label": "阜南县", "value": "阜南县",
            "pcode": "341200"
        },
        {
            "cityCode": "341226",
            "label": "颍上县", "value": "颍上县",
            "pcode": "341200"
        },
        {
            "cityCode": "341282",
            "label": "界首市", "value": "界首市",
            "pcode": "341200"
        }],
        "pcode": "340000"
    },
    {
        "cityCode": "341300",
        "label": "宿州市", "value": "宿州市",
        "children": [{
            "cityCode": "341302",
            "label": "埇桥区", "value": "埇桥区",
            "pcode": "341300"
        },
        {
            "cityCode": "341321",
            "label": "砀山县", "value": "砀山县",
            "pcode": "341300"
        },
        {
            "cityCode": "341322",
            "label": "萧县", "value": "萧县",
            "pcode": "341300"
        },
        {
            "cityCode": "341323",
            "label": "灵璧县", "value": "灵璧县",
            "pcode": "341300"
        },
        {
            "cityCode": "341324",
            "label": "泗县", "value": "泗县",
            "pcode": "341300"
        }],
        "pcode": "340000"
    },
    {
        "cityCode": "341500",
        "label": "六安市", "value": "六安市",
        "children": [{
            "cityCode": "341502",
            "label": "金安区", "value": "金安区",
            "pcode": "341500"
        },
        {
            "cityCode": "341503",
            "label": "裕安区", "value": "裕安区",
            "pcode": "341500"
        },
        {
            "cityCode": "341504",
            "label": "叶集区", "value": "叶集区",
            "pcode": "341500"
        },
        {
            "cityCode": "341522",
            "label": "霍邱县", "value": "霍邱县",
            "pcode": "341500"
        },
        {
            "cityCode": "341523",
            "label": "舒城县", "value": "舒城县",
            "pcode": "341500"
        },
        {
            "cityCode": "341524",
            "label": "金寨县", "value": "金寨县",
            "pcode": "341500"
        },
        {
            "cityCode": "341525",
            "label": "霍山县", "value": "霍山县",
            "pcode": "341500"
        }],
        "pcode": "340000"
    },
    {
        "cityCode": "341600",
        "label": "亳州市", "value": "亳州市",
        "children": [{
            "cityCode": "341602",
            "label": "谯城区", "value": "谯城区",
            "pcode": "341600"
        },
        {
            "cityCode": "341621",
            "label": "涡阳县", "value": "涡阳县",
            "pcode": "341600"
        },
        {
            "cityCode": "341622",
            "label": "蒙城县", "value": "蒙城县",
            "pcode": "341600"
        },
        {
            "cityCode": "341623",
            "label": "利辛县", "value": "利辛县",
            "pcode": "341600"
        }],
        "pcode": "340000"
    },
    {
        "cityCode": "341700",
        "label": "池州市", "value": "池州市",
        "children": [{
            "cityCode": "341702",
            "label": "贵池区", "value": "贵池区",
            "pcode": "341700"
        },
        {
            "cityCode": "341721",
            "label": "东至县", "value": "东至县",
            "pcode": "341700"
        },
        {
            "cityCode": "341722",
            "label": "石台县", "value": "石台县",
            "pcode": "341700"
        },
        {
            "cityCode": "341723",
            "label": "青阳县", "value": "青阳县",
            "pcode": "341700"
        }],
        "pcode": "340000"
    },
    {
        "cityCode": "341800",
        "label": "宣城市", "value": "宣城市",
        "children": [{
            "cityCode": "341802",
            "label": "宣州区", "value": "宣州区",
            "pcode": "341800"
        },
        {
            "cityCode": "341821",
            "label": "郎溪县", "value": "郎溪县",
            "pcode": "341800"
        },
        {
            "cityCode": "341822",
            "label": "广德县", "value": "广德县",
            "pcode": "341800"
        },
        {
            "cityCode": "341823",
            "label": "泾县", "value": "泾县",
            "pcode": "341800"
        },
        {
            "cityCode": "341824",
            "label": "绩溪县", "value": "绩溪县",
            "pcode": "341800"
        },
        {
            "cityCode": "341825",
            "label": "旌德县", "value": "旌德县",
            "pcode": "341800"
        },
        {
            "cityCode": "341881",
            "label": "宁国市", "value": "宁国市",
            "pcode": "341800"
        }],
        "pcode": "340000"
    }]
},
{
    "cityCode": "350000",
    "label": "福建省", "value": "福建省",
    "children": [{
        "cityCode": "350100",
        "label": "福州市", "value": "福州市",
        "children": [{
            "cityCode": "350102",
            "label": "鼓楼区", "value": "鼓楼区",
            "pcode": "350100"
        },
        {
            "cityCode": "350103",
            "label": "台江区", "value": "台江区",
            "pcode": "350100"
        },
        {
            "cityCode": "350104",
            "label": "仓山区", "value": "仓山区",
            "pcode": "350100"
        },
        {
            "cityCode": "350105",
            "label": "马尾区", "value": "马尾区",
            "pcode": "350100"
        },
        {
            "cityCode": "350111",
            "label": "晋安区", "value": "晋安区",
            "pcode": "350100"
        },
        {
            "cityCode": "350121",
            "label": "闽侯县", "value": "闽侯县",
            "pcode": "350100"
        },
        {
            "cityCode": "350122",
            "label": "连江县", "value": "连江县",
            "pcode": "350100"
        },
        {
            "cityCode": "350123",
            "label": "罗源县", "value": "罗源县",
            "pcode": "350100"
        },
        {
            "cityCode": "350124",
            "label": "闽清县", "value": "闽清县",
            "pcode": "350100"
        },
        {
            "cityCode": "350125",
            "label": "永泰县", "value": "永泰县",
            "pcode": "350100"
        },
        {
            "cityCode": "350128",
            "label": "平潭县", "value": "平潭县",
            "pcode": "350100"
        },
        {
            "cityCode": "350181",
            "label": "福清市", "value": "福清市",
            "pcode": "350100"
        },
        {
            "cityCode": "350182",
            "label": "长乐区", "value": "长乐区",
            "pcode": "350100"
        }],
        "pcode": "350000"
    },
    {
        "cityCode": "350200",
        "label": "厦门市", "value": "厦门市",
        "children": [{
            "cityCode": "350203",
            "label": "思明区", "value": "思明区",
            "pcode": "350200"
        },
        {
            "cityCode": "350205",
            "label": "海沧区", "value": "海沧区",
            "pcode": "350200"
        },
        {
            "cityCode": "350206",
            "label": "湖里区", "value": "湖里区",
            "pcode": "350200"
        },
        {
            "cityCode": "350211",
            "label": "集美区", "value": "集美区",
            "pcode": "350200"
        },
        {
            "cityCode": "350212",
            "label": "同安区", "value": "同安区",
            "pcode": "350200"
        },
        {
            "cityCode": "350213",
            "label": "翔安区", "value": "翔安区",
            "pcode": "350200"
        }],
        "pcode": "350000"
    },
    {
        "cityCode": "350300",
        "label": "莆田市", "value": "莆田市",
        "children": [{
            "cityCode": "350302",
            "label": "城厢区", "value": "城厢区",
            "pcode": "350300"
        },
        {
            "cityCode": "350303",
            "label": "涵江区", "value": "涵江区",
            "pcode": "350300"
        },
        {
            "cityCode": "350304",
            "label": "荔城区", "value": "荔城区",
            "pcode": "350300"
        },
        {
            "cityCode": "350305",
            "label": "秀屿区", "value": "秀屿区",
            "pcode": "350300"
        },
        {
            "cityCode": "350322",
            "label": "仙游县", "value": "仙游县",
            "pcode": "350300"
        }],
        "pcode": "350000"
    },
    {
        "cityCode": "350400",
        "label": "三明市", "value": "三明市",
        "children": [{
            "cityCode": "350402",
            "label": "梅列区", "value": "梅列区",
            "pcode": "350400"
        },
        {
            "cityCode": "350403",
            "label": "三元区", "value": "三元区",
            "pcode": "350400"
        },
        {
            "cityCode": "350421",
            "label": "明溪县", "value": "明溪县",
            "pcode": "350400"
        },
        {
            "cityCode": "350423",
            "label": "清流县", "value": "清流县",
            "pcode": "350400"
        },
        {
            "cityCode": "350424",
            "label": "宁化县", "value": "宁化县",
            "pcode": "350400"
        },
        {
            "cityCode": "350425",
            "label": "大田县", "value": "大田县",
            "pcode": "350400"
        },
        {
            "cityCode": "350426",
            "label": "尤溪县", "value": "尤溪县",
            "pcode": "350400"
        },
        {
            "cityCode": "350427",
            "label": "沙县", "value": "沙县",
            "pcode": "350400"
        },
        {
            "cityCode": "350428",
            "label": "将乐县", "value": "将乐县",
            "pcode": "350400"
        },
        {
            "cityCode": "350429",
            "label": "泰宁县", "value": "泰宁县",
            "pcode": "350400"
        },
        {
            "cityCode": "350430",
            "label": "建宁县", "value": "建宁县",
            "pcode": "350400"
        },
        {
            "cityCode": "350481",
            "label": "永安市", "value": "永安市",
            "pcode": "350400"
        }],
        "pcode": "350000"
    },
    {
        "cityCode": "350500",
        "label": "泉州市", "value": "泉州市",
        "children": [{
            "cityCode": "350502",
            "label": "鲤城区", "value": "鲤城区",
            "pcode": "350500"
        },
        {
            "cityCode": "350503",
            "label": "丰泽区", "value": "丰泽区",
            "pcode": "350500"
        },
        {
            "cityCode": "350504",
            "label": "洛江区", "value": "洛江区",
            "pcode": "350500"
        },
        {
            "cityCode": "350505",
            "label": "泉港区", "value": "泉港区",
            "pcode": "350500"
        },
        {
            "cityCode": "350521",
            "label": "惠安县", "value": "惠安县",
            "pcode": "350500"
        },
        {
            "cityCode": "350524",
            "label": "安溪县", "value": "安溪县",
            "pcode": "350500"
        },
        {
            "cityCode": "350525",
            "label": "永春县", "value": "永春县",
            "pcode": "350500"
        },
        {
            "cityCode": "350526",
            "label": "德化县", "value": "德化县",
            "pcode": "350500"
        },
        {
            "cityCode": "350527",
            "label": "金门县", "value": "金门县",
            "pcode": "350500"
        },
        {
            "cityCode": "350581",
            "label": "石狮市", "value": "石狮市",
            "pcode": "350500"
        },
        {
            "cityCode": "350582",
            "label": "晋江市", "value": "晋江市",
            "pcode": "350500"
        },
        {
            "cityCode": "350583",
            "label": "南安市", "value": "南安市",
            "pcode": "350500"
        }],
        "pcode": "350000"
    },
    {
        "cityCode": "350600",
        "label": "漳州市", "value": "漳州市",
        "children": [{
            "cityCode": "350602",
            "label": "芗城区", "value": "芗城区",
            "pcode": "350600"
        },
        {
            "cityCode": "350603",
            "label": "龙文区", "value": "龙文区",
            "pcode": "350600"
        },
        {
            "cityCode": "350622",
            "label": "云霄县", "value": "云霄县",
            "pcode": "350600"
        },
        {
            "cityCode": "350623",
            "label": "漳浦县", "value": "漳浦县",
            "pcode": "350600"
        },
        {
            "cityCode": "350624",
            "label": "诏安县", "value": "诏安县",
            "pcode": "350600"
        },
        {
            "cityCode": "350625",
            "label": "长泰县", "value": "长泰县",
            "pcode": "350600"
        },
        {
            "cityCode": "350626",
            "label": "东山县", "value": "东山县",
            "pcode": "350600"
        },
        {
            "cityCode": "350627",
            "label": "南靖县", "value": "南靖县",
            "pcode": "350600"
        },
        {
            "cityCode": "350628",
            "label": "平和县", "value": "平和县",
            "pcode": "350600"
        },
        {
            "cityCode": "350629",
            "label": "华安县", "value": "华安县",
            "pcode": "350600"
        },
        {
            "cityCode": "350681",
            "label": "龙海市", "value": "龙海市",
            "pcode": "350600"
        }],
        "pcode": "350000"
    },
    {
        "cityCode": "350700",
        "label": "南平市", "value": "南平市",
        "children": [{
            "cityCode": "350702",
            "label": "延平区", "value": "延平区",
            "pcode": "350700"
        },
        {
            "cityCode": "350703",
            "label": "建阳区", "value": "建阳区",
            "pcode": "350700"
        },
        {
            "cityCode": "350721",
            "label": "顺昌县", "value": "顺昌县",
            "pcode": "350700"
        },
        {
            "cityCode": "350722",
            "label": "浦城县", "value": "浦城县",
            "pcode": "350700"
        },
        {
            "cityCode": "350723",
            "label": "光泽县", "value": "光泽县",
            "pcode": "350700"
        },
        {
            "cityCode": "350724",
            "label": "松溪县", "value": "松溪县",
            "pcode": "350700"
        },
        {
            "cityCode": "350725",
            "label": "政和县", "value": "政和县",
            "pcode": "350700"
        },
        {
            "cityCode": "350781",
            "label": "邵武市", "value": "邵武市",
            "pcode": "350700"
        },
        {
            "cityCode": "350782",
            "label": "武夷山市", "value": "武夷山市",
            "pcode": "350700"
        },
        {
            "cityCode": "350783",
            "label": "建瓯市", "value": "建瓯市",
            "pcode": "350700"
        }],
        "pcode": "350000"
    },
    {
        "cityCode": "350800",
        "label": "龙岩市", "value": "龙岩市",
        "children": [{
            "cityCode": "350802",
            "label": "新罗区", "value": "新罗区",
            "pcode": "350800"
        },
        {
            "cityCode": "350803",
            "label": "永定区", "value": "永定区",
            "pcode": "350800"
        },
        {
            "cityCode": "350821",
            "label": "长汀县", "value": "长汀县",
            "pcode": "350800"
        },
        {
            "cityCode": "350823",
            "label": "上杭县", "value": "上杭县",
            "pcode": "350800"
        },
        {
            "cityCode": "350824",
            "label": "武平县", "value": "武平县",
            "pcode": "350800"
        },
        {
            "cityCode": "350825",
            "label": "连城县", "value": "连城县",
            "pcode": "350800"
        },
        {
            "cityCode": "350881",
            "label": "漳平市", "value": "漳平市",
            "pcode": "350800"
        }],
        "pcode": "350000"
    },
    {
        "cityCode": "350900",
        "label": "宁德市", "value": "宁德市",
        "children": [{
            "cityCode": "350902",
            "label": "蕉城区", "value": "蕉城区",
            "pcode": "350900"
        },
        {
            "cityCode": "350921",
            "label": "霞浦县", "value": "霞浦县",
            "pcode": "350900"
        },
        {
            "cityCode": "350922",
            "label": "古田县", "value": "古田县",
            "pcode": "350900"
        },
        {
            "cityCode": "350923",
            "label": "屏南县", "value": "屏南县",
            "pcode": "350900"
        },
        {
            "cityCode": "350924",
            "label": "寿宁县", "value": "寿宁县",
            "pcode": "350900"
        },
        {
            "cityCode": "350925",
            "label": "周宁县", "value": "周宁县",
            "pcode": "350900"
        },
        {
            "cityCode": "350926",
            "label": "柘荣县", "value": "柘荣县",
            "pcode": "350900"
        },
        {
            "cityCode": "350981",
            "label": "福安市", "value": "福安市",
            "pcode": "350900"
        },
        {
            "cityCode": "350982",
            "label": "福鼎市", "value": "福鼎市",
            "pcode": "350900"
        }],
        "pcode": "350000"
    }]
},
{
    "cityCode": "360000",
    "label": "江西省", "value": "江西省",
    "children": [{
        "cityCode": "360100",
        "label": "南昌市", "value": "南昌市",
        "children": [{
            "cityCode": "360102",
            "label": "东湖区", "value": "东湖区",
            "pcode": "360100"
        },
        {
            "cityCode": "360103",
            "label": "西湖区", "value": "西湖区",
            "pcode": "360100"
        },
        {
            "cityCode": "360104",
            "label": "青云谱区", "value": "青云谱区",
            "pcode": "360100"
        },
        {
            "cityCode": "360105",
            "label": "湾里区", "value": "湾里区",
            "pcode": "360100"
        },
        {
            "cityCode": "360111",
            "label": "青山湖区", "value": "青山湖区",
            "pcode": "360100"
        },
        {
            "cityCode": "360112",
            "label": "新建区", "value": "新建区",
            "pcode": "360100"
        },
        {
            "cityCode": "360121",
            "label": "南昌县", "value": "南昌县",
            "pcode": "360100"
        },
        {
            "cityCode": "360123",
            "label": "安义县", "value": "安义县",
            "pcode": "360100"
        },
        {
            "cityCode": "360124",
            "label": "进贤县", "value": "进贤县",
            "pcode": "360100"
        }],
        "pcode": "360000"
    },
    {
        "cityCode": "360200",
        "label": "景德镇市", "value": "景德镇市",
        "children": [{
            "cityCode": "360202",
            "label": "昌江区", "value": "昌江区",
            "pcode": "360200"
        },
        {
            "cityCode": "360203",
            "label": "珠山区", "value": "珠山区",
            "pcode": "360200"
        },
        {
            "cityCode": "360222",
            "label": "浮梁县", "value": "浮梁县",
            "pcode": "360200"
        },
        {
            "cityCode": "360281",
            "label": "乐平市", "value": "乐平市",
            "pcode": "360200"
        }],
        "pcode": "360000"
    },
    {
        "cityCode": "360300",
        "label": "萍乡市", "value": "萍乡市",
        "children": [{
            "cityCode": "360302",
            "label": "安源区", "value": "安源区",
            "pcode": "360300"
        },
        {
            "cityCode": "360313",
            "label": "湘东区", "value": "湘东区",
            "pcode": "360300"
        },
        {
            "cityCode": "360321",
            "label": "莲花县", "value": "莲花县",
            "pcode": "360300"
        },
        {
            "cityCode": "360322",
            "label": "上栗县", "value": "上栗县",
            "pcode": "360300"
        },
        {
            "cityCode": "360323",
            "label": "芦溪县", "value": "芦溪县",
            "pcode": "360300"
        }],
        "pcode": "360000"
    },
    {
        "cityCode": "360400",
        "label": "九江市", "value": "九江市",
        "children": [{
            "cityCode": "360402",
            "label": "濂溪区", "value": "濂溪区",
            "pcode": "360400"
        },
        {
            "cityCode": "360403",
            "label": "浔阳区", "value": "浔阳区",
            "pcode": "360400"
        },
        {
            "cityCode": "360421",
            "label": "九江县", "value": "九江县",
            "pcode": "360400"
        },
        {
            "cityCode": "360423",
            "label": "武宁县", "value": "武宁县",
            "pcode": "360400"
        },
        {
            "cityCode": "360424",
            "label": "修水县", "value": "修水县",
            "pcode": "360400"
        },
        {
            "cityCode": "360425",
            "label": "永修县", "value": "永修县",
            "pcode": "360400"
        },
        {
            "cityCode": "360426",
            "label": "德安县", "value": "德安县",
            "pcode": "360400"
        },
        {
            "cityCode": "360427",
            "label": "庐山市", "value": "庐山市",
            "pcode": "360400"
        },
        {
            "cityCode": "360428",
            "label": "都昌县", "value": "都昌县",
            "pcode": "360400"
        },
        {
            "cityCode": "360429",
            "label": "湖口县", "value": "湖口县",
            "pcode": "360400"
        },
        {
            "cityCode": "360430",
            "label": "彭泽县", "value": "彭泽县",
            "pcode": "360400"
        },
        {
            "cityCode": "360481",
            "label": "瑞昌市", "value": "瑞昌市",
            "pcode": "360400"
        },
        {
            "cityCode": "360482",
            "label": "共青城市", "value": "共青城市",
            "pcode": "360400"
        }],
        "pcode": "360000"
    },
    {
        "cityCode": "360500",
        "label": "新余市", "value": "新余市",
        "children": [{
            "cityCode": "360502",
            "label": "渝水区", "value": "渝水区",
            "pcode": "360500"
        },
        {
            "cityCode": "360521",
            "label": "分宜县", "value": "分宜县",
            "pcode": "360500"
        }],
        "pcode": "360000"
    },
    {
        "cityCode": "360600",
        "label": "鹰潭市", "value": "鹰潭市",
        "children": [{
            "cityCode": "360602",
            "label": "月湖区", "value": "月湖区",
            "pcode": "360600"
        },
        {
            "cityCode": "360622",
            "label": "余江县", "value": "余江县",
            "pcode": "360600"
        },
        {
            "cityCode": "360681",
            "label": "贵溪市", "value": "贵溪市",
            "pcode": "360600"
        }],
        "pcode": "360000"
    },
    {
        "cityCode": "360700",
        "label": "赣州市", "value": "赣州市",
        "children": [{
            "cityCode": "360702",
            "label": "章贡区", "value": "章贡区",
            "pcode": "360700"
        },
        {
            "cityCode": "360703",
            "label": "南康区", "value": "南康区",
            "pcode": "360700"
        },
        {
            "cityCode": "360704",
            "label": "赣县区", "value": "赣县区",
            "pcode": "360700"
        },
        {
            "cityCode": "360722",
            "label": "信丰县", "value": "信丰县",
            "pcode": "360700"
        },
        {
            "cityCode": "360723",
            "label": "大余县", "value": "大余县",
            "pcode": "360700"
        },
        {
            "cityCode": "360724",
            "label": "上犹县", "value": "上犹县",
            "pcode": "360700"
        },
        {
            "cityCode": "360725",
            "label": "崇义县", "value": "崇义县",
            "pcode": "360700"
        },
        {
            "cityCode": "360726",
            "label": "安远县", "value": "安远县",
            "pcode": "360700"
        },
        {
            "cityCode": "360727",
            "label": "龙南县", "value": "龙南县",
            "pcode": "360700"
        },
        {
            "cityCode": "360728",
            "label": "定南县", "value": "定南县",
            "pcode": "360700"
        },
        {
            "cityCode": "360729",
            "label": "全南县", "value": "全南县",
            "pcode": "360700"
        },
        {
            "cityCode": "360730",
            "label": "宁都县", "value": "宁都县",
            "pcode": "360700"
        },
        {
            "cityCode": "360731",
            "label": "于都县", "value": "于都县",
            "pcode": "360700"
        },
        {
            "cityCode": "360732",
            "label": "兴国县", "value": "兴国县",
            "pcode": "360700"
        },
        {
            "cityCode": "360733",
            "label": "会昌县", "value": "会昌县",
            "pcode": "360700"
        },
        {
            "cityCode": "360734",
            "label": "寻乌县", "value": "寻乌县",
            "pcode": "360700"
        },
        {
            "cityCode": "360735",
            "label": "石城县", "value": "石城县",
            "pcode": "360700"
        },
        {
            "cityCode": "360781",
            "label": "瑞金市", "value": "瑞金市",
            "pcode": "360700"
        }],
        "pcode": "360000"
    },
    {
        "cityCode": "360800",
        "label": "吉安市", "value": "吉安市",
        "children": [{
            "cityCode": "360802",
            "label": "吉州区", "value": "吉州区",
            "pcode": "360800"
        },
        {
            "cityCode": "360803",
            "label": "青原区", "value": "青原区",
            "pcode": "360800"
        },
        {
            "cityCode": "360821",
            "label": "吉安县", "value": "吉安县",
            "pcode": "360800"
        },
        {
            "cityCode": "360822",
            "label": "吉水县", "value": "吉水县",
            "pcode": "360800"
        },
        {
            "cityCode": "360823",
            "label": "峡江县", "value": "峡江县",
            "pcode": "360800"
        },
        {
            "cityCode": "360824",
            "label": "新干县", "value": "新干县",
            "pcode": "360800"
        },
        {
            "cityCode": "360825",
            "label": "永丰县", "value": "永丰县",
            "pcode": "360800"
        },
        {
            "cityCode": "360826",
            "label": "泰和县", "value": "泰和县",
            "pcode": "360800"
        },
        {
            "cityCode": "360827",
            "label": "遂川县", "value": "遂川县",
            "pcode": "360800"
        },
        {
            "cityCode": "360828",
            "label": "万安县", "value": "万安县",
            "pcode": "360800"
        },
        {
            "cityCode": "360829",
            "label": "安福县", "value": "安福县",
            "pcode": "360800"
        },
        {
            "cityCode": "360830",
            "label": "永新县", "value": "永新县",
            "pcode": "360800"
        },
        {
            "cityCode": "360881",
            "label": "井冈山市", "value": "井冈山市",
            "pcode": "360800"
        }],
        "pcode": "360000"
    },
    {
        "cityCode": "360900",
        "label": "宜春市", "value": "宜春市",
        "children": [{
            "cityCode": "360902",
            "label": "袁州区", "value": "袁州区",
            "pcode": "360900"
        },
        {
            "cityCode": "360921",
            "label": "奉新县", "value": "奉新县",
            "pcode": "360900"
        },
        {
            "cityCode": "360922",
            "label": "万载县", "value": "万载县",
            "pcode": "360900"
        },
        {
            "cityCode": "360923",
            "label": "上高县", "value": "上高县",
            "pcode": "360900"
        },
        {
            "cityCode": "360924",
            "label": "宜丰县", "value": "宜丰县",
            "pcode": "360900"
        },
        {
            "cityCode": "360925",
            "label": "靖安县", "value": "靖安县",
            "pcode": "360900"
        },
        {
            "cityCode": "360926",
            "label": "铜鼓县", "value": "铜鼓县",
            "pcode": "360900"
        },
        {
            "cityCode": "360981",
            "label": "丰城市", "value": "丰城市",
            "pcode": "360900"
        },
        {
            "cityCode": "360982",
            "label": "樟树市", "value": "樟树市",
            "pcode": "360900"
        },
        {
            "cityCode": "360983",
            "label": "高安市", "value": "高安市",
            "pcode": "360900"
        }],
        "pcode": "360000"
    },
    {
        "cityCode": "361000",
        "label": "抚州市", "value": "抚州市",
        "children": [{
            "cityCode": "361002",
            "label": "临川区", "value": "临川区",
            "pcode": "361000"
        },
        {
            "cityCode": "361021",
            "label": "南城县", "value": "南城县",
            "pcode": "361000"
        },
        {
            "cityCode": "361022",
            "label": "黎川县", "value": "黎川县",
            "pcode": "361000"
        },
        {
            "cityCode": "361023",
            "label": "南丰县", "value": "南丰县",
            "pcode": "361000"
        },
        {
            "cityCode": "361024",
            "label": "崇仁县", "value": "崇仁县",
            "pcode": "361000"
        },
        {
            "cityCode": "361025",
            "label": "乐安县", "value": "乐安县",
            "pcode": "361000"
        },
        {
            "cityCode": "361026",
            "label": "宜黄县", "value": "宜黄县",
            "pcode": "361000"
        },
        {
            "cityCode": "361027",
            "label": "金溪县", "value": "金溪县",
            "pcode": "361000"
        },
        {
            "cityCode": "361028",
            "label": "资溪县", "value": "资溪县",
            "pcode": "361000"
        },
        {
            "cityCode": "361029",
            "label": "东乡区", "value": "东乡区",
            "pcode": "361000"
        },
        {
            "cityCode": "361030",
            "label": "广昌县", "value": "广昌县",
            "pcode": "361000"
        }],
        "pcode": "360000"
    },
    {
        "cityCode": "361100",
        "label": "上饶市", "value": "上饶市",
        "children": [{
            "cityCode": "361102",
            "label": "信州区", "value": "信州区",
            "pcode": "361100"
        },
        {
            "cityCode": "361103",
            "label": "广丰区", "value": "广丰区",
            "pcode": "361100"
        },
        {
            "cityCode": "361121",
            "label": "广信区", "value": "广信区",
            "pcode": "361100"
        },
        {
            "cityCode": "361123",
            "label": "玉山县", "value": "玉山县",
            "pcode": "361100"
        },
        {
            "cityCode": "361124",
            "label": "铅山县", "value": "铅山县",
            "pcode": "361100"
        },
        {
            "cityCode": "361125",
            "label": "横峰县", "value": "横峰县",
            "pcode": "361100"
        },
        {
            "cityCode": "361126",
            "label": "弋阳县", "value": "弋阳县",
            "pcode": "361100"
        },
        {
            "cityCode": "361127",
            "label": "余干县", "value": "余干县",
            "pcode": "361100"
        },
        {
            "cityCode": "361128",
            "label": "鄱阳县", "value": "鄱阳县",
            "pcode": "361100"
        },
        {
            "cityCode": "361129",
            "label": "万年县", "value": "万年县",
            "pcode": "361100"
        },
        {
            "cityCode": "361130",
            "label": "婺源县", "value": "婺源县",
            "pcode": "361100"
        },
        {
            "cityCode": "361181",
            "label": "德兴市", "value": "德兴市",
            "pcode": "361100"
        }],
        "pcode": "360000"
    }]
},
{
    "cityCode": "370000",
    "label": "山东省", "value": "山东省",
    "children": [{
        "cityCode": "370100",
        "label": "济南市", "value": "济南市",
        "children": [{
            "cityCode": "370102",
            "label": "历下区", "value": "历下区",
            "pcode": "370100"
        },
        {
            "cityCode": "370103",
            "label": "市中区", "value": "市中区",
            "pcode": "370100"
        },
        {
            "cityCode": "370104",
            "label": "槐荫区", "value": "槐荫区",
            "pcode": "370100"
        },
        {
            "cityCode": "370105",
            "label": "天桥区", "value": "天桥区",
            "pcode": "370100"
        },
        {
            "cityCode": "370112",
            "label": "历城区", "value": "历城区",
            "pcode": "370100"
        },
        {
            "cityCode": "370113",
            "label": "长清区", "value": "长清区",
            "pcode": "370100"
        },
        {
            "cityCode": "370124",
            "label": "平阴县", "value": "平阴县",
            "pcode": "370100"
        },
        {
            "cityCode": "370125",
            "label": "济阳县", "value": "济阳县",
            "pcode": "370100"
        },
        {
            "cityCode": "370126",
            "label": "商河县", "value": "商河县",
            "pcode": "370100"
        },
        {
            "cityCode": "370181",
            "label": "章丘区", "value": "章丘区",
            "pcode": "370100"
        }],
        "pcode": "370000"
    },
    {
        "cityCode": "370200",
        "label": "青岛市", "value": "青岛市",
        "children": [{
            "cityCode": "370202",
            "label": "市南区", "value": "市南区",
            "pcode": "370200"
        },
        {
            "cityCode": "370203",
            "label": "市北区", "value": "市北区",
            "pcode": "370200"
        },
        {
            "cityCode": "370211",
            "label": "黄岛区", "value": "黄岛区",
            "pcode": "370200"
        },
        {
            "cityCode": "370212",
            "label": "崂山区", "value": "崂山区",
            "pcode": "370200"
        },
        {
            "cityCode": "370213",
            "label": "李沧区", "value": "李沧区",
            "pcode": "370200"
        },
        {
            "cityCode": "370214",
            "label": "城阳区", "value": "城阳区",
            "pcode": "370200"
        },
        {
            "cityCode": "370281",
            "label": "胶州市", "value": "胶州市",
            "pcode": "370200"
        },
        {
            "cityCode": "370282",
            "label": "即墨区", "value": "即墨区",
            "pcode": "370200"
        },
        {
            "cityCode": "370283",
            "label": "平度市", "value": "平度市",
            "pcode": "370200"
        },
        {
            "cityCode": "370285",
            "label": "莱西市", "value": "莱西市",
            "pcode": "370200"
        }],
        "pcode": "370000"
    },
    {
        "cityCode": "370300",
        "label": "淄博市", "value": "淄博市",
        "children": [{
            "cityCode": "370302",
            "label": "淄川区", "value": "淄川区",
            "pcode": "370300"
        },
        {
            "cityCode": "370303",
            "label": "张店区", "value": "张店区",
            "pcode": "370300"
        },
        {
            "cityCode": "370304",
            "label": "博山区", "value": "博山区",
            "pcode": "370300"
        },
        {
            "cityCode": "370305",
            "label": "临淄区", "value": "临淄区",
            "pcode": "370300"
        },
        {
            "cityCode": "370306",
            "label": "周村区", "value": "周村区",
            "pcode": "370300"
        },
        {
            "cityCode": "370321",
            "label": "桓台县", "value": "桓台县",
            "pcode": "370300"
        },
        {
            "cityCode": "370322",
            "label": "高青县", "value": "高青县",
            "pcode": "370300"
        },
        {
            "cityCode": "370323",
            "label": "沂源县", "value": "沂源县",
            "pcode": "370300"
        }],
        "pcode": "370000"
    },
    {
        "cityCode": "370400",
        "label": "枣庄市", "value": "枣庄市",
        "children": [{
            "cityCode": "370402",
            "label": "市中区", "value": "市中区",
            "pcode": "370400"
        },
        {
            "cityCode": "370403",
            "label": "薛城区", "value": "薛城区",
            "pcode": "370400"
        },
        {
            "cityCode": "370404",
            "label": "峄城区", "value": "峄城区",
            "pcode": "370400"
        },
        {
            "cityCode": "370405",
            "label": "台儿庄区", "value": "台儿庄区",
            "pcode": "370400"
        },
        {
            "cityCode": "370406",
            "label": "山亭区", "value": "山亭区",
            "pcode": "370400"
        },
        {
            "cityCode": "370481",
            "label": "滕州市", "value": "滕州市",
            "pcode": "370400"
        }],
        "pcode": "370000"
    },
    {
        "cityCode": "370500",
        "label": "东营市", "value": "东营市",
        "children": [{
            "cityCode": "370502",
            "label": "东营区", "value": "东营区",
            "pcode": "370500"
        },
        {
            "cityCode": "370503",
            "label": "河口区", "value": "河口区",
            "pcode": "370500"
        },
        {
            "cityCode": "370505",
            "label": "垦利区", "value": "垦利区",
            "pcode": "370500"
        },
        {
            "cityCode": "370522",
            "label": "利津县", "value": "利津县",
            "pcode": "370500"
        },
        {
            "cityCode": "370523",
            "label": "广饶县", "value": "广饶县",
            "pcode": "370500"
        }],
        "pcode": "370000"
    },
    {
        "cityCode": "370600",
        "label": "烟台市", "value": "烟台市",
        "children": [{
            "cityCode": "370602",
            "label": "芝罘区", "value": "芝罘区",
            "pcode": "370600"
        },
        {
            "cityCode": "370611",
            "label": "福山区", "value": "福山区",
            "pcode": "370600"
        },
        {
            "cityCode": "370612",
            "label": "牟平区", "value": "牟平区",
            "pcode": "370600"
        },
        {
            "cityCode": "370613",
            "label": "莱山区", "value": "莱山区",
            "pcode": "370600"
        },
        {
            "cityCode": "370634",
            "label": "长岛县", "value": "长岛县",
            "pcode": "370600"
        },
        {
            "cityCode": "370681",
            "label": "龙口市", "value": "龙口市",
            "pcode": "370600"
        },
        {
            "cityCode": "370682",
            "label": "莱阳市", "value": "莱阳市",
            "pcode": "370600"
        },
        {
            "cityCode": "370683",
            "label": "莱州市", "value": "莱州市",
            "pcode": "370600"
        },
        {
            "cityCode": "370684",
            "label": "蓬莱市", "value": "蓬莱市",
            "pcode": "370600"
        },
        {
            "cityCode": "370685",
            "label": "招远市", "value": "招远市",
            "pcode": "370600"
        },
        {
            "cityCode": "370686",
            "label": "栖霞市", "value": "栖霞市",
            "pcode": "370600"
        },
        {
            "cityCode": "370687",
            "label": "海阳市", "value": "海阳市",
            "pcode": "370600"
        }],
        "pcode": "370000"
    },
    {
        "cityCode": "370700",
        "label": "潍坊市", "value": "潍坊市",
        "children": [{
            "cityCode": "370702",
            "label": "潍城区", "value": "潍城区",
            "pcode": "370700"
        },
        {
            "cityCode": "370703",
            "label": "寒亭区", "value": "寒亭区",
            "pcode": "370700"
        },
        {
            "cityCode": "370704",
            "label": "坊子区", "value": "坊子区",
            "pcode": "370700"
        },
        {
            "cityCode": "370705",
            "label": "奎文区", "value": "奎文区",
            "pcode": "370700"
        },
        {
            "cityCode": "370724",
            "label": "临朐县", "value": "临朐县",
            "pcode": "370700"
        },
        {
            "cityCode": "370725",
            "label": "昌乐县", "value": "昌乐县",
            "pcode": "370700"
        },
        {
            "cityCode": "370781",
            "label": "青州市", "value": "青州市",
            "pcode": "370700"
        },
        {
            "cityCode": "370782",
            "label": "诸城市", "value": "诸城市",
            "pcode": "370700"
        },
        {
            "cityCode": "370783",
            "label": "寿光市", "value": "寿光市",
            "pcode": "370700"
        },
        {
            "cityCode": "370784",
            "label": "安丘市", "value": "安丘市",
            "pcode": "370700"
        },
        {
            "cityCode": "370785",
            "label": "高密市", "value": "高密市",
            "pcode": "370700"
        },
        {
            "cityCode": "370786",
            "label": "昌邑市", "value": "昌邑市",
            "pcode": "370700"
        }],
        "pcode": "370000"
    },
    {
        "cityCode": "370800",
        "label": "济宁市", "value": "济宁市",
        "children": [{
            "cityCode": "370811",
            "label": "任城区", "value": "任城区",
            "pcode": "370800"
        },
        {
            "cityCode": "370812",
            "label": "兖州区", "value": "兖州区",
            "pcode": "370800"
        },
        {
            "cityCode": "370826",
            "label": "微山县", "value": "微山县",
            "pcode": "370800"
        },
        {
            "cityCode": "370827",
            "label": "鱼台县", "value": "鱼台县",
            "pcode": "370800"
        },
        {
            "cityCode": "370828",
            "label": "金乡县", "value": "金乡县",
            "pcode": "370800"
        },
        {
            "cityCode": "370829",
            "label": "嘉祥县", "value": "嘉祥县",
            "pcode": "370800"
        },
        {
            "cityCode": "370830",
            "label": "汶上县", "value": "汶上县",
            "pcode": "370800"
        },
        {
            "cityCode": "370831",
            "label": "泗水县", "value": "泗水县",
            "pcode": "370800"
        },
        {
            "cityCode": "370832",
            "label": "梁山县", "value": "梁山县",
            "pcode": "370800"
        },
        {
            "cityCode": "370881",
            "label": "曲阜市", "value": "曲阜市",
            "pcode": "370800"
        },
        {
            "cityCode": "370883",
            "label": "邹城市", "value": "邹城市",
            "pcode": "370800"
        }],
        "pcode": "370000"
    },
    {
        "cityCode": "370900",
        "label": "泰安市", "value": "泰安市",
        "children": [{
            "cityCode": "370902",
            "label": "泰山区", "value": "泰山区",
            "pcode": "370900"
        },
        {
            "cityCode": "370911",
            "label": "岱岳区", "value": "岱岳区",
            "pcode": "370900"
        },
        {
            "cityCode": "370921",
            "label": "宁阳县", "value": "宁阳县",
            "pcode": "370900"
        },
        {
            "cityCode": "370923",
            "label": "东平县", "value": "东平县",
            "pcode": "370900"
        },
        {
            "cityCode": "370982",
            "label": "新泰市", "value": "新泰市",
            "pcode": "370900"
        },
        {
            "cityCode": "370983",
            "label": "肥城市", "value": "肥城市",
            "pcode": "370900"
        }],
        "pcode": "370000"
    },
    {
        "cityCode": "371000",
        "label": "威海市", "value": "威海市",
        "children": [{
            "cityCode": "371002",
            "label": "环翠区", "value": "环翠区",
            "pcode": "371000"
        },
        {
            "cityCode": "371003",
            "label": "文登区", "value": "文登区",
            "pcode": "371000"
        },
        {
            "cityCode": "371082",
            "label": "荣成市", "value": "荣成市",
            "pcode": "371000"
        },
        {
            "cityCode": "371083",
            "label": "乳山市", "value": "乳山市",
            "pcode": "371000"
        }],
        "pcode": "370000"
    },
    {
        "cityCode": "371100",
        "label": "日照市", "value": "日照市",
        "children": [{
            "cityCode": "371102",
            "label": "东港区", "value": "东港区",
            "pcode": "371100"
        },
        {
            "cityCode": "371103",
            "label": "岚山区", "value": "岚山区",
            "pcode": "371100"
        },
        {
            "cityCode": "371121",
            "label": "五莲县", "value": "五莲县",
            "pcode": "371100"
        },
        {
            "cityCode": "371122",
            "label": "莒县", "value": "莒县",
            "pcode": "371100"
        }],
        "pcode": "370000"
    },
    {
        "cityCode": "371200",
        "label": "莱芜市", "value": "莱芜市",
        "children": [{
            "cityCode": "371202",
            "label": "莱城区", "value": "莱城区",
            "pcode": "371200"
        },
        {
            "cityCode": "371203",
            "label": "钢城区", "value": "钢城区",
            "pcode": "371200"
        }],
        "pcode": "370000"
    },
    {
        "cityCode": "371300",
        "label": "临沂市", "value": "临沂市",
        "children": [{
            "cityCode": "371302",
            "label": "兰山区", "value": "兰山区",
            "pcode": "371300"
        },
        {
            "cityCode": "371311",
            "label": "罗庄区", "value": "罗庄区",
            "pcode": "371300"
        },
        {
            "cityCode": "371312",
            "label": "河东区", "value": "河东区",
            "pcode": "371300"
        },
        {
            "cityCode": "371321",
            "label": "沂南县", "value": "沂南县",
            "pcode": "371300"
        },
        {
            "cityCode": "371322",
            "label": "郯城县", "value": "郯城县",
            "pcode": "371300"
        },
        {
            "cityCode": "371323",
            "label": "沂水县", "value": "沂水县",
            "pcode": "371300"
        },
        {
            "cityCode": "371324",
            "label": "兰陵县", "value": "兰陵县",
            "pcode": "371300"
        },
        {
            "cityCode": "371325",
            "label": "费县", "value": "费县",
            "pcode": "371300"
        },
        {
            "cityCode": "371326",
            "label": "平邑县", "value": "平邑县",
            "pcode": "371300"
        },
        {
            "cityCode": "371327",
            "label": "莒南县", "value": "莒南县",
            "pcode": "371300"
        },
        {
            "cityCode": "371328",
            "label": "蒙阴县", "value": "蒙阴县",
            "pcode": "371300"
        },
        {
            "cityCode": "371329",
            "label": "临沭县", "value": "临沭县",
            "pcode": "371300"
        }],
        "pcode": "370000"
    },
    {
        "cityCode": "371400",
        "label": "德州市", "value": "德州市",
        "children": [{
            "cityCode": "371402",
            "label": "德城区", "value": "德城区",
            "pcode": "371400"
        },
        {
            "cityCode": "371403",
            "label": "陵城区", "value": "陵城区",
            "pcode": "371400"
        },
        {
            "cityCode": "371422",
            "label": "宁津县", "value": "宁津县",
            "pcode": "371400"
        },
        {
            "cityCode": "371423",
            "label": "庆云县", "value": "庆云县",
            "pcode": "371400"
        },
        {
            "cityCode": "371424",
            "label": "临邑县", "value": "临邑县",
            "pcode": "371400"
        },
        {
            "cityCode": "371425",
            "label": "齐河县", "value": "齐河县",
            "pcode": "371400"
        },
        {
            "cityCode": "371426",
            "label": "平原县", "value": "平原县",
            "pcode": "371400"
        },
        {
            "cityCode": "371427",
            "label": "夏津县", "value": "夏津县",
            "pcode": "371400"
        },
        {
            "cityCode": "371428",
            "label": "武城县", "value": "武城县",
            "pcode": "371400"
        },
        {
            "cityCode": "371481",
            "label": "乐陵市", "value": "乐陵市",
            "pcode": "371400"
        },
        {
            "cityCode": "371482",
            "label": "禹城市", "value": "禹城市",
            "pcode": "371400"
        }],
        "pcode": "370000"
    },
    {
        "cityCode": "371500",
        "label": "聊城市", "value": "聊城市",
        "children": [{
            "cityCode": "371502",
            "label": "东昌府区", "value": "东昌府区",
            "pcode": "371500"
        },
        {
            "cityCode": "371521",
            "label": "阳谷县", "value": "阳谷县",
            "pcode": "371500"
        },
        {
            "cityCode": "371522",
            "label": "莘县", "value": "莘县",
            "pcode": "371500"
        },
        {
            "cityCode": "371523",
            "label": "茌平县", "value": "茌平县",
            "pcode": "371500"
        },
        {
            "cityCode": "371524",
            "label": "东阿县", "value": "东阿县",
            "pcode": "371500"
        },
        {
            "cityCode": "371525",
            "label": "冠县", "value": "冠县",
            "pcode": "371500"
        },
        {
            "cityCode": "371526",
            "label": "高唐县", "value": "高唐县",
            "pcode": "371500"
        },
        {
            "cityCode": "371581",
            "label": "临清市", "value": "临清市",
            "pcode": "371500"
        }],
        "pcode": "370000"
    },
    {
        "cityCode": "371600",
        "label": "滨州市", "value": "滨州市",
        "children": [{
            "cityCode": "371602",
            "label": "滨城区", "value": "滨城区",
            "pcode": "371600"
        },
        {
            "cityCode": "371603",
            "label": "沾化区", "value": "沾化区",
            "pcode": "371600"
        },
        {
            "cityCode": "371621",
            "label": "惠民县", "value": "惠民县",
            "pcode": "371600"
        },
        {
            "cityCode": "371622",
            "label": "阳信县", "value": "阳信县",
            "pcode": "371600"
        },
        {
            "cityCode": "371623",
            "label": "无棣县", "value": "无棣县",
            "pcode": "371600"
        },
        {
            "cityCode": "371625",
            "label": "博兴县", "value": "博兴县",
            "pcode": "371600"
        },
        {
            "cityCode": "371681",
            "label": "邹平县", "value": "邹平县",
            "pcode": "371600"
        }],
        "pcode": "370000"
    },
    {
        "cityCode": "371700",
        "label": "菏泽市", "value": "菏泽市",
        "children": [{
            "cityCode": "371702",
            "label": "牡丹区", "value": "牡丹区",
            "pcode": "371700"
        },
        {
            "cityCode": "371703",
            "label": "定陶区", "value": "定陶区",
            "pcode": "371700"
        },
        {
            "cityCode": "371721",
            "label": "曹县", "value": "曹县",
            "pcode": "371700"
        },
        {
            "cityCode": "371722",
            "label": "单县", "value": "单县",
            "pcode": "371700"
        },
        {
            "cityCode": "371723",
            "label": "成武县", "value": "成武县",
            "pcode": "371700"
        },
        {
            "cityCode": "371724",
            "label": "巨野县", "value": "巨野县",
            "pcode": "371700"
        },
        {
            "cityCode": "371725",
            "label": "郓城县", "value": "郓城县",
            "pcode": "371700"
        },
        {
            "cityCode": "371726",
            "label": "鄄城县", "value": "鄄城县",
            "pcode": "371700"
        },
        {
            "cityCode": "371728",
            "label": "东明县", "value": "东明县",
            "pcode": "371700"
        }],
        "pcode": "370000"
    }]
},
{
    "cityCode": "410000",
    "label": "河南省", "value": "河南省",
    "children": [{
        "cityCode": "410100",
        "label": "郑州市", "value": "郑州市",
        "children": [{
            "cityCode": "410102",
            "label": "中原区", "value": "中原区",
            "pcode": "410100"
        },
        {
            "cityCode": "410103",
            "label": "二七区", "value": "二七区",
            "pcode": "410100"
        },
        {
            "cityCode": "410104",
            "label": "管城回族区", "value": "管城回族区",
            "pcode": "410100"
        },
        {
            "cityCode": "410105",
            "label": "金水区", "value": "金水区",
            "pcode": "410100"
        },
        {
            "cityCode": "410106",
            "label": "上街区", "value": "上街区",
            "pcode": "410100"
        },
        {
            "cityCode": "410108",
            "label": "惠济区", "value": "惠济区",
            "pcode": "410100"
        },
        {
            "cityCode": "410122",
            "label": "中牟县", "value": "中牟县",
            "pcode": "410100"
        },
        {
            "cityCode": "410181",
            "label": "巩义市", "value": "巩义市",
            "pcode": "410100"
        },
        {
            "cityCode": "410182",
            "label": "荥阳市", "value": "荥阳市",
            "pcode": "410100"
        },
        {
            "cityCode": "410183",
            "label": "新密市", "value": "新密市",
            "pcode": "410100"
        },
        {
            "cityCode": "410184",
            "label": "新郑市", "value": "新郑市",
            "pcode": "410100"
        },
        {
            "cityCode": "410185",
            "label": "登封市", "value": "登封市",
            "pcode": "410100"
        }],
        "pcode": "410000"
    },
    {
        "cityCode": "410200",
        "label": "开封市", "value": "开封市",
        "children": [{
            "cityCode": "410202",
            "label": "龙亭区", "value": "龙亭区",
            "pcode": "410200"
        },
        {
            "cityCode": "410203",
            "label": "顺河回族区", "value": "顺河回族区",
            "pcode": "410200"
        },
        {
            "cityCode": "410204",
            "label": "鼓楼区", "value": "鼓楼区",
            "pcode": "410200"
        },
        {
            "cityCode": "410205",
            "label": "禹王台区", "value": "禹王台区",
            "pcode": "410200"
        },
        {
            "cityCode": "410212",
            "label": "祥符区", "value": "祥符区",
            "pcode": "410200"
        },
        {
            "cityCode": "410221",
            "label": "杞县", "value": "杞县",
            "pcode": "410200"
        },
        {
            "cityCode": "410222",
            "label": "通许县", "value": "通许县",
            "pcode": "410200"
        },
        {
            "cityCode": "410223",
            "label": "尉氏县", "value": "尉氏县",
            "pcode": "410200"
        },
        {
            "cityCode": "410225",
            "label": "兰考县", "value": "兰考县",
            "pcode": "410200"
        }],
        "pcode": "410000"
    },
    {
        "cityCode": "410300",
        "label": "洛阳市", "value": "洛阳市",
        "children": [{
            "cityCode": "410302",
            "label": "老城区", "value": "老城区",
            "pcode": "410300"
        },
        {
            "cityCode": "410303",
            "label": "西工区", "value": "西工区",
            "pcode": "410300"
        },
        {
            "cityCode": "410304",
            "label": "瀍河回族区", "value": "瀍河回族区",
            "pcode": "410300"
        },
        {
            "cityCode": "410305",
            "label": "涧西区", "value": "涧西区",
            "pcode": "410300"
        },
        {
            "cityCode": "410306",
            "label": "吉利区", "value": "吉利区",
            "pcode": "410300"
        },
        {
            "cityCode": "410311",
            "label": "洛龙区", "value": "洛龙区",
            "pcode": "410300"
        },
        {
            "cityCode": "410322",
            "label": "孟津县", "value": "孟津县",
            "pcode": "410300"
        },
        {
            "cityCode": "410323",
            "label": "新安县", "value": "新安县",
            "pcode": "410300"
        },
        {
            "cityCode": "410324",
            "label": "栾川县", "value": "栾川县",
            "pcode": "410300"
        },
        {
            "cityCode": "410325",
            "label": "嵩县", "value": "嵩县",
            "pcode": "410300"
        },
        {
            "cityCode": "410326",
            "label": "汝阳县", "value": "汝阳县",
            "pcode": "410300"
        },
        {
            "cityCode": "410327",
            "label": "宜阳县", "value": "宜阳县",
            "pcode": "410300"
        },
        {
            "cityCode": "410328",
            "label": "洛宁县", "value": "洛宁县",
            "pcode": "410300"
        },
        {
            "cityCode": "410329",
            "label": "伊川县", "value": "伊川县",
            "pcode": "410300"
        },
        {
            "cityCode": "410381",
            "label": "偃师市", "value": "偃师市",
            "pcode": "410300"
        }],
        "pcode": "410000"
    },
    {
        "cityCode": "410400",
        "label": "平顶山市", "value": "平顶山市",
        "children": [{
            "cityCode": "410402",
            "label": "新华区", "value": "新华区",
            "pcode": "410400"
        },
        {
            "cityCode": "410403",
            "label": "卫东区", "value": "卫东区",
            "pcode": "410400"
        },
        {
            "cityCode": "410404",
            "label": "石龙区", "value": "石龙区",
            "pcode": "410400"
        },
        {
            "cityCode": "410411",
            "label": "湛河区", "value": "湛河区",
            "pcode": "410400"
        },
        {
            "cityCode": "410421",
            "label": "宝丰县", "value": "宝丰县",
            "pcode": "410400"
        },
        {
            "cityCode": "410422",
            "label": "叶县", "value": "叶县",
            "pcode": "410400"
        },
        {
            "cityCode": "410423",
            "label": "鲁山县", "value": "鲁山县",
            "pcode": "410400"
        },
        {
            "cityCode": "410425",
            "label": "郏县", "value": "郏县",
            "pcode": "410400"
        },
        {
            "cityCode": "410481",
            "label": "舞钢市", "value": "舞钢市",
            "pcode": "410400"
        },
        {
            "cityCode": "410482",
            "label": "汝州市", "value": "汝州市",
            "pcode": "410400"
        }],
        "pcode": "410000"
    },
    {
        "cityCode": "410500",
        "label": "安阳市", "value": "安阳市",
        "children": [{
            "cityCode": "410502",
            "label": "文峰区", "value": "文峰区",
            "pcode": "410500"
        },
        {
            "cityCode": "410503",
            "label": "北关区", "value": "北关区",
            "pcode": "410500"
        },
        {
            "cityCode": "410505",
            "label": "殷都区", "value": "殷都区",
            "pcode": "410500"
        },
        {
            "cityCode": "410506",
            "label": "龙安区", "value": "龙安区",
            "pcode": "410500"
        },
        {
            "cityCode": "410522",
            "label": "安阳县", "value": "安阳县",
            "pcode": "410500"
        },
        {
            "cityCode": "410523",
            "label": "汤阴县", "value": "汤阴县",
            "pcode": "410500"
        },
        {
            "cityCode": "410526",
            "label": "滑县", "value": "滑县",
            "pcode": "410500"
        },
        {
            "cityCode": "410527",
            "label": "内黄县", "value": "内黄县",
            "pcode": "410500"
        },
        {
            "cityCode": "410581",
            "label": "林州市", "value": "林州市",
            "pcode": "410500"
        }],
        "pcode": "410000"
    },
    {
        "cityCode": "410600",
        "label": "鹤壁市", "value": "鹤壁市",
        "children": [{
            "cityCode": "410602",
            "label": "鹤山区", "value": "鹤山区",
            "pcode": "410600"
        },
        {
            "cityCode": "410603",
            "label": "山城区", "value": "山城区",
            "pcode": "410600"
        },
        {
            "cityCode": "410611",
            "label": "淇滨区", "value": "淇滨区",
            "pcode": "410600"
        },
        {
            "cityCode": "410621",
            "label": "浚县", "value": "浚县",
            "pcode": "410600"
        },
        {
            "cityCode": "410622",
            "label": "淇县", "value": "淇县",
            "pcode": "410600"
        }],
        "pcode": "410000"
    },
    {
        "cityCode": "410700",
        "label": "新乡市", "value": "新乡市",
        "children": [{
            "cityCode": "410702",
            "label": "红旗区", "value": "红旗区",
            "pcode": "410700"
        },
        {
            "cityCode": "410703",
            "label": "卫滨区", "value": "卫滨区",
            "pcode": "410700"
        },
        {
            "cityCode": "410704",
            "label": "凤泉区", "value": "凤泉区",
            "pcode": "410700"
        },
        {
            "cityCode": "410711",
            "label": "牧野区", "value": "牧野区",
            "pcode": "410700"
        },
        {
            "cityCode": "410721",
            "label": "新乡县", "value": "新乡县",
            "pcode": "410700"
        },
        {
            "cityCode": "410724",
            "label": "获嘉县", "value": "获嘉县",
            "pcode": "410700"
        },
        {
            "cityCode": "410725",
            "label": "原阳县", "value": "原阳县",
            "pcode": "410700"
        },
        {
            "cityCode": "410726",
            "label": "延津县", "value": "延津县",
            "pcode": "410700"
        },
        {
            "cityCode": "410727",
            "label": "封丘县", "value": "封丘县",
            "pcode": "410700"
        },
        {
            "cityCode": "410728",
            "label": "长垣县", "value": "长垣县",
            "pcode": "410700"
        },
        {
            "cityCode": "410781",
            "label": "卫辉市", "value": "卫辉市",
            "pcode": "410700"
        },
        {
            "cityCode": "410782",
            "label": "辉县市", "value": "辉县市",
            "pcode": "410700"
        }],
        "pcode": "410000"
    },
    {
        "cityCode": "410800",
        "label": "焦作市", "value": "焦作市",
        "children": [{
            "cityCode": "410802",
            "label": "解放区", "value": "解放区",
            "pcode": "410800"
        },
        {
            "cityCode": "410803",
            "label": "中站区", "value": "中站区",
            "pcode": "410800"
        },
        {
            "cityCode": "410804",
            "label": "马村区", "value": "马村区",
            "pcode": "410800"
        },
        {
            "cityCode": "410811",
            "label": "山阳区", "value": "山阳区",
            "pcode": "410800"
        },
        {
            "cityCode": "410821",
            "label": "修武县", "value": "修武县",
            "pcode": "410800"
        },
        {
            "cityCode": "410822",
            "label": "博爱县", "value": "博爱县",
            "pcode": "410800"
        },
        {
            "cityCode": "410823",
            "label": "武陟县", "value": "武陟县",
            "pcode": "410800"
        },
        {
            "cityCode": "410825",
            "label": "温县", "value": "温县",
            "pcode": "410800"
        },
        {
            "cityCode": "410882",
            "label": "沁阳市", "value": "沁阳市",
            "pcode": "410800"
        },
        {
            "cityCode": "410883",
            "label": "孟州市", "value": "孟州市",
            "pcode": "410800"
        }],
        "pcode": "410000"
    },
    {
        "cityCode": "410900",
        "label": "濮阳市", "value": "濮阳市",
        "children": [{
            "cityCode": "410902",
            "label": "华龙区", "value": "华龙区",
            "pcode": "410900"
        },
        {
            "cityCode": "410922",
            "label": "清丰县", "value": "清丰县",
            "pcode": "410900"
        },
        {
            "cityCode": "410923",
            "label": "南乐县", "value": "南乐县",
            "pcode": "410900"
        },
        {
            "cityCode": "410926",
            "label": "范县", "value": "范县",
            "pcode": "410900"
        },
        {
            "cityCode": "410927",
            "label": "台前县", "value": "台前县",
            "pcode": "410900"
        },
        {
            "cityCode": "410928",
            "label": "濮阳县", "value": "濮阳县",
            "pcode": "410900"
        }],
        "pcode": "410000"
    },
    {
        "cityCode": "411000",
        "label": "许昌市", "value": "许昌市",
        "children": [{
            "cityCode": "411002",
            "label": "魏都区", "value": "魏都区",
            "pcode": "411000"
        },
        {
            "cityCode": "411003",
            "label": "建安区", "value": "建安区",
            "pcode": "411000"
        },
        {
            "cityCode": "411024",
            "label": "鄢陵县", "value": "鄢陵县",
            "pcode": "411000"
        },
        {
            "cityCode": "411025",
            "label": "襄城县", "value": "襄城县",
            "pcode": "411000"
        },
        {
            "cityCode": "411081",
            "label": "禹州市", "value": "禹州市",
            "pcode": "411000"
        },
        {
            "cityCode": "411082",
            "label": "长葛市", "value": "长葛市",
            "pcode": "411000"
        }],
        "pcode": "410000"
    },
    {
        "cityCode": "411100",
        "label": "漯河市", "value": "漯河市",
        "children": [{
            "cityCode": "411102",
            "label": "源汇区", "value": "源汇区",
            "pcode": "411100"
        },
        {
            "cityCode": "411103",
            "label": "郾城区", "value": "郾城区",
            "pcode": "411100"
        },
        {
            "cityCode": "411104",
            "label": "召陵区", "value": "召陵区",
            "pcode": "411100"
        },
        {
            "cityCode": "411121",
            "label": "舞阳县", "value": "舞阳县",
            "pcode": "411100"
        },
        {
            "cityCode": "411122",
            "label": "临颍县", "value": "临颍县",
            "pcode": "411100"
        }],
        "pcode": "410000"
    },
    {
        "cityCode": "411200",
        "label": "三门峡市", "value": "三门峡市",
        "children": [{
            "cityCode": "411202",
            "label": "湖滨区", "value": "湖滨区",
            "pcode": "411200"
        },
        {
            "cityCode": "411203",
            "label": "陕州区", "value": "陕州区",
            "pcode": "411200"
        },
        {
            "cityCode": "411221",
            "label": "渑池县", "value": "渑池县",
            "pcode": "411200"
        },
        {
            "cityCode": "411224",
            "label": "卢氏县", "value": "卢氏县",
            "pcode": "411200"
        },
        {
            "cityCode": "411281",
            "label": "义马市", "value": "义马市",
            "pcode": "411200"
        },
        {
            "cityCode": "411282",
            "label": "灵宝市", "value": "灵宝市",
            "pcode": "411200"
        }],
        "pcode": "410000"
    },
    {
        "cityCode": "411300",
        "label": "南阳市", "value": "南阳市",
        "children": [{
            "cityCode": "411302",
            "label": "宛城区", "value": "宛城区",
            "pcode": "411300"
        },
        {
            "cityCode": "411303",
            "label": "卧龙区", "value": "卧龙区",
            "pcode": "411300"
        },
        {
            "cityCode": "411321",
            "label": "南召县", "value": "南召县",
            "pcode": "411300"
        },
        {
            "cityCode": "411322",
            "label": "方城县", "value": "方城县",
            "pcode": "411300"
        },
        {
            "cityCode": "411323",
            "label": "西峡县", "value": "西峡县",
            "pcode": "411300"
        },
        {
            "cityCode": "411324",
            "label": "镇平县", "value": "镇平县",
            "pcode": "411300"
        },
        {
            "cityCode": "411325",
            "label": "内乡县", "value": "内乡县",
            "pcode": "411300"
        },
        {
            "cityCode": "411326",
            "label": "淅川县", "value": "淅川县",
            "pcode": "411300"
        },
        {
            "cityCode": "411327",
            "label": "社旗县", "value": "社旗县",
            "pcode": "411300"
        },
        {
            "cityCode": "411328",
            "label": "唐河县", "value": "唐河县",
            "pcode": "411300"
        },
        {
            "cityCode": "411329",
            "label": "新野县", "value": "新野县",
            "pcode": "411300"
        },
        {
            "cityCode": "411330",
            "label": "桐柏县", "value": "桐柏县",
            "pcode": "411300"
        },
        {
            "cityCode": "411381",
            "label": "邓州市", "value": "邓州市",
            "pcode": "411300"
        }],
        "pcode": "410000"
    },
    {
        "cityCode": "411400",
        "label": "商丘市", "value": "商丘市",
        "children": [{
            "cityCode": "411402",
            "label": "梁园区", "value": "梁园区",
            "pcode": "411400"
        },
        {
            "cityCode": "411403",
            "label": "睢阳区", "value": "睢阳区",
            "pcode": "411400"
        },
        {
            "cityCode": "411421",
            "label": "民权县", "value": "民权县",
            "pcode": "411400"
        },
        {
            "cityCode": "411422",
            "label": "睢县", "value": "睢县",
            "pcode": "411400"
        },
        {
            "cityCode": "411423",
            "label": "宁陵县", "value": "宁陵县",
            "pcode": "411400"
        },
        {
            "cityCode": "411424",
            "label": "柘城县", "value": "柘城县",
            "pcode": "411400"
        },
        {
            "cityCode": "411425",
            "label": "虞城县", "value": "虞城县",
            "pcode": "411400"
        },
        {
            "cityCode": "411426",
            "label": "夏邑县", "value": "夏邑县",
            "pcode": "411400"
        },
        {
            "cityCode": "411481",
            "label": "永城市", "value": "永城市",
            "pcode": "411400"
        }],
        "pcode": "410000"
    },
    {
        "cityCode": "411500",
        "label": "信阳市", "value": "信阳市",
        "children": [{
            "cityCode": "411502",
            "label": "浉河区", "value": "浉河区",
            "pcode": "411500"
        },
        {
            "cityCode": "411503",
            "label": "平桥区", "value": "平桥区",
            "pcode": "411500"
        },
        {
            "cityCode": "411521",
            "label": "罗山县", "value": "罗山县",
            "pcode": "411500"
        },
        {
            "cityCode": "411522",
            "label": "光山县", "value": "光山县",
            "pcode": "411500"
        },
        {
            "cityCode": "411523",
            "label": "新县", "value": "新县",
            "pcode": "411500"
        },
        {
            "cityCode": "411524",
            "label": "商城县", "value": "商城县",
            "pcode": "411500"
        },
        {
            "cityCode": "411525",
            "label": "固始县", "value": "固始县",
            "pcode": "411500"
        },
        {
            "cityCode": "411526",
            "label": "潢川县", "value": "潢川县",
            "pcode": "411500"
        },
        {
            "cityCode": "411527",
            "label": "淮滨县", "value": "淮滨县",
            "pcode": "411500"
        },
        {
            "cityCode": "411528",
            "label": "息县", "value": "息县",
            "pcode": "411500"
        }],
        "pcode": "410000"
    },
    {
        "cityCode": "411600",
        "label": "周口市", "value": "周口市",
        "children": [{
            "cityCode": "411602",
            "label": "川汇区", "value": "川汇区",
            "pcode": "411600"
        },
        {
            "cityCode": "411621",
            "label": "扶沟县", "value": "扶沟县",
            "pcode": "411600"
        },
        {
            "cityCode": "411622",
            "label": "西华县", "value": "西华县",
            "pcode": "411600"
        },
        {
            "cityCode": "411623",
            "label": "商水县", "value": "商水县",
            "pcode": "411600"
        },
        {
            "cityCode": "411624",
            "label": "沈丘县", "value": "沈丘县",
            "pcode": "411600"
        },
        {
            "cityCode": "411625",
            "label": "郸城县", "value": "郸城县",
            "pcode": "411600"
        },
        {
            "cityCode": "411626",
            "label": "淮阳县", "value": "淮阳县",
            "pcode": "411600"
        },
        {
            "cityCode": "411627",
            "label": "太康县", "value": "太康县",
            "pcode": "411600"
        },
        {
            "cityCode": "411628",
            "label": "鹿邑县", "value": "鹿邑县",
            "pcode": "411600"
        },
        {
            "cityCode": "411681",
            "label": "项城市", "value": "项城市",
            "pcode": "411600"
        }],
        "pcode": "410000"
    },
    {
        "cityCode": "411700",
        "label": "驻马店市", "value": "驻马店市",
        "children": [{
            "cityCode": "411702",
            "label": "驿城区", "value": "驿城区",
            "pcode": "411700"
        },
        {
            "cityCode": "411721",
            "label": "西平县", "value": "西平县",
            "pcode": "411700"
        },
        {
            "cityCode": "411722",
            "label": "上蔡县", "value": "上蔡县",
            "pcode": "411700"
        },
        {
            "cityCode": "411723",
            "label": "平舆县", "value": "平舆县",
            "pcode": "411700"
        },
        {
            "cityCode": "411724",
            "label": "正阳县", "value": "正阳县",
            "pcode": "411700"
        },
        {
            "cityCode": "411725",
            "label": "确山县", "value": "确山县",
            "pcode": "411700"
        },
        {
            "cityCode": "411726",
            "label": "泌阳县", "value": "泌阳县",
            "pcode": "411700"
        },
        {
            "cityCode": "411727",
            "label": "汝南县", "value": "汝南县",
            "pcode": "411700"
        },
        {
            "cityCode": "411728",
            "label": "遂平县", "value": "遂平县",
            "pcode": "411700"
        },
        {
            "cityCode": "411729",
            "label": "新蔡县", "value": "新蔡县",
            "pcode": "411700"
        }],
        "pcode": "410000"
    },
    {
        "cityCode": "419001",
        "label": "济源市", "value": "济源市",
        "children": [{
            "cityCode": "419001001",
            "label": "济源市沁园街道", "value": "济源市沁园街道",
            "pcode": "419001"
        },
        {
            "cityCode": "419001002",
            "label": "济源市济水街道", "value": "济源市济水街道",
            "pcode": "419001"
        },
        {
            "cityCode": "419001003",
            "label": "济源市北海街道", "value": "济源市北海街道",
            "pcode": "419001"
        },
        {
            "cityCode": "419001004",
            "label": "济源市天坛街道", "value": "济源市天坛街道",
            "pcode": "419001"
        },
        {
            "cityCode": "419001005",
            "label": "济源市玉泉街道", "value": "济源市玉泉街道",
            "pcode": "419001"
        },
        {
            "cityCode": "419001100",
            "label": "济源市克井镇", "value": "济源市克井镇",
            "pcode": "419001"
        },
        {
            "cityCode": "419001101",
            "label": "济源市五龙口镇", "value": "济源市五龙口镇",
            "pcode": "419001"
        },
        {
            "cityCode": "419001102",
            "label": "济源市轵城镇", "value": "济源市轵城镇",
            "pcode": "419001"
        },
        {
            "cityCode": "419001103",
            "label": "济源市承留镇", "value": "济源市承留镇",
            "pcode": "419001"
        },
        {
            "cityCode": "419001104",
            "label": "济源市邵原镇", "value": "济源市邵原镇",
            "pcode": "419001"
        },
        {
            "cityCode": "419001105",
            "label": "济源市坡头镇", "value": "济源市坡头镇",
            "pcode": "419001"
        },
        {
            "cityCode": "419001106",
            "label": "济源市梨林镇", "value": "济源市梨林镇",
            "pcode": "419001"
        },
        {
            "cityCode": "419001107",
            "label": "济源市大峪镇", "value": "济源市大峪镇",
            "pcode": "419001"
        },
        {
            "cityCode": "419001108",
            "label": "济源市思礼镇", "value": "济源市思礼镇",
            "pcode": "419001"
        },
        {
            "cityCode": "419001109",
            "label": "济源市王屋镇", "value": "济源市王屋镇",
            "pcode": "419001"
        },
        {
            "cityCode": "419001110",
            "label": "济源市下冶镇", "value": "济源市下冶镇",
            "pcode": "419001"
        }],
        "pcode": "410000"
    }]
},
{
    "cityCode": "420000",
    "label": "湖北省", "value": "湖北省",
    "children": [{
        "cityCode": "420100",
        "label": "武汉市", "value": "武汉市",
        "children": [{
            "cityCode": "420102",
            "label": "江岸区", "value": "江岸区",
            "pcode": "420100"
        },
        {
            "cityCode": "420103",
            "label": "江汉区", "value": "江汉区",
            "pcode": "420100"
        },
        {
            "cityCode": "420104",
            "label": "硚口区", "value": "硚口区",
            "pcode": "420100"
        },
        {
            "cityCode": "420105",
            "label": "汉阳区", "value": "汉阳区",
            "pcode": "420100"
        },
        {
            "cityCode": "420106",
            "label": "武昌区", "value": "武昌区",
            "pcode": "420100"
        },
        {
            "cityCode": "420107",
            "label": "青山区", "value": "青山区",
            "pcode": "420100"
        },
        {
            "cityCode": "420111",
            "label": "洪山区", "value": "洪山区",
            "pcode": "420100"
        },
        {
            "cityCode": "420112",
            "label": "东西湖区", "value": "东西湖区",
            "pcode": "420100"
        },
        {
            "cityCode": "420113",
            "label": "汉南区", "value": "汉南区",
            "pcode": "420100"
        },
        {
            "cityCode": "420114",
            "label": "蔡甸区", "value": "蔡甸区",
            "pcode": "420100"
        },
        {
            "cityCode": "420115",
            "label": "江夏区", "value": "江夏区",
            "pcode": "420100"
        },
        {
            "cityCode": "420116",
            "label": "黄陂区", "value": "黄陂区",
            "pcode": "420100"
        },
        {
            "cityCode": "420117",
            "label": "新洲区", "value": "新洲区",
            "pcode": "420100"
        }],
        "pcode": "420000"
    },
    {
        "cityCode": "420200",
        "label": "黄石市", "value": "黄石市",
        "children": [{
            "cityCode": "420202",
            "label": "黄石港区", "value": "黄石港区",
            "pcode": "420200"
        },
        {
            "cityCode": "420203",
            "label": "西塞山区", "value": "西塞山区",
            "pcode": "420200"
        },
        {
            "cityCode": "420204",
            "label": "下陆区", "value": "下陆区",
            "pcode": "420200"
        },
        {
            "cityCode": "420205",
            "label": "铁山区", "value": "铁山区",
            "pcode": "420200"
        },
        {
            "cityCode": "420222",
            "label": "阳新县", "value": "阳新县",
            "pcode": "420200"
        },
        {
            "cityCode": "420281",
            "label": "大冶市", "value": "大冶市",
            "pcode": "420200"
        }],
        "pcode": "420000"
    },
    {
        "cityCode": "420300",
        "label": "十堰市", "value": "十堰市",
        "children": [{
            "cityCode": "420302",
            "label": "茅箭区", "value": "茅箭区",
            "pcode": "420300"
        },
        {
            "cityCode": "420303",
            "label": "张湾区", "value": "张湾区",
            "pcode": "420300"
        },
        {
            "cityCode": "420304",
            "label": "郧阳区", "value": "郧阳区",
            "pcode": "420300"
        },
        {
            "cityCode": "420322",
            "label": "郧西县", "value": "郧西县",
            "pcode": "420300"
        },
        {
            "cityCode": "420323",
            "label": "竹山县", "value": "竹山县",
            "pcode": "420300"
        },
        {
            "cityCode": "420324",
            "label": "竹溪县", "value": "竹溪县",
            "pcode": "420300"
        },
        {
            "cityCode": "420325",
            "label": "房县", "value": "房县",
            "pcode": "420300"
        },
        {
            "cityCode": "420381",
            "label": "丹江口市", "value": "丹江口市",
            "pcode": "420300"
        }],
        "pcode": "420000"
    },
    {
        "cityCode": "420500",
        "label": "宜昌市", "value": "宜昌市",
        "children": [{
            "cityCode": "420502",
            "label": "西陵区", "value": "西陵区",
            "pcode": "420500"
        },
        {
            "cityCode": "420503",
            "label": "伍家岗区", "value": "伍家岗区",
            "pcode": "420500"
        },
        {
            "cityCode": "420504",
            "label": "点军区", "value": "点军区",
            "pcode": "420500"
        },
        {
            "cityCode": "420505",
            "label": "猇亭区", "value": "猇亭区",
            "pcode": "420500"
        },
        {
            "cityCode": "420506",
            "label": "夷陵区", "value": "夷陵区",
            "pcode": "420500"
        },
        {
            "cityCode": "420525",
            "label": "远安县", "value": "远安县",
            "pcode": "420500"
        },
        {
            "cityCode": "420526",
            "label": "兴山县", "value": "兴山县",
            "pcode": "420500"
        },
        {
            "cityCode": "420527",
            "label": "秭归县", "value": "秭归县",
            "pcode": "420500"
        },
        {
            "cityCode": "420528",
            "label": "长阳土家族自治县", "value": "长阳土家族自治县",
            "pcode": "420500"
        },
        {
            "cityCode": "420529",
            "label": "五峰土家族自治县", "value": "五峰土家族自治县",
            "pcode": "420500"
        },
        {
            "cityCode": "420581",
            "label": "宜都市", "value": "宜都市",
            "pcode": "420500"
        },
        {
            "cityCode": "420582",
            "label": "当阳市", "value": "当阳市",
            "pcode": "420500"
        },
        {
            "cityCode": "420583",
            "label": "枝江市", "value": "枝江市",
            "pcode": "420500"
        }],
        "pcode": "420000"
    },
    {
        "cityCode": "420600",
        "label": "襄阳市", "value": "襄阳市",
        "children": [{
            "cityCode": "420602",
            "label": "襄城区", "value": "襄城区",
            "pcode": "420600"
        },
        {
            "cityCode": "420606",
            "label": "樊城区", "value": "樊城区",
            "pcode": "420600"
        },
        {
            "cityCode": "420607",
            "label": "襄州区", "value": "襄州区",
            "pcode": "420600"
        },
        {
            "cityCode": "420624",
            "label": "南漳县", "value": "南漳县",
            "pcode": "420600"
        },
        {
            "cityCode": "420625",
            "label": "谷城县", "value": "谷城县",
            "pcode": "420600"
        },
        {
            "cityCode": "420626",
            "label": "保康县", "value": "保康县",
            "pcode": "420600"
        },
        {
            "cityCode": "420682",
            "label": "老河口市", "value": "老河口市",
            "pcode": "420600"
        },
        {
            "cityCode": "420683",
            "label": "枣阳市", "value": "枣阳市",
            "pcode": "420600"
        },
        {
            "cityCode": "420684",
            "label": "宜城市", "value": "宜城市",
            "pcode": "420600"
        }],
        "pcode": "420000"
    },
    {
        "cityCode": "420700",
        "label": "鄂州市", "value": "鄂州市",
        "children": [{
            "cityCode": "420702",
            "label": "梁子湖区", "value": "梁子湖区",
            "pcode": "420700"
        },
        {
            "cityCode": "420703",
            "label": "华容区", "value": "华容区",
            "pcode": "420700"
        },
        {
            "cityCode": "420704",
            "label": "鄂城区", "value": "鄂城区",
            "pcode": "420700"
        }],
        "pcode": "420000"
    },
    {
        "cityCode": "420800",
        "label": "荆门市", "value": "荆门市",
        "children": [{
            "cityCode": "420802",
            "label": "东宝区", "value": "东宝区",
            "pcode": "420800"
        },
        {
            "cityCode": "420804",
            "label": "掇刀区", "value": "掇刀区",
            "pcode": "420800"
        },
        {
            "cityCode": "420821",
            "label": "京山县", "value": "京山县",
            "pcode": "420800"
        },
        {
            "cityCode": "420822",
            "label": "沙洋县", "value": "沙洋县",
            "pcode": "420800"
        },
        {
            "cityCode": "420881",
            "label": "钟祥市", "value": "钟祥市",
            "pcode": "420800"
        }],
        "pcode": "420000"
    },
    {
        "cityCode": "420900",
        "label": "孝感市", "value": "孝感市",
        "children": [{
            "cityCode": "420902",
            "label": "孝南区", "value": "孝南区",
            "pcode": "420900"
        },
        {
            "cityCode": "420921",
            "label": "孝昌县", "value": "孝昌县",
            "pcode": "420900"
        },
        {
            "cityCode": "420922",
            "label": "大悟县", "value": "大悟县",
            "pcode": "420900"
        },
        {
            "cityCode": "420923",
            "label": "云梦县", "value": "云梦县",
            "pcode": "420900"
        },
        {
            "cityCode": "420981",
            "label": "应城市", "value": "应城市",
            "pcode": "420900"
        },
        {
            "cityCode": "420982",
            "label": "安陆市", "value": "安陆市",
            "pcode": "420900"
        },
        {
            "cityCode": "420984",
            "label": "汉川市", "value": "汉川市",
            "pcode": "420900"
        }],
        "pcode": "420000"
    },
    {
        "cityCode": "421000",
        "label": "荆州市", "value": "荆州市",
        "children": [{
            "cityCode": "421002",
            "label": "沙市区", "value": "沙市区",
            "pcode": "421000"
        },
        {
            "cityCode": "421003",
            "label": "荆州区", "value": "荆州区",
            "pcode": "421000"
        },
        {
            "cityCode": "421022",
            "label": "公安县", "value": "公安县",
            "pcode": "421000"
        },
        {
            "cityCode": "421023",
            "label": "监利县", "value": "监利县",
            "pcode": "421000"
        },
        {
            "cityCode": "421024",
            "label": "江陵县", "value": "江陵县",
            "pcode": "421000"
        },
        {
            "cityCode": "421081",
            "label": "石首市", "value": "石首市",
            "pcode": "421000"
        },
        {
            "cityCode": "421083",
            "label": "洪湖市", "value": "洪湖市",
            "pcode": "421000"
        },
        {
            "cityCode": "421087",
            "label": "松滋市", "value": "松滋市",
            "pcode": "421000"
        }],
        "pcode": "420000"
    },
    {
        "cityCode": "421100",
        "label": "黄冈市", "value": "黄冈市",
        "children": [{
            "cityCode": "421102",
            "label": "黄州区", "value": "黄州区",
            "pcode": "421100"
        },
        {
            "cityCode": "421121",
            "label": "团风县", "value": "团风县",
            "pcode": "421100"
        },
        {
            "cityCode": "421122",
            "label": "红安县", "value": "红安县",
            "pcode": "421100"
        },
        {
            "cityCode": "421123",
            "label": "罗田县", "value": "罗田县",
            "pcode": "421100"
        },
        {
            "cityCode": "421124",
            "label": "英山县", "value": "英山县",
            "pcode": "421100"
        },
        {
            "cityCode": "421125",
            "label": "浠水县", "value": "浠水县",
            "pcode": "421100"
        },
        {
            "cityCode": "421126",
            "label": "蕲春县", "value": "蕲春县",
            "pcode": "421100"
        },
        {
            "cityCode": "421127",
            "label": "黄梅县", "value": "黄梅县",
            "pcode": "421100"
        },
        {
            "cityCode": "421181",
            "label": "麻城市", "value": "麻城市",
            "pcode": "421100"
        },
        {
            "cityCode": "421182",
            "label": "武穴市", "value": "武穴市",
            "pcode": "421100"
        }],
        "pcode": "420000"
    },
    {
        "cityCode": "421200",
        "label": "咸宁市", "value": "咸宁市",
        "children": [{
            "cityCode": "421202",
            "label": "咸安区", "value": "咸安区",
            "pcode": "421200"
        },
        {
            "cityCode": "421221",
            "label": "嘉鱼县", "value": "嘉鱼县",
            "pcode": "421200"
        },
        {
            "cityCode": "421222",
            "label": "通城县", "value": "通城县",
            "pcode": "421200"
        },
        {
            "cityCode": "421223",
            "label": "崇阳县", "value": "崇阳县",
            "pcode": "421200"
        },
        {
            "cityCode": "421224",
            "label": "通山县", "value": "通山县",
            "pcode": "421200"
        },
        {
            "cityCode": "421281",
            "label": "赤壁市", "value": "赤壁市",
            "pcode": "421200"
        }],
        "pcode": "420000"
    },
    {
        "cityCode": "421300",
        "label": "随州市", "value": "随州市",
        "children": [{
            "cityCode": "421303",
            "label": "曾都区", "value": "曾都区",
            "pcode": "421300"
        },
        {
            "cityCode": "421321",
            "label": "随县", "value": "随县",
            "pcode": "421300"
        },
        {
            "cityCode": "421381",
            "label": "广水市", "value": "广水市",
            "pcode": "421300"
        }],
        "pcode": "420000"
    },
    {
        "cityCode": "422800",
        "label": "恩施土家族苗族自治州", "value": "恩施土家族苗族自治州",
        "children": [{
            "cityCode": "422801",
            "label": "恩施市", "value": "恩施市",
            "pcode": "422800"
        },
        {
            "cityCode": "422802",
            "label": "利川市", "value": "利川市",
            "pcode": "422800"
        },
        {
            "cityCode": "422822",
            "label": "建始县", "value": "建始县",
            "pcode": "422800"
        },
        {
            "cityCode": "422823",
            "label": "巴东县", "value": "巴东县",
            "pcode": "422800"
        },
        {
            "cityCode": "422825",
            "label": "宣恩县", "value": "宣恩县",
            "pcode": "422800"
        },
        {
            "cityCode": "422826",
            "label": "咸丰县", "value": "咸丰县",
            "pcode": "422800"
        },
        {
            "cityCode": "422827",
            "label": "来凤县", "value": "来凤县",
            "pcode": "422800"
        },
        {
            "cityCode": "422828",
            "label": "鹤峰县", "value": "鹤峰县",
            "pcode": "422800"
        }],
        "pcode": "420000"
    },
    {
        "cityCode": "429004",
        "label": "仙桃市", "value": "仙桃市",
        "children": [{
            "cityCode": "429004001",
            "label": "沙嘴街道", "value": "沙嘴街道",
            "pcode": "429004"
        },
        {
            "cityCode": "429004002",
            "label": "干河街道", "value": "干河街道",
            "pcode": "429004"
        },
        {
            "cityCode": "429004003",
            "label": "龙华山街道", "value": "龙华山街道",
            "pcode": "429004"
        },
        {
            "cityCode": "429004100",
            "label": "郑场镇", "value": "郑场镇",
            "pcode": "429004"
        },
        {
            "cityCode": "429004101",
            "label": "毛嘴镇", "value": "毛嘴镇",
            "pcode": "429004"
        },
        {
            "cityCode": "429004102",
            "label": "豆河镇", "value": "豆河镇",
            "pcode": "429004"
        },
        {
            "cityCode": "429004103",
            "label": "三伏潭镇", "value": "三伏潭镇",
            "pcode": "429004"
        },
        {
            "cityCode": "429004104",
            "label": "胡场镇", "value": "胡场镇",
            "pcode": "429004"
        },
        {
            "cityCode": "429004105",
            "label": "长倘口镇", "value": "长倘口镇",
            "pcode": "429004"
        },
        {
            "cityCode": "429004106",
            "label": "西流河镇", "value": "西流河镇",
            "pcode": "429004"
        },
        {
            "cityCode": "429004107",
            "label": "沙湖镇", "value": "沙湖镇",
            "pcode": "429004"
        },
        {
            "cityCode": "429004108",
            "label": "杨林尾镇", "value": "杨林尾镇",
            "pcode": "429004"
        },
        {
            "cityCode": "429004109",
            "label": "彭场镇", "value": "彭场镇",
            "pcode": "429004"
        },
        {
            "cityCode": "429004110",
            "label": "张沟镇", "value": "张沟镇",
            "pcode": "429004"
        },
        {
            "cityCode": "429004111",
            "label": "郭河镇", "value": "郭河镇",
            "pcode": "429004"
        },
        {
            "cityCode": "429004112",
            "label": "沔城回族镇", "value": "沔城回族镇",
            "pcode": "429004"
        },
        {
            "cityCode": "429004113",
            "label": "通海口镇", "value": "通海口镇",
            "pcode": "429004"
        },
        {
            "cityCode": "429004114",
            "label": "陈场镇", "value": "陈场镇",
            "pcode": "429004"
        },
        {
            "cityCode": "429004400",
            "label": "工业园区", "value": "工业园区",
            "pcode": "429004"
        },
        {
            "cityCode": "429004401",
            "label": "九合垸原种场", "value": "九合垸原种场",
            "pcode": "429004"
        },
        {
            "cityCode": "429004402",
            "label": "沙湖原种场", "value": "沙湖原种场",
            "pcode": "429004"
        },
        {
            "cityCode": "429004404",
            "label": "五湖渔场", "value": "五湖渔场",
            "pcode": "429004"
        },
        {
            "cityCode": "429004405",
            "label": "赵西垸林场", "value": "赵西垸林场",
            "pcode": "429004"
        },
        {
            "cityCode": "429004407",
            "label": "畜禽良种场", "value": "畜禽良种场",
            "pcode": "429004"
        },
        {
            "cityCode": "429004408",
            "label": "排湖风景区", "value": "排湖风景区",
            "pcode": "429004"
        }],
        "pcode": "420000"
    },
    {
        "cityCode": "429005",
        "label": "潜江市", "value": "潜江市",
        "children": [{
            "cityCode": "429005001",
            "label": "园林街道", "value": "园林街道",
            "pcode": "429005"
        },
        {
            "cityCode": "429005002",
            "label": "杨市街道", "value": "杨市街道",
            "pcode": "429005"
        },
        {
            "cityCode": "429005003",
            "label": "周矶街道", "value": "周矶街道",
            "pcode": "429005"
        },
        {
            "cityCode": "429005004",
            "label": "广华街道", "value": "广华街道",
            "pcode": "429005"
        },
        {
            "cityCode": "429005005",
            "label": "泰丰街道", "value": "泰丰街道",
            "pcode": "429005"
        },
        {
            "cityCode": "429005006",
            "label": "高场街道", "value": "高场街道",
            "pcode": "429005"
        },
        {
            "cityCode": "429005100",
            "label": "竹根滩镇", "value": "竹根滩镇",
            "pcode": "429005"
        },
        {
            "cityCode": "429005101",
            "label": "渔洋镇", "value": "渔洋镇",
            "pcode": "429005"
        },
        {
            "cityCode": "429005102",
            "label": "王场镇", "value": "王场镇",
            "pcode": "429005"
        },
        {
            "cityCode": "429005103",
            "label": "高石碑镇", "value": "高石碑镇",
            "pcode": "429005"
        },
        {
            "cityCode": "429005104",
            "label": "熊口镇", "value": "熊口镇",
            "pcode": "429005"
        },
        {
            "cityCode": "429005105",
            "label": "老新镇", "value": "老新镇",
            "pcode": "429005"
        },
        {
            "cityCode": "429005106",
            "label": "浩口镇", "value": "浩口镇",
            "pcode": "429005"
        },
        {
            "cityCode": "429005107",
            "label": "积玉口镇", "value": "积玉口镇",
            "pcode": "429005"
        },
        {
            "cityCode": "429005108",
            "label": "张金镇", "value": "张金镇",
            "pcode": "429005"
        },
        {
            "cityCode": "429005109",
            "label": "龙湾镇", "value": "龙湾镇",
            "pcode": "429005"
        },
        {
            "cityCode": "429005400",
            "label": "江汉石油管理局", "value": "江汉石油管理局",
            "pcode": "429005"
        },
        {
            "cityCode": "429005401",
            "label": "潜江经济开发区", "value": "潜江经济开发区",
            "pcode": "429005"
        },
        {
            "cityCode": "429005450",
            "label": "周矶管理区", "value": "周矶管理区",
            "pcode": "429005"
        },
        {
            "cityCode": "429005451",
            "label": "后湖管理区", "value": "后湖管理区",
            "pcode": "429005"
        },
        {
            "cityCode": "429005452",
            "label": "熊口管理区", "value": "熊口管理区",
            "pcode": "429005"
        },
        {
            "cityCode": "429005453",
            "label": "总口管理区", "value": "总口管理区",
            "pcode": "429005"
        },
        {
            "cityCode": "429005454",
            "label": "白鹭湖管理区", "value": "白鹭湖管理区",
            "pcode": "429005"
        },
        {
            "cityCode": "429005455",
            "label": "运粮湖管理区", "value": "运粮湖管理区",
            "pcode": "429005"
        },
        {
            "cityCode": "429005457",
            "label": "浩口原种场", "value": "浩口原种场",
            "pcode": "429005"
        }],
        "pcode": "420000"
    },
    {
        "cityCode": "429006",
        "label": "天门市", "value": "天门市",
        "children": [{
            "cityCode": "429006001",
            "label": "竟陵街道", "value": "竟陵街道",
            "pcode": "429006"
        },
        {
            "cityCode": "429006002",
            "label": "侨乡街道开发区", "value": "侨乡街道开发区",
            "pcode": "429006"
        },
        {
            "cityCode": "429006003",
            "label": "杨林街道", "value": "杨林街道",
            "pcode": "429006"
        },
        {
            "cityCode": "429006100",
            "label": "多宝镇", "value": "多宝镇",
            "pcode": "429006"
        },
        {
            "cityCode": "429006101",
            "label": "拖市镇", "value": "拖市镇",
            "pcode": "429006"
        },
        {
            "cityCode": "429006102",
            "label": "张港镇", "value": "张港镇",
            "pcode": "429006"
        },
        {
            "cityCode": "429006103",
            "label": "蒋场镇", "value": "蒋场镇",
            "pcode": "429006"
        },
        {
            "cityCode": "429006104",
            "label": "汪场镇", "value": "汪场镇",
            "pcode": "429006"
        },
        {
            "cityCode": "429006105",
            "label": "渔薪镇", "value": "渔薪镇",
            "pcode": "429006"
        },
        {
            "cityCode": "429006106",
            "label": "黄潭镇", "value": "黄潭镇",
            "pcode": "429006"
        },
        {
            "cityCode": "429006107",
            "label": "岳口镇", "value": "岳口镇",
            "pcode": "429006"
        },
        {
            "cityCode": "429006108",
            "label": "横林镇", "value": "横林镇",
            "pcode": "429006"
        },
        {
            "cityCode": "429006109",
            "label": "彭市镇", "value": "彭市镇",
            "pcode": "429006"
        },
        {
            "cityCode": "429006110",
            "label": "麻洋镇", "value": "麻洋镇",
            "pcode": "429006"
        },
        {
            "cityCode": "429006111",
            "label": "多祥镇", "value": "多祥镇",
            "pcode": "429006"
        },
        {
            "cityCode": "429006112",
            "label": "干驿镇", "value": "干驿镇",
            "pcode": "429006"
        },
        {
            "cityCode": "429006113",
            "label": "马湾镇", "value": "马湾镇",
            "pcode": "429006"
        },
        {
            "cityCode": "429006114",
            "label": "卢市镇", "value": "卢市镇",
            "pcode": "429006"
        },
        {
            "cityCode": "429006115",
            "label": "小板镇", "value": "小板镇",
            "pcode": "429006"
        },
        {
            "cityCode": "429006116",
            "label": "九真镇", "value": "九真镇",
            "pcode": "429006"
        },
        {
            "cityCode": "429006118",
            "label": "皂市镇", "value": "皂市镇",
            "pcode": "429006"
        },
        {
            "cityCode": "429006119",
            "label": "胡市镇", "value": "胡市镇",
            "pcode": "429006"
        },
        {
            "cityCode": "429006120",
            "label": "石河镇", "value": "石河镇",
            "pcode": "429006"
        },
        {
            "cityCode": "429006121",
            "label": "佛子山镇", "value": "佛子山镇",
            "pcode": "429006"
        },
        {
            "cityCode": "429006201",
            "label": "净潭乡", "value": "净潭乡",
            "pcode": "429006"
        },
        {
            "cityCode": "429006450",
            "label": "蒋湖农场", "value": "蒋湖农场",
            "pcode": "429006"
        },
        {
            "cityCode": "429006451",
            "label": "白茅湖农场", "value": "白茅湖农场",
            "pcode": "429006"
        },
        {
            "cityCode": "429006452",
            "label": "沉湖管委会", "value": "沉湖管委会",
            "pcode": "429006"
        }],
        "pcode": "420000"
    },
    {
        "cityCode": "429021",
        "label": "神农架林区", "value": "神农架林区",
        "children": [{
            "cityCode": "429021100",
            "label": "松柏镇", "value": "松柏镇",
            "pcode": "429021"
        },
        {
            "cityCode": "429021101",
            "label": "阳日镇", "value": "阳日镇",
            "pcode": "429021"
        },
        {
            "cityCode": "429021102",
            "label": "木鱼镇", "value": "木鱼镇",
            "pcode": "429021"
        },
        {
            "cityCode": "429021103",
            "label": "红坪镇", "value": "红坪镇",
            "pcode": "429021"
        },
        {
            "cityCode": "429021104",
            "label": "新华镇", "value": "新华镇",
            "pcode": "429021"
        },
        {
            "cityCode": "429021105",
            "label": "九湖镇", "value": "九湖镇",
            "pcode": "429021"
        },
        {
            "cityCode": "429021200",
            "label": "宋洛乡", "value": "宋洛乡",
            "pcode": "429021"
        },
        {
            "cityCode": "429021202",
            "label": "下谷坪土家族乡", "value": "下谷坪土家族乡",
            "pcode": "429021"
        }],
        "pcode": "420000"
    }]
},
{
    "cityCode": "430000",
    "label": "湖南省", "value": "湖南省",
    "children": [{
        "cityCode": "430100",
        "label": "长沙市", "value": "长沙市",
        "children": [{
            "cityCode": "430102",
            "label": "芙蓉区", "value": "芙蓉区",
            "pcode": "430100"
        },
        {
            "cityCode": "430103",
            "label": "天心区", "value": "天心区",
            "pcode": "430100"
        },
        {
            "cityCode": "430104",
            "label": "岳麓区", "value": "岳麓区",
            "pcode": "430100"
        },
        {
            "cityCode": "430105",
            "label": "开福区", "value": "开福区",
            "pcode": "430100"
        },
        {
            "cityCode": "430111",
            "label": "雨花区", "value": "雨花区",
            "pcode": "430100"
        },
        {
            "cityCode": "430112",
            "label": "望城区", "value": "望城区",
            "pcode": "430100"
        },
        {
            "cityCode": "430121",
            "label": "长沙县", "value": "长沙县",
            "pcode": "430100"
        },
        {
            "cityCode": "430124",
            "label": "宁乡市", "value": "宁乡市",
            "pcode": "430100"
        },
        {
            "cityCode": "430181",
            "label": "浏阳市", "value": "浏阳市",
            "pcode": "430100"
        }],
        "pcode": "430000"
    },
    {
        "cityCode": "430200",
        "label": "株洲市", "value": "株洲市",
        "children": [{
            "cityCode": "430202",
            "label": "荷塘区", "value": "荷塘区",
            "pcode": "430200"
        },
        {
            "cityCode": "430203",
            "label": "芦淞区", "value": "芦淞区",
            "pcode": "430200"
        },
        {
            "cityCode": "430204",
            "label": "石峰区", "value": "石峰区",
            "pcode": "430200"
        },
        {
            "cityCode": "430211",
            "label": "天元区", "value": "天元区",
            "pcode": "430200"
        },
        {
            "cityCode": "430212",
            "label": "渌口区", "value": "渌口区",
            "pcode": "430200"
        },
        {
            "cityCode": "430223",
            "label": "攸县", "value": "攸县",
            "pcode": "430200"
        },
        {
            "cityCode": "430224",
            "label": "茶陵县", "value": "茶陵县",
            "pcode": "430200"
        },
        {
            "cityCode": "430225",
            "label": "炎陵县", "value": "炎陵县",
            "pcode": "430200"
        },
        {
            "cityCode": "430281",
            "label": "醴陵市", "value": "醴陵市",
            "pcode": "430200"
        }],
        "pcode": "430000"
    },
    {
        "cityCode": "430300",
        "label": "湘潭市", "value": "湘潭市",
        "children": [{
            "cityCode": "430302",
            "label": "雨湖区", "value": "雨湖区",
            "pcode": "430300"
        },
        {
            "cityCode": "430304",
            "label": "岳塘区", "value": "岳塘区",
            "pcode": "430300"
        },
        {
            "cityCode": "430321",
            "label": "湘潭县", "value": "湘潭县",
            "pcode": "430300"
        },
        {
            "cityCode": "430381",
            "label": "湘乡市", "value": "湘乡市",
            "pcode": "430300"
        },
        {
            "cityCode": "430382",
            "label": "韶山市", "value": "韶山市",
            "pcode": "430300"
        }],
        "pcode": "430000"
    },
    {
        "cityCode": "430400",
        "label": "衡阳市", "value": "衡阳市",
        "children": [{
            "cityCode": "430405",
            "label": "珠晖区", "value": "珠晖区",
            "pcode": "430400"
        },
        {
            "cityCode": "430406",
            "label": "雁峰区", "value": "雁峰区",
            "pcode": "430400"
        },
        {
            "cityCode": "430407",
            "label": "石鼓区", "value": "石鼓区",
            "pcode": "430400"
        },
        {
            "cityCode": "430408",
            "label": "蒸湘区", "value": "蒸湘区",
            "pcode": "430400"
        },
        {
            "cityCode": "430412",
            "label": "南岳区", "value": "南岳区",
            "pcode": "430400"
        },
        {
            "cityCode": "430421",
            "label": "衡阳县", "value": "衡阳县",
            "pcode": "430400"
        },
        {
            "cityCode": "430422",
            "label": "衡南县", "value": "衡南县",
            "pcode": "430400"
        },
        {
            "cityCode": "430423",
            "label": "衡山县", "value": "衡山县",
            "pcode": "430400"
        },
        {
            "cityCode": "430424",
            "label": "衡东县", "value": "衡东县",
            "pcode": "430400"
        },
        {
            "cityCode": "430426",
            "label": "祁东县", "value": "祁东县",
            "pcode": "430400"
        },
        {
            "cityCode": "430481",
            "label": "耒阳市", "value": "耒阳市",
            "pcode": "430400"
        },
        {
            "cityCode": "430482",
            "label": "常宁市", "value": "常宁市",
            "pcode": "430400"
        }],
        "pcode": "430000"
    },
    {
        "cityCode": "430500",
        "label": "邵阳市", "value": "邵阳市",
        "children": [{
            "cityCode": "430502",
            "label": "双清区", "value": "双清区",
            "pcode": "430500"
        },
        {
            "cityCode": "430503",
            "label": "大祥区", "value": "大祥区",
            "pcode": "430500"
        },
        {
            "cityCode": "430511",
            "label": "北塔区", "value": "北塔区",
            "pcode": "430500"
        },
        {
            "cityCode": "430521",
            "label": "邵东县", "value": "邵东县",
            "pcode": "430500"
        },
        {
            "cityCode": "430522",
            "label": "新邵县", "value": "新邵县",
            "pcode": "430500"
        },
        {
            "cityCode": "430523",
            "label": "邵阳县", "value": "邵阳县",
            "pcode": "430500"
        },
        {
            "cityCode": "430524",
            "label": "隆回县", "value": "隆回县",
            "pcode": "430500"
        },
        {
            "cityCode": "430525",
            "label": "洞口县", "value": "洞口县",
            "pcode": "430500"
        },
        {
            "cityCode": "430527",
            "label": "绥宁县", "value": "绥宁县",
            "pcode": "430500"
        },
        {
            "cityCode": "430528",
            "label": "新宁县", "value": "新宁县",
            "pcode": "430500"
        },
        {
            "cityCode": "430529",
            "label": "城步苗族自治县", "value": "城步苗族自治县",
            "pcode": "430500"
        },
        {
            "cityCode": "430581",
            "label": "武冈市", "value": "武冈市",
            "pcode": "430500"
        }],
        "pcode": "430000"
    },
    {
        "cityCode": "430600",
        "label": "岳阳市", "value": "岳阳市",
        "children": [{
            "cityCode": "430602",
            "label": "岳阳楼区", "value": "岳阳楼区",
            "pcode": "430600"
        },
        {
            "cityCode": "430603",
            "label": "云溪区", "value": "云溪区",
            "pcode": "430600"
        },
        {
            "cityCode": "430611",
            "label": "君山区", "value": "君山区",
            "pcode": "430600"
        },
        {
            "cityCode": "430621",
            "label": "岳阳县", "value": "岳阳县",
            "pcode": "430600"
        },
        {
            "cityCode": "430623",
            "label": "华容县", "value": "华容县",
            "pcode": "430600"
        },
        {
            "cityCode": "430624",
            "label": "湘阴县", "value": "湘阴县",
            "pcode": "430600"
        },
        {
            "cityCode": "430626",
            "label": "平江县", "value": "平江县",
            "pcode": "430600"
        },
        {
            "cityCode": "430681",
            "label": "汨罗市", "value": "汨罗市",
            "pcode": "430600"
        },
        {
            "cityCode": "430682",
            "label": "临湘市", "value": "临湘市",
            "pcode": "430600"
        }],
        "pcode": "430000"
    },
    {
        "cityCode": "430700",
        "label": "常德市", "value": "常德市",
        "children": [{
            "cityCode": "430702",
            "label": "武陵区", "value": "武陵区",
            "pcode": "430700"
        },
        {
            "cityCode": "430703",
            "label": "鼎城区", "value": "鼎城区",
            "pcode": "430700"
        },
        {
            "cityCode": "430721",
            "label": "安乡县", "value": "安乡县",
            "pcode": "430700"
        },
        {
            "cityCode": "430722",
            "label": "汉寿县", "value": "汉寿县",
            "pcode": "430700"
        },
        {
            "cityCode": "430723",
            "label": "澧县", "value": "澧县",
            "pcode": "430700"
        },
        {
            "cityCode": "430724",
            "label": "临澧县", "value": "临澧县",
            "pcode": "430700"
        },
        {
            "cityCode": "430725",
            "label": "桃源县", "value": "桃源县",
            "pcode": "430700"
        },
        {
            "cityCode": "430726",
            "label": "石门县", "value": "石门县",
            "pcode": "430700"
        },
        {
            "cityCode": "430781",
            "label": "津市市", "value": "津市市",
            "pcode": "430700"
        }],
        "pcode": "430000"
    },
    {
        "cityCode": "430800",
        "label": "张家界市", "value": "张家界市",
        "children": [{
            "cityCode": "430802",
            "label": "永定区", "value": "永定区",
            "pcode": "430800"
        },
        {
            "cityCode": "430811",
            "label": "武陵源区", "value": "武陵源区",
            "pcode": "430800"
        },
        {
            "cityCode": "430821",
            "label": "慈利县", "value": "慈利县",
            "pcode": "430800"
        },
        {
            "cityCode": "430822",
            "label": "桑植县", "value": "桑植县",
            "pcode": "430800"
        }],
        "pcode": "430000"
    },
    {
        "cityCode": "430900",
        "label": "益阳市", "value": "益阳市",
        "children": [{
            "cityCode": "430902",
            "label": "资阳区", "value": "资阳区",
            "pcode": "430900"
        },
        {
            "cityCode": "430903",
            "label": "赫山区", "value": "赫山区",
            "pcode": "430900"
        },
        {
            "cityCode": "430921",
            "label": "南县", "value": "南县",
            "pcode": "430900"
        },
        {
            "cityCode": "430922",
            "label": "桃江县", "value": "桃江县",
            "pcode": "430900"
        },
        {
            "cityCode": "430923",
            "label": "安化县", "value": "安化县",
            "pcode": "430900"
        },
        {
            "cityCode": "430981",
            "label": "沅江市", "value": "沅江市",
            "pcode": "430900"
        }],
        "pcode": "430000"
    },
    {
        "cityCode": "431000",
        "label": "郴州市", "value": "郴州市",
        "children": [{
            "cityCode": "431002",
            "label": "北湖区", "value": "北湖区",
            "pcode": "431000"
        },
        {
            "cityCode": "431003",
            "label": "苏仙区", "value": "苏仙区",
            "pcode": "431000"
        },
        {
            "cityCode": "431021",
            "label": "桂阳县", "value": "桂阳县",
            "pcode": "431000"
        },
        {
            "cityCode": "431022",
            "label": "宜章县", "value": "宜章县",
            "pcode": "431000"
        },
        {
            "cityCode": "431023",
            "label": "永兴县", "value": "永兴县",
            "pcode": "431000"
        },
        {
            "cityCode": "431024",
            "label": "嘉禾县", "value": "嘉禾县",
            "pcode": "431000"
        },
        {
            "cityCode": "431025",
            "label": "临武县", "value": "临武县",
            "pcode": "431000"
        },
        {
            "cityCode": "431026",
            "label": "汝城县", "value": "汝城县",
            "pcode": "431000"
        },
        {
            "cityCode": "431027",
            "label": "桂东县", "value": "桂东县",
            "pcode": "431000"
        },
        {
            "cityCode": "431028",
            "label": "安仁县", "value": "安仁县",
            "pcode": "431000"
        },
        {
            "cityCode": "431081",
            "label": "资兴市", "value": "资兴市",
            "pcode": "431000"
        }],
        "pcode": "430000"
    },
    {
        "cityCode": "431100",
        "label": "永州市", "value": "永州市",
        "children": [{
            "cityCode": "431102",
            "label": "零陵区", "value": "零陵区",
            "pcode": "431100"
        },
        {
            "cityCode": "431103",
            "label": "冷水滩区", "value": "冷水滩区",
            "pcode": "431100"
        },
        {
            "cityCode": "431121",
            "label": "祁阳县", "value": "祁阳县",
            "pcode": "431100"
        },
        {
            "cityCode": "431122",
            "label": "东安县", "value": "东安县",
            "pcode": "431100"
        },
        {
            "cityCode": "431123",
            "label": "双牌县", "value": "双牌县",
            "pcode": "431100"
        },
        {
            "cityCode": "431124",
            "label": "道县", "value": "道县",
            "pcode": "431100"
        },
        {
            "cityCode": "431125",
            "label": "江永县", "value": "江永县",
            "pcode": "431100"
        },
        {
            "cityCode": "431126",
            "label": "宁远县", "value": "宁远县",
            "pcode": "431100"
        },
        {
            "cityCode": "431127",
            "label": "蓝山县", "value": "蓝山县",
            "pcode": "431100"
        },
        {
            "cityCode": "431128",
            "label": "新田县", "value": "新田县",
            "pcode": "431100"
        },
        {
            "cityCode": "431129",
            "label": "江华瑶族自治县", "value": "江华瑶族自治县",
            "pcode": "431100"
        }],
        "pcode": "430000"
    },
    {
        "cityCode": "431200",
        "label": "怀化市", "value": "怀化市",
        "children": [{
            "cityCode": "431202",
            "label": "鹤城区", "value": "鹤城区",
            "pcode": "431200"
        },
        {
            "cityCode": "431221",
            "label": "中方县", "value": "中方县",
            "pcode": "431200"
        },
        {
            "cityCode": "431222",
            "label": "沅陵县", "value": "沅陵县",
            "pcode": "431200"
        },
        {
            "cityCode": "431223",
            "label": "辰溪县", "value": "辰溪县",
            "pcode": "431200"
        },
        {
            "cityCode": "431224",
            "label": "溆浦县", "value": "溆浦县",
            "pcode": "431200"
        },
        {
            "cityCode": "431225",
            "label": "会同县", "value": "会同县",
            "pcode": "431200"
        },
        {
            "cityCode": "431226",
            "label": "麻阳苗族自治县", "value": "麻阳苗族自治县",
            "pcode": "431200"
        },
        {
            "cityCode": "431227",
            "label": "新晃侗族自治县", "value": "新晃侗族自治县",
            "pcode": "431200"
        },
        {
            "cityCode": "431228",
            "label": "芷江侗族自治县", "value": "芷江侗族自治县",
            "pcode": "431200"
        },
        {
            "cityCode": "431229",
            "label": "靖州苗族侗族自治县", "value": "靖州苗族侗族自治县",
            "pcode": "431200"
        },
        {
            "cityCode": "431230",
            "label": "通道侗族自治县", "value": "通道侗族自治县",
            "pcode": "431200"
        },
        {
            "cityCode": "431281",
            "label": "洪江市", "value": "洪江市",
            "pcode": "431200"
        }],
        "pcode": "430000"
    },
    {
        "cityCode": "431300",
        "label": "娄底市", "value": "娄底市",
        "children": [{
            "cityCode": "431302",
            "label": "娄星区", "value": "娄星区",
            "pcode": "431300"
        },
        {
            "cityCode": "431321",
            "label": "双峰县", "value": "双峰县",
            "pcode": "431300"
        },
        {
            "cityCode": "431322",
            "label": "新化县", "value": "新化县",
            "pcode": "431300"
        },
        {
            "cityCode": "431381",
            "label": "冷水江市", "value": "冷水江市",
            "pcode": "431300"
        },
        {
            "cityCode": "431382",
            "label": "涟源市", "value": "涟源市",
            "pcode": "431300"
        }],
        "pcode": "430000"
    },
    {
        "cityCode": "433100",
        "label": "湘西土家族苗族自治州", "value": "湘西土家族苗族自治州",
        "children": [{
            "cityCode": "433101",
            "label": "吉首市", "value": "吉首市",
            "pcode": "433100"
        },
        {
            "cityCode": "433122",
            "label": "泸溪县", "value": "泸溪县",
            "pcode": "433100"
        },
        {
            "cityCode": "433123",
            "label": "凤凰县", "value": "凤凰县",
            "pcode": "433100"
        },
        {
            "cityCode": "433124",
            "label": "花垣县", "value": "花垣县",
            "pcode": "433100"
        },
        {
            "cityCode": "433125",
            "label": "保靖县", "value": "保靖县",
            "pcode": "433100"
        },
        {
            "cityCode": "433126",
            "label": "古丈县", "value": "古丈县",
            "pcode": "433100"
        },
        {
            "cityCode": "433127",
            "label": "永顺县", "value": "永顺县",
            "pcode": "433100"
        },
        {
            "cityCode": "433130",
            "label": "龙山县", "value": "龙山县",
            "pcode": "433100"
        }],
        "pcode": "430000"
    }]
},
{
    "cityCode": "440000",
    "label": "广东省", "value": "广东省",
    "children": [{
        "cityCode": "440100",
        "label": "广州市", "value": "广州市",
        "children": [{
            "cityCode": "440103",
            "label": "荔湾区", "value": "荔湾区",
            "pcode": "440100"
        },
        {
            "cityCode": "440104",
            "label": "越秀区", "value": "越秀区",
            "pcode": "440100"
        },
        {
            "cityCode": "440105",
            "label": "海珠区", "value": "海珠区",
            "pcode": "440100"
        },
        {
            "cityCode": "440106",
            "label": "天河区", "value": "天河区",
            "pcode": "440100"
        },
        {
            "cityCode": "440111",
            "label": "白云区", "value": "白云区",
            "pcode": "440100"
        },
        {
            "cityCode": "440112",
            "label": "黄埔区", "value": "黄埔区",
            "pcode": "440100"
        },
        {
            "cityCode": "440113",
            "label": "番禺区", "value": "番禺区",
            "pcode": "440100"
        },
        {
            "cityCode": "440114",
            "label": "花都区", "value": "花都区",
            "pcode": "440100"
        },
        {
            "cityCode": "440115",
            "label": "南沙区", "value": "南沙区",
            "pcode": "440100"
        },
        {
            "cityCode": "440117",
            "label": "从化区", "value": "从化区",
            "pcode": "440100"
        },
        {
            "cityCode": "440118",
            "label": "增城区", "value": "增城区",
            "pcode": "440100"
        }],
        "pcode": "440000"
    },
    {
        "cityCode": "440200",
        "label": "韶关市", "value": "韶关市",
        "children": [{
            "cityCode": "440203",
            "label": "武江区", "value": "武江区",
            "pcode": "440200"
        },
        {
            "cityCode": "440204",
            "label": "浈江区", "value": "浈江区",
            "pcode": "440200"
        },
        {
            "cityCode": "440205",
            "label": "曲江区", "value": "曲江区",
            "pcode": "440200"
        },
        {
            "cityCode": "440222",
            "label": "始兴县", "value": "始兴县",
            "pcode": "440200"
        },
        {
            "cityCode": "440224",
            "label": "仁化县", "value": "仁化县",
            "pcode": "440200"
        },
        {
            "cityCode": "440229",
            "label": "翁源县", "value": "翁源县",
            "pcode": "440200"
        },
        {
            "cityCode": "440232",
            "label": "乳源瑶族自治县", "value": "乳源瑶族自治县",
            "pcode": "440200"
        },
        {
            "cityCode": "440233",
            "label": "新丰县", "value": "新丰县",
            "pcode": "440200"
        },
        {
            "cityCode": "440281",
            "label": "乐昌市", "value": "乐昌市",
            "pcode": "440200"
        },
        {
            "cityCode": "440282",
            "label": "南雄市", "value": "南雄市",
            "pcode": "440200"
        }],
        "pcode": "440000"
    },
    {
        "cityCode": "440300",
        "label": "深圳市", "value": "深圳市",
        "children": [{
            "cityCode": "440303",
            "label": "罗湖区", "value": "罗湖区",
            "pcode": "440300"
        },
        {
            "cityCode": "440304",
            "label": "福田区", "value": "福田区",
            "pcode": "440300"
        },
        {
            "cityCode": "440305",
            "label": "南山区", "value": "南山区",
            "pcode": "440300"
        },
        {
            "cityCode": "440306",
            "label": "宝安区", "value": "宝安区",
            "pcode": "440300"
        },
        {
            "cityCode": "440307",
            "label": "龙岗区", "value": "龙岗区",
            "pcode": "440300"
        },
        {
            "cityCode": "440308",
            "label": "盐田区", "value": "盐田区",
            "pcode": "440300"
        }],
        "pcode": "440000"
    },
    {
        "cityCode": "440400",
        "label": "珠海市", "value": "珠海市",
        "children": [{
            "cityCode": "440402",
            "label": "香洲区", "value": "香洲区",
            "pcode": "440400"
        },
        {
            "cityCode": "440403",
            "label": "斗门区", "value": "斗门区",
            "pcode": "440400"
        },
        {
            "cityCode": "440404",
            "label": "金湾区", "value": "金湾区",
            "pcode": "440400"
        }],
        "pcode": "440000"
    },
    {
        "cityCode": "440500",
        "label": "汕头市", "value": "汕头市",
        "children": [{
            "cityCode": "440507",
            "label": "龙湖区", "value": "龙湖区",
            "pcode": "440500"
        },
        {
            "cityCode": "440511",
            "label": "金平区", "value": "金平区",
            "pcode": "440500"
        },
        {
            "cityCode": "440512",
            "label": "濠江区", "value": "濠江区",
            "pcode": "440500"
        },
        {
            "cityCode": "440513",
            "label": "潮阳区", "value": "潮阳区",
            "pcode": "440500"
        },
        {
            "cityCode": "440514",
            "label": "潮南区", "value": "潮南区",
            "pcode": "440500"
        },
        {
            "cityCode": "440515",
            "label": "澄海区", "value": "澄海区",
            "pcode": "440500"
        },
        {
            "cityCode": "440523",
            "label": "南澳县", "value": "南澳县",
            "pcode": "440500"
        }],
        "pcode": "440000"
    },
    {
        "cityCode": "440600",
        "label": "佛山市", "value": "佛山市",
        "children": [{
            "cityCode": "440604",
            "label": "禅城区", "value": "禅城区",
            "pcode": "440600"
        },
        {
            "cityCode": "440605",
            "label": "南海区", "value": "南海区",
            "pcode": "440600"
        },
        {
            "cityCode": "440606",
            "label": "顺德区", "value": "顺德区",
            "pcode": "440600"
        },
        {
            "cityCode": "440607",
            "label": "三水区", "value": "三水区",
            "pcode": "440600"
        },
        {
            "cityCode": "440608",
            "label": "高明区", "value": "高明区",
            "pcode": "440600"
        }],
        "pcode": "440000"
    },
    {
        "cityCode": "440700",
        "label": "江门市", "value": "江门市",
        "children": [{
            "cityCode": "440703",
            "label": "蓬江区", "value": "蓬江区",
            "pcode": "440700"
        },
        {
            "cityCode": "440704",
            "label": "江海区", "value": "江海区",
            "pcode": "440700"
        },
        {
            "cityCode": "440705",
            "label": "新会区", "value": "新会区",
            "pcode": "440700"
        },
        {
            "cityCode": "440781",
            "label": "台山市", "value": "台山市",
            "pcode": "440700"
        },
        {
            "cityCode": "440783",
            "label": "开平市", "value": "开平市",
            "pcode": "440700"
        },
        {
            "cityCode": "440784",
            "label": "鹤山市", "value": "鹤山市",
            "pcode": "440700"
        },
        {
            "cityCode": "440785",
            "label": "恩平市", "value": "恩平市",
            "pcode": "440700"
        }],
        "pcode": "440000"
    },
    {
        "cityCode": "440800",
        "label": "湛江市", "value": "湛江市",
        "children": [{
            "cityCode": "440802",
            "label": "赤坎区", "value": "赤坎区",
            "pcode": "440800"
        },
        {
            "cityCode": "440803",
            "label": "霞山区", "value": "霞山区",
            "pcode": "440800"
        },
        {
            "cityCode": "440804",
            "label": "坡头区", "value": "坡头区",
            "pcode": "440800"
        },
        {
            "cityCode": "440811",
            "label": "麻章区", "value": "麻章区",
            "pcode": "440800"
        },
        {
            "cityCode": "440823",
            "label": "遂溪县", "value": "遂溪县",
            "pcode": "440800"
        },
        {
            "cityCode": "440825",
            "label": "徐闻县", "value": "徐闻县",
            "pcode": "440800"
        },
        {
            "cityCode": "440881",
            "label": "廉江市", "value": "廉江市",
            "pcode": "440800"
        },
        {
            "cityCode": "440882",
            "label": "雷州市", "value": "雷州市",
            "pcode": "440800"
        },
        {
            "cityCode": "440883",
            "label": "吴川市", "value": "吴川市",
            "pcode": "440800"
        }],
        "pcode": "440000"
    },
    {
        "cityCode": "440900",
        "label": "茂名市", "value": "茂名市",
        "children": [{
            "cityCode": "440902",
            "label": "茂南区", "value": "茂南区",
            "pcode": "440900"
        },
        {
            "cityCode": "440904",
            "label": "电白区", "value": "电白区",
            "pcode": "440900"
        },
        {
            "cityCode": "440981",
            "label": "高州市", "value": "高州市",
            "pcode": "440900"
        },
        {
            "cityCode": "440982",
            "label": "化州市", "value": "化州市",
            "pcode": "440900"
        },
        {
            "cityCode": "440983",
            "label": "信宜市", "value": "信宜市",
            "pcode": "440900"
        }],
        "pcode": "440000"
    },
    {
        "cityCode": "441200",
        "label": "肇庆市", "value": "肇庆市",
        "children": [{
            "cityCode": "441202",
            "label": "端州区", "value": "端州区",
            "pcode": "441200"
        },
        {
            "cityCode": "441203",
            "label": "鼎湖区", "value": "鼎湖区",
            "pcode": "441200"
        },
        {
            "cityCode": "441204",
            "label": "高要区", "value": "高要区",
            "pcode": "441200"
        },
        {
            "cityCode": "441223",
            "label": "广宁县", "value": "广宁县",
            "pcode": "441200"
        },
        {
            "cityCode": "441224",
            "label": "怀集县", "value": "怀集县",
            "pcode": "441200"
        },
        {
            "cityCode": "441225",
            "label": "封开县", "value": "封开县",
            "pcode": "441200"
        },
        {
            "cityCode": "441226",
            "label": "德庆县", "value": "德庆县",
            "pcode": "441200"
        },
        {
            "cityCode": "441284",
            "label": "四会市", "value": "四会市",
            "pcode": "441200"
        }],
        "pcode": "440000"
    },
    {
        "cityCode": "441300",
        "label": "惠州市", "value": "惠州市",
        "children": [{
            "cityCode": "441302",
            "label": "惠城区", "value": "惠城区",
            "pcode": "441300"
        },
        {
            "cityCode": "441303",
            "label": "惠阳区", "value": "惠阳区",
            "pcode": "441300"
        },
        {
            "cityCode": "441322",
            "label": "博罗县", "value": "博罗县",
            "pcode": "441300"
        },
        {
            "cityCode": "441323",
            "label": "惠东县", "value": "惠东县",
            "pcode": "441300"
        },
        {
            "cityCode": "441324",
            "label": "龙门县", "value": "龙门县",
            "pcode": "441300"
        }],
        "pcode": "440000"
    },
    {
        "cityCode": "441400",
        "label": "梅州市", "value": "梅州市",
        "children": [{
            "cityCode": "441402",
            "label": "梅江区", "value": "梅江区",
            "pcode": "441400"
        },
        {
            "cityCode": "441403",
            "label": "梅县区", "value": "梅县区",
            "pcode": "441400"
        },
        {
            "cityCode": "441422",
            "label": "大埔县", "value": "大埔县",
            "pcode": "441400"
        },
        {
            "cityCode": "441423",
            "label": "丰顺县", "value": "丰顺县",
            "pcode": "441400"
        },
        {
            "cityCode": "441424",
            "label": "五华县", "value": "五华县",
            "pcode": "441400"
        },
        {
            "cityCode": "441426",
            "label": "平远县", "value": "平远县",
            "pcode": "441400"
        },
        {
            "cityCode": "441427",
            "label": "蕉岭县", "value": "蕉岭县",
            "pcode": "441400"
        },
        {
            "cityCode": "441481",
            "label": "兴宁市", "value": "兴宁市",
            "pcode": "441400"
        }],
        "pcode": "440000"
    },
    {
        "cityCode": "441500",
        "label": "汕尾市", "value": "汕尾市",
        "children": [{
            "cityCode": "441502",
            "label": "城区", "value": "城区",
            "pcode": "441500"
        },
        {
            "cityCode": "441521",
            "label": "海丰县", "value": "海丰县",
            "pcode": "441500"
        },
        {
            "cityCode": "441523",
            "label": "陆河县", "value": "陆河县",
            "pcode": "441500"
        },
        {
            "cityCode": "441581",
            "label": "陆丰市", "value": "陆丰市",
            "pcode": "441500"
        }],
        "pcode": "440000"
    },
    {
        "cityCode": "441600",
        "label": "河源市", "value": "河源市",
        "children": [{
            "cityCode": "441602",
            "label": "源城区", "value": "源城区",
            "pcode": "441600"
        },
        {
            "cityCode": "441621",
            "label": "紫金县", "value": "紫金县",
            "pcode": "441600"
        },
        {
            "cityCode": "441622",
            "label": "龙川县", "value": "龙川县",
            "pcode": "441600"
        },
        {
            "cityCode": "441623",
            "label": "连平县", "value": "连平县",
            "pcode": "441600"
        },
        {
            "cityCode": "441624",
            "label": "和平县", "value": "和平县",
            "pcode": "441600"
        },
        {
            "cityCode": "441625",
            "label": "东源县", "value": "东源县",
            "pcode": "441600"
        }],
        "pcode": "440000"
    },
    {
        "cityCode": "441700",
        "label": "阳江市", "value": "阳江市",
        "children": [{
            "cityCode": "441702",
            "label": "江城区", "value": "江城区",
            "pcode": "441700"
        },
        {
            "cityCode": "441704",
            "label": "阳东区", "value": "阳东区",
            "pcode": "441700"
        },
        {
            "cityCode": "441721",
            "label": "阳西县", "value": "阳西县",
            "pcode": "441700"
        },
        {
            "cityCode": "441781",
            "label": "阳春市", "value": "阳春市",
            "pcode": "441700"
        }],
        "pcode": "440000"
    },
    {
        "cityCode": "441800",
        "label": "清远市", "value": "清远市",
        "children": [{
            "cityCode": "441802",
            "label": "清城区", "value": "清城区",
            "pcode": "441800"
        },
        {
            "cityCode": "441803",
            "label": "清新区", "value": "清新区",
            "pcode": "441800"
        },
        {
            "cityCode": "441821",
            "label": "佛冈县", "value": "佛冈县",
            "pcode": "441800"
        },
        {
            "cityCode": "441823",
            "label": "阳山县", "value": "阳山县",
            "pcode": "441800"
        },
        {
            "cityCode": "441825",
            "label": "连山壮族瑶族自治县", "value": "连山壮族瑶族自治县",
            "pcode": "441800"
        },
        {
            "cityCode": "441826",
            "label": "连南瑶族自治县", "value": "连南瑶族自治县",
            "pcode": "441800"
        },
        {
            "cityCode": "441881",
            "label": "英德市", "value": "英德市",
            "pcode": "441800"
        },
        {
            "cityCode": "441882",
            "label": "连州市", "value": "连州市",
            "pcode": "441800"
        }],
        "pcode": "440000"
    },
    {
        "cityCode": "441900",
        "label": "东莞市", "value": "东莞市",
        "children": [{
            "cityCode": "441900003",
            "label": "东城街道", "value": "东城街道",
            "pcode": "441900"
        },
        {
            "cityCode": "441900004",
            "label": "南城街道", "value": "南城街道",
            "pcode": "441900"
        },
        {
            "cityCode": "441900005",
            "label": "万江街道", "value": "万江街道",
            "pcode": "441900"
        },
        {
            "cityCode": "441900006",
            "label": "莞城街道", "value": "莞城街道",
            "pcode": "441900"
        },
        {
            "cityCode": "441900101",
            "label": "石碣镇", "value": "石碣镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900102",
            "label": "石龙镇", "value": "石龙镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900103",
            "label": "茶山镇", "value": "茶山镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900104",
            "label": "石排镇", "value": "石排镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900105",
            "label": "企石镇", "value": "企石镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900106",
            "label": "横沥镇", "value": "横沥镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900107",
            "label": "桥头镇", "value": "桥头镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900108",
            "label": "谢岗镇", "value": "谢岗镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900109",
            "label": "东坑镇", "value": "东坑镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900110",
            "label": "常平镇", "value": "常平镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900111",
            "label": "寮步镇", "value": "寮步镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900112",
            "label": "樟木头镇", "value": "樟木头镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900113",
            "label": "大朗镇", "value": "大朗镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900114",
            "label": "黄江镇", "value": "黄江镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900115",
            "label": "清溪镇", "value": "清溪镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900116",
            "label": "塘厦镇", "value": "塘厦镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900117",
            "label": "凤岗镇", "value": "凤岗镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900118",
            "label": "大岭山镇", "value": "大岭山镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900119",
            "label": "长安镇", "value": "长安镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900121",
            "label": "虎门镇", "value": "虎门镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900122",
            "label": "厚街镇", "value": "厚街镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900123",
            "label": "沙田镇", "value": "沙田镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900124",
            "label": "道滘镇", "value": "道滘镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900125",
            "label": "洪梅镇", "value": "洪梅镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900126",
            "label": "麻涌镇", "value": "麻涌镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900127",
            "label": "望牛墩镇", "value": "望牛墩镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900128",
            "label": "中堂镇", "value": "中堂镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900129",
            "label": "高埗镇", "value": "高埗镇",
            "pcode": "441900"
        },
        {
            "cityCode": "441900401",
            "label": "松山湖管委会", "value": "松山湖管委会",
            "pcode": "441900"
        },
        {
            "cityCode": "441900402",
            "label": "虎门港管委会", "value": "虎门港管委会",
            "pcode": "441900"
        },
        {
            "cityCode": "441900403",
            "label": "东莞生态园", "value": "东莞生态园",
            "pcode": "441900"
        }],
        "pcode": "440000"
    },
    {
        "cityCode": "442000",
        "label": "中山市", "value": "中山市",
        "children": [{
            "cityCode": "442000001",
            "label": "石岐区街道", "value": "石岐区街道",
            "pcode": "442000"
        },
        {
            "cityCode": "442000002",
            "label": "东区街道", "value": "东区街道",
            "pcode": "442000"
        },
        {
            "cityCode": "442000003",
            "label": "火炬开发区街道", "value": "火炬开发区街道",
            "pcode": "442000"
        },
        {
            "cityCode": "442000004",
            "label": "西区街道", "value": "西区街道",
            "pcode": "442000"
        },
        {
            "cityCode": "442000005",
            "label": "南区街道", "value": "南区街道",
            "pcode": "442000"
        },
        {
            "cityCode": "442000006",
            "label": "五桂山街道", "value": "五桂山街道",
            "pcode": "442000"
        },
        {
            "cityCode": "442000100",
            "label": "小榄镇", "value": "小榄镇",
            "pcode": "442000"
        },
        {
            "cityCode": "442000101",
            "label": "黄圃镇", "value": "黄圃镇",
            "pcode": "442000"
        },
        {
            "cityCode": "442000102",
            "label": "民众镇", "value": "民众镇",
            "pcode": "442000"
        },
        {
            "cityCode": "442000103",
            "label": "东凤镇", "value": "东凤镇",
            "pcode": "442000"
        },
        {
            "cityCode": "442000104",
            "label": "东升镇", "value": "东升镇",
            "pcode": "442000"
        },
        {
            "cityCode": "442000105",
            "label": "古镇镇", "value": "古镇镇",
            "pcode": "442000"
        },
        {
            "cityCode": "442000106",
            "label": "沙溪镇", "value": "沙溪镇",
            "pcode": "442000"
        },
        {
            "cityCode": "442000107",
            "label": "坦洲镇", "value": "坦洲镇",
            "pcode": "442000"
        },
        {
            "cityCode": "442000108",
            "label": "港口镇", "value": "港口镇",
            "pcode": "442000"
        },
        {
            "cityCode": "442000109",
            "label": "三角镇", "value": "三角镇",
            "pcode": "442000"
        },
        {
            "cityCode": "442000110",
            "label": "横栏镇", "value": "横栏镇",
            "pcode": "442000"
        },
        {
            "cityCode": "442000111",
            "label": "南头镇", "value": "南头镇",
            "pcode": "442000"
        },
        {
            "cityCode": "442000112",
            "label": "阜沙镇", "value": "阜沙镇",
            "pcode": "442000"
        },
        {
            "cityCode": "442000113",
            "label": "南朗镇", "value": "南朗镇",
            "pcode": "442000"
        },
        {
            "cityCode": "442000114",
            "label": "三乡镇", "value": "三乡镇",
            "pcode": "442000"
        },
        {
            "cityCode": "442000115",
            "label": "板芙镇", "value": "板芙镇",
            "pcode": "442000"
        },
        {
            "cityCode": "442000116",
            "label": "大涌镇", "value": "大涌镇",
            "pcode": "442000"
        },
        {
            "cityCode": "442000117",
            "label": "神湾镇", "value": "神湾镇",
            "pcode": "442000"
        }],
        "pcode": "440000"
    },
    {
        "cityCode": "442100",
        "label": "东沙群岛", "value": "东沙群岛",
        "children": [{
            "cityCode": "442101",
            "label": "东沙群岛", "value": "东沙群岛",
            "pcode": "442100"
        }],
        "pcode": "440000"
    },
    {
        "cityCode": "445100",
        "label": "潮州市", "value": "潮州市",
        "children": [{
            "cityCode": "445102",
            "label": "湘桥区", "value": "湘桥区",
            "pcode": "445100"
        },
        {
            "cityCode": "445103",
            "label": "潮安区", "value": "潮安区",
            "pcode": "445100"
        },
        {
            "cityCode": "445122",
            "label": "饶平县", "value": "饶平县",
            "pcode": "445100"
        }],
        "pcode": "440000"
    },
    {
        "cityCode": "445200",
        "label": "揭阳市", "value": "揭阳市",
        "children": [{
            "cityCode": "445202",
            "label": "榕城区", "value": "榕城区",
            "pcode": "445200"
        },
        {
            "cityCode": "445203",
            "label": "揭东区", "value": "揭东区",
            "pcode": "445200"
        },
        {
            "cityCode": "445222",
            "label": "揭西县", "value": "揭西县",
            "pcode": "445200"
        },
        {
            "cityCode": "445224",
            "label": "惠来县", "value": "惠来县",
            "pcode": "445200"
        },
        {
            "cityCode": "445281",
            "label": "普宁市", "value": "普宁市",
            "pcode": "445200"
        }],
        "pcode": "440000"
    },
    {
        "cityCode": "445300",
        "label": "云浮市", "value": "云浮市",
        "children": [{
            "cityCode": "445302",
            "label": "云城区", "value": "云城区",
            "pcode": "445300"
        },
        {
            "cityCode": "445303",
            "label": "云安区", "value": "云安区",
            "pcode": "445300"
        },
        {
            "cityCode": "445321",
            "label": "新兴县", "value": "新兴县",
            "pcode": "445300"
        },
        {
            "cityCode": "445322",
            "label": "郁南县", "value": "郁南县",
            "pcode": "445300"
        },
        {
            "cityCode": "445381",
            "label": "罗定市", "value": "罗定市",
            "pcode": "445300"
        }],
        "pcode": "440000"
    }]
},
{
    "cityCode": "450000",
    "label": "广西壮族自治区", "value": "广西壮族自治区",
    "children": [{
        "cityCode": "450100",
        "label": "南宁市", "value": "南宁市",
        "children": [{
            "cityCode": "450102",
            "label": "兴宁区", "value": "兴宁区",
            "pcode": "450100"
        },
        {
            "cityCode": "450103",
            "label": "青秀区", "value": "青秀区",
            "pcode": "450100"
        },
        {
            "cityCode": "450105",
            "label": "江南区", "value": "江南区",
            "pcode": "450100"
        },
        {
            "cityCode": "450107",
            "label": "西乡塘区", "value": "西乡塘区",
            "pcode": "450100"
        },
        {
            "cityCode": "450108",
            "label": "良庆区", "value": "良庆区",
            "pcode": "450100"
        },
        {
            "cityCode": "450109",
            "label": "邕宁区", "value": "邕宁区",
            "pcode": "450100"
        },
        {
            "cityCode": "450110",
            "label": "武鸣区", "value": "武鸣区",
            "pcode": "450100"
        },
        {
            "cityCode": "450123",
            "label": "隆安县", "value": "隆安县",
            "pcode": "450100"
        },
        {
            "cityCode": "450124",
            "label": "马山县", "value": "马山县",
            "pcode": "450100"
        },
        {
            "cityCode": "450125",
            "label": "上林县", "value": "上林县",
            "pcode": "450100"
        },
        {
            "cityCode": "450126",
            "label": "宾阳县", "value": "宾阳县",
            "pcode": "450100"
        },
        {
            "cityCode": "450127",
            "label": "横县", "value": "横县",
            "pcode": "450100"
        }],
        "pcode": "450000"
    },
    {
        "cityCode": "450200",
        "label": "柳州市", "value": "柳州市",
        "children": [{
            "cityCode": "450202",
            "label": "城中区", "value": "城中区",
            "pcode": "450200"
        },
        {
            "cityCode": "450203",
            "label": "鱼峰区", "value": "鱼峰区",
            "pcode": "450200"
        },
        {
            "cityCode": "450204",
            "label": "柳南区", "value": "柳南区",
            "pcode": "450200"
        },
        {
            "cityCode": "450205",
            "label": "柳北区", "value": "柳北区",
            "pcode": "450200"
        },
        {
            "cityCode": "450221",
            "label": "柳江区", "value": "柳江区",
            "pcode": "450200"
        },
        {
            "cityCode": "450222",
            "label": "柳城县", "value": "柳城县",
            "pcode": "450200"
        },
        {
            "cityCode": "450223",
            "label": "鹿寨县", "value": "鹿寨县",
            "pcode": "450200"
        },
        {
            "cityCode": "450224",
            "label": "融安县", "value": "融安县",
            "pcode": "450200"
        },
        {
            "cityCode": "450225",
            "label": "融水苗族自治县", "value": "融水苗族自治县",
            "pcode": "450200"
        },
        {
            "cityCode": "450226",
            "label": "三江侗族自治县", "value": "三江侗族自治县",
            "pcode": "450200"
        }],
        "pcode": "450000"
    },
    {
        "cityCode": "450300",
        "label": "桂林市", "value": "桂林市",
        "children": [{
            "cityCode": "450302",
            "label": "秀峰区", "value": "秀峰区",
            "pcode": "450300"
        },
        {
            "cityCode": "450303",
            "label": "叠彩区", "value": "叠彩区",
            "pcode": "450300"
        },
        {
            "cityCode": "450304",
            "label": "象山区", "value": "象山区",
            "pcode": "450300"
        },
        {
            "cityCode": "450305",
            "label": "七星区", "value": "七星区",
            "pcode": "450300"
        },
        {
            "cityCode": "450311",
            "label": "雁山区", "value": "雁山区",
            "pcode": "450300"
        },
        {
            "cityCode": "450312",
            "label": "临桂区", "value": "临桂区",
            "pcode": "450300"
        },
        {
            "cityCode": "450321",
            "label": "阳朔县", "value": "阳朔县",
            "pcode": "450300"
        },
        {
            "cityCode": "450323",
            "label": "灵川县", "value": "灵川县",
            "pcode": "450300"
        },
        {
            "cityCode": "450324",
            "label": "全州县", "value": "全州县",
            "pcode": "450300"
        },
        {
            "cityCode": "450325",
            "label": "兴安县", "value": "兴安县",
            "pcode": "450300"
        },
        {
            "cityCode": "450326",
            "label": "永福县", "value": "永福县",
            "pcode": "450300"
        },
        {
            "cityCode": "450327",
            "label": "灌阳县", "value": "灌阳县",
            "pcode": "450300"
        },
        {
            "cityCode": "450328",
            "label": "龙胜各族自治县", "value": "龙胜各族自治县",
            "pcode": "450300"
        },
        {
            "cityCode": "450329",
            "label": "资源县", "value": "资源县",
            "pcode": "450300"
        },
        {
            "cityCode": "450330",
            "label": "平乐县", "value": "平乐县",
            "pcode": "450300"
        },
        {
            "cityCode": "450331",
            "label": "荔浦县", "value": "荔浦县",
            "pcode": "450300"
        },
        {
            "cityCode": "450332",
            "label": "恭城瑶族自治县", "value": "恭城瑶族自治县",
            "pcode": "450300"
        }],
        "pcode": "450000"
    },
    {
        "cityCode": "450400",
        "label": "梧州市", "value": "梧州市",
        "children": [{
            "cityCode": "450403",
            "label": "万秀区", "value": "万秀区",
            "pcode": "450400"
        },
        {
            "cityCode": "450405",
            "label": "长洲区", "value": "长洲区",
            "pcode": "450400"
        },
        {
            "cityCode": "450406",
            "label": "龙圩区", "value": "龙圩区",
            "pcode": "450400"
        },
        {
            "cityCode": "450421",
            "label": "苍梧县", "value": "苍梧县",
            "pcode": "450400"
        },
        {
            "cityCode": "450422",
            "label": "藤县", "value": "藤县",
            "pcode": "450400"
        },
        {
            "cityCode": "450423",
            "label": "蒙山县", "value": "蒙山县",
            "pcode": "450400"
        },
        {
            "cityCode": "450481",
            "label": "岑溪市", "value": "岑溪市",
            "pcode": "450400"
        }],
        "pcode": "450000"
    },
    {
        "cityCode": "450500",
        "label": "北海市", "value": "北海市",
        "children": [{
            "cityCode": "450502",
            "label": "海城区", "value": "海城区",
            "pcode": "450500"
        },
        {
            "cityCode": "450503",
            "label": "银海区", "value": "银海区",
            "pcode": "450500"
        },
        {
            "cityCode": "450512",
            "label": "铁山港区", "value": "铁山港区",
            "pcode": "450500"
        },
        {
            "cityCode": "450521",
            "label": "合浦县", "value": "合浦县",
            "pcode": "450500"
        }],
        "pcode": "450000"
    },
    {
        "cityCode": "450600",
        "label": "防城港市", "value": "防城港市",
        "children": [{
            "cityCode": "450602",
            "label": "港口区", "value": "港口区",
            "pcode": "450600"
        },
        {
            "cityCode": "450603",
            "label": "防城区", "value": "防城区",
            "pcode": "450600"
        },
        {
            "cityCode": "450621",
            "label": "上思县", "value": "上思县",
            "pcode": "450600"
        },
        {
            "cityCode": "450681",
            "label": "东兴市", "value": "东兴市",
            "pcode": "450600"
        }],
        "pcode": "450000"
    },
    {
        "cityCode": "450700",
        "label": "钦州市", "value": "钦州市",
        "children": [{
            "cityCode": "450702",
            "label": "钦南区", "value": "钦南区",
            "pcode": "450700"
        },
        {
            "cityCode": "450703",
            "label": "钦北区", "value": "钦北区",
            "pcode": "450700"
        },
        {
            "cityCode": "450721",
            "label": "灵山县", "value": "灵山县",
            "pcode": "450700"
        },
        {
            "cityCode": "450722",
            "label": "浦北县", "value": "浦北县",
            "pcode": "450700"
        }],
        "pcode": "450000"
    },
    {
        "cityCode": "450800",
        "label": "贵港市", "value": "贵港市",
        "children": [{
            "cityCode": "450802",
            "label": "港北区", "value": "港北区",
            "pcode": "450800"
        },
        {
            "cityCode": "450803",
            "label": "港南区", "value": "港南区",
            "pcode": "450800"
        },
        {
            "cityCode": "450804",
            "label": "覃塘区", "value": "覃塘区",
            "pcode": "450800"
        },
        {
            "cityCode": "450821",
            "label": "平南县", "value": "平南县",
            "pcode": "450800"
        },
        {
            "cityCode": "450881",
            "label": "桂平市", "value": "桂平市",
            "pcode": "450800"
        }],
        "pcode": "450000"
    },
    {
        "cityCode": "450900",
        "label": "玉林市", "value": "玉林市",
        "children": [{
            "cityCode": "450902",
            "label": "玉州区", "value": "玉州区",
            "pcode": "450900"
        },
        {
            "cityCode": "450903",
            "label": "福绵区", "value": "福绵区",
            "pcode": "450900"
        },
        {
            "cityCode": "450921",
            "label": "容县", "value": "容县",
            "pcode": "450900"
        },
        {
            "cityCode": "450922",
            "label": "陆川县", "value": "陆川县",
            "pcode": "450900"
        },
        {
            "cityCode": "450923",
            "label": "博白县", "value": "博白县",
            "pcode": "450900"
        },
        {
            "cityCode": "450924",
            "label": "兴业县", "value": "兴业县",
            "pcode": "450900"
        },
        {
            "cityCode": "450981",
            "label": "北流市", "value": "北流市",
            "pcode": "450900"
        }],
        "pcode": "450000"
    },
    {
        "cityCode": "451000",
        "label": "百色市", "value": "百色市",
        "children": [{
            "cityCode": "451002",
            "label": "右江区", "value": "右江区",
            "pcode": "451000"
        },
        {
            "cityCode": "451021",
            "label": "田阳县", "value": "田阳县",
            "pcode": "451000"
        },
        {
            "cityCode": "451022",
            "label": "田东县", "value": "田东县",
            "pcode": "451000"
        },
        {
            "cityCode": "451023",
            "label": "平果县", "value": "平果县",
            "pcode": "451000"
        },
        {
            "cityCode": "451024",
            "label": "德保县", "value": "德保县",
            "pcode": "451000"
        },
        {
            "cityCode": "451026",
            "label": "那坡县", "value": "那坡县",
            "pcode": "451000"
        },
        {
            "cityCode": "451027",
            "label": "凌云县", "value": "凌云县",
            "pcode": "451000"
        },
        {
            "cityCode": "451028",
            "label": "乐业县", "value": "乐业县",
            "pcode": "451000"
        },
        {
            "cityCode": "451029",
            "label": "田林县", "value": "田林县",
            "pcode": "451000"
        },
        {
            "cityCode": "451030",
            "label": "西林县", "value": "西林县",
            "pcode": "451000"
        },
        {
            "cityCode": "451031",
            "label": "隆林各族自治县", "value": "隆林各族自治县",
            "pcode": "451000"
        },
        {
            "cityCode": "451081",
            "label": "靖西市", "value": "靖西市",
            "pcode": "451000"
        }],
        "pcode": "450000"
    },
    {
        "cityCode": "451100",
        "label": "贺州市", "value": "贺州市",
        "children": [{
            "cityCode": "451102",
            "label": "八步区", "value": "八步区",
            "pcode": "451100"
        },
        {
            "cityCode": "451103",
            "label": "平桂区", "value": "平桂区",
            "pcode": "451100"
        },
        {
            "cityCode": "451121",
            "label": "昭平县", "value": "昭平县",
            "pcode": "451100"
        },
        {
            "cityCode": "451122",
            "label": "钟山县", "value": "钟山县",
            "pcode": "451100"
        },
        {
            "cityCode": "451123",
            "label": "富川瑶族自治县", "value": "富川瑶族自治县",
            "pcode": "451100"
        }],
        "pcode": "450000"
    },
    {
        "cityCode": "451200",
        "label": "河池市", "value": "河池市",
        "children": [{
            "cityCode": "451202",
            "label": "金城江区", "value": "金城江区",
            "pcode": "451200"
        },
        {
            "cityCode": "451221",
            "label": "南丹县", "value": "南丹县",
            "pcode": "451200"
        },
        {
            "cityCode": "451222",
            "label": "天峨县", "value": "天峨县",
            "pcode": "451200"
        },
        {
            "cityCode": "451223",
            "label": "凤山县", "value": "凤山县",
            "pcode": "451200"
        },
        {
            "cityCode": "451224",
            "label": "东兰县", "value": "东兰县",
            "pcode": "451200"
        },
        {
            "cityCode": "451225",
            "label": "罗城仫佬族自治县", "value": "罗城仫佬族自治县",
            "pcode": "451200"
        },
        {
            "cityCode": "451226",
            "label": "环江毛南族自治县", "value": "环江毛南族自治县",
            "pcode": "451200"
        },
        {
            "cityCode": "451227",
            "label": "巴马瑶族自治县", "value": "巴马瑶族自治县",
            "pcode": "451200"
        },
        {
            "cityCode": "451228",
            "label": "都安瑶族自治县", "value": "都安瑶族自治县",
            "pcode": "451200"
        },
        {
            "cityCode": "451229",
            "label": "大化瑶族自治县", "value": "大化瑶族自治县",
            "pcode": "451200"
        },
        {
            "cityCode": "451203",
            "label": "宜州区", "value": "宜州区",
            "pcode": "451200"
        }],
        "pcode": "450000"
    },
    {
        "cityCode": "451300",
        "label": "来宾市", "value": "来宾市",
        "children": [{
            "cityCode": "451302",
            "label": "兴宾区", "value": "兴宾区",
            "pcode": "451300"
        },
        {
            "cityCode": "451321",
            "label": "忻城县", "value": "忻城县",
            "pcode": "451300"
        },
        {
            "cityCode": "451322",
            "label": "象州县", "value": "象州县",
            "pcode": "451300"
        },
        {
            "cityCode": "451323",
            "label": "武宣县", "value": "武宣县",
            "pcode": "451300"
        },
        {
            "cityCode": "451324",
            "label": "金秀瑶族自治县", "value": "金秀瑶族自治县",
            "pcode": "451300"
        },
        {
            "cityCode": "451381",
            "label": "合山市", "value": "合山市",
            "pcode": "451300"
        }],
        "pcode": "450000"
    },
    {
        "cityCode": "451400",
        "label": "崇左市", "value": "崇左市",
        "children": [{
            "cityCode": "451402",
            "label": "江州区", "value": "江州区",
            "pcode": "451400"
        },
        {
            "cityCode": "451421",
            "label": "扶绥县", "value": "扶绥县",
            "pcode": "451400"
        },
        {
            "cityCode": "451422",
            "label": "宁明县", "value": "宁明县",
            "pcode": "451400"
        },
        {
            "cityCode": "451423",
            "label": "龙州县", "value": "龙州县",
            "pcode": "451400"
        },
        {
            "cityCode": "451424",
            "label": "大新县", "value": "大新县",
            "pcode": "451400"
        },
        {
            "cityCode": "451425",
            "label": "天等县", "value": "天等县",
            "pcode": "451400"
        },
        {
            "cityCode": "451481",
            "label": "凭祥市", "value": "凭祥市",
            "pcode": "451400"
        }],
        "pcode": "450000"
    }]
},
{
    "cityCode": "460000",
    "label": "海南省", "value": "海南省",
    "children": [{
        "cityCode": "460100",
        "label": "海口市", "value": "海口市",
        "children": [{
            "cityCode": "460105",
            "label": "秀英区", "value": "秀英区",
            "pcode": "460100"
        },
        {
            "cityCode": "460106",
            "label": "龙华区", "value": "龙华区",
            "pcode": "460100"
        },
        {
            "cityCode": "460107",
            "label": "琼山区", "value": "琼山区",
            "pcode": "460100"
        },
        {
            "cityCode": "460108",
            "label": "美兰区", "value": "美兰区",
            "pcode": "460100"
        }],
        "pcode": "460000"
    },
    {
        "cityCode": "460200",
        "label": "三亚市", "value": "三亚市",
        "children": [{
            "cityCode": "460202",
            "label": "海棠区", "value": "海棠区",
            "pcode": "460200"
        },
        {
            "cityCode": "460203",
            "label": "吉阳区", "value": "吉阳区",
            "pcode": "460200"
        },
        {
            "cityCode": "460204",
            "label": "天涯区", "value": "天涯区",
            "pcode": "460200"
        },
        {
            "cityCode": "460205",
            "label": "崖州区", "value": "崖州区",
            "pcode": "460200"
        }],
        "pcode": "460000"
    },
    {
        "cityCode": "460300",
        "label": "三沙市", "value": "三沙市",
        "children": [{
            "cityCode": "460321",
            "label": "西沙群岛", "value": "西沙群岛",
            "pcode": "460300"
        },
        {
            "cityCode": "460322",
            "label": "南沙群岛", "value": "南沙群岛",
            "pcode": "460300"
        },
        {
            "cityCode": "460323",
            "label": "中沙群岛的岛礁及其海域", "value": "中沙群岛的岛礁及其海域",
            "pcode": "460300"
        }],
        "pcode": "460000"
    },
    {
        "cityCode": "460400",
        "label": "儋州市", "value": "儋州市",
        "children": [{
            "cityCode": "460400100",
            "label": "那大镇", "value": "那大镇",
            "pcode": "460400"
        },
        {
            "cityCode": "460400101",
            "label": "和庆镇", "value": "和庆镇",
            "pcode": "460400"
        },
        {
            "cityCode": "460400102",
            "label": "南丰镇", "value": "南丰镇",
            "pcode": "460400"
        },
        {
            "cityCode": "460400103",
            "label": "大成镇", "value": "大成镇",
            "pcode": "460400"
        },
        {
            "cityCode": "460400104",
            "label": "雅星镇", "value": "雅星镇",
            "pcode": "460400"
        },
        {
            "cityCode": "460400105",
            "label": "兰洋镇", "value": "兰洋镇",
            "pcode": "460400"
        },
        {
            "cityCode": "460400106",
            "label": "光村镇", "value": "光村镇",
            "pcode": "460400"
        },
        {
            "cityCode": "460400107",
            "label": "木棠镇", "value": "木棠镇",
            "pcode": "460400"
        },
        {
            "cityCode": "460400108",
            "label": "海头镇", "value": "海头镇",
            "pcode": "460400"
        },
        {
            "cityCode": "460400109",
            "label": "峨蔓镇", "value": "峨蔓镇",
            "pcode": "460400"
        },
        {
            "cityCode": "460400110",
            "label": "三都镇", "value": "三都镇",
            "pcode": "460400"
        },
        {
            "cityCode": "460400111",
            "label": "王五镇", "value": "王五镇",
            "pcode": "460400"
        },
        {
            "cityCode": "460400112",
            "label": "白马井镇", "value": "白马井镇",
            "pcode": "460400"
        },
        {
            "cityCode": "460400113",
            "label": "中和镇", "value": "中和镇",
            "pcode": "460400"
        },
        {
            "cityCode": "460400114",
            "label": "排浦镇", "value": "排浦镇",
            "pcode": "460400"
        },
        {
            "cityCode": "460400115",
            "label": "东成镇", "value": "东成镇",
            "pcode": "460400"
        },
        {
            "cityCode": "460400116",
            "label": "新州镇", "value": "新州镇",
            "pcode": "460400"
        },
        {
            "cityCode": "460400400",
            "label": "国营西培农场", "value": "国营西培农场",
            "pcode": "460400"
        },
        {
            "cityCode": "460400404",
            "label": "国营西联农场", "value": "国营西联农场",
            "pcode": "460400"
        },
        {
            "cityCode": "460400405",
            "label": "国营蓝洋农场", "value": "国营蓝洋农场",
            "pcode": "460400"
        },
        {
            "cityCode": "460400407",
            "label": "国营八一农场", "value": "国营八一农场",
            "pcode": "460400"
        },
        {
            "cityCode": "460400499",
            "label": "洋浦经济开发区", "value": "洋浦经济开发区",
            "pcode": "460400"
        },
        {
            "cityCode": "460400500",
            "label": "华南热作学院", "value": "华南热作学院",
            "pcode": "460400"
        }],
        "pcode": "460000"
    },
    {
        "cityCode": "469001",
        "label": "五指山市", "value": "五指山市",
        "children": [{
            "cityCode": "469001100",
            "label": "通什镇", "value": "通什镇",
            "pcode": "469001"
        },
        {
            "cityCode": "469001101",
            "label": "南圣镇", "value": "南圣镇",
            "pcode": "469001"
        },
        {
            "cityCode": "469001102",
            "label": "毛阳镇", "value": "毛阳镇",
            "pcode": "469001"
        },
        {
            "cityCode": "469001103",
            "label": "番阳镇", "value": "番阳镇",
            "pcode": "469001"
        },
        {
            "cityCode": "469001200",
            "label": "畅好乡", "value": "畅好乡",
            "pcode": "469001"
        },
        {
            "cityCode": "469001201",
            "label": "毛道乡", "value": "毛道乡",
            "pcode": "469001"
        },
        {
            "cityCode": "469001202",
            "label": "水满乡", "value": "水满乡",
            "pcode": "469001"
        },
        {
            "cityCode": "469001400",
            "label": "国营畅好农场", "value": "国营畅好农场",
            "pcode": "469001"
        }],
        "pcode": "460000"
    },
    {
        "cityCode": "469002",
        "label": "琼海市", "value": "琼海市",
        "children": [{
            "cityCode": "469002100",
            "label": "嘉积镇", "value": "嘉积镇",
            "pcode": "469002"
        },
        {
            "cityCode": "469002101",
            "label": "万泉镇", "value": "万泉镇",
            "pcode": "469002"
        },
        {
            "cityCode": "469002102",
            "label": "石壁镇", "value": "石壁镇",
            "pcode": "469002"
        },
        {
            "cityCode": "469002103",
            "label": "中原镇", "value": "中原镇",
            "pcode": "469002"
        },
        {
            "cityCode": "469002104",
            "label": "博鳌镇", "value": "博鳌镇",
            "pcode": "469002"
        },
        {
            "cityCode": "469002105",
            "label": "阳江镇", "value": "阳江镇",
            "pcode": "469002"
        },
        {
            "cityCode": "469002106",
            "label": "龙江镇", "value": "龙江镇",
            "pcode": "469002"
        },
        {
            "cityCode": "469002107",
            "label": "潭门镇", "value": "潭门镇",
            "pcode": "469002"
        },
        {
            "cityCode": "469002108",
            "label": "塔洋镇", "value": "塔洋镇",
            "pcode": "469002"
        },
        {
            "cityCode": "469002109",
            "label": "长坡镇", "value": "长坡镇",
            "pcode": "469002"
        },
        {
            "cityCode": "469002110",
            "label": "大路镇", "value": "大路镇",
            "pcode": "469002"
        },
        {
            "cityCode": "469002111",
            "label": "会山镇", "value": "会山镇",
            "pcode": "469002"
        },
        {
            "cityCode": "469002400",
            "label": "国营东太农场", "value": "国营东太农场",
            "pcode": "469002"
        },
        {
            "cityCode": "469002402",
            "label": "国营东红农场", "value": "国营东红农场",
            "pcode": "469002"
        },
        {
            "cityCode": "469002403",
            "label": "国营东升农场", "value": "国营东升农场",
            "pcode": "469002"
        },
        {
            "cityCode": "469002500",
            "label": "彬村山华侨农场", "value": "彬村山华侨农场",
            "pcode": "469002"
        }],
        "pcode": "460000"
    },
    {
        "cityCode": "469005",
        "label": "文昌市", "value": "文昌市",
        "children": [{
            "cityCode": "469005100",
            "label": "文城镇", "value": "文城镇",
            "pcode": "469005"
        },
        {
            "cityCode": "469005101",
            "label": "重兴镇", "value": "重兴镇",
            "pcode": "469005"
        },
        {
            "cityCode": "469005102",
            "label": "蓬莱镇", "value": "蓬莱镇",
            "pcode": "469005"
        },
        {
            "cityCode": "469005103",
            "label": "会文镇", "value": "会文镇",
            "pcode": "469005"
        },
        {
            "cityCode": "469005104",
            "label": "东路镇", "value": "东路镇",
            "pcode": "469005"
        },
        {
            "cityCode": "469005105",
            "label": "潭牛镇", "value": "潭牛镇",
            "pcode": "469005"
        },
        {
            "cityCode": "469005106",
            "label": "东阁镇", "value": "东阁镇",
            "pcode": "469005"
        },
        {
            "cityCode": "469005107",
            "label": "文教镇", "value": "文教镇",
            "pcode": "469005"
        },
        {
            "cityCode": "469005108",
            "label": "东郊镇", "value": "东郊镇",
            "pcode": "469005"
        },
        {
            "cityCode": "469005109",
            "label": "龙楼镇", "value": "龙楼镇",
            "pcode": "469005"
        },
        {
            "cityCode": "469005110",
            "label": "昌洒镇", "value": "昌洒镇",
            "pcode": "469005"
        },
        {
            "cityCode": "469005111",
            "label": "翁田镇", "value": "翁田镇",
            "pcode": "469005"
        },
        {
            "cityCode": "469005112",
            "label": "抱罗镇", "value": "抱罗镇",
            "pcode": "469005"
        },
        {
            "cityCode": "469005113",
            "label": "冯坡镇", "value": "冯坡镇",
            "pcode": "469005"
        },
        {
            "cityCode": "469005114",
            "label": "锦山镇", "value": "锦山镇",
            "pcode": "469005"
        },
        {
            "cityCode": "469005115",
            "label": "铺前镇", "value": "铺前镇",
            "pcode": "469005"
        },
        {
            "cityCode": "469005116",
            "label": "公坡镇", "value": "公坡镇",
            "pcode": "469005"
        },
        {
            "cityCode": "469005400",
            "label": "国营东路农场", "value": "国营东路农场",
            "pcode": "469005"
        },
        {
            "cityCode": "469005401",
            "label": "国营南阳农场", "value": "国营南阳农场",
            "pcode": "469005"
        },
        {
            "cityCode": "469005402",
            "label": "国营罗豆农场", "value": "国营罗豆农场",
            "pcode": "469005"
        }],
        "pcode": "460000"
    },
    {
        "cityCode": "469006",
        "label": "万宁市", "value": "万宁市",
        "children": [{
            "cityCode": "469006100",
            "label": "万城镇", "value": "万城镇",
            "pcode": "469006"
        },
        {
            "cityCode": "469006101",
            "label": "龙滚镇", "value": "龙滚镇",
            "pcode": "469006"
        },
        {
            "cityCode": "469006102",
            "label": "和乐镇", "value": "和乐镇",
            "pcode": "469006"
        },
        {
            "cityCode": "469006103",
            "label": "后安镇", "value": "后安镇",
            "pcode": "469006"
        },
        {
            "cityCode": "469006104",
            "label": "大茂镇", "value": "大茂镇",
            "pcode": "469006"
        },
        {
            "cityCode": "469006105",
            "label": "东澳镇", "value": "东澳镇",
            "pcode": "469006"
        },
        {
            "cityCode": "469006106",
            "label": "礼纪镇", "value": "礼纪镇",
            "pcode": "469006"
        },
        {
            "cityCode": "469006107",
            "label": "长丰镇", "value": "长丰镇",
            "pcode": "469006"
        },
        {
            "cityCode": "469006108",
            "label": "山根镇", "value": "山根镇",
            "pcode": "469006"
        },
        {
            "cityCode": "469006109",
            "label": "北大镇", "value": "北大镇",
            "pcode": "469006"
        },
        {
            "cityCode": "469006110",
            "label": "南桥镇", "value": "南桥镇",
            "pcode": "469006"
        },
        {
            "cityCode": "469006111",
            "label": "三更罗镇", "value": "三更罗镇",
            "pcode": "469006"
        },
        {
            "cityCode": "469006400",
            "label": "国营东兴农场", "value": "国营东兴农场",
            "pcode": "469006"
        },
        {
            "cityCode": "469006401",
            "label": "国营东和农场", "value": "国营东和农场",
            "pcode": "469006"
        },
        {
            "cityCode": "469006404",
            "label": "国营新中农场", "value": "国营新中农场",
            "pcode": "469006"
        },
        {
            "cityCode": "469006500",
            "label": "兴隆华侨农场", "value": "兴隆华侨农场",
            "pcode": "469006"
        },
        {
            "cityCode": "469006501",
            "label": "地方国营六连林场", "value": "地方国营六连林场",
            "pcode": "469006"
        }],
        "pcode": "460000"
    },
    {
        "cityCode": "469007",
        "label": "东方市", "value": "东方市",
        "children": [{
            "cityCode": "469007100",
            "label": "八所镇", "value": "八所镇",
            "pcode": "469007"
        },
        {
            "cityCode": "469007101",
            "label": "东河镇", "value": "东河镇",
            "pcode": "469007"
        },
        {
            "cityCode": "469007102",
            "label": "大田镇", "value": "大田镇",
            "pcode": "469007"
        },
        {
            "cityCode": "469007103",
            "label": "感城镇", "value": "感城镇",
            "pcode": "469007"
        },
        {
            "cityCode": "469007104",
            "label": "板桥镇", "value": "板桥镇",
            "pcode": "469007"
        },
        {
            "cityCode": "469007105",
            "label": "三家镇", "value": "三家镇",
            "pcode": "469007"
        },
        {
            "cityCode": "469007106",
            "label": "四更镇", "value": "四更镇",
            "pcode": "469007"
        },
        {
            "cityCode": "469007107",
            "label": "新龙镇", "value": "新龙镇",
            "pcode": "469007"
        },
        {
            "cityCode": "469007200",
            "label": "天安乡", "value": "天安乡",
            "pcode": "469007"
        },
        {
            "cityCode": "469007201",
            "label": "江边乡", "value": "江边乡",
            "pcode": "469007"
        },
        {
            "cityCode": "469007400",
            "label": "国营广坝农场", "value": "国营广坝农场",
            "pcode": "469007"
        },
        {
            "cityCode": "469007500",
            "label": "东方华侨农场", "value": "东方华侨农场",
            "pcode": "469007"
        }],
        "pcode": "460000"
    },
    {
        "cityCode": "469021",
        "label": "定安县", "value": "定安县",
        "children": [{
            "cityCode": "469021100",
            "label": "定城镇", "value": "定城镇",
            "pcode": "469021"
        },
        {
            "cityCode": "469021101",
            "label": "新竹镇", "value": "新竹镇",
            "pcode": "469021"
        },
        {
            "cityCode": "469021102",
            "label": "龙湖镇", "value": "龙湖镇",
            "pcode": "469021"
        },
        {
            "cityCode": "469021103",
            "label": "黄竹镇", "value": "黄竹镇",
            "pcode": "469021"
        },
        {
            "cityCode": "469021104",
            "label": "雷鸣镇", "value": "雷鸣镇",
            "pcode": "469021"
        },
        {
            "cityCode": "469021105",
            "label": "龙门镇", "value": "龙门镇",
            "pcode": "469021"
        },
        {
            "cityCode": "469021106",
            "label": "龙河镇", "value": "龙河镇",
            "pcode": "469021"
        },
        {
            "cityCode": "469021107",
            "label": "岭口镇", "value": "岭口镇",
            "pcode": "469021"
        },
        {
            "cityCode": "469021108",
            "label": "翰林镇", "value": "翰林镇",
            "pcode": "469021"
        },
        {
            "cityCode": "469021109",
            "label": "富文镇", "value": "富文镇",
            "pcode": "469021"
        },
        {
            "cityCode": "469021400",
            "label": "国营中瑞农场", "value": "国营中瑞农场",
            "pcode": "469021"
        },
        {
            "cityCode": "469021401",
            "label": "国营南海农场", "value": "国营南海农场",
            "pcode": "469021"
        },
        {
            "cityCode": "469021402",
            "label": "国营金鸡岭农场", "value": "国营金鸡岭农场",
            "pcode": "469021"
        }],
        "pcode": "460000"
    },
    {
        "cityCode": "469022",
        "label": "屯昌县", "value": "屯昌县",
        "children": [{
            "cityCode": "469022100",
            "label": "屯城镇", "value": "屯城镇",
            "pcode": "469022"
        },
        {
            "cityCode": "469022101",
            "label": "新兴镇", "value": "新兴镇",
            "pcode": "469022"
        },
        {
            "cityCode": "469022102",
            "label": "枫木镇", "value": "枫木镇",
            "pcode": "469022"
        },
        {
            "cityCode": "469022103",
            "label": "乌坡镇", "value": "乌坡镇",
            "pcode": "469022"
        },
        {
            "cityCode": "469022104",
            "label": "南吕镇", "value": "南吕镇",
            "pcode": "469022"
        },
        {
            "cityCode": "469022105",
            "label": "南坤镇", "value": "南坤镇",
            "pcode": "469022"
        },
        {
            "cityCode": "469022106",
            "label": "坡心镇", "value": "坡心镇",
            "pcode": "469022"
        },
        {
            "cityCode": "469022107",
            "label": "西昌镇", "value": "西昌镇",
            "pcode": "469022"
        },
        {
            "cityCode": "469022400",
            "label": "国营中建农场", "value": "国营中建农场",
            "pcode": "469022"
        },
        {
            "cityCode": "469022401",
            "label": "国营中坤农场", "value": "国营中坤农场",
            "pcode": "469022"
        }],
        "pcode": "460000"
    },
    {
        "cityCode": "469023",
        "label": "澄迈县", "value": "澄迈县",
        "children": [{
            "cityCode": "469023100",
            "label": "金江镇", "value": "金江镇",
            "pcode": "469023"
        },
        {
            "cityCode": "469023101",
            "label": "老城镇", "value": "老城镇",
            "pcode": "469023"
        },
        {
            "cityCode": "469023102",
            "label": "瑞溪镇", "value": "瑞溪镇",
            "pcode": "469023"
        },
        {
            "cityCode": "469023103",
            "label": "永发镇", "value": "永发镇",
            "pcode": "469023"
        },
        {
            "cityCode": "469023104",
            "label": "加乐镇", "value": "加乐镇",
            "pcode": "469023"
        },
        {
            "cityCode": "469023105",
            "label": "文儒镇", "value": "文儒镇",
            "pcode": "469023"
        },
        {
            "cityCode": "469023106",
            "label": "中兴镇", "value": "中兴镇",
            "pcode": "469023"
        },
        {
            "cityCode": "469023107",
            "label": "仁兴镇", "value": "仁兴镇",
            "pcode": "469023"
        },
        {
            "cityCode": "469023108",
            "label": "福山镇", "value": "福山镇",
            "pcode": "469023"
        },
        {
            "cityCode": "469023109",
            "label": "桥头镇", "value": "桥头镇",
            "pcode": "469023"
        },
        {
            "cityCode": "469023110",
            "label": "大丰镇", "value": "大丰镇",
            "pcode": "469023"
        },
        {
            "cityCode": "469023400",
            "label": "国营红光农场", "value": "国营红光农场",
            "pcode": "469023"
        },
        {
            "cityCode": "469023401",
            "label": "国营红岗农场", "value": "国营红岗农场",
            "pcode": "469023"
        },
        {
            "cityCode": "469023402",
            "label": "国营西达农场", "value": "国营西达农场",
            "pcode": "469023"
        },
        {
            "cityCode": "469023403",
            "label": "国营昆仑农场", "value": "国营昆仑农场",
            "pcode": "469023"
        },
        {
            "cityCode": "469023404",
            "label": "国营和岭农场", "value": "国营和岭农场",
            "pcode": "469023"
        },
        {
            "cityCode": "469023405",
            "label": "国营金安农场", "value": "国营金安农场",
            "pcode": "469023"
        }],
        "pcode": "460000"
    },
    {
        "cityCode": "469024",
        "label": "临高县", "value": "临高县",
        "children": [{
            "cityCode": "469024100",
            "label": "临城镇", "value": "临城镇",
            "pcode": "469024"
        },
        {
            "cityCode": "469024101",
            "label": "波莲镇", "value": "波莲镇",
            "pcode": "469024"
        },
        {
            "cityCode": "469024102",
            "label": "东英镇", "value": "东英镇",
            "pcode": "469024"
        },
        {
            "cityCode": "469024103",
            "label": "博厚镇", "value": "博厚镇",
            "pcode": "469024"
        },
        {
            "cityCode": "469024104",
            "label": "皇桐镇", "value": "皇桐镇",
            "pcode": "469024"
        },
        {
            "cityCode": "469024105",
            "label": "多文镇", "value": "多文镇",
            "pcode": "469024"
        },
        {
            "cityCode": "469024106",
            "label": "和舍镇", "value": "和舍镇",
            "pcode": "469024"
        },
        {
            "cityCode": "469024107",
            "label": "南宝镇", "value": "南宝镇",
            "pcode": "469024"
        },
        {
            "cityCode": "469024108",
            "label": "新盈镇", "value": "新盈镇",
            "pcode": "469024"
        },
        {
            "cityCode": "469024109",
            "label": "调楼镇", "value": "调楼镇",
            "pcode": "469024"
        },
        {
            "cityCode": "469024400",
            "label": "国营红华农场", "value": "国营红华农场",
            "pcode": "469024"
        },
        {
            "cityCode": "469024401",
            "label": "国营加来农场", "value": "国营加来农场",
            "pcode": "469024"
        }],
        "pcode": "460000"
    },
    {
        "cityCode": "469025",
        "label": "白沙黎族自治县", "value": "白沙黎族自治县",
        "children": [{
            "cityCode": "469025100",
            "label": "牙叉镇", "value": "牙叉镇",
            "pcode": "469025"
        },
        {
            "cityCode": "469025101",
            "label": "七坊镇", "value": "七坊镇",
            "pcode": "469025"
        },
        {
            "cityCode": "469025102",
            "label": "邦溪镇", "value": "邦溪镇",
            "pcode": "469025"
        },
        {
            "cityCode": "469025103",
            "label": "打安镇", "value": "打安镇",
            "pcode": "469025"
        },
        {
            "cityCode": "469025200",
            "label": "细水乡", "value": "细水乡",
            "pcode": "469025"
        },
        {
            "cityCode": "469025201",
            "label": "元门乡", "value": "元门乡",
            "pcode": "469025"
        },
        {
            "cityCode": "469025202",
            "label": "南开乡", "value": "南开乡",
            "pcode": "469025"
        },
        {
            "cityCode": "469025203",
            "label": "阜龙乡", "value": "阜龙乡",
            "pcode": "469025"
        },
        {
            "cityCode": "469025204",
            "label": "青松乡", "value": "青松乡",
            "pcode": "469025"
        },
        {
            "cityCode": "469025205",
            "label": "金波乡", "value": "金波乡",
            "pcode": "469025"
        },
        {
            "cityCode": "469025206",
            "label": "荣邦乡", "value": "荣邦乡",
            "pcode": "469025"
        },
        {
            "cityCode": "469025401",
            "label": "国营白沙农场", "value": "国营白沙农场",
            "pcode": "469025"
        },
        {
            "cityCode": "469025404",
            "label": "国营龙江农场", "value": "国营龙江农场",
            "pcode": "469025"
        },
        {
            "cityCode": "469025408",
            "label": "国营邦溪农场", "value": "国营邦溪农场",
            "pcode": "469025"
        }],
        "pcode": "460000"
    },
    {
        "cityCode": "469026",
        "label": "昌江黎族自治县", "value": "昌江黎族自治县",
        "children": [{
            "cityCode": "469026100",
            "label": "石碌镇", "value": "石碌镇",
            "pcode": "469026"
        },
        {
            "cityCode": "469026101",
            "label": "叉河镇", "value": "叉河镇",
            "pcode": "469026"
        },
        {
            "cityCode": "469026102",
            "label": "十月田镇", "value": "十月田镇",
            "pcode": "469026"
        },
        {
            "cityCode": "469026103",
            "label": "乌烈镇", "value": "乌烈镇",
            "pcode": "469026"
        },
        {
            "cityCode": "469026104",
            "label": "昌化镇", "value": "昌化镇",
            "pcode": "469026"
        },
        {
            "cityCode": "469026105",
            "label": "海尾镇", "value": "海尾镇",
            "pcode": "469026"
        },
        {
            "cityCode": "469026106",
            "label": "七叉镇", "value": "七叉镇",
            "pcode": "469026"
        },
        {
            "cityCode": "469026200",
            "label": "王下乡", "value": "王下乡",
            "pcode": "469026"
        },
        {
            "cityCode": "469026401",
            "label": "国营红林农场", "value": "国营红林农场",
            "pcode": "469026"
        },
        {
            "cityCode": "469026500",
            "label": "国营霸王岭林场", "value": "国营霸王岭林场",
            "pcode": "469026"
        },
        {
            "cityCode": "469026501",
            "label": "海南矿业联合有限公司", "value": "海南矿业联合有限公司",
            "pcode": "469026"
        }],
        "pcode": "460000"
    },
    {
        "cityCode": "469027",
        "label": "乐东黎族自治县", "value": "乐东黎族自治县",
        "children": [{
            "cityCode": "469027100",
            "label": "抱由镇", "value": "抱由镇",
            "pcode": "469027"
        },
        {
            "cityCode": "469027101",
            "label": "万冲镇", "value": "万冲镇",
            "pcode": "469027"
        },
        {
            "cityCode": "469027102",
            "label": "大安镇", "value": "大安镇",
            "pcode": "469027"
        },
        {
            "cityCode": "469027103",
            "label": "志仲镇", "value": "志仲镇",
            "pcode": "469027"
        },
        {
            "cityCode": "469027104",
            "label": "千家镇", "value": "千家镇",
            "pcode": "469027"
        },
        {
            "cityCode": "469027105",
            "label": "九所镇", "value": "九所镇",
            "pcode": "469027"
        },
        {
            "cityCode": "469027106",
            "label": "利国镇", "value": "利国镇",
            "pcode": "469027"
        },
        {
            "cityCode": "469027107",
            "label": "黄流镇", "value": "黄流镇",
            "pcode": "469027"
        },
        {
            "cityCode": "469027108",
            "label": "佛罗镇", "value": "佛罗镇",
            "pcode": "469027"
        },
        {
            "cityCode": "469027109",
            "label": "尖峰镇", "value": "尖峰镇",
            "pcode": "469027"
        },
        {
            "cityCode": "469027110",
            "label": "莺歌海镇", "value": "莺歌海镇",
            "pcode": "469027"
        },
        {
            "cityCode": "469027401",
            "label": "国营山荣农场", "value": "国营山荣农场",
            "pcode": "469027"
        },
        {
            "cityCode": "469027402",
            "label": "国营乐光农场", "value": "国营乐光农场",
            "pcode": "469027"
        },
        {
            "cityCode": "469027405",
            "label": "国营保国农场", "value": "国营保国农场",
            "pcode": "469027"
        },
        {
            "cityCode": "469027500",
            "label": "国营尖峰岭林业公司", "value": "国营尖峰岭林业公司",
            "pcode": "469027"
        },
        {
            "cityCode": "469027501",
            "label": "国营莺歌海盐场", "value": "国营莺歌海盐场",
            "pcode": "469027"
        }],
        "pcode": "460000"
    },
    {
        "cityCode": "469028",
        "label": "陵水黎族自治县", "value": "陵水黎族自治县",
        "children": [{
            "cityCode": "469028100",
            "label": "椰林镇", "value": "椰林镇",
            "pcode": "469028"
        },
        {
            "cityCode": "469028101",
            "label": "光坡镇", "value": "光坡镇",
            "pcode": "469028"
        },
        {
            "cityCode": "469028102",
            "label": "三才镇", "value": "三才镇",
            "pcode": "469028"
        },
        {
            "cityCode": "469028103",
            "label": "英州镇", "value": "英州镇",
            "pcode": "469028"
        },
        {
            "cityCode": "469028104",
            "label": "隆广镇", "value": "隆广镇",
            "pcode": "469028"
        },
        {
            "cityCode": "469028105",
            "label": "文罗镇", "value": "文罗镇",
            "pcode": "469028"
        },
        {
            "cityCode": "469028106",
            "label": "本号镇", "value": "本号镇",
            "pcode": "469028"
        },
        {
            "cityCode": "469028107",
            "label": "新村镇", "value": "新村镇",
            "pcode": "469028"
        },
        {
            "cityCode": "469028108",
            "label": "黎安镇", "value": "黎安镇",
            "pcode": "469028"
        },
        {
            "cityCode": "469028200",
            "label": "提蒙乡", "value": "提蒙乡",
            "pcode": "469028"
        },
        {
            "cityCode": "469028201",
            "label": "群英乡", "value": "群英乡",
            "pcode": "469028"
        },
        {
            "cityCode": "469028400",
            "label": "国营岭门农场", "value": "国营岭门农场",
            "pcode": "469028"
        },
        {
            "cityCode": "469028401",
            "label": "国营南平农场", "value": "国营南平农场",
            "pcode": "469028"
        },
        {
            "cityCode": "469028500",
            "label": "国营吊罗山林业公司", "value": "国营吊罗山林业公司",
            "pcode": "469028"
        }],
        "pcode": "460000"
    },
    {
        "cityCode": "469029",
        "label": "保亭黎族苗族自治县", "value": "保亭黎族苗族自治县",
        "children": [{
            "cityCode": "469029100",
            "label": "保城镇", "value": "保城镇",
            "pcode": "469029"
        },
        {
            "cityCode": "469029101",
            "label": "什玲镇", "value": "什玲镇",
            "pcode": "469029"
        },
        {
            "cityCode": "469029102",
            "label": "加茂镇", "value": "加茂镇",
            "pcode": "469029"
        },
        {
            "cityCode": "469029103",
            "label": "响水镇", "value": "响水镇",
            "pcode": "469029"
        },
        {
            "cityCode": "469029104",
            "label": "新政镇", "value": "新政镇",
            "pcode": "469029"
        },
        {
            "cityCode": "469029105",
            "label": "三道镇", "value": "三道镇",
            "pcode": "469029"
        },
        {
            "cityCode": "469029200",
            "label": "六弓乡", "value": "六弓乡",
            "pcode": "469029"
        },
        {
            "cityCode": "469029201",
            "label": "南林乡", "value": "南林乡",
            "pcode": "469029"
        },
        {
            "cityCode": "469029202",
            "label": "毛感乡", "value": "毛感乡",
            "pcode": "469029"
        },
        {
            "cityCode": "469029401",
            "label": "国营新星农场", "value": "国营新星农场",
            "pcode": "469029"
        },
        {
            "cityCode": "469029402",
            "label": "海南保亭热带作物研究所", "value": "海南保亭热带作物研究所",
            "pcode": "469029"
        },
        {
            "cityCode": "469029403",
            "label": "国营金江农场", "value": "国营金江农场",
            "pcode": "469029"
        },
        {
            "cityCode": "469029405",
            "label": "国营三道农场", "value": "国营三道农场",
            "pcode": "469029"
        }],
        "pcode": "460000"
    },
    {
        "cityCode": "469030",
        "label": "琼中黎族苗族自治县", "value": "琼中黎族苗族自治县",
        "children": [{
            "cityCode": "469030100",
            "label": "营根镇", "value": "营根镇",
            "pcode": "469030"
        },
        {
            "cityCode": "469030101",
            "label": "湾岭镇", "value": "湾岭镇",
            "pcode": "469030"
        },
        {
            "cityCode": "469030102",
            "label": "黎母山镇", "value": "黎母山镇",
            "pcode": "469030"
        },
        {
            "cityCode": "469030103",
            "label": "和平镇", "value": "和平镇",
            "pcode": "469030"
        },
        {
            "cityCode": "469030104",
            "label": "长征镇", "value": "长征镇",
            "pcode": "469030"
        },
        {
            "cityCode": "469030105",
            "label": "红毛镇", "value": "红毛镇",
            "pcode": "469030"
        },
        {
            "cityCode": "469030106",
            "label": "中平镇", "value": "中平镇",
            "pcode": "469030"
        },
        {
            "cityCode": "469030200",
            "label": "吊罗山乡", "value": "吊罗山乡",
            "pcode": "469030"
        },
        {
            "cityCode": "469030201",
            "label": "上安乡", "value": "上安乡",
            "pcode": "469030"
        },
        {
            "cityCode": "469030202",
            "label": "什运乡", "value": "什运乡",
            "pcode": "469030"
        },
        {
            "cityCode": "469030402",
            "label": "国营阳江农场", "value": "国营阳江农场",
            "pcode": "469030"
        },
        {
            "cityCode": "469030403",
            "label": "国营乌石农场", "value": "国营乌石农场",
            "pcode": "469030"
        },
        {
            "cityCode": "469030406",
            "label": "国营加钗农场", "value": "国营加钗农场",
            "pcode": "469030"
        },
        {
            "cityCode": "469030407",
            "label": "国营长征农场", "value": "国营长征农场",
            "pcode": "469030"
        },
        {
            "cityCode": "469030500",
            "label": "国营黎母山林业公司", "value": "国营黎母山林业公司",
            "pcode": "469030"
        }],
        "pcode": "460000"
    }]
},
{
    "cityCode": "500000",
    "label": "重庆", "value": "重庆",
    "children": [{
        "cityCode": "500100",
        "label": "重庆市", "value": "重庆市",
        "children": [{
            "cityCode": "500101",
            "label": "万州区", "value": "万州区",
            "pcode": "500100"
        },
        {
            "cityCode": "500102",
            "label": "涪陵区", "value": "涪陵区",
            "pcode": "500100"
        },
        {
            "cityCode": "500103",
            "label": "渝中区", "value": "渝中区",
            "pcode": "500100"
        },
        {
            "cityCode": "500104",
            "label": "大渡口区", "value": "大渡口区",
            "pcode": "500100"
        },
        {
            "cityCode": "500105",
            "label": "江北区", "value": "江北区",
            "pcode": "500100"
        },
        {
            "cityCode": "500106",
            "label": "沙坪坝区", "value": "沙坪坝区",
            "pcode": "500100"
        },
        {
            "cityCode": "500107",
            "label": "九龙坡区", "value": "九龙坡区",
            "pcode": "500100"
        },
        {
            "cityCode": "500108",
            "label": "南岸区", "value": "南岸区",
            "pcode": "500100"
        },
        {
            "cityCode": "500109",
            "label": "北碚区", "value": "北碚区",
            "pcode": "500100"
        },
        {
            "cityCode": "500110",
            "label": "綦江区", "value": "綦江区",
            "pcode": "500100"
        },
        {
            "cityCode": "500111",
            "label": "大足区", "value": "大足区",
            "pcode": "500100"
        },
        {
            "cityCode": "500112",
            "label": "渝北区", "value": "渝北区",
            "pcode": "500100"
        },
        {
            "cityCode": "500113",
            "label": "巴南区", "value": "巴南区",
            "pcode": "500100"
        },
        {
            "cityCode": "500114",
            "label": "黔江区", "value": "黔江区",
            "pcode": "500100"
        },
        {
            "cityCode": "500115",
            "label": "长寿区", "value": "长寿区",
            "pcode": "500100"
        },
        {
            "cityCode": "500116",
            "label": "江津区", "value": "江津区",
            "pcode": "500100"
        },
        {
            "cityCode": "500117",
            "label": "合川区", "value": "合川区",
            "pcode": "500100"
        },
        {
            "cityCode": "500118",
            "label": "永川区", "value": "永川区",
            "pcode": "500100"
        },
        {
            "cityCode": "500119",
            "label": "南川区", "value": "南川区",
            "pcode": "500100"
        },
        {
            "cityCode": "500120",
            "label": "璧山区", "value": "璧山区",
            "pcode": "500100"
        },
        {
            "cityCode": "500151",
            "label": "铜梁区", "value": "铜梁区",
            "pcode": "500100"
        },
        {
            "cityCode": "500152",
            "label": "潼南区", "value": "潼南区",
            "pcode": "500100"
        },
        {
            "cityCode": "500153",
            "label": "荣昌区", "value": "荣昌区",
            "pcode": "500100"
        },
        {
            "cityCode": "500154",
            "label": "开州区", "value": "开州区",
            "pcode": "500100"
        },
        {
            "cityCode": "500155",
            "label": "梁平区", "value": "梁平区",
            "pcode": "500100"
        },
        {
            "cityCode": "500156",
            "label": "武隆区", "value": "武隆区",
            "pcode": "500100"
        }],
        "pcode": "500000"
    },
    {
        "cityCode": "500200",
        "label": "重庆郊县", "value": "重庆郊县",
        "children": [{
            "cityCode": "500229",
            "label": "城口县", "value": "城口县",
            "pcode": "500200"
        },
        {
            "cityCode": "500230",
            "label": "丰都县", "value": "丰都县",
            "pcode": "500200"
        },
        {
            "cityCode": "500231",
            "label": "垫江县", "value": "垫江县",
            "pcode": "500200"
        },
        {
            "cityCode": "500233",
            "label": "忠县", "value": "忠县",
            "pcode": "500200"
        },
        {
            "cityCode": "500235",
            "label": "云阳县", "value": "云阳县",
            "pcode": "500200"
        },
        {
            "cityCode": "500236",
            "label": "奉节县", "value": "奉节县",
            "pcode": "500200"
        },
        {
            "cityCode": "500237",
            "label": "巫山县", "value": "巫山县",
            "pcode": "500200"
        },
        {
            "cityCode": "500238",
            "label": "巫溪县", "value": "巫溪县",
            "pcode": "500200"
        },
        {
            "cityCode": "500240",
            "label": "石柱土家族自治县", "value": "石柱土家族自治县",
            "pcode": "500200"
        },
        {
            "cityCode": "500241",
            "label": "秀山土家族苗族自治县", "value": "秀山土家族苗族自治县",
            "pcode": "500200"
        },
        {
            "cityCode": "500242",
            "label": "酉阳土家族苗族自治县", "value": "酉阳土家族苗族自治县",
            "pcode": "500200"
        },
        {
            "cityCode": "500243",
            "label": "彭水苗族土家族自治县", "value": "彭水苗族土家族自治县",
            "pcode": "500200"
        }],
        "pcode": "500000"
    }]
},
{
    "cityCode": "510000",
    "label": "四川省", "value": "四川省",
    "children": [{
        "cityCode": "510100",
        "label": "成都市", "value": "成都市",
        "children": [{
            "cityCode": "510104",
            "label": "锦江区", "value": "锦江区",
            "pcode": "510100"
        },
        {
            "cityCode": "510105",
            "label": "青羊区", "value": "青羊区",
            "pcode": "510100"
        },
        {
            "cityCode": "510106",
            "label": "金牛区", "value": "金牛区",
            "pcode": "510100"
        },
        {
            "cityCode": "510107",
            "label": "武侯区", "value": "武侯区",
            "pcode": "510100"
        },
        {
            "cityCode": "510108",
            "label": "成华区", "value": "成华区",
            "pcode": "510100"
        },
        {
            "cityCode": "510112",
            "label": "龙泉驿区", "value": "龙泉驿区",
            "pcode": "510100"
        },
        {
            "cityCode": "510113",
            "label": "青白江区", "value": "青白江区",
            "pcode": "510100"
        },
        {
            "cityCode": "510114",
            "label": "新都区", "value": "新都区",
            "pcode": "510100"
        },
        {
            "cityCode": "510115",
            "label": "温江区", "value": "温江区",
            "pcode": "510100"
        },
        {
            "cityCode": "510116",
            "label": "双流区", "value": "双流区",
            "pcode": "510100"
        },
        {
            "cityCode": "510121",
            "label": "金堂县", "value": "金堂县",
            "pcode": "510100"
        },
        {
            "cityCode": "510117",
            "label": "郫都区", "value": "郫都区",
            "pcode": "510100"
        },
        {
            "cityCode": "510129",
            "label": "大邑县", "value": "大邑县",
            "pcode": "510100"
        },
        {
            "cityCode": "510131",
            "label": "蒲江县", "value": "蒲江县",
            "pcode": "510100"
        },
        {
            "cityCode": "510132",
            "label": "新津县", "value": "新津县",
            "pcode": "510100"
        },
        {
            "cityCode": "510180",
            "label": "简阳市", "value": "简阳市",
            "pcode": "510100"
        },
        {
            "cityCode": "510181",
            "label": "都江堰市", "value": "都江堰市",
            "pcode": "510100"
        },
        {
            "cityCode": "510182",
            "label": "彭州市", "value": "彭州市",
            "pcode": "510100"
        },
        {
            "cityCode": "510183",
            "label": "邛崃市", "value": "邛崃市",
            "pcode": "510100"
        },
        {
            "cityCode": "510184",
            "label": "崇州市", "value": "崇州市",
            "pcode": "510100"
        }],
        "pcode": "510000"
    },
    {
        "cityCode": "510300",
        "label": "自贡市", "value": "自贡市",
        "children": [{
            "cityCode": "510302",
            "label": "自流井区", "value": "自流井区",
            "pcode": "510300"
        },
        {
            "cityCode": "510303",
            "label": "贡井区", "value": "贡井区",
            "pcode": "510300"
        },
        {
            "cityCode": "510304",
            "label": "大安区", "value": "大安区",
            "pcode": "510300"
        },
        {
            "cityCode": "510311",
            "label": "沿滩区", "value": "沿滩区",
            "pcode": "510300"
        },
        {
            "cityCode": "510321",
            "label": "荣县", "value": "荣县",
            "pcode": "510300"
        },
        {
            "cityCode": "510322",
            "label": "富顺县", "value": "富顺县",
            "pcode": "510300"
        }],
        "pcode": "510000"
    },
    {
        "cityCode": "510400",
        "label": "攀枝花市", "value": "攀枝花市",
        "children": [{
            "cityCode": "510402",
            "label": "东区", "value": "东区",
            "pcode": "510400"
        },
        {
            "cityCode": "510403",
            "label": "西区", "value": "西区",
            "pcode": "510400"
        },
        {
            "cityCode": "510411",
            "label": "仁和区", "value": "仁和区",
            "pcode": "510400"
        },
        {
            "cityCode": "510421",
            "label": "米易县", "value": "米易县",
            "pcode": "510400"
        },
        {
            "cityCode": "510422",
            "label": "盐边县", "value": "盐边县",
            "pcode": "510400"
        }],
        "pcode": "510000"
    },
    {
        "cityCode": "510500",
        "label": "泸州市", "value": "泸州市",
        "children": [{
            "cityCode": "510502",
            "label": "江阳区", "value": "江阳区",
            "pcode": "510500"
        },
        {
            "cityCode": "510503",
            "label": "纳溪区", "value": "纳溪区",
            "pcode": "510500"
        },
        {
            "cityCode": "510504",
            "label": "龙马潭区", "value": "龙马潭区",
            "pcode": "510500"
        },
        {
            "cityCode": "510521",
            "label": "泸县", "value": "泸县",
            "pcode": "510500"
        },
        {
            "cityCode": "510522",
            "label": "合江县", "value": "合江县",
            "pcode": "510500"
        },
        {
            "cityCode": "510524",
            "label": "叙永县", "value": "叙永县",
            "pcode": "510500"
        },
        {
            "cityCode": "510525",
            "label": "古蔺县", "value": "古蔺县",
            "pcode": "510500"
        }],
        "pcode": "510000"
    },
    {
        "cityCode": "510600",
        "label": "德阳市", "value": "德阳市",
        "children": [{
            "cityCode": "510603",
            "label": "旌阳区", "value": "旌阳区",
            "pcode": "510600"
        },
        {
            "cityCode": "510623",
            "label": "中江县", "value": "中江县",
            "pcode": "510600"
        },
        {
            "cityCode": "510626",
            "label": "罗江区", "value": "罗江区",
            "pcode": "510600"
        },
        {
            "cityCode": "510681",
            "label": "广汉市", "value": "广汉市",
            "pcode": "510600"
        },
        {
            "cityCode": "510682",
            "label": "什邡市", "value": "什邡市",
            "pcode": "510600"
        },
        {
            "cityCode": "510683",
            "label": "绵竹市", "value": "绵竹市",
            "pcode": "510600"
        }],
        "pcode": "510000"
    },
    {
        "cityCode": "510700",
        "label": "绵阳市", "value": "绵阳市",
        "children": [{
            "cityCode": "510703",
            "label": "涪城区", "value": "涪城区",
            "pcode": "510700"
        },
        {
            "cityCode": "510704",
            "label": "游仙区", "value": "游仙区",
            "pcode": "510700"
        },
        {
            "cityCode": "510705",
            "label": "安州区", "value": "安州区",
            "pcode": "510700"
        },
        {
            "cityCode": "510722",
            "label": "三台县", "value": "三台县",
            "pcode": "510700"
        },
        {
            "cityCode": "510723",
            "label": "盐亭县", "value": "盐亭县",
            "pcode": "510700"
        },
        {
            "cityCode": "510725",
            "label": "梓潼县", "value": "梓潼县",
            "pcode": "510700"
        },
        {
            "cityCode": "510726",
            "label": "北川羌族自治县", "value": "北川羌族自治县",
            "pcode": "510700"
        },
        {
            "cityCode": "510727",
            "label": "平武县", "value": "平武县",
            "pcode": "510700"
        },
        {
            "cityCode": "510781",
            "label": "江油市", "value": "江油市",
            "pcode": "510700"
        }],
        "pcode": "510000"
    },
    {
        "cityCode": "510800",
        "label": "广元市", "value": "广元市",
        "children": [{
            "cityCode": "510802",
            "label": "利州区", "value": "利州区",
            "pcode": "510800"
        },
        {
            "cityCode": "510811",
            "label": "元坝区", "value": "元坝区",
            "pcode": "510800"
        },
        {
            "cityCode": "510812",
            "label": "朝天区", "value": "朝天区",
            "pcode": "510800"
        },
        {
            "cityCode": "510821",
            "label": "旺苍县", "value": "旺苍县",
            "pcode": "510800"
        },
        {
            "cityCode": "510822",
            "label": "青川县", "value": "青川县",
            "pcode": "510800"
        },
        {
            "cityCode": "510823",
            "label": "剑阁县", "value": "剑阁县",
            "pcode": "510800"
        },
        {
            "cityCode": "510824",
            "label": "苍溪县", "value": "苍溪县",
            "pcode": "510800"
        }],
        "pcode": "510000"
    },
    {
        "cityCode": "510900",
        "label": "遂宁市", "value": "遂宁市",
        "children": [{
            "cityCode": "510903",
            "label": "船山区", "value": "船山区",
            "pcode": "510900"
        },
        {
            "cityCode": "510904",
            "label": "安居区", "value": "安居区",
            "pcode": "510900"
        },
        {
            "cityCode": "510921",
            "label": "蓬溪县", "value": "蓬溪县",
            "pcode": "510900"
        },
        {
            "cityCode": "510922",
            "label": "射洪县", "value": "射洪县",
            "pcode": "510900"
        },
        {
            "cityCode": "510923",
            "label": "大英县", "value": "大英县",
            "pcode": "510900"
        }],
        "pcode": "510000"
    },
    {
        "cityCode": "511000",
        "label": "内江市", "value": "内江市",
        "children": [{
            "cityCode": "511002",
            "label": "市中区", "value": "市中区",
            "pcode": "511000"
        },
        {
            "cityCode": "511011",
            "label": "东兴区", "value": "东兴区",
            "pcode": "511000"
        },
        {
            "cityCode": "511024",
            "label": "威远县", "value": "威远县",
            "pcode": "511000"
        },
        {
            "cityCode": "511025",
            "label": "资中县", "value": "资中县",
            "pcode": "511000"
        },
        {
            "cityCode": "511083",
            "label": "隆昌市", "value": "隆昌市",
            "pcode": "511000"
        }],
        "pcode": "510000"
    },
    {
        "cityCode": "511100",
        "label": "乐山市", "value": "乐山市",
        "children": [{
            "cityCode": "511102",
            "label": "市中区", "value": "市中区",
            "pcode": "511100"
        },
        {
            "cityCode": "511111",
            "label": "沙湾区", "value": "沙湾区",
            "pcode": "511100"
        },
        {
            "cityCode": "511112",
            "label": "五通桥区", "value": "五通桥区",
            "pcode": "511100"
        },
        {
            "cityCode": "511113",
            "label": "金口河区", "value": "金口河区",
            "pcode": "511100"
        },
        {
            "cityCode": "511123",
            "label": "犍为县", "value": "犍为县",
            "pcode": "511100"
        },
        {
            "cityCode": "511124",
            "label": "井研县", "value": "井研县",
            "pcode": "511100"
        },
        {
            "cityCode": "511126",
            "label": "夹江县", "value": "夹江县",
            "pcode": "511100"
        },
        {
            "cityCode": "511129",
            "label": "沐川县", "value": "沐川县",
            "pcode": "511100"
        },
        {
            "cityCode": "511132",
            "label": "峨边彝族自治县", "value": "峨边彝族自治县",
            "pcode": "511100"
        },
        {
            "cityCode": "511133",
            "label": "马边彝族自治县", "value": "马边彝族自治县",
            "pcode": "511100"
        },
        {
            "cityCode": "511181",
            "label": "峨眉山市", "value": "峨眉山市",
            "pcode": "511100"
        }],
        "pcode": "510000"
    },
    {
        "cityCode": "511300",
        "label": "南充市", "value": "南充市",
        "children": [{
            "cityCode": "511302",
            "label": "顺庆区", "value": "顺庆区",
            "pcode": "511300"
        },
        {
            "cityCode": "511303",
            "label": "高坪区", "value": "高坪区",
            "pcode": "511300"
        },
        {
            "cityCode": "511304",
            "label": "嘉陵区", "value": "嘉陵区",
            "pcode": "511300"
        },
        {
            "cityCode": "511321",
            "label": "南部县", "value": "南部县",
            "pcode": "511300"
        },
        {
            "cityCode": "511322",
            "label": "营山县", "value": "营山县",
            "pcode": "511300"
        },
        {
            "cityCode": "511323",
            "label": "蓬安县", "value": "蓬安县",
            "pcode": "511300"
        },
        {
            "cityCode": "511324",
            "label": "仪陇县", "value": "仪陇县",
            "pcode": "511300"
        },
        {
            "cityCode": "511325",
            "label": "西充县", "value": "西充县",
            "pcode": "511300"
        },
        {
            "cityCode": "511381",
            "label": "阆中市", "value": "阆中市",
            "pcode": "511300"
        }],
        "pcode": "510000"
    },
    {
        "cityCode": "511400",
        "label": "眉山市", "value": "眉山市",
        "children": [{
            "cityCode": "511402",
            "label": "东坡区", "value": "东坡区",
            "pcode": "511400"
        },
        {
            "cityCode": "511403",
            "label": "彭山区", "value": "彭山区",
            "pcode": "511400"
        },
        {
            "cityCode": "511421",
            "label": "仁寿县", "value": "仁寿县",
            "pcode": "511400"
        },
        {
            "cityCode": "511423",
            "label": "洪雅县", "value": "洪雅县",
            "pcode": "511400"
        },
        {
            "cityCode": "511424",
            "label": "丹棱县", "value": "丹棱县",
            "pcode": "511400"
        },
        {
            "cityCode": "511425",
            "label": "青神县", "value": "青神县",
            "pcode": "511400"
        }],
        "pcode": "510000"
    },
    {
        "cityCode": "511500",
        "label": "宜宾市", "value": "宜宾市",
        "children": [{
            "cityCode": "511502",
            "label": "翠屏区", "value": "翠屏区",
            "pcode": "511500"
        },
        {
            "cityCode": "511503",
            "label": "南溪区", "value": "南溪区",
            "pcode": "511500"
        },
        {
            "cityCode": "511521",
            "label": "宜宾县", "value": "宜宾县",
            "pcode": "511500"
        },
        {
            "cityCode": "511523",
            "label": "江安县", "value": "江安县",
            "pcode": "511500"
        },
        {
            "cityCode": "511524",
            "label": "长宁县", "value": "长宁县",
            "pcode": "511500"
        },
        {
            "cityCode": "511525",
            "label": "高县", "value": "高县",
            "pcode": "511500"
        },
        {
            "cityCode": "511526",
            "label": "珙县", "value": "珙县",
            "pcode": "511500"
        },
        {
            "cityCode": "511527",
            "label": "筠连县", "value": "筠连县",
            "pcode": "511500"
        },
        {
            "cityCode": "511528",
            "label": "兴文县", "value": "兴文县",
            "pcode": "511500"
        },
        {
            "cityCode": "511529",
            "label": "屏山县", "value": "屏山县",
            "pcode": "511500"
        }, {
            "cityCode": "511504",
            "label": "叙州区", "value": "叙州区",
            "pcode": "511500"
        }],
        "pcode": "510000"
    },
    {
        "cityCode": "511600",
        "label": "广安市", "value": "广安市",
        "children": [{
            "cityCode": "511602",
            "label": "广安区", "value": "广安区",
            "pcode": "511600"
        },
        {
            "cityCode": "511603",
            "label": "前锋区", "value": "前锋区",
            "pcode": "511600"
        },
        {
            "cityCode": "511621",
            "label": "岳池县", "value": "岳池县",
            "pcode": "511600"
        },
        {
            "cityCode": "511622",
            "label": "武胜县", "value": "武胜县",
            "pcode": "511600"
        },
        {
            "cityCode": "511623",
            "label": "邻水县", "value": "邻水县",
            "pcode": "511600"
        },
        {
            "cityCode": "511681",
            "label": "华蓥市", "value": "华蓥市",
            "pcode": "511600"
        }],
        "pcode": "510000"
    },
    {
        "cityCode": "511700",
        "label": "达州市", "value": "达州市",
        "children": [{
            "cityCode": "511702",
            "label": "通川区", "value": "通川区",
            "pcode": "511700"
        },
        {
            "cityCode": "511703",
            "label": "达川区", "value": "达川区",
            "pcode": "511700"
        },
        {
            "cityCode": "511722",
            "label": "宣汉县", "value": "宣汉县",
            "pcode": "511700"
        },
        {
            "cityCode": "511723",
            "label": "开江县", "value": "开江县",
            "pcode": "511700"
        },
        {
            "cityCode": "511724",
            "label": "大竹县", "value": "大竹县",
            "pcode": "511700"
        },
        {
            "cityCode": "511725",
            "label": "渠县", "value": "渠县",
            "pcode": "511700"
        },
        {
            "cityCode": "511781",
            "label": "万源市", "value": "万源市",
            "pcode": "511700"
        }],
        "pcode": "510000"
    },
    {
        "cityCode": "511800",
        "label": "雅安市", "value": "雅安市",
        "children": [{
            "cityCode": "511802",
            "label": "雨城区", "value": "雨城区",
            "pcode": "511800"
        },
        {
            "cityCode": "511803",
            "label": "名山区", "value": "名山区",
            "pcode": "511800"
        },
        {
            "cityCode": "511822",
            "label": "荥经县", "value": "荥经县",
            "pcode": "511800"
        },
        {
            "cityCode": "511823",
            "label": "汉源县", "value": "汉源县",
            "pcode": "511800"
        },
        {
            "cityCode": "511824",
            "label": "石棉县", "value": "石棉县",
            "pcode": "511800"
        },
        {
            "cityCode": "511825",
            "label": "天全县", "value": "天全县",
            "pcode": "511800"
        },
        {
            "cityCode": "511826",
            "label": "芦山县", "value": "芦山县",
            "pcode": "511800"
        },
        {
            "cityCode": "511827",
            "label": "宝兴县", "value": "宝兴县",
            "pcode": "511800"
        }],
        "pcode": "510000"
    },
    {
        "cityCode": "511900",
        "label": "巴中市", "value": "巴中市",
        "children": [{
            "cityCode": "511902",
            "label": "巴州区", "value": "巴州区",
            "pcode": "511900"
        },
        {
            "cityCode": "511903",
            "label": "恩阳区", "value": "恩阳区",
            "pcode": "511900"
        },
        {
            "cityCode": "511921",
            "label": "通江县", "value": "通江县",
            "pcode": "511900"
        },
        {
            "cityCode": "511922",
            "label": "南江县", "value": "南江县",
            "pcode": "511900"
        },
        {
            "cityCode": "511923",
            "label": "平昌县", "value": "平昌县",
            "pcode": "511900"
        }],
        "pcode": "510000"
    },
    {
        "cityCode": "512000",
        "label": "资阳市", "value": "资阳市",
        "children": [{
            "cityCode": "512002",
            "label": "雁江区", "value": "雁江区",
            "pcode": "512000"
        },
        {
            "cityCode": "512021",
            "label": "安岳县", "value": "安岳县",
            "pcode": "512000"
        },
        {
            "cityCode": "512022",
            "label": "乐至县", "value": "乐至县",
            "pcode": "512000"
        }],
        "pcode": "510000"
    },
    {
        "cityCode": "513200",
        "label": "阿坝藏族羌族自治州", "value": "阿坝藏族羌族自治州",
        "children": [{
            "cityCode": "513201",
            "label": "马尔康市", "value": "马尔康市",
            "pcode": "513200"
        },
        {
            "cityCode": "513221",
            "label": "汶川县", "value": "汶川县",
            "pcode": "513200"
        },
        {
            "cityCode": "513222",
            "label": "理县", "value": "理县",
            "pcode": "513200"
        },
        {
            "cityCode": "513223",
            "label": "茂县", "value": "茂县",
            "pcode": "513200"
        },
        {
            "cityCode": "513224",
            "label": "松潘县", "value": "松潘县",
            "pcode": "513200"
        },
        {
            "cityCode": "513225",
            "label": "九寨沟县", "value": "九寨沟县",
            "pcode": "513200"
        },
        {
            "cityCode": "513226",
            "label": "金川县", "value": "金川县",
            "pcode": "513200"
        },
        {
            "cityCode": "513227",
            "label": "小金县", "value": "小金县",
            "pcode": "513200"
        },
        {
            "cityCode": "513228",
            "label": "黑水县", "value": "黑水县",
            "pcode": "513200"
        },
        {
            "cityCode": "513230",
            "label": "壤塘县", "value": "壤塘县",
            "pcode": "513200"
        },
        {
            "cityCode": "513231",
            "label": "阿坝县", "value": "阿坝县",
            "pcode": "513200"
        },
        {
            "cityCode": "513232",
            "label": "若尔盖县", "value": "若尔盖县",
            "pcode": "513200"
        },
        {
            "cityCode": "513233",
            "label": "红原县", "value": "红原县",
            "pcode": "513200"
        }],
        "pcode": "510000"
    },
    {
        "cityCode": "513300",
        "label": "甘孜藏族自治州", "value": "甘孜藏族自治州",
        "children": [{
            "cityCode": "513301",
            "label": "康定市", "value": "康定市",
            "pcode": "513300"
        },
        {
            "cityCode": "513322",
            "label": "泸定县", "value": "泸定县",
            "pcode": "513300"
        },
        {
            "cityCode": "513323",
            "label": "丹巴县", "value": "丹巴县",
            "pcode": "513300"
        },
        {
            "cityCode": "513324",
            "label": "九龙县", "value": "九龙县",
            "pcode": "513300"
        },
        {
            "cityCode": "513325",
            "label": "雅江县", "value": "雅江县",
            "pcode": "513300"
        },
        {
            "cityCode": "513326",
            "label": "道孚县", "value": "道孚县",
            "pcode": "513300"
        },
        {
            "cityCode": "513327",
            "label": "炉霍县", "value": "炉霍县",
            "pcode": "513300"
        },
        {
            "cityCode": "513328",
            "label": "甘孜县", "value": "甘孜县",
            "pcode": "513300"
        },
        {
            "cityCode": "513329",
            "label": "新龙县", "value": "新龙县",
            "pcode": "513300"
        },
        {
            "cityCode": "513330",
            "label": "德格县", "value": "德格县",
            "pcode": "513300"
        },
        {
            "cityCode": "513331",
            "label": "白玉县", "value": "白玉县",
            "pcode": "513300"
        },
        {
            "cityCode": "513332",
            "label": "石渠县", "value": "石渠县",
            "pcode": "513300"
        },
        {
            "cityCode": "513333",
            "label": "色达县", "value": "色达县",
            "pcode": "513300"
        },
        {
            "cityCode": "513334",
            "label": "理塘县", "value": "理塘县",
            "pcode": "513300"
        },
        {
            "cityCode": "513335",
            "label": "巴塘县", "value": "巴塘县",
            "pcode": "513300"
        },
        {
            "cityCode": "513336",
            "label": "乡城县", "value": "乡城县",
            "pcode": "513300"
        },
        {
            "cityCode": "513337",
            "label": "稻城县", "value": "稻城县",
            "pcode": "513300"
        },
        {
            "cityCode": "513338",
            "label": "得荣县", "value": "得荣县",
            "pcode": "513300"
        }],
        "pcode": "510000"
    },
    {
        "cityCode": "513400",
        "label": "凉山彝族自治州", "value": "凉山彝族自治州",
        "children": [{
            "cityCode": "513401",
            "label": "西昌市", "value": "西昌市",
            "pcode": "513400"
        },
        {
            "cityCode": "513422",
            "label": "木里藏族自治县", "value": "木里藏族自治县",
            "pcode": "513400"
        },
        {
            "cityCode": "513423",
            "label": "盐源县", "value": "盐源县",
            "pcode": "513400"
        },
        {
            "cityCode": "513424",
            "label": "德昌县", "value": "德昌县",
            "pcode": "513400"
        },
        {
            "cityCode": "513425",
            "label": "会理县", "value": "会理县",
            "pcode": "513400"
        },
        {
            "cityCode": "513426",
            "label": "会东县", "value": "会东县",
            "pcode": "513400"
        },
        {
            "cityCode": "513427",
            "label": "宁南县", "value": "宁南县",
            "pcode": "513400"
        },
        {
            "cityCode": "513428",
            "label": "普格县", "value": "普格县",
            "pcode": "513400"
        },
        {
            "cityCode": "513429",
            "label": "布拖县", "value": "布拖县",
            "pcode": "513400"
        },
        {
            "cityCode": "513430",
            "label": "金阳县", "value": "金阳县",
            "pcode": "513400"
        },
        {
            "cityCode": "513431",
            "label": "昭觉县", "value": "昭觉县",
            "pcode": "513400"
        },
        {
            "cityCode": "513432",
            "label": "喜德县", "value": "喜德县",
            "pcode": "513400"
        },
        {
            "cityCode": "513433",
            "label": "冕宁县", "value": "冕宁县",
            "pcode": "513400"
        },
        {
            "cityCode": "513434",
            "label": "越西县", "value": "越西县",
            "pcode": "513400"
        },
        {
            "cityCode": "513435",
            "label": "甘洛县", "value": "甘洛县",
            "pcode": "513400"
        },
        {
            "cityCode": "513436",
            "label": "美姑县", "value": "美姑县",
            "pcode": "513400"
        },
        {
            "cityCode": "513437",
            "label": "雷波县", "value": "雷波县",
            "pcode": "513400"
        }],
        "pcode": "510000"
    }]
},
{
    "cityCode": "520000",
    "label": "贵州省", "value": "贵州省",
    "children": [{
        "cityCode": "520100",
        "label": "贵阳市", "value": "贵阳市",
        "children": [{
            "cityCode": "520102",
            "label": "南明区", "value": "南明区",
            "pcode": "520100"
        },
        {
            "cityCode": "520103",
            "label": "云岩区", "value": "云岩区",
            "pcode": "520100"
        },
        {
            "cityCode": "520111",
            "label": "花溪区", "value": "花溪区",
            "pcode": "520100"
        },
        {
            "cityCode": "520112",
            "label": "乌当区", "value": "乌当区",
            "pcode": "520100"
        },
        {
            "cityCode": "520113",
            "label": "白云区", "value": "白云区",
            "pcode": "520100"
        },
        {
            "cityCode": "520115",
            "label": "观山湖区", "value": "观山湖区",
            "pcode": "520100"
        },
        {
            "cityCode": "520121",
            "label": "开阳县", "value": "开阳县",
            "pcode": "520100"
        },
        {
            "cityCode": "520122",
            "label": "息烽县", "value": "息烽县",
            "pcode": "520100"
        },
        {
            "cityCode": "520123",
            "label": "修文县", "value": "修文县",
            "pcode": "520100"
        },
        {
            "cityCode": "520181",
            "label": "清镇市", "value": "清镇市",
            "pcode": "520100"
        }],
        "pcode": "520000"
    },
    {
        "cityCode": "520200",
        "label": "六盘水市", "value": "六盘水市",
        "children": [{
            "cityCode": "520201",
            "label": "钟山区", "value": "钟山区",
            "pcode": "520200"
        },
        {
            "cityCode": "520203",
            "label": "六枝特区", "value": "六枝特区",
            "pcode": "520200"
        },
        {
            "cityCode": "520221",
            "label": "水城县", "value": "水城县",
            "pcode": "520200"
        },
        {
            "cityCode": "520222",
            "label": "盘县", "value": "盘县",
            "pcode": "520200"
        }],
        "pcode": "520000"
    },
    {
        "cityCode": "520300",
        "label": "遵义市", "value": "遵义市",
        "children": [{
            "cityCode": "520302",
            "label": "红花岗区", "value": "红花岗区",
            "pcode": "520300"
        },
        {
            "cityCode": "520303",
            "label": "汇川区", "value": "汇川区",
            "pcode": "520300"
        },
        {
            "cityCode": "520304",
            "label": "播州区", "value": "播州区",
            "pcode": "520300"
        },
        {
            "cityCode": "520322",
            "label": "桐梓县", "value": "桐梓县",
            "pcode": "520300"
        },
        {
            "cityCode": "520323",
            "label": "绥阳县", "value": "绥阳县",
            "pcode": "520300"
        },
        {
            "cityCode": "520324",
            "label": "正安县", "value": "正安县",
            "pcode": "520300"
        },
        {
            "cityCode": "520325",
            "label": "道真仡佬族苗族自治县", "value": "道真仡佬族苗族自治县",
            "pcode": "520300"
        },
        {
            "cityCode": "520326",
            "label": "务川仡佬族苗族自治县", "value": "务川仡佬族苗族自治县",
            "pcode": "520300"
        },
        {
            "cityCode": "520327",
            "label": "凤冈县", "value": "凤冈县",
            "pcode": "520300"
        },
        {
            "cityCode": "520328",
            "label": "湄潭县", "value": "湄潭县",
            "pcode": "520300"
        },
        {
            "cityCode": "520329",
            "label": "余庆县", "value": "余庆县",
            "pcode": "520300"
        },
        {
            "cityCode": "520330",
            "label": "习水县", "value": "习水县",
            "pcode": "520300"
        },
        {
            "cityCode": "520381",
            "label": "赤水市", "value": "赤水市",
            "pcode": "520300"
        },
        {
            "cityCode": "520382",
            "label": "仁怀市", "value": "仁怀市",
            "pcode": "520300"
        }],
        "pcode": "520000"
    },
    {
        "cityCode": "520400",
        "label": "安顺市", "value": "安顺市",
        "children": [{
            "cityCode": "520402",
            "label": "西秀区", "value": "西秀区",
            "pcode": "520400"
        },
        {
            "cityCode": "520403",
            "label": "平坝区", "value": "平坝区",
            "pcode": "520400"
        },
        {
            "cityCode": "520422",
            "label": "普定县", "value": "普定县",
            "pcode": "520400"
        },
        {
            "cityCode": "520423",
            "label": "镇宁布依族苗族自治县", "value": "镇宁布依族苗族自治县",
            "pcode": "520400"
        },
        {
            "cityCode": "520424",
            "label": "关岭布依族苗族自治县", "value": "关岭布依族苗族自治县",
            "pcode": "520400"
        },
        {
            "cityCode": "520425",
            "label": "紫云苗族布依族自治县", "value": "紫云苗族布依族自治县",
            "pcode": "520400"
        }],
        "pcode": "520000"
    },
    {
        "cityCode": "520500",
        "label": "毕节市", "value": "毕节市",
        "children": [{
            "cityCode": "520502",
            "label": "七星关区", "value": "七星关区",
            "pcode": "520500"
        },
        {
            "cityCode": "520521",
            "label": "大方县", "value": "大方县",
            "pcode": "520500"
        },
        {
            "cityCode": "520522",
            "label": "黔西县", "value": "黔西县",
            "pcode": "520500"
        },
        {
            "cityCode": "520523",
            "label": "金沙县", "value": "金沙县",
            "pcode": "520500"
        },
        {
            "cityCode": "520524",
            "label": "织金县", "value": "织金县",
            "pcode": "520500"
        },
        {
            "cityCode": "520525",
            "label": "纳雍县", "value": "纳雍县",
            "pcode": "520500"
        },
        {
            "cityCode": "520526",
            "label": "威宁彝族回族苗族自治县", "value": "威宁彝族回族苗族自治县",
            "pcode": "520500"
        },
        {
            "cityCode": "520527",
            "label": "赫章县", "value": "赫章县",
            "pcode": "520500"
        }],
        "pcode": "520000"
    },
    {
        "cityCode": "520600",
        "label": "铜仁市", "value": "铜仁市",
        "children": [{
            "cityCode": "520602",
            "label": "碧江区", "value": "碧江区",
            "pcode": "520600"
        },
        {
            "cityCode": "520603",
            "label": "万山区", "value": "万山区",
            "pcode": "520600"
        },
        {
            "cityCode": "520621",
            "label": "江口县", "value": "江口县",
            "pcode": "520600"
        },
        {
            "cityCode": "520622",
            "label": "玉屏侗族自治县", "value": "玉屏侗族自治县",
            "pcode": "520600"
        },
        {
            "cityCode": "520623",
            "label": "石阡县", "value": "石阡县",
            "pcode": "520600"
        },
        {
            "cityCode": "520624",
            "label": "思南县", "value": "思南县",
            "pcode": "520600"
        },
        {
            "cityCode": "520625",
            "label": "印江土家族苗族自治县", "value": "印江土家族苗族自治县",
            "pcode": "520600"
        },
        {
            "cityCode": "520626",
            "label": "德江县", "value": "德江县",
            "pcode": "520600"
        },
        {
            "cityCode": "520627",
            "label": "沿河土家族自治县", "value": "沿河土家族自治县",
            "pcode": "520600"
        },
        {
            "cityCode": "520628",
            "label": "松桃苗族自治县", "value": "松桃苗族自治县",
            "pcode": "520600"
        }],
        "pcode": "520000"
    },
    {
        "cityCode": "522300",
        "label": "黔西南布依族苗族自治州", "value": "黔西南布依族苗族自治州",
        "children": [{
            "cityCode": "522301",
            "label": "兴义市", "value": "兴义市",
            "pcode": "522300"
        },
        {
            "cityCode": "522322",
            "label": "兴仁县", "value": "兴仁县",
            "pcode": "522300"
        },
        {
            "cityCode": "522323",
            "label": "普安县", "value": "普安县",
            "pcode": "522300"
        },
        {
            "cityCode": "522324",
            "label": "晴隆县", "value": "晴隆县",
            "pcode": "522300"
        },
        {
            "cityCode": "522325",
            "label": "贞丰县", "value": "贞丰县",
            "pcode": "522300"
        },
        {
            "cityCode": "522326",
            "label": "望谟县", "value": "望谟县",
            "pcode": "522300"
        },
        {
            "cityCode": "522327",
            "label": "册亨县", "value": "册亨县",
            "pcode": "522300"
        },
        {
            "cityCode": "522328",
            "label": "安龙县", "value": "安龙县",
            "pcode": "522300"
        }],
        "pcode": "520000"
    },
    {
        "cityCode": "522600",
        "label": "黔东南苗族侗族自治州", "value": "黔东南苗族侗族自治州",
        "children": [{
            "cityCode": "522601",
            "label": "凯里市", "value": "凯里市",
            "pcode": "522600"
        },
        {
            "cityCode": "522622",
            "label": "黄平县", "value": "黄平县",
            "pcode": "522600"
        },
        {
            "cityCode": "522623",
            "label": "施秉县", "value": "施秉县",
            "pcode": "522600"
        },
        {
            "cityCode": "522624",
            "label": "三穗县", "value": "三穗县",
            "pcode": "522600"
        },
        {
            "cityCode": "522625",
            "label": "镇远县", "value": "镇远县",
            "pcode": "522600"
        },
        {
            "cityCode": "522626",
            "label": "岑巩县", "value": "岑巩县",
            "pcode": "522600"
        },
        {
            "cityCode": "522627",
            "label": "天柱县", "value": "天柱县",
            "pcode": "522600"
        },
        {
            "cityCode": "522628",
            "label": "锦屏县", "value": "锦屏县",
            "pcode": "522600"
        },
        {
            "cityCode": "522629",
            "label": "剑河县", "value": "剑河县",
            "pcode": "522600"
        },
        {
            "cityCode": "522630",
            "label": "台江县", "value": "台江县",
            "pcode": "522600"
        },
        {
            "cityCode": "522631",
            "label": "黎平县", "value": "黎平县",
            "pcode": "522600"
        },
        {
            "cityCode": "522632",
            "label": "榕江县", "value": "榕江县",
            "pcode": "522600"
        },
        {
            "cityCode": "522633",
            "label": "从江县", "value": "从江县",
            "pcode": "522600"
        },
        {
            "cityCode": "522634",
            "label": "雷山县", "value": "雷山县",
            "pcode": "522600"
        },
        {
            "cityCode": "522635",
            "label": "麻江县", "value": "麻江县",
            "pcode": "522600"
        },
        {
            "cityCode": "522636",
            "label": "丹寨县", "value": "丹寨县",
            "pcode": "522600"
        }],
        "pcode": "520000"
    },
    {
        "cityCode": "522700",
        "label": "黔南布依族苗族自治州", "value": "黔南布依族苗族自治州",
        "children": [{
            "cityCode": "522701",
            "label": "都匀市", "value": "都匀市",
            "pcode": "522700"
        },
        {
            "cityCode": "522702",
            "label": "福泉市", "value": "福泉市",
            "pcode": "522700"
        },
        {
            "cityCode": "522722",
            "label": "荔波县", "value": "荔波县",
            "pcode": "522700"
        },
        {
            "cityCode": "522723",
            "label": "贵定县", "value": "贵定县",
            "pcode": "522700"
        },
        {
            "cityCode": "522725",
            "label": "瓮安县", "value": "瓮安县",
            "pcode": "522700"
        },
        {
            "cityCode": "522726",
            "label": "独山县", "value": "独山县",
            "pcode": "522700"
        },
        {
            "cityCode": "522727",
            "label": "平塘县", "value": "平塘县",
            "pcode": "522700"
        },
        {
            "cityCode": "522728",
            "label": "罗甸县", "value": "罗甸县",
            "pcode": "522700"
        },
        {
            "cityCode": "522729",
            "label": "长顺县", "value": "长顺县",
            "pcode": "522700"
        },
        {
            "cityCode": "522730",
            "label": "龙里县", "value": "龙里县",
            "pcode": "522700"
        },
        {
            "cityCode": "522731",
            "label": "惠水县", "value": "惠水县",
            "pcode": "522700"
        },
        {
            "cityCode": "522732",
            "label": "三都水族自治县", "value": "三都水族自治县",
            "pcode": "522700"
        }],
        "pcode": "520000"
    }]
},
{
    "cityCode": "530000",
    "label": "云南省", "value": "云南省",
    "children": [{
        "cityCode": "530100",
        "label": "昆明市", "value": "昆明市",
        "children": [{
            "cityCode": "530102",
            "label": "五华区", "value": "五华区",
            "pcode": "530100"
        },
        {
            "cityCode": "530103",
            "label": "盘龙区", "value": "盘龙区",
            "pcode": "530100"
        },
        {
            "cityCode": "530111",
            "label": "官渡区", "value": "官渡区",
            "pcode": "530100"
        },
        {
            "cityCode": "530112",
            "label": "西山区", "value": "西山区",
            "pcode": "530100"
        },
        {
            "cityCode": "530113",
            "label": "东川区", "value": "东川区",
            "pcode": "530100"
        },
        {
            "cityCode": "530114",
            "label": "呈贡区", "value": "呈贡区",
            "pcode": "530100"
        },
        {
            "cityCode": "530115",
            "label": "晋宁区", "value": "晋宁区",
            "pcode": "530100"
        },
        {
            "cityCode": "530124",
            "label": "富民县", "value": "富民县",
            "pcode": "530100"
        },
        {
            "cityCode": "530125",
            "label": "宜良县", "value": "宜良县",
            "pcode": "530100"
        },
        {
            "cityCode": "530126",
            "label": "石林彝族自治县", "value": "石林彝族自治县",
            "pcode": "530100"
        },
        {
            "cityCode": "530127",
            "label": "嵩明县", "value": "嵩明县",
            "pcode": "530100"
        },
        {
            "cityCode": "530128",
            "label": "禄劝彝族苗族自治县", "value": "禄劝彝族苗族自治县",
            "pcode": "530100"
        },
        {
            "cityCode": "530129",
            "label": "寻甸回族彝族自治县", "value": "寻甸回族彝族自治县",
            "pcode": "530100"
        },
        {
            "cityCode": "530181",
            "label": "安宁市", "value": "安宁市",
            "pcode": "530100"
        }],
        "pcode": "530000"
    },
    {
        "cityCode": "530300",
        "label": "曲靖市", "value": "曲靖市",
        "children": [{
            "cityCode": "530302",
            "label": "麒麟区", "value": "麒麟区",
            "pcode": "530300"
        },
        {
            "cityCode": "530303",
            "label": "沾益区", "value": "沾益区",
            "pcode": "530300"
        },
        {
            "cityCode": "530321",
            "label": "马龙县", "value": "马龙县",
            "pcode": "530300"
        },
        {
            "cityCode": "530322",
            "label": "陆良县", "value": "陆良县",
            "pcode": "530300"
        },
        {
            "cityCode": "530323",
            "label": "师宗县", "value": "师宗县",
            "pcode": "530300"
        },
        {
            "cityCode": "530324",
            "label": "罗平县", "value": "罗平县",
            "pcode": "530300"
        },
        {
            "cityCode": "530325",
            "label": "富源县", "value": "富源县",
            "pcode": "530300"
        },
        {
            "cityCode": "530326",
            "label": "会泽县", "value": "会泽县",
            "pcode": "530300"
        },
        {
            "cityCode": "530381",
            "label": "宣威市", "value": "宣威市",
            "pcode": "530300"
        }],
        "pcode": "530000"
    },
    {
        "cityCode": "530400",
        "label": "玉溪市", "value": "玉溪市",
        "children": [{
            "cityCode": "530402",
            "label": "红塔区", "value": "红塔区",
            "pcode": "530400"
        },
        {
            "cityCode": "530403",
            "label": "江川区", "value": "江川区",
            "pcode": "530400"
        },
        {
            "cityCode": "530422",
            "label": "澄江县", "value": "澄江县",
            "pcode": "530400"
        },
        {
            "cityCode": "530423",
            "label": "通海县", "value": "通海县",
            "pcode": "530400"
        },
        {
            "cityCode": "530424",
            "label": "华宁县", "value": "华宁县",
            "pcode": "530400"
        },
        {
            "cityCode": "530425",
            "label": "易门县", "value": "易门县",
            "pcode": "530400"
        },
        {
            "cityCode": "530426",
            "label": "峨山彝族自治县", "value": "峨山彝族自治县",
            "pcode": "530400"
        },
        {
            "cityCode": "530427",
            "label": "新平彝族傣族自治县", "value": "新平彝族傣族自治县",
            "pcode": "530400"
        },
        {
            "cityCode": "530428",
            "label": "元江哈尼族彝族傣族自治县", "value": "元江哈尼族彝族傣族自治县",
            "pcode": "530400"
        }],
        "pcode": "530000"
    },
    {
        "cityCode": "530500",
        "label": "保山市", "value": "保山市",
        "children": [{
            "cityCode": "530502",
            "label": "隆阳区", "value": "隆阳区",
            "pcode": "530500"
        },
        {
            "cityCode": "530521",
            "label": "施甸县", "value": "施甸县",
            "pcode": "530500"
        },
        {
            "cityCode": "530523",
            "label": "龙陵县", "value": "龙陵县",
            "pcode": "530500"
        },
        {
            "cityCode": "530524",
            "label": "昌宁县", "value": "昌宁县",
            "pcode": "530500"
        },
        {
            "cityCode": "530581",
            "label": "腾冲市", "value": "腾冲市",
            "pcode": "530500"
        }],
        "pcode": "530000"
    },
    {
        "cityCode": "530600",
        "label": "昭通市", "value": "昭通市",
        "children": [{
            "cityCode": "530602",
            "label": "昭阳区", "value": "昭阳区",
            "pcode": "530600"
        },
        {
            "cityCode": "530621",
            "label": "鲁甸县", "value": "鲁甸县",
            "pcode": "530600"
        },
        {
            "cityCode": "530622",
            "label": "巧家县", "value": "巧家县",
            "pcode": "530600"
        },
        {
            "cityCode": "530623",
            "label": "盐津县", "value": "盐津县",
            "pcode": "530600"
        },
        {
            "cityCode": "530624",
            "label": "大关县", "value": "大关县",
            "pcode": "530600"
        },
        {
            "cityCode": "530625",
            "label": "永善县", "value": "永善县",
            "pcode": "530600"
        },
        {
            "cityCode": "530626",
            "label": "绥江县", "value": "绥江县",
            "pcode": "530600"
        },
        {
            "cityCode": "530627",
            "label": "镇雄县", "value": "镇雄县",
            "pcode": "530600"
        },
        {
            "cityCode": "530628",
            "label": "彝良县", "value": "彝良县",
            "pcode": "530600"
        },
        {
            "cityCode": "530629",
            "label": "威信县", "value": "威信县",
            "pcode": "530600"
        },
        {
            "cityCode": "530630",
            "label": "水富县", "value": "水富县",
            "pcode": "530600"
        }],
        "pcode": "530000"
    },
    {
        "cityCode": "530700",
        "label": "丽江市", "value": "丽江市",
        "children": [{
            "cityCode": "530702",
            "label": "古城区", "value": "古城区",
            "pcode": "530700"
        },
        {
            "cityCode": "530721",
            "label": "玉龙纳西族自治县", "value": "玉龙纳西族自治县",
            "pcode": "530700"
        },
        {
            "cityCode": "530722",
            "label": "永胜县", "value": "永胜县",
            "pcode": "530700"
        },
        {
            "cityCode": "530723",
            "label": "华坪县", "value": "华坪县",
            "pcode": "530700"
        },
        {
            "cityCode": "530724",
            "label": "宁蒗彝族自治县", "value": "宁蒗彝族自治县",
            "pcode": "530700"
        }],
        "pcode": "530000"
    },
    {
        "cityCode": "530800",
        "label": "普洱市", "value": "普洱市",
        "children": [{
            "cityCode": "530802",
            "label": "思茅区", "value": "思茅区",
            "pcode": "530800"
        },
        {
            "cityCode": "530821",
            "label": "宁洱哈尼族彝族自治县", "value": "宁洱哈尼族彝族自治县",
            "pcode": "530800"
        },
        {
            "cityCode": "530822",
            "label": "墨江哈尼族自治县", "value": "墨江哈尼族自治县",
            "pcode": "530800"
        },
        {
            "cityCode": "530823",
            "label": "景东彝族自治县", "value": "景东彝族自治县",
            "pcode": "530800"
        },
        {
            "cityCode": "530824",
            "label": "景谷傣族彝族自治县", "value": "景谷傣族彝族自治县",
            "pcode": "530800"
        },
        {
            "cityCode": "530825",
            "label": "镇沅彝族哈尼族拉祜族自治县", "value": "镇沅彝族哈尼族拉祜族自治县",
            "pcode": "530800"
        },
        {
            "cityCode": "530826",
            "label": "江城哈尼族彝族自治县", "value": "江城哈尼族彝族自治县",
            "pcode": "530800"
        },
        {
            "cityCode": "530827",
            "label": "孟连傣族拉祜族佤族自治县", "value": "孟连傣族拉祜族佤族自治县",
            "pcode": "530800"
        },
        {
            "cityCode": "530828",
            "label": "澜沧拉祜族自治县", "value": "澜沧拉祜族自治县",
            "pcode": "530800"
        },
        {
            "cityCode": "530829",
            "label": "西盟佤族自治县", "value": "西盟佤族自治县",
            "pcode": "530800"
        }],
        "pcode": "530000"
    },
    {
        "cityCode": "530900",
        "label": "临沧市", "value": "临沧市",
        "children": [{
            "cityCode": "530902",
            "label": "临翔区", "value": "临翔区",
            "pcode": "530900"
        },
        {
            "cityCode": "530921",
            "label": "凤庆县", "value": "凤庆县",
            "pcode": "530900"
        },
        {
            "cityCode": "530922",
            "label": "云县", "value": "云县",
            "pcode": "530900"
        },
        {
            "cityCode": "530923",
            "label": "永德县", "value": "永德县",
            "pcode": "530900"
        },
        {
            "cityCode": "530924",
            "label": "镇康县", "value": "镇康县",
            "pcode": "530900"
        },
        {
            "cityCode": "530925",
            "label": "双江拉祜族佤族布朗族傣族自治县", "value": "双江拉祜族佤族布朗族傣族自治县",
            "pcode": "530900"
        },
        {
            "cityCode": "530926",
            "label": "耿马傣族佤族自治县", "value": "耿马傣族佤族自治县",
            "pcode": "530900"
        },
        {
            "cityCode": "530927",
            "label": "沧源佤族自治县", "value": "沧源佤族自治县",
            "pcode": "530900"
        }],
        "pcode": "530000"
    },
    {
        "cityCode": "532300",
        "label": "楚雄彝族自治州", "value": "楚雄彝族自治州",
        "children": [{
            "cityCode": "532301",
            "label": "楚雄市", "value": "楚雄市",
            "pcode": "532300"
        },
        {
            "cityCode": "532322",
            "label": "双柏县", "value": "双柏县",
            "pcode": "532300"
        },
        {
            "cityCode": "532323",
            "label": "牟定县", "value": "牟定县",
            "pcode": "532300"
        },
        {
            "cityCode": "532324",
            "label": "南华县", "value": "南华县",
            "pcode": "532300"
        },
        {
            "cityCode": "532325",
            "label": "姚安县", "value": "姚安县",
            "pcode": "532300"
        },
        {
            "cityCode": "532326",
            "label": "大姚县", "value": "大姚县",
            "pcode": "532300"
        },
        {
            "cityCode": "532327",
            "label": "永仁县", "value": "永仁县",
            "pcode": "532300"
        },
        {
            "cityCode": "532328",
            "label": "元谋县", "value": "元谋县",
            "pcode": "532300"
        },
        {
            "cityCode": "532329",
            "label": "武定县", "value": "武定县",
            "pcode": "532300"
        },
        {
            "cityCode": "532331",
            "label": "禄丰县", "value": "禄丰县",
            "pcode": "532300"
        }],
        "pcode": "530000"
    },
    {
        "cityCode": "532500",
        "label": "红河哈尼族彝族自治州", "value": "红河哈尼族彝族自治州",
        "children": [{
            "cityCode": "532501",
            "label": "个旧市", "value": "个旧市",
            "pcode": "532500"
        },
        {
            "cityCode": "532502",
            "label": "开远市", "value": "开远市",
            "pcode": "532500"
        },
        {
            "cityCode": "532503",
            "label": "蒙自市", "value": "蒙自市",
            "pcode": "532500"
        },
        {
            "cityCode": "532504",
            "label": "弥勒市", "value": "弥勒市",
            "pcode": "532500"
        },
        {
            "cityCode": "532523",
            "label": "屏边苗族自治县", "value": "屏边苗族自治县",
            "pcode": "532500"
        },
        {
            "cityCode": "532524",
            "label": "建水县", "value": "建水县",
            "pcode": "532500"
        },
        {
            "cityCode": "532525",
            "label": "石屏县", "value": "石屏县",
            "pcode": "532500"
        },
        {
            "cityCode": "532527",
            "label": "泸西县", "value": "泸西县",
            "pcode": "532500"
        },
        {
            "cityCode": "532528",
            "label": "元阳县", "value": "元阳县",
            "pcode": "532500"
        },
        {
            "cityCode": "532529",
            "label": "红河县", "value": "红河县",
            "pcode": "532500"
        },
        {
            "cityCode": "532530",
            "label": "金平苗族瑶族傣族自治县", "value": "金平苗族瑶族傣族自治县",
            "pcode": "532500"
        },
        {
            "cityCode": "532531",
            "label": "绿春县", "value": "绿春县",
            "pcode": "532500"
        },
        {
            "cityCode": "532532",
            "label": "河口瑶族自治县", "value": "河口瑶族自治县",
            "pcode": "532500"
        }],
        "pcode": "530000"
    },
    {
        "cityCode": "532600",
        "label": "文山壮族苗族自治州", "value": "文山壮族苗族自治州",
        "children": [{
            "cityCode": "532601",
            "label": "文山市", "value": "文山市",
            "pcode": "532600"
        },
        {
            "cityCode": "532622",
            "label": "砚山县", "value": "砚山县",
            "pcode": "532600"
        },
        {
            "cityCode": "532623",
            "label": "西畴县", "value": "西畴县",
            "pcode": "532600"
        },
        {
            "cityCode": "532624",
            "label": "麻栗坡县", "value": "麻栗坡县",
            "pcode": "532600"
        },
        {
            "cityCode": "532625",
            "label": "马关县", "value": "马关县",
            "pcode": "532600"
        },
        {
            "cityCode": "532626",
            "label": "丘北县", "value": "丘北县",
            "pcode": "532600"
        },
        {
            "cityCode": "532627",
            "label": "广南县", "value": "广南县",
            "pcode": "532600"
        },
        {
            "cityCode": "532628",
            "label": "富宁县", "value": "富宁县",
            "pcode": "532600"
        }],
        "pcode": "530000"
    },
    {
        "cityCode": "532800",
        "label": "西双版纳傣族自治州", "value": "西双版纳傣族自治州",
        "children": [{
            "cityCode": "532801",
            "label": "景洪市", "value": "景洪市",
            "pcode": "532800"
        },
        {
            "cityCode": "532822",
            "label": "勐海县", "value": "勐海县",
            "pcode": "532800"
        },
        {
            "cityCode": "532823",
            "label": "勐腊县", "value": "勐腊县",
            "pcode": "532800"
        }],
        "pcode": "530000"
    },
    {
        "cityCode": "532900",
        "label": "大理白族自治州", "value": "大理白族自治州",
        "children": [{
            "cityCode": "532901",
            "label": "大理市", "value": "大理市",
            "pcode": "532900"
        },
        {
            "cityCode": "532922",
            "label": "漾濞彝族自治县", "value": "漾濞彝族自治县",
            "pcode": "532900"
        },
        {
            "cityCode": "532923",
            "label": "祥云县", "value": "祥云县",
            "pcode": "532900"
        },
        {
            "cityCode": "532924",
            "label": "宾川县", "value": "宾川县",
            "pcode": "532900"
        },
        {
            "cityCode": "532925",
            "label": "弥渡县", "value": "弥渡县",
            "pcode": "532900"
        },
        {
            "cityCode": "532926",
            "label": "南涧彝族自治县", "value": "南涧彝族自治县",
            "pcode": "532900"
        },
        {
            "cityCode": "532927",
            "label": "巍山彝族回族自治县", "value": "巍山彝族回族自治县",
            "pcode": "532900"
        },
        {
            "cityCode": "532928",
            "label": "永平县", "value": "永平县",
            "pcode": "532900"
        },
        {
            "cityCode": "532929",
            "label": "云龙县", "value": "云龙县",
            "pcode": "532900"
        },
        {
            "cityCode": "532930",
            "label": "洱源县", "value": "洱源县",
            "pcode": "532900"
        },
        {
            "cityCode": "532931",
            "label": "剑川县", "value": "剑川县",
            "pcode": "532900"
        },
        {
            "cityCode": "532932",
            "label": "鹤庆县", "value": "鹤庆县",
            "pcode": "532900"
        }],
        "pcode": "530000"
    },
    {
        "cityCode": "533100",
        "label": "德宏傣族景颇族自治州", "value": "德宏傣族景颇族自治州",
        "children": [{
            "cityCode": "533102",
            "label": "瑞丽市", "value": "瑞丽市",
            "pcode": "533100"
        },
        {
            "cityCode": "533103",
            "label": "芒市", "value": "芒市",
            "pcode": "533100"
        },
        {
            "cityCode": "533122",
            "label": "梁河县", "value": "梁河县",
            "pcode": "533100"
        },
        {
            "cityCode": "533123",
            "label": "盈江县", "value": "盈江县",
            "pcode": "533100"
        },
        {
            "cityCode": "533124",
            "label": "陇川县", "value": "陇川县",
            "pcode": "533100"
        }],
        "pcode": "530000"
    },
    {
        "cityCode": "533300",
        "label": "怒江傈僳族自治州", "value": "怒江傈僳族自治州",
        "children": [{
            "cityCode": "533301",
            "label": "泸水市", "value": "泸水市",
            "pcode": "533300"
        },
        {
            "cityCode": "533323",
            "label": "福贡县", "value": "福贡县",
            "pcode": "533300"
        },
        {
            "cityCode": "533324",
            "label": "贡山独龙族怒族自治县", "value": "贡山独龙族怒族自治县",
            "pcode": "533300"
        },
        {
            "cityCode": "533325",
            "label": "兰坪白族普米族自治县", "value": "兰坪白族普米族自治县",
            "pcode": "533300"
        }],
        "pcode": "530000"
    },
    {
        "cityCode": "533400",
        "label": "迪庆藏族自治州", "value": "迪庆藏族自治州",
        "children": [{
            "cityCode": "533401",
            "label": "香格里拉市", "value": "香格里拉市",
            "pcode": "533400"
        },
        {
            "cityCode": "533422",
            "label": "德钦县", "value": "德钦县",
            "pcode": "533400"
        },
        {
            "cityCode": "533423",
            "label": "维西傈僳族自治县", "value": "维西傈僳族自治县",
            "pcode": "533400"
        }],
        "pcode": "530000"
    }]
},
{
    "cityCode": "540000",
    "label": "西藏自治区", "value": "西藏自治区",
    "children": [{
        "cityCode": "540100",
        "label": "拉萨市", "value": "拉萨市",
        "children": [{
            "cityCode": "540102",
            "label": "城关区", "value": "城关区",
            "pcode": "540100"
        },
        {
            "cityCode": "540103",
            "label": "堆龙德庆区", "value": "堆龙德庆区",
            "pcode": "540100"
        },
        {
            "cityCode": "540121",
            "label": "林周县", "value": "林周县",
            "pcode": "540100"
        },
        {
            "cityCode": "540122",
            "label": "当雄县", "value": "当雄县",
            "pcode": "540100"
        },
        {
            "cityCode": "540123",
            "label": "尼木县", "value": "尼木县",
            "pcode": "540100"
        },
        {
            "cityCode": "540124",
            "label": "曲水县", "value": "曲水县",
            "pcode": "540100"
        },
        {
            "cityCode": "540126",
            "label": "达孜县", "value": "达孜县",
            "pcode": "540100"
        },
        {
            "cityCode": "540127",
            "label": "墨竹工卡县", "value": "墨竹工卡县",
            "pcode": "540100"
        }],
        "pcode": "540000"
    },
    {
        "cityCode": "540200",
        "label": "日喀则市", "value": "日喀则市",
        "children": [{
            "cityCode": "540202",
            "label": "桑珠孜区", "value": "桑珠孜区",
            "pcode": "540200"
        },
        {
            "cityCode": "540221",
            "label": "南木林县", "value": "南木林县",
            "pcode": "540200"
        },
        {
            "cityCode": "540222",
            "label": "江孜县", "value": "江孜县",
            "pcode": "540200"
        },
        {
            "cityCode": "540223",
            "label": "定日县", "value": "定日县",
            "pcode": "540200"
        },
        {
            "cityCode": "540224",
            "label": "萨迦县", "value": "萨迦县",
            "pcode": "540200"
        },
        {
            "cityCode": "540225",
            "label": "拉孜县", "value": "拉孜县",
            "pcode": "540200"
        },
        {
            "cityCode": "540226",
            "label": "昂仁县", "value": "昂仁县",
            "pcode": "540200"
        },
        {
            "cityCode": "540227",
            "label": "谢通门县", "value": "谢通门县",
            "pcode": "540200"
        },
        {
            "cityCode": "540228",
            "label": "白朗县", "value": "白朗县",
            "pcode": "540200"
        },
        {
            "cityCode": "540229",
            "label": "仁布县", "value": "仁布县",
            "pcode": "540200"
        },
        {
            "cityCode": "540230",
            "label": "康马县", "value": "康马县",
            "pcode": "540200"
        },
        {
            "cityCode": "540231",
            "label": "定结县", "value": "定结县",
            "pcode": "540200"
        },
        {
            "cityCode": "540232",
            "label": "仲巴县", "value": "仲巴县",
            "pcode": "540200"
        },
        {
            "cityCode": "540233",
            "label": "亚东县", "value": "亚东县",
            "pcode": "540200"
        },
        {
            "cityCode": "540234",
            "label": "吉隆县", "value": "吉隆县",
            "pcode": "540200"
        },
        {
            "cityCode": "540235",
            "label": "聂拉木县", "value": "聂拉木县",
            "pcode": "540200"
        },
        {
            "cityCode": "540236",
            "label": "萨嘎县", "value": "萨嘎县",
            "pcode": "540200"
        },
        {
            "cityCode": "540237",
            "label": "岗巴县", "value": "岗巴县",
            "pcode": "540200"
        }],
        "pcode": "540000"
    },
    {
        "cityCode": "540300",
        "label": "昌都市", "value": "昌都市",
        "children": [{
            "cityCode": "540302",
            "label": "卡若区", "value": "卡若区",
            "pcode": "540300"
        },
        {
            "cityCode": "540321",
            "label": "江达县", "value": "江达县",
            "pcode": "540300"
        },
        {
            "cityCode": "540322",
            "label": "贡觉县", "value": "贡觉县",
            "pcode": "540300"
        },
        {
            "cityCode": "540323",
            "label": "类乌齐县", "value": "类乌齐县",
            "pcode": "540300"
        },
        {
            "cityCode": "540324",
            "label": "丁青县", "value": "丁青县",
            "pcode": "540300"
        },
        {
            "cityCode": "540325",
            "label": "察雅县", "value": "察雅县",
            "pcode": "540300"
        },
        {
            "cityCode": "540326",
            "label": "八宿县", "value": "八宿县",
            "pcode": "540300"
        },
        {
            "cityCode": "540327",
            "label": "左贡县", "value": "左贡县",
            "pcode": "540300"
        },
        {
            "cityCode": "540328",
            "label": "芒康县", "value": "芒康县",
            "pcode": "540300"
        },
        {
            "cityCode": "540329",
            "label": "洛隆县", "value": "洛隆县",
            "pcode": "540300"
        },
        {
            "cityCode": "540330",
            "label": "边坝县", "value": "边坝县",
            "pcode": "540300"
        }],
        "pcode": "540000"
    },
    {
        "cityCode": "540400",
        "label": "林芝市", "value": "林芝市",
        "children": [{
            "cityCode": "540402",
            "label": "巴宜区", "value": "巴宜区",
            "pcode": "540400"
        },
        {
            "cityCode": "540421",
            "label": "工布江达县", "value": "工布江达县",
            "pcode": "540400"
        },
        {
            "cityCode": "540422",
            "label": "米林县", "value": "米林县",
            "pcode": "540400"
        },
        {
            "cityCode": "540423",
            "label": "墨脱县", "value": "墨脱县",
            "pcode": "540400"
        },
        {
            "cityCode": "540424",
            "label": "波密县", "value": "波密县",
            "pcode": "540400"
        },
        {
            "cityCode": "540425",
            "label": "察隅县", "value": "察隅县",
            "pcode": "540400"
        },
        {
            "cityCode": "540426",
            "label": "朗县", "value": "朗县",
            "pcode": "540400"
        }],
        "pcode": "540000"
    },
    {
        "cityCode": "540500",
        "label": "山南市", "value": "山南市",
        "children": [{
            "cityCode": "540502",
            "label": "乃东区", "value": "乃东区",
            "pcode": "540500"
        },
        {
            "cityCode": "540521",
            "label": "扎囊县", "value": "扎囊县",
            "pcode": "540500"
        },
        {
            "cityCode": "540522",
            "label": "贡嘎县", "value": "贡嘎县",
            "pcode": "540500"
        },
        {
            "cityCode": "540523",
            "label": "桑日县", "value": "桑日县",
            "pcode": "540500"
        },
        {
            "cityCode": "540524",
            "label": "琼结县", "value": "琼结县",
            "pcode": "540500"
        },
        {
            "cityCode": "540525",
            "label": "曲松县", "value": "曲松县",
            "pcode": "540500"
        },
        {
            "cityCode": "540526",
            "label": "措美县", "value": "措美县",
            "pcode": "540500"
        },
        {
            "cityCode": "540527",
            "label": "洛扎县", "value": "洛扎县",
            "pcode": "540500"
        },
        {
            "cityCode": "540528",
            "label": "加查县", "value": "加查县",
            "pcode": "540500"
        },
        {
            "cityCode": "540529",
            "label": "隆子县", "value": "隆子县",
            "pcode": "540500"
        },
        {
            "cityCode": "540530",
            "label": "错那县", "value": "错那县",
            "pcode": "540500"
        },
        {
            "cityCode": "540531",
            "label": "浪卡子县", "value": "浪卡子县",
            "pcode": "540500"
        }],
        "pcode": "540000"
    },
    {
        "cityCode": "542400",
        "label": "那曲地区", "value": "那曲地区",
        "children": [{
            "cityCode": "542421",
            "label": "那曲县", "value": "那曲县",
            "pcode": "542400"
        },
        {
            "cityCode": "542422",
            "label": "嘉黎县", "value": "嘉黎县",
            "pcode": "542400"
        },
        {
            "cityCode": "542423",
            "label": "比如县", "value": "比如县",
            "pcode": "542400"
        },
        {
            "cityCode": "542424",
            "label": "聂荣县", "value": "聂荣县",
            "pcode": "542400"
        },
        {
            "cityCode": "542425",
            "label": "安多县", "value": "安多县",
            "pcode": "542400"
        },
        {
            "cityCode": "542426",
            "label": "申扎县", "value": "申扎县",
            "pcode": "542400"
        },
        {
            "cityCode": "542427",
            "label": "索县", "value": "索县",
            "pcode": "542400"
        },
        {
            "cityCode": "542428",
            "label": "班戈县", "value": "班戈县",
            "pcode": "542400"
        },
        {
            "cityCode": "542429",
            "label": "巴青县", "value": "巴青县",
            "pcode": "542400"
        },
        {
            "cityCode": "542430",
            "label": "尼玛县", "value": "尼玛县",
            "pcode": "542400"
        },
        {
            "cityCode": "542431",
            "label": "双湖县", "value": "双湖县",
            "pcode": "542400"
        }],
        "pcode": "540000"
    },
    {
        "cityCode": "542500",
        "label": "阿里地区", "value": "阿里地区",
        "children": [{
            "cityCode": "542521",
            "label": "普兰县", "value": "普兰县",
            "pcode": "542500"
        },
        {
            "cityCode": "542522",
            "label": "札达县", "value": "札达县",
            "pcode": "542500"
        },
        {
            "cityCode": "542523",
            "label": "噶尔县", "value": "噶尔县",
            "pcode": "542500"
        },
        {
            "cityCode": "542524",
            "label": "日土县", "value": "日土县",
            "pcode": "542500"
        },
        {
            "cityCode": "542525",
            "label": "革吉县", "value": "革吉县",
            "pcode": "542500"
        },
        {
            "cityCode": "542526",
            "label": "改则县", "value": "改则县",
            "pcode": "542500"
        },
        {
            "cityCode": "542527",
            "label": "措勤县", "value": "措勤县",
            "pcode": "542500"
        }],
        "pcode": "540000"
    }]
},
{
    "cityCode": "610000",
    "label": "陕西省", "value": "陕西省",
    "children": [{
        "cityCode": "610100",
        "label": "西安市", "value": "西安市",
        "children": [{
            "cityCode": "610102",
            "label": "新城区", "value": "新城区",
            "pcode": "610100"
        },
        {
            "cityCode": "610103",
            "label": "碑林区", "value": "碑林区",
            "pcode": "610100"
        },
        {
            "cityCode": "610104",
            "label": "莲湖区", "value": "莲湖区",
            "pcode": "610100"
        },
        {
            "cityCode": "610111",
            "label": "灞桥区", "value": "灞桥区",
            "pcode": "610100"
        },
        {
            "cityCode": "610112",
            "label": "未央区", "value": "未央区",
            "pcode": "610100"
        },
        {
            "cityCode": "610113",
            "label": "雁塔区", "value": "雁塔区",
            "pcode": "610100"
        },
        {
            "cityCode": "610114",
            "label": "阎良区", "value": "阎良区",
            "pcode": "610100"
        },
        {
            "cityCode": "610115",
            "label": "临潼区", "value": "临潼区",
            "pcode": "610100"
        },
        {
            "cityCode": "610116",
            "label": "长安区", "value": "长安区",
            "pcode": "610100"
        },
        {
            "cityCode": "610117",
            "label": "高陵区", "value": "高陵区",
            "pcode": "610100"
        },
        {
            "cityCode": "610122",
            "label": "蓝田县", "value": "蓝田县",
            "pcode": "610100"
        },
        {
            "cityCode": "610124",
            "label": "周至县", "value": "周至县",
            "pcode": "610100"
        },
        {
            "cityCode": "610118",
            "label": "鄠邑区", "value": "鄠邑区",
            "pcode": "610100"
        }],
        "pcode": "610000"
    },
    {
        "cityCode": "610200",
        "label": "铜川市", "value": "铜川市",
        "children": [{
            "cityCode": "610202",
            "label": "王益区", "value": "王益区",
            "pcode": "610200"
        },
        {
            "cityCode": "610203",
            "label": "印台区", "value": "印台区",
            "pcode": "610200"
        },
        {
            "cityCode": "610204",
            "label": "耀州区", "value": "耀州区",
            "pcode": "610200"
        },
        {
            "cityCode": "610222",
            "label": "宜君县", "value": "宜君县",
            "pcode": "610200"
        }],
        "pcode": "610000"
    },
    {
        "cityCode": "610300",
        "label": "宝鸡市", "value": "宝鸡市",
        "children": [{
            "cityCode": "610302",
            "label": "渭滨区", "value": "渭滨区",
            "pcode": "610300"
        },
        {
            "cityCode": "610303",
            "label": "金台区", "value": "金台区",
            "pcode": "610300"
        },
        {
            "cityCode": "610304",
            "label": "陈仓区", "value": "陈仓区",
            "pcode": "610300"
        },
        {
            "cityCode": "610322",
            "label": "凤翔县", "value": "凤翔县",
            "pcode": "610300"
        },
        {
            "cityCode": "610323",
            "label": "岐山县", "value": "岐山县",
            "pcode": "610300"
        },
        {
            "cityCode": "610324",
            "label": "扶风县", "value": "扶风县",
            "pcode": "610300"
        },
        {
            "cityCode": "610326",
            "label": "眉县", "value": "眉县",
            "pcode": "610300"
        },
        {
            "cityCode": "610327",
            "label": "陇县", "value": "陇县",
            "pcode": "610300"
        },
        {
            "cityCode": "610328",
            "label": "千阳县", "value": "千阳县",
            "pcode": "610300"
        },
        {
            "cityCode": "610329",
            "label": "麟游县", "value": "麟游县",
            "pcode": "610300"
        },
        {
            "cityCode": "610330",
            "label": "凤县", "value": "凤县",
            "pcode": "610300"
        },
        {
            "cityCode": "610331",
            "label": "太白县", "value": "太白县",
            "pcode": "610300"
        }],
        "pcode": "610000"
    },
    {
        "cityCode": "610400",
        "label": "咸阳市", "value": "咸阳市",
        "children": [{
            "cityCode": "610402",
            "label": "秦都区", "value": "秦都区",
            "pcode": "610400"
        },
        {
            "cityCode": "610403",
            "label": "杨陵区", "value": "杨陵区",
            "pcode": "610400"
        },
        {
            "cityCode": "610404",
            "label": "渭城区", "value": "渭城区",
            "pcode": "610400"
        },
        {
            "cityCode": "610422",
            "label": "三原县", "value": "三原县",
            "pcode": "610400"
        },
        {
            "cityCode": "610423",
            "label": "泾阳县", "value": "泾阳县",
            "pcode": "610400"
        },
        {
            "cityCode": "610424",
            "label": "乾县", "value": "乾县",
            "pcode": "610400"
        },
        {
            "cityCode": "610425",
            "label": "礼泉县", "value": "礼泉县",
            "pcode": "610400"
        },
        {
            "cityCode": "610426",
            "label": "永寿县", "value": "永寿县",
            "pcode": "610400"
        },
        {
            "cityCode": "610427",
            "label": "彬县", "value": "彬县",
            "pcode": "610400"
        },
        {
            "cityCode": "610428",
            "label": "长武县", "value": "长武县",
            "pcode": "610400"
        },
        {
            "cityCode": "610429",
            "label": "旬邑县", "value": "旬邑县",
            "pcode": "610400"
        },
        {
            "cityCode": "610430",
            "label": "淳化县", "value": "淳化县",
            "pcode": "610400"
        },
        {
            "cityCode": "610431",
            "label": "武功县", "value": "武功县",
            "pcode": "610400"
        },
        {
            "cityCode": "610481",
            "label": "兴平市", "value": "兴平市",
            "pcode": "610400"
        }],
        "pcode": "610000"
    },
    {
        "cityCode": "610500",
        "label": "渭南市", "value": "渭南市",
        "children": [{
            "cityCode": "610502",
            "label": "临渭区", "value": "临渭区",
            "pcode": "610500"
        },
        {
            "cityCode": "610503",
            "label": "华州区", "value": "华州区",
            "pcode": "610500"
        },
        {
            "cityCode": "610522",
            "label": "潼关县", "value": "潼关县",
            "pcode": "610500"
        },
        {
            "cityCode": "610523",
            "label": "大荔县", "value": "大荔县",
            "pcode": "610500"
        },
        {
            "cityCode": "610524",
            "label": "合阳县", "value": "合阳县",
            "pcode": "610500"
        },
        {
            "cityCode": "610525",
            "label": "澄城县", "value": "澄城县",
            "pcode": "610500"
        },
        {
            "cityCode": "610526",
            "label": "蒲城县", "value": "蒲城县",
            "pcode": "610500"
        },
        {
            "cityCode": "610527",
            "label": "白水县", "value": "白水县",
            "pcode": "610500"
        },
        {
            "cityCode": "610528",
            "label": "富平县", "value": "富平县",
            "pcode": "610500"
        },
        {
            "cityCode": "610581",
            "label": "韩城市", "value": "韩城市",
            "pcode": "610500"
        },
        {
            "cityCode": "610582",
            "label": "华阴市", "value": "华阴市",
            "pcode": "610500"
        }],
        "pcode": "610000"
    },
    {
        "cityCode": "610600",
        "label": "延安市", "value": "延安市",
        "children": [{
            "cityCode": "610602",
            "label": "宝塔区", "value": "宝塔区",
            "pcode": "610600"
        },
        {
            "cityCode": "610621",
            "label": "延长县", "value": "延长县",
            "pcode": "610600"
        },
        {
            "cityCode": "610622",
            "label": "延川县", "value": "延川县",
            "pcode": "610600"
        },
        {
            "cityCode": "610623",
            "label": "子长县", "value": "子长县",
            "pcode": "610600"
        },
        {
            "cityCode": "610624",
            "label": "安塞区", "value": "安塞区",
            "pcode": "610600"
        },
        {
            "cityCode": "610625",
            "label": "志丹县", "value": "志丹县",
            "pcode": "610600"
        },
        {
            "cityCode": "610626",
            "label": "吴起县", "value": "吴起县",
            "pcode": "610600"
        },
        {
            "cityCode": "610627",
            "label": "甘泉县", "value": "甘泉县",
            "pcode": "610600"
        },
        {
            "cityCode": "610628",
            "label": "富县", "value": "富县",
            "pcode": "610600"
        },
        {
            "cityCode": "610629",
            "label": "洛川县", "value": "洛川县",
            "pcode": "610600"
        },
        {
            "cityCode": "610630",
            "label": "宜川县", "value": "宜川县",
            "pcode": "610600"
        },
        {
            "cityCode": "610631",
            "label": "黄龙县", "value": "黄龙县",
            "pcode": "610600"
        },
        {
            "cityCode": "610632",
            "label": "黄陵县", "value": "黄陵县",
            "pcode": "610600"
        }],
        "pcode": "610000"
    },
    {
        "cityCode": "610700",
        "label": "汉中市", "value": "汉中市",
        "children": [{
            "cityCode": "610702",
            "label": "汉台区", "value": "汉台区",
            "pcode": "610700"
        },
        {
            "cityCode": "610721",
            "label": "南郑区", "value": "南郑区",
            "pcode": "610700"
        },
        {
            "cityCode": "610722",
            "label": "城固县", "value": "城固县",
            "pcode": "610700"
        },
        {
            "cityCode": "610723",
            "label": "洋县", "value": "洋县",
            "pcode": "610700"
        },
        {
            "cityCode": "610724",
            "label": "西乡县", "value": "西乡县",
            "pcode": "610700"
        },
        {
            "cityCode": "610725",
            "label": "勉县", "value": "勉县",
            "pcode": "610700"
        },
        {
            "cityCode": "610726",
            "label": "宁强县", "value": "宁强县",
            "pcode": "610700"
        },
        {
            "cityCode": "610727",
            "label": "略阳县", "value": "略阳县",
            "pcode": "610700"
        },
        {
            "cityCode": "610728",
            "label": "镇巴县", "value": "镇巴县",
            "pcode": "610700"
        },
        {
            "cityCode": "610729",
            "label": "留坝县", "value": "留坝县",
            "pcode": "610700"
        },
        {
            "cityCode": "610730",
            "label": "佛坪县", "value": "佛坪县",
            "pcode": "610700"
        }],
        "pcode": "610000"
    },
    {
        "cityCode": "610800",
        "label": "榆林市", "value": "榆林市",
        "children": [{
            "cityCode": "610802",
            "label": "榆阳区", "value": "榆阳区",
            "pcode": "610800"
        },
        {
            "cityCode": "610803",
            "label": "横山区", "value": "横山区",
            "pcode": "610800"
        },
        {
            "cityCode": "610821",
            "label": "神木县", "value": "神木县",
            "pcode": "610800"
        },
        {
            "cityCode": "610822",
            "label": "府谷县", "value": "府谷县",
            "pcode": "610800"
        },
        {
            "cityCode": "610824",
            "label": "靖边县", "value": "靖边县",
            "pcode": "610800"
        },
        {
            "cityCode": "610825",
            "label": "定边县", "value": "定边县",
            "pcode": "610800"
        },
        {
            "cityCode": "610826",
            "label": "绥德县", "value": "绥德县",
            "pcode": "610800"
        },
        {
            "cityCode": "610827",
            "label": "米脂县", "value": "米脂县",
            "pcode": "610800"
        },
        {
            "cityCode": "610828",
            "label": "佳县", "value": "佳县",
            "pcode": "610800"
        },
        {
            "cityCode": "610829",
            "label": "吴堡县", "value": "吴堡县",
            "pcode": "610800"
        },
        {
            "cityCode": "610830",
            "label": "清涧县", "value": "清涧县",
            "pcode": "610800"
        },
        {
            "cityCode": "610831",
            "label": "子洲县", "value": "子洲县",
            "pcode": "610800"
        }],
        "pcode": "610000"
    },
    {
        "cityCode": "610900",
        "label": "安康市", "value": "安康市",
        "children": [{
            "cityCode": "610902",
            "label": "汉滨区", "value": "汉滨区",
            "pcode": "610900"
        },
        {
            "cityCode": "610921",
            "label": "汉阴县", "value": "汉阴县",
            "pcode": "610900"
        },
        {
            "cityCode": "610922",
            "label": "石泉县", "value": "石泉县",
            "pcode": "610900"
        },
        {
            "cityCode": "610923",
            "label": "宁陕县", "value": "宁陕县",
            "pcode": "610900"
        },
        {
            "cityCode": "610924",
            "label": "紫阳县", "value": "紫阳县",
            "pcode": "610900"
        },
        {
            "cityCode": "610925",
            "label": "岚皋县", "value": "岚皋县",
            "pcode": "610900"
        },
        {
            "cityCode": "610926",
            "label": "平利县", "value": "平利县",
            "pcode": "610900"
        },
        {
            "cityCode": "610927",
            "label": "镇坪县", "value": "镇坪县",
            "pcode": "610900"
        },
        {
            "cityCode": "610928",
            "label": "旬阳县", "value": "旬阳县",
            "pcode": "610900"
        },
        {
            "cityCode": "610929",
            "label": "白河县", "value": "白河县",
            "pcode": "610900"
        }],
        "pcode": "610000"
    },
    {
        "cityCode": "611000",
        "label": "商洛市", "value": "商洛市",
        "children": [{
            "cityCode": "611002",
            "label": "商州区", "value": "商州区",
            "pcode": "611000"
        },
        {
            "cityCode": "611021",
            "label": "洛南县", "value": "洛南县",
            "pcode": "611000"
        },
        {
            "cityCode": "611022",
            "label": "丹凤县", "value": "丹凤县",
            "pcode": "611000"
        },
        {
            "cityCode": "611023",
            "label": "商南县", "value": "商南县",
            "pcode": "611000"
        },
        {
            "cityCode": "611024",
            "label": "山阳县", "value": "山阳县",
            "pcode": "611000"
        },
        {
            "cityCode": "611025",
            "label": "镇安县", "value": "镇安县",
            "pcode": "611000"
        },
        {
            "cityCode": "611026",
            "label": "柞水县", "value": "柞水县",
            "pcode": "611000"
        }],
        "pcode": "610000"
    }]
},
{
    "cityCode": "620000",
    "label": "甘肃省", "value": "甘肃省",
    "children": [{
        "cityCode": "620100",
        "label": "兰州市", "value": "兰州市",
        "children": [{
            "cityCode": "620102",
            "label": "城关区", "value": "城关区",
            "pcode": "620100"
        },
        {
            "cityCode": "620103",
            "label": "七里河区", "value": "七里河区",
            "pcode": "620100"
        },
        {
            "cityCode": "620104",
            "label": "西固区", "value": "西固区",
            "pcode": "620100"
        },
        {
            "cityCode": "620105",
            "label": "安宁区", "value": "安宁区",
            "pcode": "620100"
        },
        {
            "cityCode": "620111",
            "label": "红古区", "value": "红古区",
            "pcode": "620100"
        },
        {
            "cityCode": "620121",
            "label": "永登县", "value": "永登县",
            "pcode": "620100"
        },
        {
            "cityCode": "620122",
            "label": "皋兰县", "value": "皋兰县",
            "pcode": "620100"
        },
        {
            "cityCode": "620123",
            "label": "榆中县", "value": "榆中县",
            "pcode": "620100"
        }],
        "pcode": "620000"
    },
    {
        "cityCode": "620200",
        "label": "嘉峪关市", "value": "嘉峪关市",
        "children": [{
            "cityCode": "620200100",
            "label": "新城镇", "value": "新城镇",
            "pcode": "620200"
        },
        {
            "cityCode": "620200101",
            "label": "峪泉镇", "value": "峪泉镇",
            "pcode": "620200"
        },
        {
            "cityCode": "620200102",
            "label": "文殊镇", "value": "文殊镇",
            "pcode": "620200"
        },
        {
            "cityCode": "620200401",
            "label": "雄关区", "value": "雄关区",
            "pcode": "620200"
        },
        {
            "cityCode": "620200402",
            "label": "镜铁区", "value": "镜铁区",
            "pcode": "620200"
        },
        {
            "cityCode": "620200403",
            "label": "长城区", "value": "长城区",
            "pcode": "620200"
        }],
        "pcode": "620000"
    },
    {
        "cityCode": "620300",
        "label": "金昌市", "value": "金昌市",
        "children": [{
            "cityCode": "620302",
            "label": "金川区", "value": "金川区",
            "pcode": "620300"
        },
        {
            "cityCode": "620321",
            "label": "永昌县", "value": "永昌县",
            "pcode": "620300"
        }],
        "pcode": "620000"
    },
    {
        "cityCode": "620400",
        "label": "白银市", "value": "白银市",
        "children": [{
            "cityCode": "620402",
            "label": "白银区", "value": "白银区",
            "pcode": "620400"
        },
        {
            "cityCode": "620403",
            "label": "平川区", "value": "平川区",
            "pcode": "620400"
        },
        {
            "cityCode": "620421",
            "label": "靖远县", "value": "靖远县",
            "pcode": "620400"
        },
        {
            "cityCode": "620422",
            "label": "会宁县", "value": "会宁县",
            "pcode": "620400"
        },
        {
            "cityCode": "620423",
            "label": "景泰县", "value": "景泰县",
            "pcode": "620400"
        }],
        "pcode": "620000"
    },
    {
        "cityCode": "620500",
        "label": "天水市", "value": "天水市",
        "children": [{
            "cityCode": "620502",
            "label": "秦州区", "value": "秦州区",
            "pcode": "620500"
        },
        {
            "cityCode": "620503",
            "label": "麦积区", "value": "麦积区",
            "pcode": "620500"
        },
        {
            "cityCode": "620521",
            "label": "清水县", "value": "清水县",
            "pcode": "620500"
        },
        {
            "cityCode": "620522",
            "label": "秦安县", "value": "秦安县",
            "pcode": "620500"
        },
        {
            "cityCode": "620523",
            "label": "甘谷县", "value": "甘谷县",
            "pcode": "620500"
        },
        {
            "cityCode": "620524",
            "label": "武山县", "value": "武山县",
            "pcode": "620500"
        },
        {
            "cityCode": "620525",
            "label": "张家川回族自治县", "value": "张家川回族自治县",
            "pcode": "620500"
        }],
        "pcode": "620000"
    },
    {
        "cityCode": "620600",
        "label": "武威市", "value": "武威市",
        "children": [{
            "cityCode": "620602",
            "label": "凉州区", "value": "凉州区",
            "pcode": "620600"
        },
        {
            "cityCode": "620621",
            "label": "民勤县", "value": "民勤县",
            "pcode": "620600"
        },
        {
            "cityCode": "620622",
            "label": "古浪县", "value": "古浪县",
            "pcode": "620600"
        },
        {
            "cityCode": "620623",
            "label": "天祝藏族自治县", "value": "天祝藏族自治县",
            "pcode": "620600"
        }],
        "pcode": "620000"
    },
    {
        "cityCode": "620700",
        "label": "张掖市", "value": "张掖市",
        "children": [{
            "cityCode": "620702",
            "label": "甘州区", "value": "甘州区",
            "pcode": "620700"
        },
        {
            "cityCode": "620721",
            "label": "肃南裕固族自治县", "value": "肃南裕固族自治县",
            "pcode": "620700"
        },
        {
            "cityCode": "620722",
            "label": "民乐县", "value": "民乐县",
            "pcode": "620700"
        },
        {
            "cityCode": "620723",
            "label": "临泽县", "value": "临泽县",
            "pcode": "620700"
        },
        {
            "cityCode": "620724",
            "label": "高台县", "value": "高台县",
            "pcode": "620700"
        },
        {
            "cityCode": "620725",
            "label": "山丹县", "value": "山丹县",
            "pcode": "620700"
        }],
        "pcode": "620000"
    },
    {
        "cityCode": "620800",
        "label": "平凉市", "value": "平凉市",
        "children": [{
            "cityCode": "620802",
            "label": "崆峒区", "value": "崆峒区",
            "pcode": "620800"
        },
        {
            "cityCode": "620821",
            "label": "泾川县", "value": "泾川县",
            "pcode": "620800"
        },
        {
            "cityCode": "620822",
            "label": "灵台县", "value": "灵台县",
            "pcode": "620800"
        },
        {
            "cityCode": "620823",
            "label": "崇信县", "value": "崇信县",
            "pcode": "620800"
        },
        {
            "cityCode": "620824",
            "label": "华亭县", "value": "华亭县",
            "pcode": "620800"
        },
        {
            "cityCode": "620825",
            "label": "庄浪县", "value": "庄浪县",
            "pcode": "620800"
        },
        {
            "cityCode": "620826",
            "label": "静宁县", "value": "静宁县",
            "pcode": "620800"
        }],
        "pcode": "620000"
    },
    {
        "cityCode": "620900",
        "label": "酒泉市", "value": "酒泉市",
        "children": [{
            "cityCode": "620902",
            "label": "肃州区", "value": "肃州区",
            "pcode": "620900"
        },
        {
            "cityCode": "620921",
            "label": "金塔县", "value": "金塔县",
            "pcode": "620900"
        },
        {
            "cityCode": "620922",
            "label": "瓜州县", "value": "瓜州县",
            "pcode": "620900"
        },
        {
            "cityCode": "620923",
            "label": "肃北蒙古族自治县", "value": "肃北蒙古族自治县",
            "pcode": "620900"
        },
        {
            "cityCode": "620924",
            "label": "阿克塞哈萨克族自治县", "value": "阿克塞哈萨克族自治县",
            "pcode": "620900"
        },
        {
            "cityCode": "620981",
            "label": "玉门市", "value": "玉门市",
            "pcode": "620900"
        },
        {
            "cityCode": "620982",
            "label": "敦煌市", "value": "敦煌市",
            "pcode": "620900"
        }],
        "pcode": "620000"
    },
    {
        "cityCode": "621000",
        "label": "庆阳市", "value": "庆阳市",
        "children": [{
            "cityCode": "621002",
            "label": "西峰区", "value": "西峰区",
            "pcode": "621000"
        },
        {
            "cityCode": "621021",
            "label": "庆城县", "value": "庆城县",
            "pcode": "621000"
        },
        {
            "cityCode": "621022",
            "label": "环县", "value": "环县",
            "pcode": "621000"
        },
        {
            "cityCode": "621023",
            "label": "华池县", "value": "华池县",
            "pcode": "621000"
        },
        {
            "cityCode": "621024",
            "label": "合水县", "value": "合水县",
            "pcode": "621000"
        },
        {
            "cityCode": "621025",
            "label": "正宁县", "value": "正宁县",
            "pcode": "621000"
        },
        {
            "cityCode": "621026",
            "label": "宁县", "value": "宁县",
            "pcode": "621000"
        },
        {
            "cityCode": "621027",
            "label": "镇原县", "value": "镇原县",
            "pcode": "621000"
        }],
        "pcode": "620000"
    },
    {
        "cityCode": "621100",
        "label": "定西市", "value": "定西市",
        "children": [{
            "cityCode": "621102",
            "label": "安定区", "value": "安定区",
            "pcode": "621100"
        },
        {
            "cityCode": "621121",
            "label": "通渭县", "value": "通渭县",
            "pcode": "621100"
        },
        {
            "cityCode": "621122",
            "label": "陇西县", "value": "陇西县",
            "pcode": "621100"
        },
        {
            "cityCode": "621123",
            "label": "渭源县", "value": "渭源县",
            "pcode": "621100"
        },
        {
            "cityCode": "621124",
            "label": "临洮县", "value": "临洮县",
            "pcode": "621100"
        },
        {
            "cityCode": "621125",
            "label": "漳县", "value": "漳县",
            "pcode": "621100"
        },
        {
            "cityCode": "621126",
            "label": "岷县", "value": "岷县",
            "pcode": "621100"
        }],
        "pcode": "620000"
    },
    {
        "cityCode": "621200",
        "label": "陇南市", "value": "陇南市",
        "children": [{
            "cityCode": "621202",
            "label": "武都区", "value": "武都区",
            "pcode": "621200"
        },
        {
            "cityCode": "621221",
            "label": "成县", "value": "成县",
            "pcode": "621200"
        },
        {
            "cityCode": "621222",
            "label": "文县", "value": "文县",
            "pcode": "621200"
        },
        {
            "cityCode": "621223",
            "label": "宕昌县", "value": "宕昌县",
            "pcode": "621200"
        },
        {
            "cityCode": "621224",
            "label": "康县", "value": "康县",
            "pcode": "621200"
        },
        {
            "cityCode": "621225",
            "label": "西和县", "value": "西和县",
            "pcode": "621200"
        },
        {
            "cityCode": "621226",
            "label": "礼县", "value": "礼县",
            "pcode": "621200"
        },
        {
            "cityCode": "621227",
            "label": "徽县", "value": "徽县",
            "pcode": "621200"
        },
        {
            "cityCode": "621228",
            "label": "两当县", "value": "两当县",
            "pcode": "621200"
        }],
        "pcode": "620000"
    },
    {
        "cityCode": "622900",
        "label": "临夏回族自治州", "value": "临夏回族自治州",
        "children": [{
            "cityCode": "622901",
            "label": "临夏市", "value": "临夏市",
            "pcode": "622900"
        },
        {
            "cityCode": "622921",
            "label": "临夏县", "value": "临夏县",
            "pcode": "622900"
        },
        {
            "cityCode": "622922",
            "label": "康乐县", "value": "康乐县",
            "pcode": "622900"
        },
        {
            "cityCode": "622923",
            "label": "永靖县", "value": "永靖县",
            "pcode": "622900"
        },
        {
            "cityCode": "622924",
            "label": "广河县", "value": "广河县",
            "pcode": "622900"
        },
        {
            "cityCode": "622925",
            "label": "和政县", "value": "和政县",
            "pcode": "622900"
        },
        {
            "cityCode": "622926",
            "label": "东乡族自治县", "value": "东乡族自治县",
            "pcode": "622900"
        },
        {
            "cityCode": "622927",
            "label": "积石山保安族东乡族撒拉族自治县", "value": "积石山保安族东乡族撒拉族自治县",
            "pcode": "622900"
        }],
        "pcode": "620000"
    },
    {
        "cityCode": "623000",
        "label": "甘南藏族自治州", "value": "甘南藏族自治州",
        "children": [{
            "cityCode": "623001",
            "label": "合作市", "value": "合作市",
            "pcode": "623000"
        },
        {
            "cityCode": "623021",
            "label": "临潭县", "value": "临潭县",
            "pcode": "623000"
        },
        {
            "cityCode": "623022",
            "label": "卓尼县", "value": "卓尼县",
            "pcode": "623000"
        },
        {
            "cityCode": "623023",
            "label": "舟曲县", "value": "舟曲县",
            "pcode": "623000"
        },
        {
            "cityCode": "623024",
            "label": "迭部县", "value": "迭部县",
            "pcode": "623000"
        },
        {
            "cityCode": "623025",
            "label": "玛曲县", "value": "玛曲县",
            "pcode": "623000"
        },
        {
            "cityCode": "623026",
            "label": "碌曲县", "value": "碌曲县",
            "pcode": "623000"
        },
        {
            "cityCode": "623027",
            "label": "夏河县", "value": "夏河县",
            "pcode": "623000"
        }],
        "pcode": "620000"
    }]
},
{
    "cityCode": "630000",
    "label": "青海省", "value": "青海省",
    "children": [{
        "cityCode": "630100",
        "label": "西宁市", "value": "西宁市",
        "children": [{
            "cityCode": "630102",
            "label": "城东区", "value": "城东区",
            "pcode": "630100"
        },
        {
            "cityCode": "630103",
            "label": "城中区", "value": "城中区",
            "pcode": "630100"
        },
        {
            "cityCode": "630104",
            "label": "城西区", "value": "城西区",
            "pcode": "630100"
        },
        {
            "cityCode": "630105",
            "label": "城北区", "value": "城北区",
            "pcode": "630100"
        },
        {
            "cityCode": "630121",
            "label": "大通回族土族自治县", "value": "大通回族土族自治县",
            "pcode": "630100"
        },
        {
            "cityCode": "630122",
            "label": "湟中县", "value": "湟中县",
            "pcode": "630100"
        },
        {
            "cityCode": "630123",
            "label": "湟源县", "value": "湟源县",
            "pcode": "630100"
        }],
        "pcode": "630000"
    },
    {
        "cityCode": "630200",
        "label": "海东市", "value": "海东市",
        "children": [{
            "cityCode": "630202",
            "label": "乐都区", "value": "乐都区",
            "pcode": "630200"
        },
        {
            "cityCode": "630203",
            "label": "平安区", "value": "平安区",
            "pcode": "630200"
        },
        {
            "cityCode": "630222",
            "label": "民和回族土族自治县", "value": "民和回族土族自治县",
            "pcode": "630200"
        },
        {
            "cityCode": "630223",
            "label": "互助土族自治县", "value": "互助土族自治县",
            "pcode": "630200"
        },
        {
            "cityCode": "630224",
            "label": "化隆回族自治县", "value": "化隆回族自治县",
            "pcode": "630200"
        },
        {
            "cityCode": "630225",
            "label": "循化撒拉族自治县", "value": "循化撒拉族自治县",
            "pcode": "630200"
        }],
        "pcode": "630000"
    },
    {
        "cityCode": "632200",
        "label": "海北藏族自治州", "value": "海北藏族自治州",
        "children": [{
            "cityCode": "632221",
            "label": "门源回族自治县", "value": "门源回族自治县",
            "pcode": "632200"
        },
        {
            "cityCode": "632222",
            "label": "祁连县", "value": "祁连县",
            "pcode": "632200"
        },
        {
            "cityCode": "632223",
            "label": "海晏县", "value": "海晏县",
            "pcode": "632200"
        },
        {
            "cityCode": "632224",
            "label": "刚察县", "value": "刚察县",
            "pcode": "632200"
        }],
        "pcode": "630000"
    },
    {
        "cityCode": "632300",
        "label": "黄南藏族自治州", "value": "黄南藏族自治州",
        "children": [{
            "cityCode": "632321",
            "label": "同仁县", "value": "同仁县",
            "pcode": "632300"
        },
        {
            "cityCode": "632322",
            "label": "尖扎县", "value": "尖扎县",
            "pcode": "632300"
        },
        {
            "cityCode": "632323",
            "label": "泽库县", "value": "泽库县",
            "pcode": "632300"
        },
        {
            "cityCode": "632324",
            "label": "河南蒙古族自治县", "value": "河南蒙古族自治县",
            "pcode": "632300"
        }],
        "pcode": "630000"
    },
    {
        "cityCode": "632500",
        "label": "海南藏族自治州", "value": "海南藏族自治州",
        "children": [{
            "cityCode": "632521",
            "label": "共和县", "value": "共和县",
            "pcode": "632500"
        },
        {
            "cityCode": "632522",
            "label": "同德县", "value": "同德县",
            "pcode": "632500"
        },
        {
            "cityCode": "632523",
            "label": "贵德县", "value": "贵德县",
            "pcode": "632500"
        },
        {
            "cityCode": "632524",
            "label": "兴海县", "value": "兴海县",
            "pcode": "632500"
        },
        {
            "cityCode": "632525",
            "label": "贵南县", "value": "贵南县",
            "pcode": "632500"
        }],
        "pcode": "630000"
    },
    {
        "cityCode": "632600",
        "label": "果洛藏族自治州", "value": "果洛藏族自治州",
        "children": [{
            "cityCode": "632621",
            "label": "玛沁县", "value": "玛沁县",
            "pcode": "632600"
        },
        {
            "cityCode": "632622",
            "label": "班玛县", "value": "班玛县",
            "pcode": "632600"
        },
        {
            "cityCode": "632623",
            "label": "甘德县", "value": "甘德县",
            "pcode": "632600"
        },
        {
            "cityCode": "632624",
            "label": "达日县", "value": "达日县",
            "pcode": "632600"
        },
        {
            "cityCode": "632625",
            "label": "久治县", "value": "久治县",
            "pcode": "632600"
        },
        {
            "cityCode": "632626",
            "label": "玛多县", "value": "玛多县",
            "pcode": "632600"
        }],
        "pcode": "630000"
    },
    {
        "cityCode": "632700",
        "label": "玉树藏族自治州", "value": "玉树藏族自治州",
        "children": [{
            "cityCode": "632701",
            "label": "玉树市", "value": "玉树市",
            "pcode": "632700"
        },
        {
            "cityCode": "632722",
            "label": "杂多县", "value": "杂多县",
            "pcode": "632700"
        },
        {
            "cityCode": "632723",
            "label": "称多县", "value": "称多县",
            "pcode": "632700"
        },
        {
            "cityCode": "632724",
            "label": "治多县", "value": "治多县",
            "pcode": "632700"
        },
        {
            "cityCode": "632725",
            "label": "囊谦县", "value": "囊谦县",
            "pcode": "632700"
        },
        {
            "cityCode": "632726",
            "label": "曲麻莱县", "value": "曲麻莱县",
            "pcode": "632700"
        }],
        "pcode": "630000"
    },
    {
        "cityCode": "632800",
        "label": "海西蒙古族藏族自治州", "value": "海西蒙古族藏族自治州",
        "children": [{
            "cityCode": "632801",
            "label": "格尔木市", "value": "格尔木市",
            "pcode": "632800"
        },
        {
            "cityCode": "632802",
            "label": "德令哈市", "value": "德令哈市",
            "pcode": "632800"
        },
        {
            "cityCode": "632821",
            "label": "乌兰县", "value": "乌兰县",
            "pcode": "632800"
        },
        {
            "cityCode": "632822",
            "label": "都兰县", "value": "都兰县",
            "pcode": "632800"
        },
        {
            "cityCode": "632823",
            "label": "天峻县", "value": "天峻县",
            "pcode": "632800"
        },
        {
            "cityCode": "632825",
            "label": "海西蒙古族藏族自治州直辖", "value": "海西蒙古族藏族自治州直辖",
            "pcode": "632800"
        }],
        "pcode": "630000"
    }]
},
{
    "cityCode": "640000",
    "label": "宁夏回族自治区", "value": "宁夏回族自治区",
    "children": [{
        "cityCode": "640100",
        "label": "银川市", "value": "银川市",
        "children": [{
            "cityCode": "640104",
            "label": "兴庆区", "value": "兴庆区",
            "pcode": "640100"
        },
        {
            "cityCode": "640105",
            "label": "西夏区", "value": "西夏区",
            "pcode": "640100"
        },
        {
            "cityCode": "640106",
            "label": "金凤区", "value": "金凤区",
            "pcode": "640100"
        },
        {
            "cityCode": "640121",
            "label": "永宁县", "value": "永宁县",
            "pcode": "640100"
        },
        {
            "cityCode": "640122",
            "label": "贺兰县", "value": "贺兰县",
            "pcode": "640100"
        },
        {
            "cityCode": "640181",
            "label": "灵武市", "value": "灵武市",
            "pcode": "640100"
        }],
        "pcode": "640000"
    },
    {
        "cityCode": "640200",
        "label": "石嘴山市", "value": "石嘴山市",
        "children": [{
            "cityCode": "640202",
            "label": "大武口区", "value": "大武口区",
            "pcode": "640200"
        },
        {
            "cityCode": "640205",
            "label": "惠农区", "value": "惠农区",
            "pcode": "640200"
        },
        {
            "cityCode": "640221",
            "label": "平罗县", "value": "平罗县",
            "pcode": "640200"
        }],
        "pcode": "640000"
    },
    {
        "cityCode": "640300",
        "label": "吴忠市", "value": "吴忠市",
        "children": [{
            "cityCode": "640302",
            "label": "利通区", "value": "利通区",
            "pcode": "640300"
        },
        {
            "cityCode": "640303",
            "label": "红寺堡区", "value": "红寺堡区",
            "pcode": "640300"
        },
        {
            "cityCode": "640323",
            "label": "盐池县", "value": "盐池县",
            "pcode": "640300"
        },
        {
            "cityCode": "640324",
            "label": "同心县", "value": "同心县",
            "pcode": "640300"
        },
        {
            "cityCode": "640381",
            "label": "青铜峡市", "value": "青铜峡市",
            "pcode": "640300"
        }],
        "pcode": "640000"
    },
    {
        "cityCode": "640400",
        "label": "固原市", "value": "固原市",
        "children": [{
            "cityCode": "640402",
            "label": "原州区", "value": "原州区",
            "pcode": "640400"
        },
        {
            "cityCode": "640422",
            "label": "西吉县", "value": "西吉县",
            "pcode": "640400"
        },
        {
            "cityCode": "640423",
            "label": "隆德县", "value": "隆德县",
            "pcode": "640400"
        },
        {
            "cityCode": "640424",
            "label": "泾源县", "value": "泾源县",
            "pcode": "640400"
        },
        {
            "cityCode": "640425",
            "label": "彭阳县", "value": "彭阳县",
            "pcode": "640400"
        }],
        "pcode": "640000"
    },
    {
        "cityCode": "640500",
        "label": "中卫市", "value": "中卫市",
        "children": [{
            "cityCode": "640502",
            "label": "沙坡头区", "value": "沙坡头区",
            "pcode": "640500"
        },
        {
            "cityCode": "640521",
            "label": "中宁县", "value": "中宁县",
            "pcode": "640500"
        },
        {
            "cityCode": "640522",
            "label": "海原县", "value": "海原县",
            "pcode": "640500"
        }],
        "pcode": "640000"
    }]
},
{
    "cityCode": "650000",
    "label": "新疆维吾尔自治区", "value": "新疆维吾尔自治区",
    "children": [{
        "cityCode": "650100",
        "label": "乌鲁木齐市", "value": "乌鲁木齐市",
        "children": [{
            "cityCode": "650102",
            "label": "天山区", "value": "天山区",
            "pcode": "650100"
        },
        {
            "cityCode": "650103",
            "label": "沙依巴克区", "value": "沙依巴克区",
            "pcode": "650100"
        },
        {
            "cityCode": "650104",
            "label": "新市区", "value": "新市区",
            "pcode": "650100"
        },
        {
            "cityCode": "650105",
            "label": "水磨沟区", "value": "水磨沟区",
            "pcode": "650100"
        },
        {
            "cityCode": "650106",
            "label": "头屯河区", "value": "头屯河区",
            "pcode": "650100"
        },
        {
            "cityCode": "650107",
            "label": "达坂城区", "value": "达坂城区",
            "pcode": "650100"
        },
        {
            "cityCode": "650109",
            "label": "米东区", "value": "米东区",
            "pcode": "650100"
        },
        {
            "cityCode": "650121",
            "label": "乌鲁木齐县", "value": "乌鲁木齐县",
            "pcode": "650100"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "650200",
        "label": "克拉玛依市", "value": "克拉玛依市",
        "children": [{
            "cityCode": "650202",
            "label": "独山子区", "value": "独山子区",
            "pcode": "650200"
        },
        {
            "cityCode": "650203",
            "label": "克拉玛依区", "value": "克拉玛依区",
            "pcode": "650200"
        },
        {
            "cityCode": "650204",
            "label": "白碱滩区", "value": "白碱滩区",
            "pcode": "650200"
        },
        {
            "cityCode": "650205",
            "label": "乌尔禾区", "value": "乌尔禾区",
            "pcode": "650200"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "650400",
        "label": "吐鲁番市", "value": "吐鲁番市",
        "children": [{
            "cityCode": "650402",
            "label": "高昌区", "value": "高昌区",
            "pcode": "650400"
        },
        {
            "cityCode": "650421",
            "label": "鄯善县", "value": "鄯善县",
            "pcode": "650400"
        },
        {
            "cityCode": "650422",
            "label": "托克逊县", "value": "托克逊县",
            "pcode": "650400"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "650500",
        "label": "哈密市", "value": "哈密市",
        "children": [{
            "cityCode": "650502",
            "label": "伊州区", "value": "伊州区",
            "pcode": "650500"
        },
        {
            "cityCode": "650521",
            "label": "巴里坤哈萨克自治县", "value": "巴里坤哈萨克自治县",
            "pcode": "650500"
        },
        {
            "cityCode": "650522",
            "label": "伊吾县", "value": "伊吾县",
            "pcode": "650500"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "652300",
        "label": "昌吉回族自治州", "value": "昌吉回族自治州",
        "children": [{
            "cityCode": "652301",
            "label": "昌吉市", "value": "昌吉市",
            "pcode": "652300"
        },
        {
            "cityCode": "652302",
            "label": "阜康市", "value": "阜康市",
            "pcode": "652300"
        },
        {
            "cityCode": "652323",
            "label": "呼图壁县", "value": "呼图壁县",
            "pcode": "652300"
        },
        {
            "cityCode": "652324",
            "label": "玛纳斯县", "value": "玛纳斯县",
            "pcode": "652300"
        },
        {
            "cityCode": "652325",
            "label": "奇台县", "value": "奇台县",
            "pcode": "652300"
        },
        {
            "cityCode": "652327",
            "label": "吉木萨尔县", "value": "吉木萨尔县",
            "pcode": "652300"
        },
        {
            "cityCode": "652328",
            "label": "木垒哈萨克自治县", "value": "木垒哈萨克自治县",
            "pcode": "652300"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "652700",
        "label": "博尔塔拉蒙古自治州", "value": "博尔塔拉蒙古自治州",
        "children": [{
            "cityCode": "652701",
            "label": "博乐市", "value": "博乐市",
            "pcode": "652700"
        },
        {
            "cityCode": "652702",
            "label": "阿拉山口市", "value": "阿拉山口市",
            "pcode": "652700"
        },
        {
            "cityCode": "652722",
            "label": "精河县", "value": "精河县",
            "pcode": "652700"
        },
        {
            "cityCode": "652723",
            "label": "温泉县", "value": "温泉县",
            "pcode": "652700"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "652800",
        "label": "巴音郭楞蒙古自治州", "value": "巴音郭楞蒙古自治州",
        "children": [{
            "cityCode": "652801",
            "label": "库尔勒市", "value": "库尔勒市",
            "pcode": "652800"
        },
        {
            "cityCode": "652822",
            "label": "轮台县", "value": "轮台县",
            "pcode": "652800"
        },
        {
            "cityCode": "652823",
            "label": "尉犁县", "value": "尉犁县",
            "pcode": "652800"
        },
        {
            "cityCode": "652824",
            "label": "若羌县", "value": "若羌县",
            "pcode": "652800"
        },
        {
            "cityCode": "652825",
            "label": "且末县", "value": "且末县",
            "pcode": "652800"
        },
        {
            "cityCode": "652826",
            "label": "焉耆回族自治县", "value": "焉耆回族自治县",
            "pcode": "652800"
        },
        {
            "cityCode": "652827",
            "label": "和静县", "value": "和静县",
            "pcode": "652800"
        },
        {
            "cityCode": "652828",
            "label": "和硕县", "value": "和硕县",
            "pcode": "652800"
        },
        {
            "cityCode": "652829",
            "label": "博湖县", "value": "博湖县",
            "pcode": "652800"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "652900",
        "label": "阿克苏地区", "value": "阿克苏地区",
        "children": [{
            "cityCode": "652901",
            "label": "阿克苏市", "value": "阿克苏市",
            "pcode": "652900"
        },
        {
            "cityCode": "652922",
            "label": "温宿县", "value": "温宿县",
            "pcode": "652900"
        },
        {
            "cityCode": "652923",
            "label": "库车县", "value": "库车县",
            "pcode": "652900"
        },
        {
            "cityCode": "652924",
            "label": "沙雅县", "value": "沙雅县",
            "pcode": "652900"
        },
        {
            "cityCode": "652925",
            "label": "新和县", "value": "新和县",
            "pcode": "652900"
        },
        {
            "cityCode": "652926",
            "label": "拜城县", "value": "拜城县",
            "pcode": "652900"
        },
        {
            "cityCode": "652927",
            "label": "乌什县", "value": "乌什县",
            "pcode": "652900"
        },
        {
            "cityCode": "652928",
            "label": "阿瓦提县", "value": "阿瓦提县",
            "pcode": "652900"
        },
        {
            "cityCode": "652929",
            "label": "柯坪县", "value": "柯坪县",
            "pcode": "652900"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "653000",
        "label": "克孜勒苏柯尔克孜自治州", "value": "克孜勒苏柯尔克孜自治州",
        "children": [{
            "cityCode": "653001",
            "label": "阿图什市", "value": "阿图什市",
            "pcode": "653000"
        },
        {
            "cityCode": "653022",
            "label": "阿克陶县", "value": "阿克陶县",
            "pcode": "653000"
        },
        {
            "cityCode": "653023",
            "label": "阿合奇县", "value": "阿合奇县",
            "pcode": "653000"
        },
        {
            "cityCode": "653024",
            "label": "乌恰县", "value": "乌恰县",
            "pcode": "653000"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "653100",
        "label": "喀什地区", "value": "喀什地区",
        "children": [{
            "cityCode": "653101",
            "label": "喀什市", "value": "喀什市",
            "pcode": "653100"
        },
        {
            "cityCode": "653121",
            "label": "疏附县", "value": "疏附县",
            "pcode": "653100"
        },
        {
            "cityCode": "653122",
            "label": "疏勒县", "value": "疏勒县",
            "pcode": "653100"
        },
        {
            "cityCode": "653123",
            "label": "英吉沙县", "value": "英吉沙县",
            "pcode": "653100"
        },
        {
            "cityCode": "653124",
            "label": "泽普县", "value": "泽普县",
            "pcode": "653100"
        },
        {
            "cityCode": "653125",
            "label": "莎车县", "value": "莎车县",
            "pcode": "653100"
        },
        {
            "cityCode": "653126",
            "label": "叶城县", "value": "叶城县",
            "pcode": "653100"
        },
        {
            "cityCode": "653127",
            "label": "麦盖提县", "value": "麦盖提县",
            "pcode": "653100"
        },
        {
            "cityCode": "653128",
            "label": "岳普湖县", "value": "岳普湖县",
            "pcode": "653100"
        },
        {
            "cityCode": "653129",
            "label": "伽师县", "value": "伽师县",
            "pcode": "653100"
        },
        {
            "cityCode": "653130",
            "label": "巴楚县", "value": "巴楚县",
            "pcode": "653100"
        },
        {
            "cityCode": "653131",
            "label": "塔什库尔干塔吉克自治县", "value": "塔什库尔干塔吉克自治县",
            "pcode": "653100"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "653200",
        "label": "和田地区", "value": "和田地区",
        "children": [{
            "cityCode": "653201",
            "label": "和田市", "value": "和田市",
            "pcode": "653200"
        },
        {
            "cityCode": "653221",
            "label": "和田县", "value": "和田县",
            "pcode": "653200"
        },
        {
            "cityCode": "653222",
            "label": "墨玉县", "value": "墨玉县",
            "pcode": "653200"
        },
        {
            "cityCode": "653223",
            "label": "皮山县", "value": "皮山县",
            "pcode": "653200"
        },
        {
            "cityCode": "653224",
            "label": "洛浦县", "value": "洛浦县",
            "pcode": "653200"
        },
        {
            "cityCode": "653225",
            "label": "策勒县", "value": "策勒县",
            "pcode": "653200"
        },
        {
            "cityCode": "653226",
            "label": "于田县", "value": "于田县",
            "pcode": "653200"
        },
        {
            "cityCode": "653227",
            "label": "民丰县", "value": "民丰县",
            "pcode": "653200"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "654000",
        "label": "伊犁哈萨克自治州", "value": "伊犁哈萨克自治州",
        "children": [{
            "cityCode": "654002",
            "label": "伊宁市", "value": "伊宁市",
            "pcode": "654000"
        },
        {
            "cityCode": "654003",
            "label": "奎屯市", "value": "奎屯市",
            "pcode": "654000"
        },
        {
            "cityCode": "654004",
            "label": "霍尔果斯市", "value": "霍尔果斯市",
            "pcode": "654000"
        },
        {
            "cityCode": "654021",
            "label": "伊宁县", "value": "伊宁县",
            "pcode": "654000"
        },
        {
            "cityCode": "654022",
            "label": "察布查尔锡伯自治县", "value": "察布查尔锡伯自治县",
            "pcode": "654000"
        },
        {
            "cityCode": "654023",
            "label": "霍城县", "value": "霍城县",
            "pcode": "654000"
        },
        {
            "cityCode": "654024",
            "label": "巩留县", "value": "巩留县",
            "pcode": "654000"
        },
        {
            "cityCode": "654025",
            "label": "新源县", "value": "新源县",
            "pcode": "654000"
        },
        {
            "cityCode": "654026",
            "label": "昭苏县", "value": "昭苏县",
            "pcode": "654000"
        },
        {
            "cityCode": "654027",
            "label": "特克斯县", "value": "特克斯县",
            "pcode": "654000"
        },
        {
            "cityCode": "654028",
            "label": "尼勒克县", "value": "尼勒克县",
            "pcode": "654000"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "654200",
        "label": "塔城地区", "value": "塔城地区",
        "children": [{
            "cityCode": "654201",
            "label": "塔城市", "value": "塔城市",
            "pcode": "654200"
        },
        {
            "cityCode": "654202",
            "label": "乌苏市", "value": "乌苏市",
            "pcode": "654200"
        },
        {
            "cityCode": "654221",
            "label": "额敏县", "value": "额敏县",
            "pcode": "654200"
        },
        {
            "cityCode": "654223",
            "label": "沙湾县", "value": "沙湾县",
            "pcode": "654200"
        },
        {
            "cityCode": "654224",
            "label": "托里县", "value": "托里县",
            "pcode": "654200"
        },
        {
            "cityCode": "654225",
            "label": "裕民县", "value": "裕民县",
            "pcode": "654200"
        },
        {
            "cityCode": "654226",
            "label": "和布克赛尔蒙古自治县", "value": "和布克赛尔蒙古自治县",
            "pcode": "654200"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "654300",
        "label": "阿勒泰地区", "value": "阿勒泰地区",
        "children": [{
            "cityCode": "654301",
            "label": "阿勒泰市", "value": "阿勒泰市",
            "pcode": "654300"
        },
        {
            "cityCode": "654321",
            "label": "布尔津县", "value": "布尔津县",
            "pcode": "654300"
        },
        {
            "cityCode": "654322",
            "label": "富蕴县", "value": "富蕴县",
            "pcode": "654300"
        },
        {
            "cityCode": "654323",
            "label": "福海县", "value": "福海县",
            "pcode": "654300"
        },
        {
            "cityCode": "654324",
            "label": "哈巴河县", "value": "哈巴河县",
            "pcode": "654300"
        },
        {
            "cityCode": "654325",
            "label": "青河县", "value": "青河县",
            "pcode": "654300"
        },
        {
            "cityCode": "654326",
            "label": "吉木乃县", "value": "吉木乃县",
            "pcode": "654300"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "659001",
        "label": "石河子市", "value": "石河子市",
        "children": [{
            "cityCode": "659001001",
            "label": "新城街道", "value": "新城街道",
            "pcode": "659001"
        },
        {
            "cityCode": "659001002",
            "label": "向阳街道", "value": "向阳街道",
            "pcode": "659001"
        },
        {
            "cityCode": "659001003",
            "label": "红山街道", "value": "红山街道",
            "pcode": "659001"
        },
        {
            "cityCode": "659001004",
            "label": "老街街道", "value": "老街街道",
            "pcode": "659001"
        },
        {
            "cityCode": "659001005",
            "label": "东城街道", "value": "东城街道",
            "pcode": "659001"
        },
        {
            "cityCode": "659001100",
            "label": "北泉镇", "value": "北泉镇",
            "pcode": "659001"
        },
        {
            "cityCode": "659001200",
            "label": "石河子乡", "value": "石河子乡",
            "pcode": "659001"
        },
        {
            "cityCode": "659001500",
            "label": "兵团一五二团", "value": "兵团一五二团",
            "pcode": "659001"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "659002",
        "label": "阿拉尔市", "value": "阿拉尔市",
        "children": [{
            "cityCode": "659002001",
            "label": "金银川路街道", "value": "金银川路街道",
            "pcode": "659002"
        },
        {
            "cityCode": "659002002",
            "label": "幸福路街道", "value": "幸福路街道",
            "pcode": "659002"
        },
        {
            "cityCode": "659002003",
            "label": "青松路街道", "value": "青松路街道",
            "pcode": "659002"
        },
        {
            "cityCode": "659002004",
            "label": "南口街道", "value": "南口街道",
            "pcode": "659002"
        },
        {
            "cityCode": "659002200",
            "label": "托喀依乡", "value": "托喀依乡",
            "pcode": "659002"
        },
        {
            "cityCode": "659002402",
            "label": "工业园区", "value": "工业园区",
            "pcode": "659002"
        },
        {
            "cityCode": "659002500",
            "label": "兵团七团", "value": "兵团七团",
            "pcode": "659002"
        },
        {
            "cityCode": "659002501",
            "label": "兵团八团", "value": "兵团八团",
            "pcode": "659002"
        },
        {
            "cityCode": "659002503",
            "label": "兵团十团", "value": "兵团十团",
            "pcode": "659002"
        },
        {
            "cityCode": "659002504",
            "label": "兵团十一团", "value": "兵团十一团",
            "pcode": "659002"
        },
        {
            "cityCode": "659002505",
            "label": "兵团十二团", "value": "兵团十二团",
            "pcode": "659002"
        },
        {
            "cityCode": "659002506",
            "label": "兵团十三团", "value": "兵团十三团",
            "pcode": "659002"
        },
        {
            "cityCode": "659002507",
            "label": "兵团十四团", "value": "兵团十四团",
            "pcode": "659002"
        },
        {
            "cityCode": "659002509",
            "label": "兵团十六团", "value": "兵团十六团",
            "pcode": "659002"
        },
        {
            "cityCode": "659002511",
            "label": "兵团第一师水利水电工程处", "value": "兵团第一师水利水电工程处",
            "pcode": "659002"
        },
        {
            "cityCode": "659002512",
            "label": "兵团第一师塔里木灌区水利管理处", "value": "兵团第一师塔里木灌区水利管理处",
            "pcode": "659002"
        },
        {
            "cityCode": "659002513",
            "label": "阿拉尔农场", "value": "阿拉尔农场",
            "pcode": "659002"
        },
        {
            "cityCode": "659002514",
            "label": "兵团第一师幸福农场", "value": "兵团第一师幸福农场",
            "pcode": "659002"
        },
        {
            "cityCode": "659002515",
            "label": "中心监狱", "value": "中心监狱",
            "pcode": "659002"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "659003",
        "label": "图木舒克市", "value": "图木舒克市",
        "children": [{
            "cityCode": "659003001",
            "label": "齐干却勒街道", "value": "齐干却勒街道",
            "pcode": "659003"
        },
        {
            "cityCode": "659003002",
            "label": "前海街道", "value": "前海街道",
            "pcode": "659003"
        },
        {
            "cityCode": "659003003",
            "label": "永安坝街道", "value": "永安坝街道",
            "pcode": "659003"
        },
        {
            "cityCode": "659003504",
            "label": "兵团四十四团", "value": "兵团四十四团",
            "pcode": "659003"
        },
        {
            "cityCode": "659003509",
            "label": "兵团四十九团", "value": "兵团四十九团",
            "pcode": "659003"
        },
        {
            "cityCode": "659003510",
            "label": "兵团五十团", "value": "兵团五十团",
            "pcode": "659003"
        },
        {
            "cityCode": "659003511",
            "label": "兵团五十一团", "value": "兵团五十一团",
            "pcode": "659003"
        },
        {
            "cityCode": "659003513",
            "label": "兵团五十三团", "value": "兵团五十三团",
            "pcode": "659003"
        },
        {
            "cityCode": "659003514",
            "label": "兵团图木舒克市喀拉拜勒镇", "value": "兵团图木舒克市喀拉拜勒镇",
            "pcode": "659003"
        },
        {
            "cityCode": "659003515",
            "label": "兵团图木舒克市永安坝", "value": "兵团图木舒克市永安坝",
            "pcode": "659003"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "659004",
        "label": "五家渠市", "value": "五家渠市",
        "children": [{
            "cityCode": "659004001",
            "label": "军垦路街道", "value": "军垦路街道",
            "pcode": "659004"
        },
        {
            "cityCode": "659004002",
            "label": "青湖路街道", "value": "青湖路街道",
            "pcode": "659004"
        },
        {
            "cityCode": "659004003",
            "label": "人民路街道", "value": "人民路街道",
            "pcode": "659004"
        },
        {
            "cityCode": "659004500",
            "label": "兵团一零一团", "value": "兵团一零一团",
            "pcode": "659004"
        },
        {
            "cityCode": "659004501",
            "label": "兵团一零二团", "value": "兵团一零二团",
            "pcode": "659004"
        },
        {
            "cityCode": "659004502",
            "label": "兵团一零三团", "value": "兵团一零三团",
            "pcode": "659004"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "659005",
        "label": "北屯市", "value": "北屯市",
        "children": [{
            "cityCode": "659005100",
            "label": "北屯镇", "value": "北屯镇",
            "pcode": "659005"
        },
        {
            "cityCode": "659005501",
            "label": "兵团一八八团", "value": "兵团一八八团",
            "pcode": "659005"
        },
        {
            "cityCode": "659005502",
            "label": "兵团一八七团", "value": "兵团一八七团",
            "pcode": "659005"
        },
        {
            "cityCode": "659005503",
            "label": "兵团一八三团", "value": "兵团一八三团",
            "pcode": "659005"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "659006",
        "label": "铁门关市", "value": "铁门关市",
        "children": [{
            "cityCode": "659006501",
            "label": "兵团二十九团", "value": "兵团二十九团",
            "pcode": "659006"
        },
        {
            "cityCode": "659006502",
            "label": "农二师三十团", "value": "农二师三十团",
            "pcode": "659006"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "659007",
        "label": "双河市", "value": "双河市",
        "children": [{
            "cityCode": "659007501",
            "label": "兵团八十一团", "value": "兵团八十一团",
            "pcode": "659007"
        },
        {
            "cityCode": "659007502",
            "label": "兵团八十四团", "value": "兵团八十四团",
            "pcode": "659007"
        },
        {
            "cityCode": "659007504",
            "label": "兵团八十六团", "value": "兵团八十六团",
            "pcode": "659007"
        },
        {
            "cityCode": "659007505",
            "label": "兵团八十九团", "value": "兵团八十九团",
            "pcode": "659007"
        },
        {
            "cityCode": "659007506",
            "label": "兵团九十团", "value": "兵团九十团",
            "pcode": "659007"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "659008",
        "label": "可克达拉市", "value": "可克达拉市",
        "children": [{
            "cityCode": "659008408",
            "label": "都拉塔口岸", "value": "都拉塔口岸",
            "pcode": "659008"
        },
        {
            "cityCode": "659008502",
            "label": "兵团六十七团", "value": "兵团六十七团",
            "pcode": "659008"
        },
        {
            "cityCode": "659008503",
            "label": "兵团六十八团", "value": "兵团六十八团",
            "pcode": "659008"
        },
        {
            "cityCode": "659008507",
            "label": "兵团六十三团", "value": "兵团六十三团",
            "pcode": "659008"
        },
        {
            "cityCode": "659008508",
            "label": "兵团六十四团", "value": "兵团六十四团",
            "pcode": "659008"
        },
        {
            "cityCode": "659008509",
            "label": "兵团六十六团", "value": "兵团六十六团",
            "pcode": "659008"
        }],
        "pcode": "650000"
    },
    {
        "cityCode": "659009",
        "label": "昆玉市", "value": "昆玉市",
        "children": [{
            "cityCode": "659009100",
            "label": "喀拉喀什镇", "value": "喀拉喀什镇",
            "pcode": "659009"
        },
        {
            "cityCode": "659009200",
            "label": "乌尔其乡", "value": "乌尔其乡",
            "pcode": "659009"
        },
        {
            "cityCode": "659009201",
            "label": "普恰克其乡", "value": "普恰克其乡",
            "pcode": "659009"
        },
        {
            "cityCode": "659009202",
            "label": "阔依其乡", "value": "阔依其乡",
            "pcode": "659009"
        },
        {
            "cityCode": "659009203",
            "label": "乌鲁克萨依乡", "value": "乌鲁克萨依乡",
            "pcode": "659009"
        },
        {
            "cityCode": "659009204",
            "label": "奴尔乡", "value": "奴尔乡",
            "pcode": "659009"
        },
        {
            "cityCode": "659009205",
            "label": "博斯坦乡", "value": "博斯坦乡",
            "pcode": "659009"
        },
        {
            "cityCode": "659009500",
            "label": "兵团皮山农场", "value": "兵团皮山农场",
            "pcode": "659009"
        },
        {
            "cityCode": "659009501",
            "label": "兵团二二四团", "value": "兵团二二四团",
            "pcode": "659009"
        },
        {
            "cityCode": "659009502",
            "label": "兵团四十七团", "value": "兵团四十七团",
            "pcode": "659009"
        },
        {
            "cityCode": "659009503",
            "label": "兵团一牧场", "value": "兵团一牧场",
            "pcode": "659009"
        }],
        "pcode": "650000"
    }]
},
{
    "cityCode": "710000",
    "label": "台湾省", "value": "台湾省",
    "children": [{
        "cityCode": "710100",
        "label": "台北市", "value": "台北市",
        "children": [{
            "cityCode": "710101",
            "label": "中正区", "value": "中正区",
            "pcode": "710100"
        },
        {
            "cityCode": "710102",
            "label": "大同区", "value": "大同区",
            "pcode": "710100"
        },
        {
            "cityCode": "710103",
            "label": "中山区", "value": "中山区",
            "pcode": "710100"
        },
        {
            "cityCode": "710104",
            "label": "松山区", "value": "松山区",
            "pcode": "710100"
        },
        {
            "cityCode": "710105",
            "label": "大安区", "value": "大安区",
            "pcode": "710100"
        },
        {
            "cityCode": "710106",
            "label": "万华区", "value": "万华区",
            "pcode": "710100"
        },
        {
            "cityCode": "710107",
            "label": "信义区", "value": "信义区",
            "pcode": "710100"
        },
        {
            "cityCode": "710108",
            "label": "士林区", "value": "士林区",
            "pcode": "710100"
        },
        {
            "cityCode": "710109",
            "label": "北投区", "value": "北投区",
            "pcode": "710100"
        },
        {
            "cityCode": "710110",
            "label": "内湖区", "value": "内湖区",
            "pcode": "710100"
        },
        {
            "cityCode": "710111",
            "label": "南港区", "value": "南港区",
            "pcode": "710100"
        },
        {
            "cityCode": "710112",
            "label": "文山区", "value": "文山区",
            "pcode": "710100"
        },
        {
            "cityCode": "710113",
            "label": "其它区", "value": "其它区",
            "pcode": "710100"
        }],
        "pcode": "710000"
    },
    {
        "cityCode": "710200",
        "label": "高雄市", "value": "高雄市",
        "children": [{
            "cityCode": "710201",
            "label": "新兴区", "value": "新兴区",
            "pcode": "710200"
        },
        {
            "cityCode": "710202",
            "label": "前金区", "value": "前金区",
            "pcode": "710200"
        },
        {
            "cityCode": "710203",
            "label": "芩雅区", "value": "芩雅区",
            "pcode": "710200"
        },
        {
            "cityCode": "710204",
            "label": "盐埕区", "value": "盐埕区",
            "pcode": "710200"
        },
        {
            "cityCode": "710205",
            "label": "鼓山区", "value": "鼓山区",
            "pcode": "710200"
        },
        {
            "cityCode": "710206",
            "label": "旗津区", "value": "旗津区",
            "pcode": "710200"
        },
        {
            "cityCode": "710207",
            "label": "前镇区", "value": "前镇区",
            "pcode": "710200"
        },
        {
            "cityCode": "710208",
            "label": "三民区", "value": "三民区",
            "pcode": "710200"
        },
        {
            "cityCode": "710209",
            "label": "左营区", "value": "左营区",
            "pcode": "710200"
        },
        {
            "cityCode": "710210",
            "label": "楠梓区", "value": "楠梓区",
            "pcode": "710200"
        },
        {
            "cityCode": "710211",
            "label": "小港区", "value": "小港区",
            "pcode": "710200"
        },
        {
            "cityCode": "710212",
            "label": "其它区", "value": "其它区",
            "pcode": "710200"
        },
        {
            "cityCode": "710241",
            "label": "苓雅区", "value": "苓雅区",
            "pcode": "710200"
        },
        {
            "cityCode": "710242",
            "label": "仁武区", "value": "仁武区",
            "pcode": "710200"
        },
        {
            "cityCode": "710243",
            "label": "大社区", "value": "大社区",
            "pcode": "710200"
        },
        {
            "cityCode": "710244",
            "label": "冈山区", "value": "冈山区",
            "pcode": "710200"
        },
        {
            "cityCode": "710245",
            "label": "路竹区", "value": "路竹区",
            "pcode": "710200"
        },
        {
            "cityCode": "710246",
            "label": "阿莲区", "value": "阿莲区",
            "pcode": "710200"
        },
        {
            "cityCode": "710247",
            "label": "田寮区", "value": "田寮区",
            "pcode": "710200"
        },
        {
            "cityCode": "710248",
            "label": "燕巢区", "value": "燕巢区",
            "pcode": "710200"
        },
        {
            "cityCode": "710249",
            "label": "桥头区", "value": "桥头区",
            "pcode": "710200"
        },
        {
            "cityCode": "710250",
            "label": "梓官区", "value": "梓官区",
            "pcode": "710200"
        },
        {
            "cityCode": "710251",
            "label": "弥陀区", "value": "弥陀区",
            "pcode": "710200"
        },
        {
            "cityCode": "710252",
            "label": "永安区", "value": "永安区",
            "pcode": "710200"
        },
        {
            "cityCode": "710253",
            "label": "湖内区", "value": "湖内区",
            "pcode": "710200"
        },
        {
            "cityCode": "710254",
            "label": "凤山区", "value": "凤山区",
            "pcode": "710200"
        },
        {
            "cityCode": "710255",
            "label": "大寮区", "value": "大寮区",
            "pcode": "710200"
        },
        {
            "cityCode": "710256",
            "label": "林园区", "value": "林园区",
            "pcode": "710200"
        },
        {
            "cityCode": "710257",
            "label": "鸟松区", "value": "鸟松区",
            "pcode": "710200"
        },
        {
            "cityCode": "710258",
            "label": "大树区", "value": "大树区",
            "pcode": "710200"
        },
        {
            "cityCode": "710259",
            "label": "旗山区", "value": "旗山区",
            "pcode": "710200"
        },
        {
            "cityCode": "710260",
            "label": "美浓区", "value": "美浓区",
            "pcode": "710200"
        },
        {
            "cityCode": "710261",
            "label": "六龟区", "value": "六龟区",
            "pcode": "710200"
        },
        {
            "cityCode": "710262",
            "label": "内门区", "value": "内门区",
            "pcode": "710200"
        },
        {
            "cityCode": "710263",
            "label": "杉林区", "value": "杉林区",
            "pcode": "710200"
        },
        {
            "cityCode": "710264",
            "label": "甲仙区", "value": "甲仙区",
            "pcode": "710200"
        },
        {
            "cityCode": "710265",
            "label": "桃源区", "value": "桃源区",
            "pcode": "710200"
        },
        {
            "cityCode": "710266",
            "label": "那玛夏区", "value": "那玛夏区",
            "pcode": "710200"
        },
        {
            "cityCode": "710267",
            "label": "茂林区", "value": "茂林区",
            "pcode": "710200"
        },
        {
            "cityCode": "710268",
            "label": "茄萣区", "value": "茄萣区",
            "pcode": "710200"
        }],
        "pcode": "710000"
    },
    {
        "cityCode": "710300",
        "label": "台南市", "value": "台南市",
        "children": [{
            "cityCode": "710301",
            "label": "中西区", "value": "中西区",
            "pcode": "710300"
        },
        {
            "cityCode": "710302",
            "label": "东区", "value": "东区",
            "pcode": "710300"
        },
        {
            "cityCode": "710303",
            "label": "南区", "value": "南区",
            "pcode": "710300"
        },
        {
            "cityCode": "710304",
            "label": "北区", "value": "北区",
            "pcode": "710300"
        },
        {
            "cityCode": "710305",
            "label": "安平区", "value": "安平区",
            "pcode": "710300"
        },
        {
            "cityCode": "710306",
            "label": "安南区", "value": "安南区",
            "pcode": "710300"
        },
        {
            "cityCode": "710307",
            "label": "其它区", "value": "其它区",
            "pcode": "710300"
        },
        {
            "cityCode": "710339",
            "label": "永康区", "value": "永康区",
            "pcode": "710300"
        },
        {
            "cityCode": "710340",
            "label": "归仁区", "value": "归仁区",
            "pcode": "710300"
        },
        {
            "cityCode": "710341",
            "label": "新化区", "value": "新化区",
            "pcode": "710300"
        },
        {
            "cityCode": "710342",
            "label": "左镇区", "value": "左镇区",
            "pcode": "710300"
        },
        {
            "cityCode": "710343",
            "label": "玉井区", "value": "玉井区",
            "pcode": "710300"
        },
        {
            "cityCode": "710344",
            "label": "楠西区", "value": "楠西区",
            "pcode": "710300"
        },
        {
            "cityCode": "710345",
            "label": "南化区", "value": "南化区",
            "pcode": "710300"
        },
        {
            "cityCode": "710346",
            "label": "仁德区", "value": "仁德区",
            "pcode": "710300"
        },
        {
            "cityCode": "710347",
            "label": "关庙区", "value": "关庙区",
            "pcode": "710300"
        },
        {
            "cityCode": "710348",
            "label": "龙崎区", "value": "龙崎区",
            "pcode": "710300"
        },
        {
            "cityCode": "710349",
            "label": "官田区", "value": "官田区",
            "pcode": "710300"
        },
        {
            "cityCode": "710350",
            "label": "麻豆区", "value": "麻豆区",
            "pcode": "710300"
        },
        {
            "cityCode": "710351",
            "label": "佳里区", "value": "佳里区",
            "pcode": "710300"
        },
        {
            "cityCode": "710352",
            "label": "西港区", "value": "西港区",
            "pcode": "710300"
        },
        {
            "cityCode": "710353",
            "label": "七股区", "value": "七股区",
            "pcode": "710300"
        },
        {
            "cityCode": "710354",
            "label": "将军区", "value": "将军区",
            "pcode": "710300"
        },
        {
            "cityCode": "710355",
            "label": "学甲区", "value": "学甲区",
            "pcode": "710300"
        },
        {
            "cityCode": "710356",
            "label": "北门区", "value": "北门区",
            "pcode": "710300"
        },
        {
            "cityCode": "710357",
            "label": "新营区", "value": "新营区",
            "pcode": "710300"
        },
        {
            "cityCode": "710358",
            "label": "后壁区", "value": "后壁区",
            "pcode": "710300"
        },
        {
            "cityCode": "710359",
            "label": "白河区", "value": "白河区",
            "pcode": "710300"
        },
        {
            "cityCode": "710360",
            "label": "东山区", "value": "东山区",
            "pcode": "710300"
        },
        {
            "cityCode": "710361",
            "label": "六甲区", "value": "六甲区",
            "pcode": "710300"
        },
        {
            "cityCode": "710362",
            "label": "下营区", "value": "下营区",
            "pcode": "710300"
        },
        {
            "cityCode": "710363",
            "label": "柳营区", "value": "柳营区",
            "pcode": "710300"
        },
        {
            "cityCode": "710364",
            "label": "盐水区", "value": "盐水区",
            "pcode": "710300"
        },
        {
            "cityCode": "710365",
            "label": "善化区", "value": "善化区",
            "pcode": "710300"
        },
        {
            "cityCode": "710366",
            "label": "大内区", "value": "大内区",
            "pcode": "710300"
        },
        {
            "cityCode": "710367",
            "label": "山上区", "value": "山上区",
            "pcode": "710300"
        },
        {
            "cityCode": "710368",
            "label": "新市区", "value": "新市区",
            "pcode": "710300"
        },
        {
            "cityCode": "710369",
            "label": "安定区", "value": "安定区",
            "pcode": "710300"
        }],
        "pcode": "710000"
    },
    {
        "cityCode": "710400",
        "label": "台中市", "value": "台中市",
        "children": [{
            "cityCode": "710401",
            "label": "中区", "value": "中区",
            "pcode": "710400"
        },
        {
            "cityCode": "710402",
            "label": "东区", "value": "东区",
            "pcode": "710400"
        },
        {
            "cityCode": "710403",
            "label": "南区", "value": "南区",
            "pcode": "710400"
        },
        {
            "cityCode": "710404",
            "label": "西区", "value": "西区",
            "pcode": "710400"
        },
        {
            "cityCode": "710405",
            "label": "北区", "value": "北区",
            "pcode": "710400"
        },
        {
            "cityCode": "710406",
            "label": "北屯区", "value": "北屯区",
            "pcode": "710400"
        },
        {
            "cityCode": "710407",
            "label": "西屯区", "value": "西屯区",
            "pcode": "710400"
        },
        {
            "cityCode": "710408",
            "label": "南屯区", "value": "南屯区",
            "pcode": "710400"
        },
        {
            "cityCode": "710409",
            "label": "其它区", "value": "其它区",
            "pcode": "710400"
        },
        {
            "cityCode": "710431",
            "label": "太平区", "value": "太平区",
            "pcode": "710400"
        },
        {
            "cityCode": "710432",
            "label": "大里区", "value": "大里区",
            "pcode": "710400"
        },
        {
            "cityCode": "710433",
            "label": "雾峰区", "value": "雾峰区",
            "pcode": "710400"
        },
        {
            "cityCode": "710434",
            "label": "乌日区", "value": "乌日区",
            "pcode": "710400"
        },
        {
            "cityCode": "710435",
            "label": "丰原区", "value": "丰原区",
            "pcode": "710400"
        },
        {
            "cityCode": "710436",
            "label": "后里区", "value": "后里区",
            "pcode": "710400"
        },
        {
            "cityCode": "710437",
            "label": "石冈区", "value": "石冈区",
            "pcode": "710400"
        },
        {
            "cityCode": "710438",
            "label": "东势区", "value": "东势区",
            "pcode": "710400"
        },
        {
            "cityCode": "710439",
            "label": "和平区", "value": "和平区",
            "pcode": "710400"
        },
        {
            "cityCode": "710440",
            "label": "新社区", "value": "新社区",
            "pcode": "710400"
        },
        {
            "cityCode": "710441",
            "label": "潭子区", "value": "潭子区",
            "pcode": "710400"
        },
        {
            "cityCode": "710442",
            "label": "大雅区", "value": "大雅区",
            "pcode": "710400"
        },
        {
            "cityCode": "710443",
            "label": "神冈区", "value": "神冈区",
            "pcode": "710400"
        },
        {
            "cityCode": "710444",
            "label": "大肚区", "value": "大肚区",
            "pcode": "710400"
        },
        {
            "cityCode": "710445",
            "label": "沙鹿区", "value": "沙鹿区",
            "pcode": "710400"
        },
        {
            "cityCode": "710446",
            "label": "龙井区", "value": "龙井区",
            "pcode": "710400"
        },
        {
            "cityCode": "710447",
            "label": "梧栖区", "value": "梧栖区",
            "pcode": "710400"
        },
        {
            "cityCode": "710448",
            "label": "清水区", "value": "清水区",
            "pcode": "710400"
        },
        {
            "cityCode": "710449",
            "label": "大甲区", "value": "大甲区",
            "pcode": "710400"
        },
        {
            "cityCode": "710450",
            "label": "外埔区", "value": "外埔区",
            "pcode": "710400"
        },
        {
            "cityCode": "710451",
            "label": "大安区", "value": "大安区",
            "pcode": "710400"
        }],
        "pcode": "710000"
    },
    {
        "cityCode": "710500",
        "label": "金门县", "value": "金门县",
        "children": [{
            "cityCode": "710507",
            "label": "金沙镇", "value": "金沙镇",
            "pcode": "710500"
        },
        {
            "cityCode": "710508",
            "label": "金湖镇", "value": "金湖镇",
            "pcode": "710500"
        },
        {
            "cityCode": "710509",
            "label": "金宁乡", "value": "金宁乡",
            "pcode": "710500"
        },
        {
            "cityCode": "710510",
            "label": "金城镇", "value": "金城镇",
            "pcode": "710500"
        },
        {
            "cityCode": "710511",
            "label": "烈屿乡", "value": "烈屿乡",
            "pcode": "710500"
        },
        {
            "cityCode": "710512",
            "label": "乌坵乡", "value": "乌坵乡",
            "pcode": "710500"
        }],
        "pcode": "710000"
    },
    {
        "cityCode": "710600",
        "label": "南投县", "value": "南投县",
        "children": [{
            "cityCode": "710614",
            "label": "南投市", "value": "南投市",
            "pcode": "710600"
        },
        {
            "cityCode": "710615",
            "label": "中寮乡", "value": "中寮乡",
            "pcode": "710600"
        },
        {
            "cityCode": "710616",
            "label": "草屯镇", "value": "草屯镇",
            "pcode": "710600"
        },
        {
            "cityCode": "710617",
            "label": "国姓乡", "value": "国姓乡",
            "pcode": "710600"
        },
        {
            "cityCode": "710618",
            "label": "埔里镇", "value": "埔里镇",
            "pcode": "710600"
        },
        {
            "cityCode": "710619",
            "label": "仁爱乡", "value": "仁爱乡",
            "pcode": "710600"
        },
        {
            "cityCode": "710620",
            "label": "名间乡", "value": "名间乡",
            "pcode": "710600"
        },
        {
            "cityCode": "710621",
            "label": "集集镇", "value": "集集镇",
            "pcode": "710600"
        },
        {
            "cityCode": "710622",
            "label": "水里乡", "value": "水里乡",
            "pcode": "710600"
        },
        {
            "cityCode": "710623",
            "label": "鱼池乡", "value": "鱼池乡",
            "pcode": "710600"
        },
        {
            "cityCode": "710624",
            "label": "信义乡", "value": "信义乡",
            "pcode": "710600"
        },
        {
            "cityCode": "710625",
            "label": "竹山镇", "value": "竹山镇",
            "pcode": "710600"
        },
        {
            "cityCode": "710626",
            "label": "鹿谷乡", "value": "鹿谷乡",
            "pcode": "710600"
        }],
        "pcode": "710000"
    },
    {
        "cityCode": "710700",
        "label": "基隆市", "value": "基隆市",
        "children": [{
            "cityCode": "710701",
            "label": "仁爱区", "value": "仁爱区",
            "pcode": "710700"
        },
        {
            "cityCode": "710702",
            "label": "信义区", "value": "信义区",
            "pcode": "710700"
        },
        {
            "cityCode": "710703",
            "label": "中正区", "value": "中正区",
            "pcode": "710700"
        },
        {
            "cityCode": "710704",
            "label": "中山区", "value": "中山区",
            "pcode": "710700"
        },
        {
            "cityCode": "710705",
            "label": "安乐区", "value": "安乐区",
            "pcode": "710700"
        },
        {
            "cityCode": "710706",
            "label": "暖暖区", "value": "暖暖区",
            "pcode": "710700"
        },
        {
            "cityCode": "710707",
            "label": "七堵区", "value": "七堵区",
            "pcode": "710700"
        },
        {
            "cityCode": "710708",
            "label": "其它区", "value": "其它区",
            "pcode": "710700"
        }],
        "pcode": "710000"
    },
    {
        "cityCode": "710800",
        "label": "新竹市", "value": "新竹市",
        "children": [{
            "cityCode": "710801",
            "label": "东区", "value": "东区",
            "pcode": "710800"
        },
        {
            "cityCode": "710802",
            "label": "北区", "value": "北区",
            "pcode": "710800"
        },
        {
            "cityCode": "710803",
            "label": "香山区", "value": "香山区",
            "pcode": "710800"
        },
        {
            "cityCode": "710804",
            "label": "其它区", "value": "其它区",
            "pcode": "710800"
        }],
        "pcode": "710000"
    },
    {
        "cityCode": "710900",
        "label": "嘉义市", "value": "嘉义市",
        "children": [{
            "cityCode": "710901",
            "label": "东区", "value": "东区",
            "pcode": "710900"
        },
        {
            "cityCode": "710902",
            "label": "西区", "value": "西区",
            "pcode": "710900"
        },
        {
            "cityCode": "710903",
            "label": "其它区", "value": "其它区",
            "pcode": "710900"
        }],
        "pcode": "710000"
    },
    {
        "cityCode": "711100",
        "label": "新北市", "value": "新北市",
        "children": [{
            "cityCode": "711130",
            "label": "万里区", "value": "万里区",
            "pcode": "711100"
        },
        {
            "cityCode": "711131",
            "label": "金山区", "value": "金山区",
            "pcode": "711100"
        },
        {
            "cityCode": "711132",
            "label": "板桥区", "value": "板桥区",
            "pcode": "711100"
        },
        {
            "cityCode": "711133",
            "label": "汐止区", "value": "汐止区",
            "pcode": "711100"
        },
        {
            "cityCode": "711134",
            "label": "深坑区", "value": "深坑区",
            "pcode": "711100"
        },
        {
            "cityCode": "711135",
            "label": "石碇区", "value": "石碇区",
            "pcode": "711100"
        },
        {
            "cityCode": "711136",
            "label": "瑞芳区", "value": "瑞芳区",
            "pcode": "711100"
        },
        {
            "cityCode": "711137",
            "label": "平溪区", "value": "平溪区",
            "pcode": "711100"
        },
        {
            "cityCode": "711138",
            "label": "双溪区", "value": "双溪区",
            "pcode": "711100"
        },
        {
            "cityCode": "711139",
            "label": "贡寮区", "value": "贡寮区",
            "pcode": "711100"
        },
        {
            "cityCode": "711140",
            "label": "新店区", "value": "新店区",
            "pcode": "711100"
        },
        {
            "cityCode": "711141",
            "label": "坪林区", "value": "坪林区",
            "pcode": "711100"
        },
        {
            "cityCode": "711142",
            "label": "乌来区", "value": "乌来区",
            "pcode": "711100"
        },
        {
            "cityCode": "711143",
            "label": "永和区", "value": "永和区",
            "pcode": "711100"
        },
        {
            "cityCode": "711144",
            "label": "中和区", "value": "中和区",
            "pcode": "711100"
        },
        {
            "cityCode": "711145",
            "label": "土城区", "value": "土城区",
            "pcode": "711100"
        },
        {
            "cityCode": "711146",
            "label": "三峡区", "value": "三峡区",
            "pcode": "711100"
        },
        {
            "cityCode": "711147",
            "label": "树林区", "value": "树林区",
            "pcode": "711100"
        },
        {
            "cityCode": "711148",
            "label": "莺歌区", "value": "莺歌区",
            "pcode": "711100"
        },
        {
            "cityCode": "711149",
            "label": "三重区", "value": "三重区",
            "pcode": "711100"
        },
        {
            "cityCode": "711150",
            "label": "新庄区", "value": "新庄区",
            "pcode": "711100"
        },
        {
            "cityCode": "711151",
            "label": "泰山区", "value": "泰山区",
            "pcode": "711100"
        },
        {
            "cityCode": "711152",
            "label": "林口区", "value": "林口区",
            "pcode": "711100"
        },
        {
            "cityCode": "711153",
            "label": "芦洲区", "value": "芦洲区",
            "pcode": "711100"
        },
        {
            "cityCode": "711154",
            "label": "五股区", "value": "五股区",
            "pcode": "711100"
        },
        {
            "cityCode": "711155",
            "label": "八里区", "value": "八里区",
            "pcode": "711100"
        },
        {
            "cityCode": "711156",
            "label": "淡水区", "value": "淡水区",
            "pcode": "711100"
        },
        {
            "cityCode": "711157",
            "label": "三芝区", "value": "三芝区",
            "pcode": "711100"
        },
        {
            "cityCode": "711158",
            "label": "石门区", "value": "石门区",
            "pcode": "711100"
        }],
        "pcode": "710000"
    },
    {
        "cityCode": "711200",
        "label": "宜兰县", "value": "宜兰县",
        "children": [{
            "cityCode": "711214",
            "label": "宜兰市", "value": "宜兰市",
            "pcode": "711200"
        },
        {
            "cityCode": "711215",
            "label": "头城镇", "value": "头城镇",
            "pcode": "711200"
        },
        {
            "cityCode": "711216",
            "label": "礁溪乡", "value": "礁溪乡",
            "pcode": "711200"
        },
        {
            "cityCode": "711217",
            "label": "壮围乡", "value": "壮围乡",
            "pcode": "711200"
        },
        {
            "cityCode": "711218",
            "label": "员山乡", "value": "员山乡",
            "pcode": "711200"
        },
        {
            "cityCode": "711219",
            "label": "罗东镇", "value": "罗东镇",
            "pcode": "711200"
        },
        {
            "cityCode": "711220",
            "label": "三星乡", "value": "三星乡",
            "pcode": "711200"
        },
        {
            "cityCode": "711221",
            "label": "大同乡", "value": "大同乡",
            "pcode": "711200"
        },
        {
            "cityCode": "711222",
            "label": "五结乡", "value": "五结乡",
            "pcode": "711200"
        },
        {
            "cityCode": "711223",
            "label": "冬山乡", "value": "冬山乡",
            "pcode": "711200"
        },
        {
            "cityCode": "711224",
            "label": "苏澳镇", "value": "苏澳镇",
            "pcode": "711200"
        },
        {
            "cityCode": "711225",
            "label": "南澳乡", "value": "南澳乡",
            "pcode": "711200"
        },
        {
            "cityCode": "711226",
            "label": "钓鱼台", "value": "钓鱼台",
            "pcode": "711200"
        }],
        "pcode": "710000"
    },
    {
        "cityCode": "711300",
        "label": "新竹县", "value": "新竹县",
        "children": [{
            "cityCode": "711314",
            "label": "竹北市", "value": "竹北市",
            "pcode": "711300"
        },
        {
            "cityCode": "711315",
            "label": "湖口乡", "value": "湖口乡",
            "pcode": "711300"
        },
        {
            "cityCode": "711316",
            "label": "新丰乡", "value": "新丰乡",
            "pcode": "711300"
        },
        {
            "cityCode": "711317",
            "label": "新埔镇", "value": "新埔镇",
            "pcode": "711300"
        },
        {
            "cityCode": "711318",
            "label": "关西镇", "value": "关西镇",
            "pcode": "711300"
        },
        {
            "cityCode": "711319",
            "label": "芎林乡", "value": "芎林乡",
            "pcode": "711300"
        },
        {
            "cityCode": "711320",
            "label": "宝山乡", "value": "宝山乡",
            "pcode": "711300"
        },
        {
            "cityCode": "711321",
            "label": "竹东镇", "value": "竹东镇",
            "pcode": "711300"
        },
        {
            "cityCode": "711322",
            "label": "五峰乡", "value": "五峰乡",
            "pcode": "711300"
        },
        {
            "cityCode": "711323",
            "label": "横山乡", "value": "横山乡",
            "pcode": "711300"
        },
        {
            "cityCode": "711324",
            "label": "尖石乡", "value": "尖石乡",
            "pcode": "711300"
        },
        {
            "cityCode": "711325",
            "label": "北埔乡", "value": "北埔乡",
            "pcode": "711300"
        },
        {
            "cityCode": "711326",
            "label": "峨眉乡", "value": "峨眉乡",
            "pcode": "711300"
        }],
        "pcode": "710000"
    },
    {
        "cityCode": "711400",
        "label": "桃园县", "value": "桃园县",
        "children": [{
            "cityCode": "711414",
            "label": "中坜市", "value": "中坜市",
            "pcode": "711400"
        },
        {
            "cityCode": "711415",
            "label": "平镇市", "value": "平镇市",
            "pcode": "711400"
        },
        {
            "cityCode": "711416",
            "label": "龙潭乡", "value": "龙潭乡",
            "pcode": "711400"
        },
        {
            "cityCode": "711417",
            "label": "杨梅市", "value": "杨梅市",
            "pcode": "711400"
        },
        {
            "cityCode": "711418",
            "label": "新屋乡", "value": "新屋乡",
            "pcode": "711400"
        },
        {
            "cityCode": "711419",
            "label": "观音乡", "value": "观音乡",
            "pcode": "711400"
        },
        {
            "cityCode": "711420",
            "label": "桃园市", "value": "桃园市",
            "pcode": "711400"
        },
        {
            "cityCode": "711421",
            "label": "龟山乡", "value": "龟山乡",
            "pcode": "711400"
        },
        {
            "cityCode": "711422",
            "label": "八德市", "value": "八德市",
            "pcode": "711400"
        },
        {
            "cityCode": "711423",
            "label": "大溪镇", "value": "大溪镇",
            "pcode": "711400"
        },
        {
            "cityCode": "711424",
            "label": "复兴乡", "value": "复兴乡",
            "pcode": "711400"
        },
        {
            "cityCode": "711425",
            "label": "大园乡", "value": "大园乡",
            "pcode": "711400"
        },
        {
            "cityCode": "711426",
            "label": "芦竹乡", "value": "芦竹乡",
            "pcode": "711400"
        }],
        "pcode": "710000"
    },
    {
        "cityCode": "711500",
        "label": "苗栗县", "value": "苗栗县",
        "children": [{
            "cityCode": "711519",
            "label": "竹南镇", "value": "竹南镇",
            "pcode": "711500"
        },
        {
            "cityCode": "711520",
            "label": "头份镇", "value": "头份镇",
            "pcode": "711500"
        },
        {
            "cityCode": "711521",
            "label": "三湾乡", "value": "三湾乡",
            "pcode": "711500"
        },
        {
            "cityCode": "711522",
            "label": "南庄乡", "value": "南庄乡",
            "pcode": "711500"
        },
        {
            "cityCode": "711523",
            "label": "狮潭乡", "value": "狮潭乡",
            "pcode": "711500"
        },
        {
            "cityCode": "711524",
            "label": "后龙镇", "value": "后龙镇",
            "pcode": "711500"
        },
        {
            "cityCode": "711525",
            "label": "通霄镇", "value": "通霄镇",
            "pcode": "711500"
        },
        {
            "cityCode": "711526",
            "label": "苑里镇", "value": "苑里镇",
            "pcode": "711500"
        },
        {
            "cityCode": "711527",
            "label": "苗栗市", "value": "苗栗市",
            "pcode": "711500"
        },
        {
            "cityCode": "711528",
            "label": "造桥乡", "value": "造桥乡",
            "pcode": "711500"
        },
        {
            "cityCode": "711529",
            "label": "头屋乡", "value": "头屋乡",
            "pcode": "711500"
        },
        {
            "cityCode": "711530",
            "label": "公馆乡", "value": "公馆乡",
            "pcode": "711500"
        },
        {
            "cityCode": "711531",
            "label": "大湖乡", "value": "大湖乡",
            "pcode": "711500"
        },
        {
            "cityCode": "711532",
            "label": "泰安乡", "value": "泰安乡",
            "pcode": "711500"
        },
        {
            "cityCode": "711533",
            "label": "铜锣乡", "value": "铜锣乡",
            "pcode": "711500"
        },
        {
            "cityCode": "711534",
            "label": "三义乡", "value": "三义乡",
            "pcode": "711500"
        },
        {
            "cityCode": "711535",
            "label": "西湖乡", "value": "西湖乡",
            "pcode": "711500"
        },
        {
            "cityCode": "711536",
            "label": "卓兰镇", "value": "卓兰镇",
            "pcode": "711500"
        }],
        "pcode": "710000"
    },
    {
        "cityCode": "711700",
        "label": "彰化县", "value": "彰化县",
        "children": [{
            "cityCode": "711727",
            "label": "彰化市", "value": "彰化市",
            "pcode": "711700"
        },
        {
            "cityCode": "711728",
            "label": "芬园乡", "value": "芬园乡",
            "pcode": "711700"
        },
        {
            "cityCode": "711729",
            "label": "花坛乡", "value": "花坛乡",
            "pcode": "711700"
        },
        {
            "cityCode": "711730",
            "label": "秀水乡", "value": "秀水乡",
            "pcode": "711700"
        },
        {
            "cityCode": "711731",
            "label": "鹿港镇", "value": "鹿港镇",
            "pcode": "711700"
        },
        {
            "cityCode": "711732",
            "label": "福兴乡", "value": "福兴乡",
            "pcode": "711700"
        },
        {
            "cityCode": "711733",
            "label": "线西乡", "value": "线西乡",
            "pcode": "711700"
        },
        {
            "cityCode": "711734",
            "label": "和美镇", "value": "和美镇",
            "pcode": "711700"
        },
        {
            "cityCode": "711735",
            "label": "伸港乡", "value": "伸港乡",
            "pcode": "711700"
        },
        {
            "cityCode": "711736",
            "label": "员林镇", "value": "员林镇",
            "pcode": "711700"
        },
        {
            "cityCode": "711737",
            "label": "社头乡", "value": "社头乡",
            "pcode": "711700"
        },
        {
            "cityCode": "711738",
            "label": "永靖乡", "value": "永靖乡",
            "pcode": "711700"
        },
        {
            "cityCode": "711739",
            "label": "埔心乡", "value": "埔心乡",
            "pcode": "711700"
        },
        {
            "cityCode": "711740",
            "label": "溪湖镇", "value": "溪湖镇",
            "pcode": "711700"
        },
        {
            "cityCode": "711741",
            "label": "大村乡", "value": "大村乡",
            "pcode": "711700"
        },
        {
            "cityCode": "711742",
            "label": "埔盐乡", "value": "埔盐乡",
            "pcode": "711700"
        },
        {
            "cityCode": "711743",
            "label": "田中镇", "value": "田中镇",
            "pcode": "711700"
        },
        {
            "cityCode": "711744",
            "label": "北斗镇", "value": "北斗镇",
            "pcode": "711700"
        },
        {
            "cityCode": "711745",
            "label": "田尾乡", "value": "田尾乡",
            "pcode": "711700"
        },
        {
            "cityCode": "711746",
            "label": "埤头乡", "value": "埤头乡",
            "pcode": "711700"
        },
        {
            "cityCode": "711747",
            "label": "溪州乡", "value": "溪州乡",
            "pcode": "711700"
        },
        {
            "cityCode": "711748",
            "label": "竹塘乡", "value": "竹塘乡",
            "pcode": "711700"
        },
        {
            "cityCode": "711749",
            "label": "二林镇", "value": "二林镇",
            "pcode": "711700"
        },
        {
            "cityCode": "711750",
            "label": "大城乡", "value": "大城乡",
            "pcode": "711700"
        },
        {
            "cityCode": "711751",
            "label": "芳苑乡", "value": "芳苑乡",
            "pcode": "711700"
        },
        {
            "cityCode": "711752",
            "label": "二水乡", "value": "二水乡",
            "pcode": "711700"
        }],
        "pcode": "710000"
    },
    {
        "cityCode": "711900",
        "label": "嘉义县", "value": "嘉义县",
        "children": [{
            "cityCode": "711919",
            "label": "番路乡", "value": "番路乡",
            "pcode": "711900"
        },
        {
            "cityCode": "711920",
            "label": "梅山乡", "value": "梅山乡",
            "pcode": "711900"
        },
        {
            "cityCode": "711921",
            "label": "竹崎乡", "value": "竹崎乡",
            "pcode": "711900"
        },
        {
            "cityCode": "711922",
            "label": "阿里山乡", "value": "阿里山乡",
            "pcode": "711900"
        },
        {
            "cityCode": "711923",
            "label": "中埔乡", "value": "中埔乡",
            "pcode": "711900"
        },
        {
            "cityCode": "711924",
            "label": "大埔乡", "value": "大埔乡",
            "pcode": "711900"
        },
        {
            "cityCode": "711925",
            "label": "水上乡", "value": "水上乡",
            "pcode": "711900"
        },
        {
            "cityCode": "711926",
            "label": "鹿草乡", "value": "鹿草乡",
            "pcode": "711900"
        },
        {
            "cityCode": "711927",
            "label": "太保市", "value": "太保市",
            "pcode": "711900"
        },
        {
            "cityCode": "711928",
            "label": "朴子市", "value": "朴子市",
            "pcode": "711900"
        },
        {
            "cityCode": "711929",
            "label": "东石乡", "value": "东石乡",
            "pcode": "711900"
        },
        {
            "cityCode": "711930",
            "label": "六脚乡", "value": "六脚乡",
            "pcode": "711900"
        },
        {
            "cityCode": "711931",
            "label": "新港乡", "value": "新港乡",
            "pcode": "711900"
        },
        {
            "cityCode": "711932",
            "label": "民雄乡", "value": "民雄乡",
            "pcode": "711900"
        },
        {
            "cityCode": "711933",
            "label": "大林镇", "value": "大林镇",
            "pcode": "711900"
        },
        {
            "cityCode": "711934",
            "label": "溪口乡", "value": "溪口乡",
            "pcode": "711900"
        },
        {
            "cityCode": "711935",
            "label": "义竹乡", "value": "义竹乡",
            "pcode": "711900"
        },
        {
            "cityCode": "711936",
            "label": "布袋镇", "value": "布袋镇",
            "pcode": "711900"
        }],
        "pcode": "710000"
    },
    {
        "cityCode": "712100",
        "label": "云林县", "value": "云林县",
        "children": [{
            "cityCode": "712121",
            "label": "斗南镇", "value": "斗南镇",
            "pcode": "712100"
        },
        {
            "cityCode": "712122",
            "label": "大埤乡", "value": "大埤乡",
            "pcode": "712100"
        },
        {
            "cityCode": "712123",
            "label": "虎尾镇", "value": "虎尾镇",
            "pcode": "712100"
        },
        {
            "cityCode": "712124",
            "label": "土库镇", "value": "土库镇",
            "pcode": "712100"
        },
        {
            "cityCode": "712125",
            "label": "褒忠乡", "value": "褒忠乡",
            "pcode": "712100"
        },
        {
            "cityCode": "712126",
            "label": "东势乡", "value": "东势乡",
            "pcode": "712100"
        },
        {
            "cityCode": "712127",
            "label": "台西乡", "value": "台西乡",
            "pcode": "712100"
        },
        {
            "cityCode": "712128",
            "label": "仑背乡", "value": "仑背乡",
            "pcode": "712100"
        },
        {
            "cityCode": "712129",
            "label": "麦寮乡", "value": "麦寮乡",
            "pcode": "712100"
        },
        {
            "cityCode": "712130",
            "label": "斗六市", "value": "斗六市",
            "pcode": "712100"
        },
        {
            "cityCode": "712131",
            "label": "林内乡", "value": "林内乡",
            "pcode": "712100"
        },
        {
            "cityCode": "712132",
            "label": "古坑乡", "value": "古坑乡",
            "pcode": "712100"
        },
        {
            "cityCode": "712133",
            "label": "莿桐乡", "value": "莿桐乡",
            "pcode": "712100"
        },
        {
            "cityCode": "712134",
            "label": "西螺镇", "value": "西螺镇",
            "pcode": "712100"
        },
        {
            "cityCode": "712135",
            "label": "二仑乡", "value": "二仑乡",
            "pcode": "712100"
        },
        {
            "cityCode": "712136",
            "label": "北港镇", "value": "北港镇",
            "pcode": "712100"
        },
        {
            "cityCode": "712137",
            "label": "水林乡", "value": "水林乡",
            "pcode": "712100"
        },
        {
            "cityCode": "712138",
            "label": "口湖乡", "value": "口湖乡",
            "pcode": "712100"
        },
        {
            "cityCode": "712139",
            "label": "四湖乡", "value": "四湖乡",
            "pcode": "712100"
        },
        {
            "cityCode": "712140",
            "label": "元长乡", "value": "元长乡",
            "pcode": "712100"
        }],
        "pcode": "710000"
    },
    {
        "cityCode": "712400",
        "label": "屏东县", "value": "屏东县",
        "children": [{
            "cityCode": "712434",
            "label": "屏东市", "value": "屏东市",
            "pcode": "712400"
        },
        {
            "cityCode": "712435",
            "label": "三地门乡", "value": "三地门乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712436",
            "label": "雾台乡", "value": "雾台乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712437",
            "label": "玛家乡", "value": "玛家乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712438",
            "label": "九如乡", "value": "九如乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712439",
            "label": "里港乡", "value": "里港乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712440",
            "label": "高树乡", "value": "高树乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712441",
            "label": "盐埔乡", "value": "盐埔乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712442",
            "label": "长治乡", "value": "长治乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712443",
            "label": "麟洛乡", "value": "麟洛乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712444",
            "label": "竹田乡", "value": "竹田乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712445",
            "label": "内埔乡", "value": "内埔乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712446",
            "label": "万丹乡", "value": "万丹乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712447",
            "label": "潮州镇", "value": "潮州镇",
            "pcode": "712400"
        },
        {
            "cityCode": "712448",
            "label": "泰武乡", "value": "泰武乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712449",
            "label": "来义乡", "value": "来义乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712450",
            "label": "万峦乡", "value": "万峦乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712451",
            "label": "崁顶乡", "value": "崁顶乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712452",
            "label": "新埤乡", "value": "新埤乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712453",
            "label": "南州乡", "value": "南州乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712454",
            "label": "林边乡", "value": "林边乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712455",
            "label": "东港镇", "value": "东港镇",
            "pcode": "712400"
        },
        {
            "cityCode": "712456",
            "label": "琉球乡", "value": "琉球乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712457",
            "label": "佳冬乡", "value": "佳冬乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712458",
            "label": "新园乡", "value": "新园乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712459",
            "label": "枋寮乡", "value": "枋寮乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712460",
            "label": "枋山乡", "value": "枋山乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712461",
            "label": "春日乡", "value": "春日乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712462",
            "label": "狮子乡", "value": "狮子乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712463",
            "label": "车城乡", "value": "车城乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712464",
            "label": "牡丹乡", "value": "牡丹乡",
            "pcode": "712400"
        },
        {
            "cityCode": "712465",
            "label": "恒春镇", "value": "恒春镇",
            "pcode": "712400"
        },
        {
            "cityCode": "712466",
            "label": "满州乡", "value": "满州乡",
            "pcode": "712400"
        }],
        "pcode": "710000"
    },
    {
        "cityCode": "712500",
        "label": "台东县", "value": "台东县",
        "children": [{
            "cityCode": "712517",
            "label": "台东市", "value": "台东市",
            "pcode": "712500"
        },
        {
            "cityCode": "712518",
            "label": "绿岛乡", "value": "绿岛乡",
            "pcode": "712500"
        },
        {
            "cityCode": "712519",
            "label": "兰屿乡", "value": "兰屿乡",
            "pcode": "712500"
        },
        {
            "cityCode": "712520",
            "label": "延平乡", "value": "延平乡",
            "pcode": "712500"
        },
        {
            "cityCode": "712521",
            "label": "卑南乡", "value": "卑南乡",
            "pcode": "712500"
        },
        {
            "cityCode": "712522",
            "label": "鹿野乡", "value": "鹿野乡",
            "pcode": "712500"
        },
        {
            "cityCode": "712523",
            "label": "关山镇", "value": "关山镇",
            "pcode": "712500"
        },
        {
            "cityCode": "712524",
            "label": "海端乡", "value": "海端乡",
            "pcode": "712500"
        },
        {
            "cityCode": "712525",
            "label": "池上乡", "value": "池上乡",
            "pcode": "712500"
        },
        {
            "cityCode": "712526",
            "label": "东河乡", "value": "东河乡",
            "pcode": "712500"
        },
        {
            "cityCode": "712527",
            "label": "成功镇", "value": "成功镇",
            "pcode": "712500"
        },
        {
            "cityCode": "712528",
            "label": "长滨乡", "value": "长滨乡",
            "pcode": "712500"
        },
        {
            "cityCode": "712529",
            "label": "金峰乡", "value": "金峰乡",
            "pcode": "712500"
        },
        {
            "cityCode": "712530",
            "label": "大武乡", "value": "大武乡",
            "pcode": "712500"
        },
        {
            "cityCode": "712531",
            "label": "达仁乡", "value": "达仁乡",
            "pcode": "712500"
        },
        {
            "cityCode": "712532",
            "label": "太麻里乡", "value": "太麻里乡",
            "pcode": "712500"
        }],
        "pcode": "710000"
    },
    {
        "cityCode": "712600",
        "label": "花莲县", "value": "花莲县",
        "children": [{
            "cityCode": "712615",
            "label": "花莲市", "value": "花莲市",
            "pcode": "712600"
        },
        {
            "cityCode": "712616",
            "label": "新城乡", "value": "新城乡",
            "pcode": "712600"
        },
        {
            "cityCode": "712617",
            "label": "太鲁阁", "value": "太鲁阁",
            "pcode": "712600"
        },
        {
            "cityCode": "712618",
            "label": "秀林乡", "value": "秀林乡",
            "pcode": "712600"
        },
        {
            "cityCode": "712619",
            "label": "吉安乡", "value": "吉安乡",
            "pcode": "712600"
        },
        {
            "cityCode": "712620",
            "label": "寿丰乡", "value": "寿丰乡",
            "pcode": "712600"
        },
        {
            "cityCode": "712621",
            "label": "凤林镇", "value": "凤林镇",
            "pcode": "712600"
        },
        {
            "cityCode": "712622",
            "label": "光复乡", "value": "光复乡",
            "pcode": "712600"
        },
        {
            "cityCode": "712623",
            "label": "丰滨乡", "value": "丰滨乡",
            "pcode": "712600"
        },
        {
            "cityCode": "712624",
            "label": "瑞穗乡", "value": "瑞穗乡",
            "pcode": "712600"
        },
        {
            "cityCode": "712625",
            "label": "万荣乡", "value": "万荣乡",
            "pcode": "712600"
        },
        {
            "cityCode": "712626",
            "label": "玉里镇", "value": "玉里镇",
            "pcode": "712600"
        },
        {
            "cityCode": "712627",
            "label": "卓溪乡", "value": "卓溪乡",
            "pcode": "712600"
        },
        {
            "cityCode": "712628",
            "label": "富里乡", "value": "富里乡",
            "pcode": "712600"
        }],
        "pcode": "710000"
    },
    {
        "cityCode": "712700",
        "label": "澎湖县", "value": "澎湖县",
        "children": [{
            "cityCode": "712707",
            "label": "马公市", "value": "马公市",
            "pcode": "712700"
        },
        {
            "cityCode": "712708",
            "label": "西屿乡", "value": "西屿乡",
            "pcode": "712700"
        },
        {
            "cityCode": "712709",
            "label": "望安乡", "value": "望安乡",
            "pcode": "712700"
        },
        {
            "cityCode": "712710",
            "label": "七美乡", "value": "七美乡",
            "pcode": "712700"
        },
        {
            "cityCode": "712711",
            "label": "白沙乡", "value": "白沙乡",
            "pcode": "712700"
        },
        {
            "cityCode": "712712",
            "label": "湖西乡", "value": "湖西乡",
            "pcode": "712700"
        }],
        "pcode": "710000"
    },
    {
        "cityCode": "712800",
        "label": "连江县", "value": "连江县",
        "children": [{
            "cityCode": "712805",
            "label": "南竿乡", "value": "南竿乡",
            "pcode": "712800"
        },
        {
            "cityCode": "712806",
            "label": "北竿乡", "value": "北竿乡",
            "pcode": "712800"
        },
        {
            "cityCode": "712807",
            "label": "莒光乡", "value": "莒光乡",
            "pcode": "712800"
        },
        {
            "cityCode": "712808",
            "label": "东引乡", "value": "东引乡",
            "pcode": "712800"
        }],
        "pcode": "710000"
    }]
},
{
    "cityCode": "810000",
    "label": "香港特别行政区", "value": "香港特别行政区",
    "children": [{
        "cityCode": "810001",
        "label": "中西区", "value": "中西区",
        "children": [],
        "pcode": "810000"
    },
    {
        "cityCode": "810002",
        "label": "湾仔区", "value": "湾仔区",
        "children": [],
        "pcode": "810000"
    },
    {
        "cityCode": "810003",
        "label": "东区", "value": "东区",
        "children": [],
        "pcode": "810000"
    },
    {
        "cityCode": "810004",
        "label": "南区", "value": "南区",
        "children": [],
        "pcode": "810000"
    },
    {
        "cityCode": "810005",
        "label": "油尖旺区", "value": "油尖旺区",
        "children": [],
        "pcode": "810000"
    },
    {
        "cityCode": "810006",
        "label": "深水埗区", "value": "深水埗区",
        "children": [],
        "pcode": "810000"
    },
    {
        "cityCode": "810007",
        "label": "九龙城区", "value": "九龙城区",
        "children": [],
        "pcode": "810000"
    },
    {
        "cityCode": "810008",
        "label": "黃大仙区", "value": "黃大仙区",
        "children": [],
        "pcode": "810000"
    },
    {
        "cityCode": "810009",
        "label": "观塘区", "value": "观塘区",
        "children": [],
        "pcode": "810000"
    },
    {
        "cityCode": "810010",
        "label": "荃湾区", "value": "荃湾区",
        "children": [],
        "pcode": "810000"
    },
    {
        "cityCode": "810011",
        "label": "屯門区", "value": "屯門区",
        "children": [],
        "pcode": "810000"
    },
    {
        "cityCode": "810012",
        "label": "元朗区", "value": "元朗区",
        "children": [],
        "pcode": "810000"
    },
    {
        "cityCode": "810013",
        "label": "北区", "value": "北区",
        "children": [],
        "pcode": "810000"
    },
    {
        "cityCode": "810014",
        "label": "大埔区", "value": "大埔区",
        "children": [],
        "pcode": "810000"
    },
    {
        "cityCode": "810015",
        "label": "西贡区", "value": "西贡区",
        "children": [],
        "pcode": "810000"
    },
    {
        "cityCode": "810016",
        "label": "沙田区", "value": "沙田区",
        "children": [],
        "pcode": "810000"
    },
    {
        "cityCode": "810017",
        "label": "葵青区", "value": "葵青区",
        "children": [],
        "pcode": "810000"
    },
    {
        "cityCode": "810018",
        "label": "离岛区", "value": "离岛区",
        "children": [],
        "pcode": "810000"
    }]
},
{
    "cityCode": "820000",
    "label": "澳门特别行政区", "value": "澳门特别行政区",
    "children": [{
        "cityCode": "820001",
        "label": "花地玛堂区", "value": "花地玛堂区",
        "children": [],
        "pcode": "820000"
    },
    {
        "cityCode": "820002",
        "label": "花王堂区", "value": "花王堂区",
        "children": [],
        "pcode": "820000"
    },
    {
        "cityCode": "820003",
        "label": "望德堂区", "value": "望德堂区",
        "children": [],
        "pcode": "820000"
    },
    {
        "cityCode": "820004",
        "label": "大堂区", "value": "大堂区",
        "children": [],
        "pcode": "820000"
    },
    {
        "cityCode": "820005",
        "label": "风顺堂区", "value": "风顺堂区",
        "children": [],
        "pcode": "820000"
    },
    {
        "cityCode": "820006",
        "label": "嘉模堂区", "value": "嘉模堂区",
        "children": [],
        "pcode": "820000"
    },
    {
        "cityCode": "820007",
        "label": "路凼填海区", "value": "路凼填海区",
        "children": [],
        "pcode": "820000"
    },
    {
        "cityCode": "820008",
        "label": "圣方济各堂区", "value": "圣方济各堂区",
        "children": [],
        "pcode": "820000"
    }]
}]

export default {
    adr
}


// WEBPACK FOOTER //
// ./src/assets/js/adr.js